import { t as e } from "./defineProperty-CGeCBTWF.js";
import t, { css as n } from "styled-components";
import * as r from "react";
import i, { Component as a, createContext as o, useCallback as s, useContext as c, useEffect as l, useId as u, useLayoutEffect as d, useMemo as f, useRef as p, useState as m } from "react";
import { Fragment as h, jsx as g, jsxs as _ } from "react/jsx-runtime";
import * as v from "react-dom";
import y from "react-player";
import b from "moment";
import x from "@microlink/react";
//#region \0rolldown/runtime.js
var S = Object.create, C = Object.defineProperty, w = Object.getOwnPropertyDescriptor, T = Object.getOwnPropertyNames, E = Object.getPrototypeOf, D = Object.prototype.hasOwnProperty, O = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), k = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = T(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !D.call(e, s) && s !== n && C(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = w(t, s)) || r.enumerable
	});
	return e;
}, A = (e, t, n) => (n = e == null ? {} : S(E(e)), k(t || !e || !e.__esModule || !D.call(e, "default") ? C(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), j = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
}), M = /* @__PURE__ */ O(((e, t) => {
	var n = function(e) {
		return e && e.Math === Math && e;
	};
	t.exports = n(typeof globalThis == "object" && globalThis) || n(typeof window == "object" && window) || n(typeof self == "object" && self) || n(typeof global == "object" && global) || n(typeof e == "object" && e) || (function() {
		return this;
	})() || Function("return this")();
})), N = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e) {
		try {
			return !!e();
		} catch {
			return !0;
		}
	};
})), P = /* @__PURE__ */ O(((e, t) => {
	t.exports = !N()(function() {
		var e = function() {}.bind();
		return typeof e != "function" || e.hasOwnProperty("prototype");
	});
})), ee = /* @__PURE__ */ O(((e, t) => {
	var n = P(), r = Function.prototype, i = r.apply, a = r.call;
	t.exports = typeof Reflect == "object" && Reflect.apply || (n ? a.bind(i) : function() {
		return a.apply(i, arguments);
	});
})), F = /* @__PURE__ */ O(((e, t) => {
	var n = P(), r = Function.prototype, i = r.call, a = n && r.bind.bind(i, i);
	t.exports = n ? a : function(e) {
		return function() {
			return i.apply(e, arguments);
		};
	};
})), te = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = n({}.toString), i = n("".slice);
	t.exports = function(e) {
		return i(r(e), 8, -1);
	};
})), ne = /* @__PURE__ */ O(((e, t) => {
	var n = te(), r = F();
	t.exports = function(e) {
		if (n(e) === "Function") return r(e);
	};
})), I = /* @__PURE__ */ O(((e, t) => {
	var n = typeof document == "object" && document.all;
	t.exports = n === void 0 && n !== void 0 ? function(e) {
		return typeof e == "function" || e === n;
	} : function(e) {
		return typeof e == "function";
	};
})), L = /* @__PURE__ */ O(((e, t) => {
	t.exports = !N()(function() {
		return Object.defineProperty({}, 1, { get: function() {
			return 7;
		} })[1] !== 7;
	});
})), R = /* @__PURE__ */ O(((e, t) => {
	var n = P(), r = Function.prototype.call;
	t.exports = n ? r.bind(r) : function() {
		return r.apply(r, arguments);
	};
})), z = /* @__PURE__ */ O(((e) => {
	var t = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor;
	e.f = n && !t.call({ 1: 2 }, 1) ? function(e) {
		var t = n(this, e);
		return !!t && t.enumerable;
	} : t;
})), B = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e, t) {
		return {
			enumerable: !(e & 1),
			configurable: !(e & 2),
			writable: !(e & 4),
			value: t
		};
	};
})), V = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = N(), i = te(), a = Object, o = n("".split);
	t.exports = r(function() {
		return !a("z").propertyIsEnumerable(0);
	}) ? function(e) {
		return i(e) === "String" ? o(e, "") : a(e);
	} : a;
})), H = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e) {
		return e == null;
	};
})), re = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = TypeError;
	t.exports = function(e) {
		if (n(e)) throw new r("Can't call method on " + e);
		return e;
	};
})), ie = /* @__PURE__ */ O(((e, t) => {
	var n = V(), r = re();
	t.exports = function(e) {
		return n(r(e));
	};
})), ae = /* @__PURE__ */ O(((e, t) => {
	var n = I();
	t.exports = function(e) {
		return typeof e == "object" ? e !== null : n(e);
	};
})), oe = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), U = /* @__PURE__ */ O(((e, t) => {
	var n = oe(), r = M(), i = I(), a = function(e) {
		return i(e) ? e : void 0;
	};
	t.exports = function(e, t) {
		return arguments.length < 2 ? a(n[e]) || a(r[e]) : n[e] && n[e][t] || r[e] && r[e][t];
	};
})), W = /* @__PURE__ */ O(((e, t) => {
	t.exports = F()({}.isPrototypeOf);
})), se = /* @__PURE__ */ O(((e, t) => {
	var n = M().navigator, r = n && n.userAgent;
	t.exports = r ? String(r) : "";
})), ce = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = se(), i = n.process, a = n.Deno, o = i && i.versions || a && a.version, s = o && o.v8, c, l;
	s && (c = s.split("."), l = c[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !l && r && (c = r.match(/Edge\/(\d+)/), (!c || c[1] >= 74) && (c = r.match(/Chrome\/(\d+)/), c && (l = +c[1]))), t.exports = l;
})), le = /* @__PURE__ */ O(((e, t) => {
	var n = ce(), r = N(), i = M().String;
	t.exports = !!Object.getOwnPropertySymbols && !r(function() {
		var e = Symbol("symbol detection");
		return !i(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
	});
})), ue = /* @__PURE__ */ O(((e, t) => {
	t.exports = le() && !Symbol.sham && typeof Symbol.iterator == "symbol";
})), de = /* @__PURE__ */ O(((e, t) => {
	var n = U(), r = I(), i = W(), a = ue(), o = Object;
	t.exports = a ? function(e) {
		return typeof e == "symbol";
	} : function(e) {
		var t = n("Symbol");
		return r(t) && i(t.prototype, o(e));
	};
})), fe = /* @__PURE__ */ O(((e, t) => {
	var n = String;
	t.exports = function(e) {
		try {
			return n(e);
		} catch {
			return "Object";
		}
	};
})), G = /* @__PURE__ */ O(((e, t) => {
	var n = I(), r = fe(), i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not a function");
	};
})), K = /* @__PURE__ */ O(((e, t) => {
	var n = G(), r = H();
	t.exports = function(e, t) {
		var i = e[t];
		return r(i) ? void 0 : n(i);
	};
})), pe = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = I(), i = ae(), a = TypeError;
	t.exports = function(e, t) {
		var o, s;
		if (t === "string" && r(o = e.toString) && !i(s = n(o, e)) || r(o = e.valueOf) && !i(s = n(o, e)) || t !== "string" && r(o = e.toString) && !i(s = n(o, e))) return s;
		throw new a("Can't convert object to primitive value");
	};
})), me = /* @__PURE__ */ O(((e, t) => {
	t.exports = !0;
})), he = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = Object.defineProperty;
	t.exports = function(e, t) {
		try {
			r(n, e, {
				value: t,
				configurable: !0,
				writable: !0
			});
		} catch {
			n[e] = t;
		}
		return t;
	};
})), ge = /* @__PURE__ */ O(((e, t) => {
	var n = me(), r = M(), i = he(), a = "__core-js_shared__", o = t.exports = r[a] || i(a, {});
	(o.versions || (o.versions = [])).push({
		version: "3.49.0",
		mode: n ? "pure" : "global",
		copyright: "© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.",
		license: "https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE",
		source: "https://github.com/zloirock/core-js"
	});
})), _e = /* @__PURE__ */ O(((e, t) => {
	var n = ge();
	t.exports = function(e, t) {
		return n[e] || (n[e] = t || {});
	};
})), ve = /* @__PURE__ */ O(((e, t) => {
	var n = re(), r = Object;
	t.exports = function(e) {
		return r(n(e));
	};
})), ye = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = ve(), i = n({}.hasOwnProperty);
	t.exports = Object.hasOwn || function(e, t) {
		return i(r(e), t);
	};
})), be = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = 0, i = Math.random(), a = n(1.1.toString);
	t.exports = function(e) {
		return "Symbol(" + (e === void 0 ? "" : e) + ")_" + a(++r + i, 36);
	};
})), xe = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = _e(), i = ye(), a = be(), o = le(), s = ue(), c = n.Symbol, l = r("wks"), u = s ? c.for || c : c && c.withoutSetter || a;
	t.exports = function(e) {
		return i(l, e) || (l[e] = o && i(c, e) ? c[e] : u("Symbol." + e)), l[e];
	};
})), Se = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = ae(), i = de(), a = K(), o = pe(), s = xe(), c = TypeError, l = s("toPrimitive");
	t.exports = function(e, t) {
		if (!r(e) || i(e)) return e;
		var s = a(e, l), u;
		if (s) {
			if (t === void 0 && (t = "default"), u = n(s, e, t), !r(u) || i(u)) return u;
			throw new c("Can't convert object to primitive value");
		}
		return t === void 0 && (t = "number"), o(e, t);
	};
})), Ce = /* @__PURE__ */ O(((e, t) => {
	var n = Se(), r = de();
	t.exports = function(e) {
		var t = n(e, "string");
		return r(t) ? t : t + "";
	};
})), we = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = ae(), i = n.document, a = r(i) && r(i.createElement);
	t.exports = function(e) {
		return a ? i.createElement(e) : {};
	};
})), Te = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = N(), i = we();
	t.exports = !n && !r(function() {
		return Object.defineProperty(i("div"), "a", { get: function() {
			return 7;
		} }).a !== 7;
	});
})), Ee = /* @__PURE__ */ O(((e) => {
	var t = L(), n = R(), r = z(), i = B(), a = ie(), o = Ce(), s = ye(), c = Te(), l = Object.getOwnPropertyDescriptor;
	e.f = t ? l : function(e, t) {
		if (e = a(e), t = o(t), c) try {
			return l(e, t);
		} catch {}
		if (s(e, t)) return i(!n(r.f, e, t), e[t]);
	};
})), De = /* @__PURE__ */ O(((e, t) => {
	var n = N(), r = I(), i = /#|\.prototype\./, a = function(e, t) {
		var i = s[o(e)];
		return i === l ? !0 : i === c ? !1 : r(t) ? n(t) : !!t;
	}, o = a.normalize = function(e) {
		return String(e).replace(i, ".").toLowerCase();
	}, s = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
	t.exports = a;
})), Oe = /* @__PURE__ */ O(((e, t) => {
	var n = ne(), r = G(), i = P(), a = n(n.bind);
	t.exports = function(e, t) {
		return r(e), t === void 0 ? e : i ? a(e, t) : function() {
			return e.apply(t, arguments);
		};
	};
})), ke = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = N();
	t.exports = n && r(function() {
		return Object.defineProperty(function() {}, "prototype", {
			value: 42,
			writable: !1
		}).prototype !== 42;
	});
})), Ae = /* @__PURE__ */ O(((e, t) => {
	var n = ae(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not an object");
	};
})), je = /* @__PURE__ */ O(((e) => {
	var t = L(), n = Te(), r = ke(), i = Ae(), a = Ce(), o = TypeError, s = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = "enumerable", u = "configurable", d = "writable";
	e.f = t ? r ? function(e, t, n) {
		if (i(e), t = a(t), i(n), typeof e == "function" && t === "prototype" && "value" in n && d in n && !n[d]) {
			var r = c(e, t);
			r && r[d] && (e[t] = n.value, n = {
				configurable: u in n ? n[u] : r[u],
				enumerable: l in n ? n[l] : r[l],
				writable: !1
			});
		}
		return s(e, t, n);
	} : s : function(e, t, r) {
		if (i(e), t = a(t), i(r), n) try {
			return s(e, t, r);
		} catch {}
		if ("get" in r || "set" in r) throw new o("Accessors not supported");
		return "value" in r && (e[t] = r.value), e;
	};
})), Me = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = je(), i = B();
	t.exports = n ? function(e, t, n) {
		return r.f(e, t, i(1, n));
	} : function(e, t, n) {
		return e[t] = n, e;
	};
})), q = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = ee(), i = ne(), a = I(), o = Ee().f, s = De(), c = oe(), l = Oe(), u = Me(), d = ye();
	ge();
	var f = function(e) {
		var t = function(n, i, a) {
			if (this instanceof t) {
				switch (arguments.length) {
					case 0: return new e();
					case 1: return new e(n);
					case 2: return new e(n, i);
				}
				return new e(n, i, a);
			}
			return r(e, this, arguments);
		};
		return t.prototype = e.prototype, t;
	};
	t.exports = function(e, t) {
		var r = e.target, p = e.global, m = e.stat, h = e.proto, g = p ? n : m ? n[r] : n[r] && n[r].prototype, _ = p ? c : c[r] || u(c, r, {})[r], v = _.prototype, y, b, x, S, C, w, T, E, D;
		for (S in t) y = s(p ? S : r + (m ? "." : "#") + S, e.forced), b = !y && g && d(g, S), w = _[S], b && (e.dontCallGetSet ? (D = o(g, S), T = D && D.value) : T = g[S]), C = b && T ? T : t[S], (y || h || typeof w != typeof C) && (E = e.bind && b ? l(C, n) : e.wrap && b ? f(C) : h && a(C) ? i(C) : C, (e.sham || C && C.sham || w && w.sham) && u(E, "sham", !0), u(_, S, E), h && (x = r + "Prototype", d(c, x) || u(c, x, {}), u(c[x], S, C), e.real && v && (y || !v[S]) && u(v, S, C)));
	};
})), Ne = /* @__PURE__ */ O((() => {
	var e = q(), t = L(), n = je().f;
	e({
		target: "Object",
		stat: !0,
		forced: Object.defineProperty !== n,
		sham: !t
	}, { defineProperty: n });
})), J = /* @__PURE__ */ O(((e, t) => {
	Ne();
	var n = oe().Object, r = t.exports = function(e, t, r) {
		return n.defineProperty(e, t, r);
	};
	n.defineProperty.sham && (r.sham = !0);
})), Pe = /* @__PURE__ */ O(((e, t) => {
	t.exports = J();
})), Fe = /* @__PURE__ */ O(((e, t) => {
	t.exports = Pe();
})), Ie = /* @__PURE__ */ O(((e, t) => {
	function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Le = /* @__PURE__ */ O(((e, t) => {
	var n = te();
	t.exports = Array.isArray || function(e) {
		return n(e) === "Array";
	};
})), Re = /* @__PURE__ */ O(((e, t) => {
	var n = xe()("toStringTag"), r = {};
	r[n] = "z", t.exports = String(r) === "[object z]";
})), ze = /* @__PURE__ */ O(((e, t) => {
	var n = Re(), r = I(), i = te(), a = xe()("toStringTag"), o = Object, s = i(function() {
		return arguments;
	}()) === "Arguments", c = function(e, t) {
		try {
			return e[t];
		} catch {}
	};
	t.exports = n ? i : function(e) {
		var t, n, l;
		return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = c(t = o(e), a)) == "string" ? n : s ? i(t) : (l = i(t)) === "Object" && r(t.callee) ? "Arguments" : l;
	};
})), Be = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = I(), i = ge(), a = n(Function.toString);
	r(i.inspectSource) || (i.inspectSource = function(e) {
		return a(e);
	}), t.exports = i.inspectSource;
})), Ve = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = N(), i = I(), a = ze(), o = U(), s = Be(), c = function() {}, l = o("Reflect", "construct"), u = /^\s*(?:class|function)\b/, d = n(u.exec), f = !u.test(c), p = function(e) {
		if (!i(e)) return !1;
		try {
			return l(c, [], e), !0;
		} catch {
			return !1;
		}
	}, m = function(e) {
		if (!i(e)) return !1;
		switch (a(e)) {
			case "AsyncFunction":
			case "GeneratorFunction":
			case "AsyncGeneratorFunction": return !1;
		}
		try {
			return f || !!d(u, s(e));
		} catch {
			return !0;
		}
	};
	m.sham = !0, t.exports = !l || r(function() {
		var e;
		return p(p.call) || !p(Object) || !p(function() {
			e = !0;
		}) || e;
	}) ? m : p;
})), He = /* @__PURE__ */ O(((e, t) => {
	var n = Math.ceil, r = Math.floor;
	t.exports = Math.trunc || function(e) {
		var t = +e;
		return (t > 0 ? r : n)(t);
	};
})), Ue = /* @__PURE__ */ O(((e, t) => {
	var n = He();
	t.exports = function(e) {
		var t = +e;
		return t !== t || t === 0 ? 0 : n(t);
	};
})), We = /* @__PURE__ */ O(((e, t) => {
	var n = Ue(), r = Math.max, i = Math.min;
	t.exports = function(e, t) {
		var a = n(e);
		return a < 0 ? r(a + t, 0) : i(a, t);
	};
})), Ge = /* @__PURE__ */ O(((e, t) => {
	var n = Ue(), r = Math.min;
	t.exports = function(e) {
		var t = n(e);
		return t > 0 ? r(t, 9007199254740991) : 0;
	};
})), Ke = /* @__PURE__ */ O(((e, t) => {
	var n = Ge();
	t.exports = function(e) {
		return n(e.length);
	};
})), qe = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = je(), i = B();
	t.exports = function(e, t, a) {
		n ? r.f(e, t, i(0, a)) : e[t] = a;
	};
})), Je = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = Le(), i = TypeError, a = Object.getOwnPropertyDescriptor;
	t.exports = n && !function() {
		if (this !== void 0) return !0;
		try {
			Object.defineProperty([], "length", { writable: !1 }).length = 1;
		} catch (e) {
			return e instanceof TypeError;
		}
	}() ? function(e, t) {
		if (r(e) && !a(e, "length").writable) throw new i("Cannot set read only .length");
		return e.length = t;
	} : function(e, t) {
		return e.length = t;
	};
})), Ye = /* @__PURE__ */ O(((e, t) => {
	var n = N(), r = xe(), i = ce(), a = r("species");
	t.exports = function(e) {
		return i >= 51 || !n(function() {
			var t = [], n = t.constructor = {};
			return n[a] = function() {
				return { foo: 1 };
			}, t[e](Boolean).foo !== 1;
		});
	};
})), Xe = /* @__PURE__ */ O(((e, t) => {
	t.exports = F()([].slice);
})), Ze = /* @__PURE__ */ O((() => {
	var e = q(), t = Le(), n = Ve(), r = ae(), i = We(), a = Ke(), o = ie(), s = qe(), c = Je(), l = xe(), u = Ye(), d = Xe(), f = u("slice"), p = l("species"), m = Array, h = Math.max;
	e({
		target: "Array",
		proto: !0,
		forced: !f
	}, { slice: function(e, l) {
		var u = o(this), f = a(u), g = i(e, f), _ = i(l === void 0 ? f : l, f), v, y, b;
		if (t(u) && (v = u.constructor, n(v) && (v === m || t(v.prototype)) ? v = void 0 : r(v) && (v = v[p], v === null && (v = void 0)), v === m || v === void 0)) return d(u, g, _);
		for (y = new (v === void 0 ? m : v)(h(_ - g, 0)), b = 0; g < _; g++, b++) g in u && s(y, b, u[g]);
		return c(y, b), y;
	} });
})), Qe = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = oe();
	t.exports = function(e, t) {
		var i = r[e + "Prototype"], a = i && i[t];
		if (a) return a;
		var o = n[e], s = o && o.prototype;
		return s && s[t];
	};
})), $e = /* @__PURE__ */ O(((e, t) => {
	Ze(), t.exports = Qe()("Array", "slice");
})), et = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = $e(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.slice;
		return e === i || n(i, e) && t === i.slice ? r : t;
	};
})), tt = /* @__PURE__ */ O(((e, t) => {
	t.exports = et();
})), nt = /* @__PURE__ */ O(((e, t) => {
	t.exports = tt();
})), rt = /* @__PURE__ */ O(((e, t) => {
	var n = ze(), r = String;
	t.exports = function(e) {
		if (n(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
		return r(e);
	};
})), it = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = Ue(), i = rt(), a = re(), o = n("".charAt), s = n("".charCodeAt), c = n("".slice), l = function(e) {
		return function(t, n) {
			var l = i(a(t)), u = r(n), d = l.length, f, p;
			return u < 0 || u >= d ? e ? "" : void 0 : (f = s(l, u), f < 55296 || f > 56319 || u + 1 === d || (p = s(l, u + 1)) < 56320 || p > 57343 ? e ? o(l, u) : f : e ? c(l, u, u + 2) : (f - 55296 << 10) + (p - 56320) + 65536);
		};
	};
	t.exports = {
		codeAt: l(!1),
		charAt: l(!0)
	};
})), at = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = I(), i = n.WeakMap;
	t.exports = r(i) && /native code/.test(String(i));
})), ot = /* @__PURE__ */ O(((e, t) => {
	var n = _e(), r = be(), i = n("keys");
	t.exports = function(e) {
		return i[e] || (i[e] = r(e));
	};
})), st = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), ct = /* @__PURE__ */ O(((e, t) => {
	var n = at(), r = M(), i = ae(), a = Me(), o = ye(), s = ge(), c = ot(), l = st(), u = "Object already initialized", d = r.TypeError, f = r.WeakMap, p, m, h, g = function(e) {
		return h(e) ? m(e) : p(e, {});
	}, _ = function(e) {
		return function(t) {
			var n;
			if (!i(t) || (n = m(t)).type !== e) throw new d("Incompatible receiver, " + e + " required");
			return n;
		};
	};
	if (n || s.state) {
		var v = s.state || (s.state = new f());
		v.get = v.get, v.has = v.has, v.set = v.set, p = function(e, t) {
			if (v.has(e)) throw new d(u);
			return t.facade = e, v.set(e, t), t;
		}, m = function(e) {
			return v.get(e) || {};
		}, h = function(e) {
			return v.has(e);
		};
	} else {
		var y = c("state");
		l[y] = !0, p = function(e, t) {
			if (o(e, y)) throw new d(u);
			return t.facade = e, a(e, y, t), t;
		}, m = function(e) {
			return o(e, y) ? e[y] : {};
		}, h = function(e) {
			return o(e, y);
		};
	}
	t.exports = {
		set: p,
		get: m,
		has: h,
		enforce: g,
		getterFor: _
	};
})), lt = /* @__PURE__ */ O(((e, t) => {
	var n = L(), r = ye(), i = Function.prototype, a = n && Object.getOwnPropertyDescriptor, o = r(i, "name");
	t.exports = {
		EXISTS: o,
		PROPER: o && function() {}.name === "something",
		CONFIGURABLE: o && (!n || n && a(i, "name").configurable)
	};
})), ut = /* @__PURE__ */ O(((e, t) => {
	var n = ie(), r = We(), i = Ke(), a = function(e) {
		return function(t, a, o) {
			var s = n(t), c = i(s);
			if (c === 0) return !e && -1;
			var l = r(o, c), u;
			if (e && a !== a) {
				for (; c > l;) if (u = s[l++], u !== u) return !0;
			} else for (; c > l; l++) if ((e || l in s) && s[l] === a) return e || l || 0;
			return !e && -1;
		};
	};
	t.exports = {
		includes: a(!0),
		indexOf: a(!1)
	};
})), dt = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = ye(), i = ie(), a = ut().indexOf, o = st(), s = n([].push);
	t.exports = function(e, t) {
		var n = i(e), c = 0, l = [], u;
		for (u in n) !r(o, u) && r(n, u) && s(l, u);
		for (; t.length > c;) r(n, u = t[c++]) && (~a(l, u) || s(l, u));
		return l;
	};
})), ft = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		"constructor",
		"hasOwnProperty",
		"isPrototypeOf",
		"propertyIsEnumerable",
		"toLocaleString",
		"toString",
		"valueOf"
	];
})), pt = /* @__PURE__ */ O(((e, t) => {
	var n = dt(), r = ft();
	t.exports = Object.keys || function(e) {
		return n(e, r);
	};
})), mt = /* @__PURE__ */ O(((e) => {
	var t = L(), n = ke(), r = je(), i = Ae(), a = ie(), o = pt();
	e.f = t && !n ? Object.defineProperties : function(e, t) {
		i(e);
		for (var n = a(t), s = o(t), c = s.length, l = 0, u; c > l;) r.f(e, u = s[l++], n[u]);
		return e;
	};
})), ht = /* @__PURE__ */ O(((e, t) => {
	t.exports = U()("document", "documentElement");
})), gt = /* @__PURE__ */ O(((e, t) => {
	var n = Ae(), r = mt(), i = ft(), a = st(), o = ht(), s = we(), c = ot(), l = ">", u = "<", d = "prototype", f = "script", p = c("IE_PROTO"), m = function() {}, h = function(e) {
		return u + f + l + e + u + "/" + f + l;
	}, g = function(e) {
		e.write(h("")), e.close();
		var t = e.parentWindow.Object;
		return e = null, t;
	}, _ = function() {
		var e = s("iframe"), t = "java" + f + ":", n;
		return e.style.display = "none", o.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(h("document.F=Object")), n.close(), n.F;
	}, v, y = function() {
		try {
			v = new ActiveXObject("htmlfile");
		} catch {}
		y = typeof document < "u" ? document.domain && v ? g(v) : _() : g(v);
		for (var e = i.length; e--;) delete y[d][i[e]];
		return y();
	};
	a[p] = !0, t.exports = Object.create || function(e, t) {
		var i;
		return e === null ? i = y() : (m[d] = n(e), i = new m(), m[d] = null, i[p] = e), t === void 0 ? i : r.f(i, t);
	};
})), _t = /* @__PURE__ */ O(((e, t) => {
	t.exports = !N()(function() {
		function e() {}
		return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
	});
})), vt = /* @__PURE__ */ O(((e, t) => {
	var n = ye(), r = I(), i = ve(), a = ot(), o = _t(), s = a("IE_PROTO"), c = Object, l = c.prototype;
	t.exports = o ? c.getPrototypeOf : function(e) {
		var t = i(e);
		if (n(t, s)) return t[s];
		var a = t.constructor;
		return r(a) && t instanceof a ? a.prototype : t instanceof c ? l : null;
	};
})), yt = /* @__PURE__ */ O(((e, t) => {
	var n = Me();
	t.exports = function(e, t, r, i) {
		return i && i.enumerable ? e[t] = r : n(e, t, r), e;
	};
})), bt = /* @__PURE__ */ O(((e, t) => {
	var n = N(), r = I(), i = ae(), a = gt(), o = vt(), s = yt(), c = xe(), l = me(), u = c("iterator"), d = !1, f, p, m;
	[].keys && (m = [].keys(), "next" in m ? (p = o(o(m)), p !== Object.prototype && (f = p)) : d = !0), !i(f) || n(function() {
		var e = {};
		return f[u].call(e) !== e;
	}) ? f = {} : l && (f = a(f)), r(f[u]) || s(f, u, function() {
		return this;
	}), t.exports = {
		IteratorPrototype: f,
		BUGGY_SAFARI_ITERATORS: d
	};
})), xt = /* @__PURE__ */ O(((e, t) => {
	var n = Re(), r = ze();
	t.exports = n ? {}.toString : function() {
		return "[object " + r(this) + "]";
	};
})), St = /* @__PURE__ */ O(((e, t) => {
	var n = Re(), r = je().f, i = Me(), a = ye(), o = xt(), s = xe()("toStringTag");
	t.exports = function(e, t, c, l) {
		var u = c ? e : e && e.prototype;
		u && (a(u, s) || r(u, s, {
			configurable: !0,
			value: t
		}), l && !n && i(u, "toString", o));
	};
})), Ct = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), wt = /* @__PURE__ */ O(((e, t) => {
	var n = bt().IteratorPrototype, r = gt(), i = B(), a = St(), o = Ct(), s = function() {
		return this;
	};
	t.exports = function(e, t, c, l) {
		var u = t + " Iterator";
		return e.prototype = r(n, { next: i(+!l, c) }), a(e, u, !1, !0), o[u] = s, e;
	};
})), Tt = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = G();
	t.exports = function(e, t, i) {
		try {
			return n(r(Object.getOwnPropertyDescriptor(e, t)[i]));
		} catch {}
	};
})), Et = /* @__PURE__ */ O(((e, t) => {
	var n = ae();
	t.exports = function(e) {
		return n(e) || e === null;
	};
})), Dt = /* @__PURE__ */ O(((e, t) => {
	var n = Et(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i("Can't set " + r(e) + " as a prototype");
	};
})), Ot = /* @__PURE__ */ O(((e, t) => {
	var n = Tt(), r = ae(), i = re(), a = Dt();
	t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
		var e = !1, t = {}, o;
		try {
			o = n(Object.prototype, "__proto__", "set"), o(t, []), e = t instanceof Array;
		} catch {}
		return function(t, n) {
			return i(t), a(n), r(t) && (e ? o(t, n) : t.__proto__ = n), t;
		};
	}() : void 0);
})), kt = /* @__PURE__ */ O(((e, t) => {
	var n = q(), r = R(), i = me(), a = lt(), o = I(), s = wt(), c = vt(), l = Ot(), u = St(), d = Me(), f = yt(), p = xe(), m = Ct(), h = bt(), g = a.PROPER, _ = a.CONFIGURABLE, v = h.IteratorPrototype, y = h.BUGGY_SAFARI_ITERATORS, b = p("iterator"), x = "keys", S = "values", C = "entries", w = function() {
		return this;
	};
	t.exports = function(e, t, a, p, h, T, E) {
		s(a, t, p);
		var D = function(e) {
			if (e === h && M) return M;
			if (!y && e && e in A) return A[e];
			switch (e) {
				case x: return function() {
					return new a(this, e);
				};
				case S: return function() {
					return new a(this, e);
				};
				case C: return function() {
					return new a(this, e);
				};
			}
			return function() {
				return new a(this);
			};
		}, O = t + " Iterator", k = !1, A = e.prototype, j = A[b] || A["@@iterator"] || h && A[h], M = !y && j || D(h), N = t === "Array" && A.entries || j, P, ee, F;
		if (N && (P = c(N.call(new e())), P !== Object.prototype && P.next && (!i && c(P) !== v && (l ? l(P, v) : o(P[b]) || f(P, b, w)), u(P, O, !0, !0), i && (m[O] = w))), g && h === S && j && j.name !== S && (!i && _ ? d(A, "name", S) : (k = !0, M = function() {
			return r(j, this);
		})), h) {
			if (ee = {
				values: D(S),
				keys: T ? M : D(x),
				entries: D(C)
			}, E) for (F in ee) (y || k || !(F in A)) && f(A, F, ee[F]);
			else n({
				target: t,
				proto: !0,
				forced: y || k
			}, ee);
		}
		return (!i || E) && A[b] !== M && f(A, b, M, { name: h }), m[t] = M, ee;
	};
})), At = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e, t) {
		return {
			value: e,
			done: t
		};
	};
})), jt = /* @__PURE__ */ O((() => {
	var e = it().charAt, t = rt(), n = ct(), r = kt(), i = At(), a = "String Iterator", o = n.set, s = n.getterFor(a);
	r(String, "String", function(e) {
		o(this, {
			type: a,
			string: t(e),
			index: 0
		});
	}, function() {
		var t = s(this), n = t.string, r = t.index, a;
		return r >= n.length ? i(void 0, !0) : (a = e(n, r), t.index += a.length, i(a, !1));
	});
})), Mt = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = Ae(), i = K();
	t.exports = function(e, t, a) {
		var o, s;
		r(e);
		try {
			if (o = i(e, "return"), !o) {
				if (t === "throw") throw a;
				return a;
			}
			o = n(o, e);
		} catch (e) {
			s = !0, o = e;
		}
		if (t === "throw") throw a;
		if (s) throw o;
		return r(o), a;
	};
})), Nt = /* @__PURE__ */ O(((e, t) => {
	var n = Ae(), r = Mt();
	t.exports = function(e, t, i, a) {
		try {
			return a ? t(n(i)[0], i[1]) : t(i);
		} catch (t) {
			r(e, "throw", t);
		}
	};
})), Pt = /* @__PURE__ */ O(((e, t) => {
	var n = xe(), r = Ct(), i = n("iterator"), a = Array.prototype;
	t.exports = function(e) {
		return e !== void 0 && (r.Array === e || a[i] === e);
	};
})), Ft = /* @__PURE__ */ O(((e, t) => {
	var n = ze(), r = K(), i = H(), a = Ct(), o = xe()("iterator");
	t.exports = function(e) {
		if (!i(e)) return r(e, o) || r(e, "@@iterator") || a[n(e)];
	};
})), It = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = G(), i = Ae(), a = fe(), o = Ft(), s = TypeError;
	t.exports = function(e, t) {
		var c = arguments.length < 2 ? o(e) : t;
		if (r(c)) return i(n(c, e));
		throw new s(a(e) + " is not iterable");
	};
})), Lt = /* @__PURE__ */ O(((e, t) => {
	var n = Oe(), r = R(), i = ve(), a = Nt(), o = Pt(), s = Ve(), c = Ke(), l = qe(), u = Je(), d = It(), f = Ft(), p = Mt(), m = Array;
	t.exports = function(e) {
		var t = s(this), h = arguments.length, g = h > 1 ? arguments[1] : void 0, _ = g !== void 0;
		_ && (g = n(g, h > 2 ? arguments[2] : void 0));
		var v = i(e), y = f(v), b = 0, x, S, C, w, T, E;
		if (y && !(this === m && o(y))) for (S = t ? new this() : [], w = d(v, y), T = w.next; !(C = r(T, w)).done; b++) {
			E = _ ? a(w, g, [C.value, b], !0) : C.value;
			try {
				l(S, b, E);
			} catch (e) {
				p(w, "throw", e);
			}
		}
		else for (x = c(v), S = t ? new this(x) : m(x); x > b; b++) E = _ ? g(v[b], b) : v[b], l(S, b, E);
		return u(S, b), S;
	};
})), Rt = /* @__PURE__ */ O(((e, t) => {
	var n = xe()("iterator"), r = !1;
	try {
		var i = 0, a = {
			next: function() {
				return { done: !!i++ };
			},
			return: function() {
				r = !0;
			}
		};
		a[n] = function() {
			return this;
		}, Array.from(a, function() {
			throw 2;
		});
	} catch {}
	t.exports = function(e, t) {
		try {
			if (!t && !r) return !1;
		} catch {
			return !1;
		}
		var i = !1;
		try {
			var a = {};
			a[n] = function() {
				return { next: function() {
					return { done: i = !0 };
				} };
			}, e(a);
		} catch {}
		return i;
	};
})), zt = /* @__PURE__ */ O((() => {
	var e = q(), t = Lt();
	e({
		target: "Array",
		stat: !0,
		forced: !Rt()(function(e) {
			Array.from(e);
		})
	}, { from: t });
})), Bt = /* @__PURE__ */ O(((e, t) => {
	jt(), zt(), t.exports = oe().Array.from;
})), Vt = /* @__PURE__ */ O(((e, t) => {
	t.exports = Bt();
})), Ht = /* @__PURE__ */ O(((e, t) => {
	t.exports = Vt();
})), Ut = /* @__PURE__ */ O(((e, t) => {
	var n = TypeError, r = 9007199254740991;
	t.exports = function(e) {
		if (e > r) throw new n("Maximum allowed index exceeded");
		return e;
	};
})), Wt = /* @__PURE__ */ O(((e, t) => {
	var n = Le(), r = Ve(), i = ae(), a = xe()("species"), o = Array;
	t.exports = function(e) {
		var t;
		return n(e) && (t = e.constructor, r(t) && (t === o || n(t.prototype)) ? t = void 0 : i(t) && (t = t[a], t === null && (t = void 0))), t === void 0 ? o : t;
	};
})), Gt = /* @__PURE__ */ O(((e, t) => {
	var n = Wt();
	t.exports = function(e, t) {
		return new (n(e))(t === 0 ? 0 : t);
	};
})), Kt = /* @__PURE__ */ O((() => {
	var e = q(), t = N(), n = Le(), r = ae(), i = ve(), a = Ke(), o = Ut(), s = qe(), c = Je(), l = Gt(), u = Ye(), d = xe(), f = ce(), p = d("isConcatSpreadable"), m = f >= 51 || !t(function() {
		var e = [];
		return e[p] = !1, e.concat()[0] !== e;
	}), h = function(e) {
		if (!r(e)) return !1;
		var t = e[p];
		return t === void 0 ? n(e) : !!t;
	};
	e({
		target: "Array",
		proto: !0,
		arity: 1,
		forced: !m || !u("concat")
	}, { concat: function(e) {
		for (var t = i(this), n = l(t, 0), r = 0, u = -1, d, f = arguments.length, p, m; u < f; u++) if (m = u === -1 ? t : arguments[u], h(m)) for (p = a(m), o(r + p), d = 0; d < p; d++, r++) d in m && s(n, r, m[d]);
		else o(r + 1), s(n, r++, m);
		return c(n, r), n;
	} });
})), qt = /* @__PURE__ */ O((() => {})), Jt = /* @__PURE__ */ O(((e) => {
	var t = dt(), n = ft().concat("length", "prototype");
	e.f = Object.getOwnPropertyNames || function(e) {
		return t(e, n);
	};
})), Yt = /* @__PURE__ */ O(((e, t) => {
	var n = te(), r = ie(), i = Jt().f, a = Xe(), o = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], s = function(e) {
		try {
			return i(e);
		} catch {
			return a(o);
		}
	};
	t.exports.f = function(e) {
		return o && n(e) === "Window" ? s(e) : i(r(e));
	};
})), Xt = /* @__PURE__ */ O(((e) => {
	e.f = Object.getOwnPropertySymbols;
})), Zt = /* @__PURE__ */ O(((e, t) => {
	var n = je();
	t.exports = function(e, t, r) {
		return n.f(e, t, r);
	};
})), Qt = /* @__PURE__ */ O(((e) => {
	e.f = xe();
})), $t = /* @__PURE__ */ O(((e, t) => {
	var n = oe(), r = ye(), i = Qt(), a = je().f;
	t.exports = function(e) {
		var t = n.Symbol || (n.Symbol = {});
		r(t, e) || a(t, e, { value: i.f(e) });
	};
})), en = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = U(), i = xe(), a = yt();
	t.exports = function() {
		var e = r("Symbol"), t = e && e.prototype, o = t && t.valueOf, s = i("toPrimitive");
		t && !t[s] && a(t, s, function(e) {
			return n(o, this);
		}, { arity: 1 });
	};
})), tn = /* @__PURE__ */ O(((e, t) => {
	var n = Oe(), r = V(), i = ve(), a = Ke(), o = Gt(), s = qe(), c = function(e) {
		var t = e === 1, c = e === 2, l = e === 3, u = e === 4, d = e === 6, f = e === 7, p = e === 5 || d;
		return function(m, h, g) {
			for (var _ = i(m), v = r(_), y = a(v), b = n(h, g), x = 0, S = 0, C = t ? o(m, y) : c || f ? o(m, 0) : void 0, w, T; y > x; x++) if ((p || x in v) && (w = v[x], T = b(w, x, _), e)) {
				if (t) s(C, x, T);
				else if (T) switch (e) {
					case 3: return !0;
					case 5: return w;
					case 6: return x;
					case 2: s(C, S++, w);
				}
				else switch (e) {
					case 4: return !1;
					case 7: s(C, S++, w);
				}
			}
			return d ? -1 : l || u ? u : C;
		};
	};
	t.exports = {
		forEach: c(0),
		map: c(1),
		filter: c(2),
		some: c(3),
		every: c(4),
		find: c(5),
		findIndex: c(6),
		filterReject: c(7)
	};
})), nn = /* @__PURE__ */ O((() => {
	var e = q(), t = M(), n = R(), r = F(), i = me(), a = L(), o = le(), s = N(), c = ye(), l = W(), u = Ae(), d = ie(), f = Ce(), p = rt(), m = B(), h = gt(), g = pt(), _ = Jt(), v = Yt(), y = Xt(), b = Ee(), x = je(), S = mt(), C = z(), w = yt(), T = Zt(), E = _e(), D = ot(), O = st(), k = be(), A = xe(), j = Qt(), P = $t(), ee = en(), te = St(), ne = ct(), I = tn().forEach, V = D("hidden"), H = "Symbol", re = "prototype", ae = ne.set, oe = ne.getterFor(H), U = Object[re], se = t.Symbol, ce = se && se[re], ue = t.RangeError, de = t.TypeError, fe = t.QObject, G = b.f, K = x.f, pe = v.f, he = C.f, ge = r([].push), ve = E("symbols"), Se = E("op-symbols"), we = E("wks"), Te = !fe || !fe[re] || !fe[re].findChild, De = function(e, t, n) {
		var r = G(U, t);
		return r && delete U[t], K(e, t, n), r && e !== U && K(U, t, r), e;
	}, Oe = a && s(function() {
		return h(K({}, "a", { get: function() {
			return K(this, "a", { value: 7 }).a;
		} })).a !== 7;
	}) ? De : K, ke = function(e, t) {
		var n = ve[e] = h(ce);
		return ae(n, {
			type: H,
			tag: e,
			description: t
		}), a || (n.description = t), n;
	}, Me = function(e, t, n) {
		e === U && Me(Se, t, n), u(e);
		var r = f(t);
		return u(n), c(ve, r) ? (("enumerable" in n ? !n.enumerable : !c(e, r) || c(e, V) && e[V][r]) ? (c(e, V) || K(e, V, m(1, h(null))), e[V][r] = !0) : (c(e, V) && e[V][r] && (e[V][r] = !1), n = h(n, { enumerable: m(0, !1) })), Oe(e, r, n)) : K(e, r, n);
	}, Ne = function(e, t) {
		u(e);
		var r = d(t);
		return I(g(r).concat(Le(r)), function(t) {
			(!a || n(Pe, r, t)) && Me(e, t, r[t]);
		}), e;
	}, J = function(e, t) {
		return t === void 0 ? h(e) : Ne(h(e), t);
	}, Pe = function(e) {
		var t = f(e), r = n(he, this, t);
		return this === U && c(ve, t) && !c(Se, t) ? !1 : r || !c(this, t) || !c(ve, t) || c(this, V) && this[V][t] ? r : !0;
	}, Fe = function(e, t) {
		var n = d(e), r = f(t);
		if (n !== U || !c(ve, r) || c(Se, r)) {
			var i = G(n, r);
			return i && c(ve, r) && !(c(n, V) && n[V][r]) && (i.enumerable = !0), i;
		}
	}, Ie = function(e) {
		var t = pe(d(e)), n = [];
		return I(t, function(e) {
			!c(ve, e) && !c(O, e) && ge(n, e);
		}), n;
	}, Le = function(e) {
		var t = e === U, n = pe(t ? Se : d(e)), r = [];
		return I(n, function(e) {
			c(ve, e) && (!t || c(U, e)) && ge(r, ve[e]);
		}), r;
	};
	o || (se = function() {
		if (l(ce, this)) throw new de("Symbol is not a constructor");
		var e = !arguments.length || arguments[0] === void 0 ? void 0 : p(arguments[0]), r = k(e), i = function(e) {
			var a = this === void 0 ? t : this;
			a === U && n(i, Se, e), c(a, V) && c(a[V], r) && (a[V][r] = !1);
			var o = m(1, e);
			try {
				Oe(a, r, o);
			} catch (e) {
				if (!(e instanceof ue)) throw e;
				De(a, r, o);
			}
		};
		return a && Te && Oe(U, r, {
			configurable: !0,
			set: i
		}), ke(r, e);
	}, ce = se[re], w(ce, "toString", function() {
		return oe(this).tag;
	}), w(se, "withoutSetter", function(e) {
		return ke(k(e), e);
	}), C.f = Pe, x.f = Me, S.f = Ne, b.f = Fe, _.f = v.f = Ie, y.f = Le, j.f = function(e) {
		return ke(A(e), e);
	}, a && (T(ce, "description", {
		configurable: !0,
		get: function() {
			return oe(this).description;
		}
	}), i || w(U, "propertyIsEnumerable", Pe, { unsafe: !0 }))), e({
		global: !0,
		constructor: !0,
		wrap: !0,
		forced: !o,
		sham: !o
	}, { Symbol: se }), I(g(we), function(e) {
		P(e);
	}), e({
		target: H,
		stat: !0,
		forced: !o
	}, {
		useSetter: function() {
			Te = !0;
		},
		useSimple: function() {
			Te = !1;
		}
	}), e({
		target: "Object",
		stat: !0,
		forced: !o,
		sham: !a
	}, {
		create: J,
		defineProperty: Me,
		defineProperties: Ne,
		getOwnPropertyDescriptor: Fe
	}), e({
		target: "Object",
		stat: !0,
		forced: !o
	}, { getOwnPropertyNames: Ie }), ee(), te(se, H), O[V] = !0;
})), rn = /* @__PURE__ */ O(((e, t) => {
	t.exports = le() && !!Symbol.for && !!Symbol.keyFor;
})), an = /* @__PURE__ */ O((() => {
	var e = q(), t = U(), n = ye(), r = rt(), i = _e(), a = rn(), o = i("string-to-symbol-registry"), s = i("symbol-to-string-registry");
	e({
		target: "Symbol",
		stat: !0,
		forced: !a
	}, { for: function(e) {
		var i = r(e);
		if (n(o, i)) return o[i];
		var a = t("Symbol")(i);
		return o[i] = a, s[a] = i, a;
	} });
})), on = /* @__PURE__ */ O((() => {
	var e = q(), t = ye(), n = de(), r = fe(), i = _e(), a = rn(), o = i("symbol-to-string-registry");
	e({
		target: "Symbol",
		stat: !0,
		forced: !a
	}, { keyFor: function(e) {
		if (!n(e)) throw TypeError(r(e) + " is not a symbol");
		if (t(o, e)) return o[e];
	} });
})), sn = /* @__PURE__ */ O(((e, t) => {
	var n = ae(), r = ct().get;
	t.exports = function(e) {
		if (!n(e)) return !1;
		var t = r(e);
		return !!t && t.type === "RawJSON";
	};
})), cn = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = ye(), i = SyntaxError, a = parseInt, o = String.fromCharCode, s = n("".charAt), c = n("".slice), l = n(/./.exec), u = {
		"\\\"": "\"",
		"\\\\": "\\",
		"\\/": "/",
		"\\b": "\b",
		"\\f": "\f",
		"\\n": "\n",
		"\\r": "\r",
		"\\t": "	"
	}, d = /^[\da-f]{4}$/i, f = /^[\u0000-\u001F]$/;
	t.exports = function(e, t) {
		for (var n = !0, p = ""; t < e.length;) {
			var m = s(e, t);
			if (m === "\\") {
				var h = c(e, t, t + 2);
				if (r(u, h)) p += u[h], t += 2;
				else if (h === "\\u") {
					t += 2;
					var g = c(e, t, t + 4);
					if (!l(d, g)) throw new i("Bad Unicode escape at: " + t);
					p += o(a(g, 16)), t += 4;
				} else throw new i("Unknown escape sequence: \"" + h + "\"");
			} else if (m === "\"") {
				n = !1, t++;
				break;
			} else {
				if (l(f, m)) throw new i("Bad control character in string literal at: " + t);
				p += m, t++;
			}
		}
		if (n) throw new i("Unterminated string at: " + t);
		return {
			value: p,
			end: t
		};
	};
})), ln = /* @__PURE__ */ O(((e, t) => {
	t.exports = !N()(function() {
		var e = "9007199254740993", t = JSON.rawJSON(e);
		return !JSON.isRawJSON(t) || JSON.stringify(t) !== e;
	});
})), un = /* @__PURE__ */ O((() => {
	var e = q(), t = U(), n = ee(), r = R(), i = F(), a = N(), o = Le(), s = I(), c = sn(), l = de(), u = te(), d = rt(), f = Xe(), p = cn(), m = be(), h = le(), g = ln(), _ = String, v = t("JSON", "stringify"), y = i(/./.exec), b = i("".charAt), x = i("".charCodeAt), S = i("".replace), C = i("".slice), w = i([].push), T = i(1.1.toString), E = /[\uD800-\uDFFF]/g, D = /^[\uD800-\uDBFF]$/, O = /^[\uDC00-\uDFFF]$/, k = m(), A = k.length, j = !h || a(function() {
		var e = t("Symbol")("stringify detection");
		return v([e]) !== "[null]" || v({ a: e }) !== "{}" || v(Object(e)) !== "{}";
	}), M = a(function() {
		return v("\udf06\ud834") !== "\"\\udf06\\ud834\"" || v("\udead") !== "\"\\udead\"";
	}), P = j ? function(e, t) {
		var i = f(arguments), a = L(t);
		if (s(a) || e !== void 0 && !l(e)) return i[1] = function(e, t) {
			if (s(a) && (t = r(a, this, _(e), t)), !l(t)) return t;
		}, n(v, null, i);
	} : v, ne = function(e, t, n) {
		var r = b(n, t - 1), i = b(n, t + 1);
		return y(D, e) && !y(O, i) || y(O, e) && !y(D, r) ? "\\u" + T(x(e, 0), 16) : e;
	}, L = function(e) {
		if (s(e)) return e;
		if (o(e)) {
			for (var t = e.length, n = [], r = 0; r < t; r++) {
				var i = e[r];
				typeof i == "string" ? w(n, i) : (typeof i == "number" || u(i) === "Number" || u(i) === "String") && w(n, d(i));
			}
			var a = n.length, c = !0;
			return function(e, t) {
				if (c) return c = !1, t;
				if (o(this)) return t;
				for (var r = 0; r < a; r++) if (n[r] === e) return t;
			};
		}
	};
	v && e({
		target: "JSON",
		stat: !0,
		arity: 3,
		forced: j || M || !g
	}, { stringify: function(e, t, n) {
		var i = L(t), a = [], o = P(e, function(e, t) {
			var n = s(i) ? r(i, this, _(e), t) : t;
			return !g && c(n) ? k + (w(a, n.rawJSON) - 1) : n;
		}, n);
		if (typeof o != "string" || (M && (o = S(o, E, ne)), g)) return o;
		for (var l = "", u = o.length, d = 0; d < u; d++) {
			var f = b(o, d);
			if (f === "\"") {
				var m = p(o, ++d).end - 1, h = C(o, d, m);
				l += C(h, 0, A) === k ? a[C(h, A)] : "\"" + h + "\"", d = m;
			} else l += f;
		}
		return l;
	} });
})), dn = /* @__PURE__ */ O((() => {
	var e = q(), t = le(), n = N(), r = Xt(), i = ve();
	e({
		target: "Object",
		stat: !0,
		forced: !t || n(function() {
			r.f(1);
		})
	}, { getOwnPropertySymbols: function(e) {
		var t = r.f;
		return t ? t(i(e)) : [];
	} });
})), fn = /* @__PURE__ */ O((() => {
	nn(), an(), on(), un(), dn();
})), pn = /* @__PURE__ */ O((() => {
	$t()("asyncDispose");
})), mn = /* @__PURE__ */ O((() => {
	$t()("asyncIterator");
})), hn = /* @__PURE__ */ O((() => {})), gn = /* @__PURE__ */ O((() => {
	$t()("dispose");
})), _n = /* @__PURE__ */ O((() => {
	$t()("hasInstance");
})), vn = /* @__PURE__ */ O((() => {
	$t()("isConcatSpreadable");
})), yn = /* @__PURE__ */ O((() => {
	$t()("iterator");
})), bn = /* @__PURE__ */ O((() => {
	$t()("match");
})), xn = /* @__PURE__ */ O((() => {
	$t()("matchAll");
})), Sn = /* @__PURE__ */ O((() => {
	$t()("replace");
})), Cn = /* @__PURE__ */ O((() => {
	$t()("search");
})), wn = /* @__PURE__ */ O((() => {
	$t()("species");
})), Tn = /* @__PURE__ */ O((() => {
	$t()("split");
})), En = /* @__PURE__ */ O((() => {
	var e = $t(), t = en();
	e("toPrimitive"), t();
})), Dn = /* @__PURE__ */ O((() => {
	var e = U(), t = $t(), n = St();
	t("toStringTag"), n(e("Symbol"), "Symbol");
})), On = /* @__PURE__ */ O((() => {
	$t()("unscopables");
})), kn = /* @__PURE__ */ O((() => {
	var e = M();
	St()(e.JSON, "JSON", !0);
})), An = /* @__PURE__ */ O((() => {})), jn = /* @__PURE__ */ O((() => {})), Mn = /* @__PURE__ */ O(((e, t) => {
	Kt(), qt(), fn(), pn(), mn(), hn(), gn(), _n(), vn(), yn(), bn(), xn(), Sn(), Cn(), wn(), Tn(), En(), Dn(), On(), kn(), An(), jn(), t.exports = oe().Symbol;
})), Nn = /* @__PURE__ */ O(((e, t) => {
	t.exports = function() {};
})), Pn = /* @__PURE__ */ O(((e, t) => {
	var n = ie(), r = Nn(), i = Ct(), a = ct(), o = je().f, s = kt(), c = At(), l = me(), u = L(), d = "Array Iterator", f = a.set, p = a.getterFor(d);
	t.exports = s(Array, "Array", function(e, t) {
		f(this, {
			type: d,
			target: n(e),
			index: 0,
			kind: t
		});
	}, function() {
		var e = p(this), t = e.target, n = e.index++;
		if (!t || n >= t.length) return e.target = null, c(void 0, !0);
		switch (e.kind) {
			case "keys": return c(n, !1);
			case "values": return c(t[n], !1);
		}
		return c([n, t[n]], !1);
	}, "values");
	var m = i.Arguments = i.Array;
	if (r("keys"), r("values"), r("entries"), !l && u && m.name !== "values") try {
		o(m, "name", { value: "values" });
	} catch {}
})), Fn = /* @__PURE__ */ O(((e, t) => {
	t.exports = {
		CSSRuleList: 0,
		CSSStyleDeclaration: 0,
		CSSValueList: 0,
		ClientRectList: 0,
		DOMRectList: 0,
		DOMStringList: 0,
		DOMTokenList: 1,
		DataTransferItemList: 0,
		FileList: 0,
		HTMLAllCollection: 0,
		HTMLCollection: 0,
		HTMLFormElement: 0,
		HTMLSelectElement: 0,
		MediaList: 0,
		MimeTypeArray: 0,
		NamedNodeMap: 0,
		NodeList: 1,
		PaintRequestList: 0,
		Plugin: 0,
		PluginArray: 0,
		SVGLengthList: 0,
		SVGNumberList: 0,
		SVGPathSegList: 0,
		SVGPointList: 0,
		SVGStringList: 0,
		SVGTransformList: 0,
		SourceBufferList: 0,
		StyleSheetList: 0,
		TextTrackCueList: 0,
		TextTrackList: 0,
		TouchList: 0
	};
})), In = /* @__PURE__ */ O((() => {
	Pn();
	var e = Fn(), t = M(), n = St(), r = Ct();
	for (var i in e) n(t[i], i), r[i] = r.Array;
})), Ln = /* @__PURE__ */ O(((e, t) => {
	var n = Mn();
	In(), t.exports = n;
})), Rn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ln();
})), zn = /* @__PURE__ */ O(((e, t) => {
	Pn(), jt(), t.exports = Ft();
})), Bn = /* @__PURE__ */ O(((e, t) => {
	var n = zn();
	In(), t.exports = n;
})), Vn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Bn();
})), Hn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Vn();
})), Un = /* @__PURE__ */ O(((e, t) => {
	t.exports = Hn();
})), Wn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Un();
})), Gn = /* @__PURE__ */ O((() => {
	q()({
		target: "Array",
		stat: !0
	}, { isArray: Le() });
})), Kn = /* @__PURE__ */ O(((e, t) => {
	Gn(), t.exports = oe().Array.isArray;
})), qn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Kn();
})), Jn = /* @__PURE__ */ O(((e, t) => {
	t.exports = qn();
})), Yn = /* @__PURE__ */ O(((e, t) => {
	t.exports = qn();
})), Xn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Yn();
})), Zn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Xn();
})), Qn = /* @__PURE__ */ O(((e, t) => {
	var n = Zn();
	function r(e) {
		if (n(e)) return e;
	}
	t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})), $n = /* @__PURE__ */ O((() => {
	var e = xe(), t = je().f, n = e("metadata"), r = Function.prototype;
	r[n] === void 0 && t(r, n, { value: null });
})), er = /* @__PURE__ */ O((() => {
	pn();
})), tr = /* @__PURE__ */ O((() => {
	gn();
})), nr = /* @__PURE__ */ O((() => {
	$t()("metadata");
})), rr = /* @__PURE__ */ O(((e, t) => {
	var n = Ln();
	$n(), er(), tr(), nr(), t.exports = n;
})), ir = /* @__PURE__ */ O(((e, t) => {
	var n = U(), r = F(), i = n("Symbol"), a = i.keyFor, o = r(i.prototype.valueOf);
	t.exports = i.isRegisteredSymbol || function(e) {
		try {
			return a(o(e)) !== void 0;
		} catch {
			return !1;
		}
	};
})), ar = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0
	}, { isRegisteredSymbol: ir() });
})), or = /* @__PURE__ */ O(((e, t) => {
	for (var n = _e(), r = U(), i = F(), a = de(), o = xe(), s = r("Symbol"), c = s.isWellKnownSymbol, l = r("Object", "getOwnPropertyNames"), u = i(s.prototype.valueOf), d = n("wks"), f = 0, p = l(s), m = p.length; f < m; f++) try {
		var h = p[f];
		a(s[h]) && o(h);
	} catch {}
	t.exports = function(e) {
		if (c && c(e)) return !0;
		try {
			for (var t = u(e), n = 0, r = l(d), i = r.length; n < i; n++) if (d[r[n]] == t) return !0;
		} catch {}
		return !1;
	};
})), sr = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		forced: !0
	}, { isWellKnownSymbol: or() });
})), cr = /* @__PURE__ */ O((() => {
	$t()("customMatcher");
})), lr = /* @__PURE__ */ O((() => {
	$t()("observable");
})), ur = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		name: "isRegisteredSymbol"
	}, { isRegistered: ir() });
})), dr = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		name: "isWellKnownSymbol",
		forced: !0
	}, { isWellKnown: or() });
})), fr = /* @__PURE__ */ O((() => {
	$t()("matcher");
})), pr = /* @__PURE__ */ O((() => {
	$t()("metadataKey");
})), mr = /* @__PURE__ */ O((() => {
	$t()("patternMatch");
})), hr = /* @__PURE__ */ O((() => {
	$t()("replaceAll");
})), gr = /* @__PURE__ */ O(((e, t) => {
	var n = rr();
	ar(), sr(), cr(), lr(), ur(), dr(), fr(), pr(), mr(), hr(), t.exports = n;
})), _r = /* @__PURE__ */ O(((e, t) => {
	t.exports = gr();
})), vr = /* @__PURE__ */ O((() => {
	var e = q(), t = ve(), n = Ke(), r = Je(), i = Ut();
	e({
		target: "Array",
		proto: !0,
		arity: 1,
		forced: N()(function() {
			return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
		}) || !function() {
			try {
				Object.defineProperty([], "length", { writable: !1 }).push();
			} catch (e) {
				return e instanceof TypeError;
			}
		}()
	}, { push: function(e) {
		var a = t(this), o = n(a), s = arguments.length;
		i(o + s);
		for (var c = 0; c < s; c++) a[o] = arguments[c], o++;
		return r(a, o), o;
	} });
})), yr = /* @__PURE__ */ O(((e, t) => {
	vr(), t.exports = Qe()("Array", "push");
})), br = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = yr(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.push;
		return e === i || n(i, e) && t === i.push ? r : t;
	};
})), xr = /* @__PURE__ */ O(((e, t) => {
	t.exports = br();
})), Sr = /* @__PURE__ */ O(((e, t) => {
	t.exports = xr();
})), Cr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Sr();
})), wr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Cr();
})), Tr = /* @__PURE__ */ O(((e, t) => {
	var n = _r(), r = Un(), i = wr();
	function a(e, t) {
		var a = e == null ? null : n !== void 0 && r(e) || e["@@iterator"];
		if (a != null) {
			var o, s, c, l, u = [], d = !0, f = !1;
			try {
				if (c = (a = a.call(e)).next, t === 0) {
					if (Object(a) !== a) return;
					d = !1;
				} else for (; !(d = (o = c.call(a)).done) && (i(u).call(u, o.value), u.length !== t); d = !0);
			} catch (e) {
				f = !0, s = e;
			} finally {
				try {
					if (!d && a.return != null && (l = a.return(), Object(l) !== l)) return;
				} finally {
					if (f) throw s;
				}
			}
			return u;
		}
	}
	t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Er = /* @__PURE__ */ O(((e, t) => {
	t.exports = tt();
})), Dr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Er();
})), Or = /* @__PURE__ */ O(((e, t) => {
	t.exports = Dr();
})), kr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Vt();
})), Ar = /* @__PURE__ */ O(((e, t) => {
	t.exports = kr();
})), jr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ar();
})), Mr = /* @__PURE__ */ O(((e, t) => {
	function n(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Nr = /* @__PURE__ */ O(((e, t) => {
	var n = Or(), r = jr(), i = Mr();
	function a(e, t) {
		if (e) {
			var a;
			if (typeof e == "string") return i(e, t);
			var o = n(a = {}.toString.call(e)).call(a, 8, -1);
			return o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set" ? r(e) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? i(e, t) : void 0;
		}
	}
	t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Pr = /* @__PURE__ */ O(((e, t) => {
	function n() {
		throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Fr = /* @__PURE__ */ O(((e, t) => {
	var n = Qn(), r = Tr(), i = Nr(), a = Pr();
	function o(e, t) {
		return n(e) || r(e, t) || i(e, t) || a();
	}
	t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ir = /* @__PURE__ */ O((() => {
	var e = q(), t = L(), n = gt();
	e({
		target: "Object",
		stat: !0,
		sham: !t
	}, { create: n });
})), Lr = /* @__PURE__ */ O(((e, t) => {
	Ir();
	var n = oe().Object;
	t.exports = function(e, t) {
		return n.create(e, t);
	};
})), Rr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Lr();
})), zr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Rr();
})), Br = /* @__PURE__ */ O((() => {})), Vr = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = N(), i = n.RegExp;
	t.exports = { correct: !r(function() {
		var e = !0;
		try {
			i(".", "d");
		} catch {
			e = !1;
		}
		var t = {}, n = "", r = e ? "dgimsy" : "gimsy", a = function(e, r) {
			Object.defineProperty(t, e, { get: function() {
				return n += r, !0;
			} });
		}, o = {
			dotAll: "s",
			global: "g",
			ignoreCase: "i",
			multiline: "m",
			sticky: "y"
		};
		for (var s in e && (o.hasIndices = "d"), o) a(s, o[s]);
		return Object.getOwnPropertyDescriptor(i.prototype, "flags").get.call(t) !== r || n !== r;
	}) };
})), Hr = /* @__PURE__ */ O(((e, t) => {
	var n = Ae();
	t.exports = function() {
		var e = n(this), t = "";
		return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
	};
})), Ur = /* @__PURE__ */ O(((e, t) => {
	var n = R(), r = ye(), i = W(), a = Vr(), o = Hr(), s = RegExp.prototype;
	t.exports = a.correct ? function(e) {
		return e.flags;
	} : function(e) {
		return !a.correct && i(s, e) && !r(e, "flags") ? n(o, e) : e.flags;
	};
})), Wr = /* @__PURE__ */ O(((e, t) => {
	Br(), t.exports = Ur();
})), Gr = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Wr(), i = RegExp.prototype;
	t.exports = function(e) {
		return e === i || n(i, e) ? r(e) : e.flags;
	};
})), Kr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Gr();
})), qr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Kr();
})), Jr = /* @__PURE__ */ O((() => {
	q()({
		target: "Object",
		stat: !0
	}, { setPrototypeOf: Ot() });
})), Yr = /* @__PURE__ */ O(((e, t) => {
	Jr(), t.exports = oe().Object.setPrototypeOf;
})), Xr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Yr();
})), Zr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Xr();
})), Qr = /* @__PURE__ */ O(((e, t) => {
	var n = fe(), r = TypeError;
	t.exports = function(e, t) {
		if (!delete e[t]) throw new r("Cannot delete property " + n(t) + " of " + n(e));
	};
})), $r = /* @__PURE__ */ O(((e, t) => {
	var n = Xe(), r = Math.floor, i = function(e, t) {
		var a = e.length;
		if (a < 8) for (var o = 1, s, c; o < a;) {
			for (c = o, s = e[o]; c && t(e[c - 1], s) > 0;) e[c] = e[--c];
			c !== o++ && (e[c] = s);
		}
		else for (var l = r(a / 2), u = i(n(e, 0, l), t), d = i(n(e, l), t), f = u.length, p = d.length, m = 0, h = 0; m < f || h < p;) e[m + h] = m < f && h < p ? t(u[m], d[h]) <= 0 ? u[m++] : d[h++] : m < f ? u[m++] : d[h++];
		return e;
	};
	t.exports = i;
})), ei = /* @__PURE__ */ O(((e, t) => {
	var n = N();
	t.exports = function(e, t) {
		var r = [][e];
		return !!r && n(function() {
			r.call(null, t || function() {
				return 1;
			}, 1);
		});
	};
})), ti = /* @__PURE__ */ O(((e, t) => {
	var n = se().match(/firefox\/(\d+)/i);
	t.exports = !!n && +n[1];
})), ni = /* @__PURE__ */ O(((e, t) => {
	var n = se();
	t.exports = /MSIE|Trident/.test(n);
})), ri = /* @__PURE__ */ O(((e, t) => {
	var n = se().match(/AppleWebKit\/(\d+)\./);
	t.exports = !!n && +n[1];
})), ii = /* @__PURE__ */ O((() => {
	var e = q(), t = F(), n = G(), r = ve(), i = Ke(), a = Qr(), o = rt(), s = N(), c = $r(), l = ei(), u = ti(), d = ni(), f = ce(), p = ri(), m = [], h = t(m.sort), g = t(m.push), _ = s(function() {
		m.sort(void 0);
	}), v = s(function() {
		m.sort(null);
	}), y = l("sort"), b = !s(function() {
		if (f) return f < 70;
		if (!(u && u > 3)) {
			if (d) return !0;
			if (p) return p < 603;
			for (var e = "", t = 65, n, r, i; t < 76; t++) {
				switch (n = String.fromCharCode(t), t) {
					case 66:
					case 69:
					case 70:
					case 72:
						r = 3;
						break;
					case 68:
					case 71:
						r = 4;
						break;
					default: r = 2;
				}
				for (i = 0; i < 47; i++) m.push({
					k: n + i,
					v: r
				});
			}
			for (m.sort(function(e, t) {
				return t.v - e.v;
			}), i = 0; i < m.length; i++) n = m[i].k.charAt(0), e.charAt(e.length - 1) !== n && (e += n);
			return e !== "DGBEFHACIJK";
		}
	}), x = _ || !v || !y || !b, S = function(e) {
		return function(t, n) {
			if (n === void 0) return -1;
			if (t === void 0) return 1;
			if (e !== void 0) return +e(t, n) || 0;
			var r = o(t), i = o(n);
			return r === i ? 0 : r > i ? 1 : -1;
		};
	};
	e({
		target: "Array",
		proto: !0,
		forced: x
	}, { sort: function(e) {
		e !== void 0 && n(e);
		var t = r(this);
		if (b) return e === void 0 ? h(t) : h(t, e);
		for (var o = [], s = i(t), l, u = 0; u < s; u++) u in t && g(o, t[u]);
		for (c(o, S(e)), l = i(o), u = 0; u < l;) t[u] = o[u++];
		for (; u < s;) a(t, u++);
		return t;
	} });
})), ai = /* @__PURE__ */ O(((e, t) => {
	ii(), t.exports = Qe()("Array", "sort");
})), oi = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = ai(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.sort;
		return e === i || n(i, e) && t === i.sort ? r : t;
	};
})), si = /* @__PURE__ */ O(((e, t) => {
	t.exports = oi();
})), ci = /* @__PURE__ */ O(((e, t) => {
	t.exports = si();
})), li = /* @__PURE__ */ O(((e, t) => {
	t.exports = "	\n\v\f\r \xA0              　\u2028\u2029﻿";
})), ui = /* @__PURE__ */ O(((e, t) => {
	var n = F(), r = re(), i = rt(), a = li(), o = n("".replace), s = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(e) {
		return function(t) {
			var n = i(r(t));
			return e & 1 && (n = o(n, s, "")), e & 2 && (n = o(n, c, "$1")), n;
		};
	};
	t.exports = {
		start: l(1),
		end: l(2),
		trim: l(3)
	};
})), di = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = N(), i = F(), a = rt(), o = ui().trim, s = li(), c = n.parseInt, l = n.Symbol, u = l && l.iterator, d = /^[+-]?0x/i, f = i(d.exec);
	t.exports = c(s + "08") !== 8 || c(s + "0x16") !== 22 || u && !r(function() {
		c(Object(u));
	}) ? function(e, t) {
		var n = o(a(e));
		return c(n, t >>> 0 || (f(d, n) ? 16 : 10));
	} : c;
})), fi = /* @__PURE__ */ O((() => {
	var e = q(), t = di();
	e({
		global: !0,
		forced: parseInt !== t
	}, { parseInt: t });
})), pi = /* @__PURE__ */ O(((e, t) => {
	fi(), t.exports = oe().parseInt;
})), mi = /* @__PURE__ */ O(((e, t) => {
	t.exports = pi();
})), hi = /* @__PURE__ */ O(((e, t) => {
	t.exports = mi();
})), gi = /* @__PURE__ */ O((() => {
	var e = q(), t = ne(), n = ut().indexOf, r = ei(), i = t([].indexOf), a = !!i && 1 / i([1], 1, -0) < 0;
	e({
		target: "Array",
		proto: !0,
		forced: a || !r("indexOf")
	}, { indexOf: function(e) {
		var t = arguments.length > 1 ? arguments[1] : void 0;
		return a ? i(this, e, t) || 0 : n(this, e, t);
	} });
})), _i = /* @__PURE__ */ O(((e, t) => {
	gi(), t.exports = Qe()("Array", "indexOf");
})), vi = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = _i(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.indexOf;
		return e === i || n(i, e) && t === i.indexOf ? r : t;
	};
})), yi = /* @__PURE__ */ O(((e, t) => {
	t.exports = vi();
})), bi = /* @__PURE__ */ O(((e, t) => {
	t.exports = yi();
})), xi = /* @__PURE__ */ O(((e, t) => {
	var n = tn().forEach;
	t.exports = ei()("forEach") ? [].forEach : function(e) {
		return n(this, e, arguments.length > 1 ? arguments[1] : void 0);
	};
})), Si = /* @__PURE__ */ O((() => {
	var e = q(), t = xi();
	e({
		target: "Array",
		proto: !0,
		forced: [].forEach !== t
	}, { forEach: t });
})), Ci = /* @__PURE__ */ O(((e, t) => {
	Si(), t.exports = Qe()("Array", "forEach");
})), wi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ci();
})), Ti = /* @__PURE__ */ O((() => {})), Ei = /* @__PURE__ */ O(((e, t) => {
	var n = ze(), r = ye(), i = W(), a = wi();
	Ti();
	var o = Array.prototype, s = {
		DOMTokenList: !0,
		NodeList: !0
	};
	t.exports = function(e) {
		var t = e.forEach;
		return e === o || i(o, e) && t === o.forEach || r(s, n(e)) ? a : t;
	};
})), Di = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ei();
})), Oi = /* @__PURE__ */ O(((e, t) => {
	Kt(), t.exports = Qe()("Array", "concat");
})), ki = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Oi(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.concat;
		return e === i || n(i, e) && t === i.concat ? r : t;
	};
})), Ai = /* @__PURE__ */ O(((e, t) => {
	t.exports = ki();
})), ji = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ai();
})), Mi = /* @__PURE__ */ O(((e, t) => {
	var n = nt(), r = Ht(), i = Rn(), a = Wn(), o = Jn(), s = Fe(), c = Ie();
	s(e, "__esModule", { value: !0 }), e.default = void 0;
	var l = c(Fr()), u = c(zr()), d = c(qr()), f = c(Zr()), p = c(ci()), m = c(nt()), h = c(hi()), g = c(bi()), _ = c(Di()), v = c(ji());
	function y(e, t) {
		var n = i !== void 0 && a(e) || e["@@iterator"];
		if (!n) {
			if (o(e) || (n = b(e)) || t && e && typeof e.length == "number") {
				n && (e = n);
				var r = 0, s = function() {};
				return {
					s,
					n: function() {
						return r >= e.length ? { done: !0 } : {
							done: !1,
							value: e[r++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: s
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var c, l = !0, u = !1;
		return {
			s: function() {
				n = n.call(e);
			},
			n: function() {
				var e = n.next();
				return l = e.done, e;
			},
			e: function(e) {
				u = !0, c = e;
			},
			f: function() {
				try {
					l || n.return == null || n.return();
				} finally {
					if (u) throw c;
				}
			}
		};
	}
	function b(e, t) {
		if (e) {
			var i;
			if (typeof e == "string") return x(e, t);
			var a = n(i = {}.toString.call(e)).call(i, 8, -1);
			return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? r(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? x(e, t) : void 0;
		}
	}
	function x(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	var S = "xregexp", C = (0, u.default)(null);
	C.astral = !1, C.namespacing = !0;
	var w = {}, T = (0, u.default)(null), E = (0, u.default)(null), D = [], O = "default", k = "class", A = {
		default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
		class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
	}, j = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, M = /()??/.exec("")[1] === void 0, N = (0, d.default)(/x/) !== void 0;
	function P(e) {
		var t = !0;
		try {
			if (RegExp("", e), e === "y") {
				var n = function() {
					return "gy";
				}();
				".a".replace(RegExp("a", n), ".") === ".." && (t = !1);
			}
		} catch {
			t = !1;
		}
		return t;
	}
	var ee = P("d"), F = P("s"), te = P("u"), ne = P("y"), I = (0, u.default)(null);
	I.d = ee, I.g = !0, I.i = !0, I.m = !0, I.s = F, I.u = te, I.y = ne;
	var L = F ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
	function R(e, t, n, r, i) {
		var a;
		if (e[S] = { captureNames: t }, i) return e;
		if (f.default) (0, f.default)(e, K.prototype);
		else for (var o in K.prototype) e[o] = K.prototype[o];
		return e[S].source = n, e[S].flags = r && (0, p.default)(a = r.split("")).call(a).join(""), e;
	}
	function z(e) {
		return e.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
	}
	function B(e, t) {
		var n;
		if (!K.isRegExp(e)) throw TypeError("Type RegExp expected");
		var r = e[S] || {}, i = re(e), a = "", o = "", s = null, c = null;
		return t = t || {}, t.removeG && (o += "g"), t.removeY && (o += "y"), o && (i = i.replace(RegExp(`[${o}]+`, "g"), "")), t.addG && (a += "g"), t.addY && (a += "y"), a && (i = z(i + a)), t.isInternalOnly || (r.source !== void 0 && (s = r.source), (0, d.default)(r) != null && (c = a ? z((0, d.default)(r) + a) : (0, d.default)(r))), e = R(new RegExp(t.source || e.source, i), ie(e) ? (0, m.default)(n = r.captureNames).call(n, 0) : null, s, c, t.isInternalOnly), e;
	}
	function V(e) {
		return (0, h.default)(e, 16);
	}
	function H(e, t, n) {
		var r = e.index + e[0].length, i = e.input[e.index - 1], a = e.input[r];
		return /^[()|]$/.test(i) || /^[()|]$/.test(a) || e.index === 0 || r === e.input.length || /\(\?(?:[:=!]|<[=!])$/.test(e.input.substring(e.index - 4, e.index)) || oe(e.input, r, n) ? "" : "(?:)";
	}
	function re(e) {
		return N ? (0, d.default)(e) : /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(e))[1];
	}
	function ie(e) {
		return !!(e[S] && e[S].captureNames);
	}
	function ae(e) {
		return (0, h.default)(e, 10).toString(16);
	}
	function oe(e, t, n) {
		return ((0, g.default)(n).call(n, "x") === -1 ? /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ : /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/).test((0, m.default)(e).call(e, t));
	}
	function U(e, t) {
		return Object.prototype.toString.call(e) === `[object ${t}]`;
	}
	function W(e) {
		if (e == null) throw TypeError("Cannot convert null or undefined to object");
		return e;
	}
	function se(e) {
		for (; e.length < 4;) e = `0${e}`;
		return e;
	}
	function ce(e, t) {
		if (z(t) !== t) throw SyntaxError(`Invalid duplicate regex flag ${t}`);
		e = e.replace(/^\(\?([\w$]+)\)/, function(e, n) {
			if (/[dgy]/.test(n)) throw SyntaxError(`Cannot use flags dgy in mode modifier ${e}`);
			return t = z(t + n), "";
		});
		var n = y(t), r;
		try {
			for (n.s(); !(r = n.n()).done;) {
				var i = r.value;
				if (!I[i]) throw SyntaxError(`Unknown regex flag ${i}`);
			}
		} catch (e) {
			n.e(e);
		} finally {
			n.f();
		}
		return {
			pattern: e,
			flags: t
		};
	}
	function le(e) {
		var t = {};
		return U(e, "String") ? ((0, _.default)(K).call(K, e, /[^\s,]+/, function(e) {
			t[e] = !0;
		}), t) : e;
	}
	function ue(e) {
		if (!/^[\w$]$/.test(e)) throw Error("Flag must be a single character A-Za-z0-9_$");
		I[e] = !0;
	}
	function de(e, t, n, r, i) {
		for (var a = D.length, o = e[n], s = null, c, l; a--;) if (l = D[a], !(l.leadChar && l.leadChar !== o || l.scope !== r && l.scope !== "all" || l.flag && (0, g.default)(t).call(t, l.flag) === -1) && (c = K.exec(e, l.regex, n, "sticky"), c)) {
			s = {
				matchLength: c[0].length,
				output: l.handler.call(i, c, r, t),
				reparse: l.reparse
			};
			break;
		}
		return s;
	}
	function fe(e) {
		C.astral = e;
	}
	function G(e) {
		C.namespacing = e;
	}
	function K(e, t) {
		if (K.isRegExp(e)) {
			if (t !== void 0) throw TypeError("Cannot supply flags when copying a RegExp");
			return B(e);
		}
		if (e = e === void 0 ? "" : String(e), t = t === void 0 ? "" : String(t), K.isInstalled("astral") && (0, g.default)(t).call(t, "A") === -1 && (t += "A"), E[e] || (E[e] = (0, u.default)(null)), !E[e][t]) {
			for (var n = {
				hasNamedCapture: !1,
				captureNames: []
			}, r = O, i = "", a = 0, o, s = ce(e, t), c = s.pattern, f = (0, d.default)(s); a < c.length;) {
				do
					o = de(c, f, a, r, n), o && o.reparse && (c = (0, m.default)(c).call(c, 0, a) + o.output + (0, m.default)(c).call(c, a + o.matchLength));
				while (o && o.reparse);
				if (o) i += o.output, a += o.matchLength || 1;
				else {
					var p = K.exec(c, A[r], a, "sticky"), h = (0, l.default)(p, 1)[0];
					i += h, a += h.length, h === "[" && r === O ? r = k : h === "]" && r === k && (r = O);
				}
			}
			E[e][t] = {
				pattern: i.replace(/(?:\(\?:\))+/g, "(?:)"),
				flags: f.replace(L, ""),
				captures: n.hasNamedCapture ? n.captureNames : null
			};
		}
		var _ = E[e][t];
		return R(new RegExp(_.pattern, (0, d.default)(_)), _.captures, e, t);
	}
	K.prototype = /(?:)/, K.version = "5.1.3", K._clipDuplicates = z, K._hasNativeFlag = P, K._dec = V, K._hex = ae, K._pad4 = se, K.addToken = function(e, t, n) {
		n = n || {};
		var r = n.optionalFlags;
		if (n.flag && ue(n.flag), r) {
			r = r.split("");
			var i = y(r), a;
			try {
				for (i.s(); !(a = i.n()).done;) {
					var o = a.value;
					ue(o);
				}
			} catch (e) {
				i.e(e);
			} finally {
				i.f();
			}
		}
		D.push({
			regex: B(e, {
				addG: !0,
				addY: ne,
				isInternalOnly: !0
			}),
			handler: t,
			scope: n.scope || O,
			flag: n.flag,
			reparse: n.reparse,
			leadChar: n.leadChar
		}), K.cache.flush("patterns");
	}, K.cache = function(e, t) {
		return T[e] || (T[e] = (0, u.default)(null)), T[e][t] || (T[e][t] = K(e, t));
	}, K.cache.flush = function(e) {
		e === "patterns" ? E = (0, u.default)(null) : T = (0, u.default)(null);
	}, K.escape = function(e) {
		return String(W(e)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, function(e) {
			return `\\u${se(ae(e.charCodeAt(0)))}`;
		});
	}, K.exec = function(e, t, n, r) {
		var i = "g", a = !1, o = !1, s;
		a = ne && !!(r || t.sticky && r !== !1), a ? i += "y" : r && (o = !0, i += "FakeY"), t[S] = t[S] || {};
		var c = t[S][i] || (t[S][i] = B(t, {
			addG: !0,
			addY: a,
			source: o ? `${t.source}|()` : void 0,
			removeY: r === !1,
			isInternalOnly: !0
		}));
		return n = n || 0, c.lastIndex = n, s = w.exec.call(c, e), o && s && s.pop() === "" && (s = null), t.global && (t.lastIndex = s ? c.lastIndex : 0), s;
	}, K.forEach = function(e, t, n) {
		for (var r = 0, i = -1, a; a = K.exec(e, t, r);) n(a, ++i, e, t), r = a.index + (a[0].length || 1);
	}, K.globalize = function(e) {
		return B(e, { addG: !0 });
	}, K.install = function(e) {
		e = le(e), !C.astral && e.astral && fe(!0), !C.namespacing && e.namespacing && G(!0);
	}, K.isInstalled = function(e) {
		return !!C[e];
	}, K.isRegExp = function(e) {
		return Object.prototype.toString.call(e) === "[object RegExp]";
	}, K.match = function(e, t, n) {
		var r = t.global && n !== "one" || n === "all", i = (r ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
		t[S] = t[S] || {};
		var a = t[S][i] || (t[S][i] = B(t, {
			addG: !!r,
			removeG: n === "one",
			isInternalOnly: !0
		})), o = String(W(e)).match(a);
		return t.global && (t.lastIndex = n === "one" && o ? o.index + o[0].length : 0), r ? o || [] : o && o[0];
	}, K.matchChain = function(e, t) {
		return function e(n, r) {
			var i = t[r].regex ? t[r] : { regex: t[r] }, a = [];
			function o(e) {
				if (i.backref) {
					var t = `Backreference to undefined group: ${i.backref}`, n = isNaN(i.backref);
					if (n && K.isInstalled("namespacing")) {
						if (!(e.groups && i.backref in e.groups)) throw ReferenceError(t);
					} else if (!e.hasOwnProperty(i.backref)) throw ReferenceError(t);
					var r = n && K.isInstalled("namespacing") ? e.groups[i.backref] : e[i.backref];
					a.push(r || "");
				} else a.push(e[0]);
			}
			var s = y(n), c;
			try {
				for (s.s(); !(c = s.n()).done;) {
					var l = c.value;
					(0, _.default)(K).call(K, l, i.regex, o);
				}
			} catch (e) {
				s.e(e);
			} finally {
				s.f();
			}
			return r === t.length - 1 || !a.length ? a : e(a, r + 1);
		}([e], 0);
	}, K.replace = function(e, t, n, r) {
		var i = K.isRegExp(t), a = t.global && r !== "one" || r === "all", o = (a ? "g" : "") + (t.sticky ? "y" : "") || "noGY", s = t;
		i ? (t[S] = t[S] || {}, s = t[S][o] || (t[S][o] = B(t, {
			addG: !!a,
			removeG: r === "one",
			isInternalOnly: !0
		}))) : a && (s = new RegExp(K.escape(String(t)), "g"));
		var c = w.replace.call(W(e), s, n);
		return i && t.global && (t.lastIndex = 0), c;
	}, K.replaceEach = function(e, t) {
		var n = y(t), r;
		try {
			for (n.s(); !(r = n.n()).done;) {
				var i = r.value;
				e = K.replace(e, i[0], i[1], i[2]);
			}
		} catch (e) {
			n.e(e);
		} finally {
			n.f();
		}
		return e;
	}, K.split = function(e, t, n) {
		return w.split.call(W(e), t, n);
	}, K.test = function(e, t, n, r) {
		return !!K.exec(e, t, n, r);
	}, K.uninstall = function(e) {
		e = le(e), C.astral && e.astral && fe(!1), C.namespacing && e.namespacing && G(!1);
	}, K.union = function(e, t, n) {
		n = n || {};
		var r = n.conjunction || "or", i = 0, a, o;
		function s(e, t, n) {
			var r = o[i - a];
			if (t) {
				if (++i, r) return `(?<${r}>`;
			} else if (n) return `\\${+n + a}`;
			return e;
		}
		if (!(U(e, "Array") && e.length)) throw TypeError("Must provide a nonempty array of patterns to merge");
		var c = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, l = [], u = y(e), d;
		try {
			for (u.s(); !(d = u.n()).done;) {
				var f = d.value;
				K.isRegExp(f) ? (a = i, o = f[S] && f[S].captureNames || [], l.push(K(f.source).source.replace(c, s))) : l.push(K.escape(f));
			}
		} catch (e) {
			u.e(e);
		} finally {
			u.f();
		}
		var p = r === "none" ? "" : "|";
		return K(l.join(p), t);
	}, w.exec = function(e) {
		var t = this.lastIndex, n = RegExp.prototype.exec.apply(this, arguments);
		if (n) {
			if (!M && n.length > 1 && (0, g.default)(n).call(n, "") !== -1) {
				var r, i = B(this, {
					removeG: !0,
					isInternalOnly: !0
				});
				(0, m.default)(r = String(e)).call(r, n.index).replace(i, function() {
					for (var e = arguments.length, t = 1; t < e - 2; ++t) (t < 0 || arguments.length <= t ? void 0 : arguments[t]) === void 0 && (n[t] = void 0);
				});
			}
			if (this[S] && this[S].captureNames) {
				var a = n;
				K.isInstalled("namespacing") && (n.groups = (0, u.default)(null), a = n.groups);
				for (var o = 1; o < n.length; ++o) {
					var s = this[S].captureNames[o - 1];
					s && (a[s] = n[o]);
				}
			} else !n.groups && K.isInstalled("namespacing") && (n.groups = void 0);
			this.global && !n[0].length && this.lastIndex > n.index && (this.lastIndex = n.index);
		}
		return this.global || (this.lastIndex = t), n;
	}, w.test = function(e) {
		return !!w.exec.call(this, e);
	}, w.match = function(e) {
		if (!K.isRegExp(e)) e = new RegExp(e);
		else if (e.global) {
			var t = String.prototype.match.apply(this, arguments);
			return e.lastIndex = 0, t;
		}
		return w.exec.call(e, W(this));
	}, w.replace = function(e, t) {
		var n = K.isRegExp(e), r, i, a;
		return n ? (e[S] && (i = e[S].captureNames), r = e.lastIndex) : e += "", a = U(t, "Function") ? String(this).replace(e, function() {
			var e = [...arguments];
			if (i) {
				var n;
				K.isInstalled("namespacing") ? (n = (0, u.default)(null), e.push(n)) : (e[0] = new String(e[0]), n = e[0]);
				for (var r = 0; r < i.length; ++r) i[r] && (n[i[r]] = e[r + 1]);
			}
			return t.apply(void 0, e);
		}) : String(W(this)).replace(e, function() {
			var e = [...arguments];
			return String(t).replace(j, n);
			function n(t, n, r, a) {
				n = n || r;
				var o = U(e[e.length - 1], "Object") ? 4 : 3, s = e.length - o;
				if (n) {
					if (/^\d+$/.test(n)) {
						var c = +n;
						if (c <= s) return e[c] || "";
					}
					var l = i ? (0, g.default)(i).call(i, n) : -1;
					if (l < 0) throw SyntaxError(`Backreference to undefined group ${t}`);
					return e[l + 1] || "";
				}
				if (a === "" || a === " ") throw SyntaxError(`Invalid token ${t}`);
				if (a === "&" || +a == 0) return e[0];
				if (a === "$") return "$";
				if (a === "`") {
					var u;
					return (0, m.default)(u = e[e.length - 1]).call(u, 0, e[e.length - 2]);
				}
				if (a === "'") {
					var d;
					return (0, m.default)(d = e[e.length - 1]).call(d, e[e.length - 2] + e[0].length);
				}
				if (a = +a, !isNaN(a)) {
					if (a > s) throw SyntaxError(`Backreference to undefined group ${t}`);
					return e[a] || "";
				}
				throw SyntaxError(`Invalid token ${t}`);
			}
		}), n && (e.global ? e.lastIndex = 0 : e.lastIndex = r), a;
	}, w.split = function(e, t) {
		if (!K.isRegExp(e)) return String.prototype.split.apply(this, arguments);
		var n = String(this), r = [], i = e.lastIndex, a = 0, o;
		return t = (t === void 0 ? -1 : t) >>> 0, (0, _.default)(K).call(K, n, e, function(e) {
			e.index + e[0].length > a && (r.push((0, m.default)(n).call(n, a, e.index)), e.length > 1 && e.index < n.length && Array.prototype.push.apply(r, (0, m.default)(e).call(e, 1)), o = e[0].length, a = e.index + o);
		}), a === n.length ? (!e.test("") || o) && r.push("") : r.push((0, m.default)(n).call(n, a)), e.lastIndex = i, r.length > t ? (0, m.default)(r).call(r, 0, t) : r;
	}, K.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function(e, t) {
		if (e[1] === "B" && t === O) return e[0];
		throw SyntaxError(`Invalid escape ${e[0]}`);
	}, {
		scope: "all",
		leadChar: "\\"
	}), K.addToken(/\\u{([\dA-Fa-f]+)}/, function(e, t, n) {
		var r = V(e[1]);
		if (r > 1114111) throw SyntaxError(`Invalid Unicode code point ${e[0]}`);
		if (r <= 65535) return `\\u${se(ae(r))}`;
		if (te && (0, g.default)(n).call(n, "u") !== -1) return e[0];
		throw SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
	}, {
		scope: "all",
		leadChar: "\\"
	}), K.addToken(/\(\?#[^)]*\)/, H, { leadChar: "(" }), K.addToken(/\s+|#[^\n]*\n?/, H, { flag: "x" }), F || K.addToken(/\./, function() {
		return "[\\s\\S]";
	}, {
		flag: "s",
		leadChar: "."
	}), K.addToken(/\\k<([^>]+)>/, function(e) {
		var t, n, r = isNaN(e[1]) ? (0, g.default)(t = this.captureNames).call(t, e[1]) + 1 : +e[1], i = e.index + e[0].length;
		if (!r || r > this.captureNames.length) throw SyntaxError(`Backreference to undefined group ${e[0]}`);
		return (0, v.default)(n = `\\${r}`).call(n, i === e.input.length || isNaN(e.input[i]) ? "" : "(?:)");
	}, { leadChar: "\\" }), K.addToken(/\\(\d+)/, function(e, t) {
		if (!(t === O && /^[1-9]/.test(e[1]) && +e[1] <= this.captureNames.length) && e[1] !== "0") throw SyntaxError(`Cannot use octal escape or backreference to undefined group ${e[0]}`);
		return e[0];
	}, {
		scope: "all",
		leadChar: "\\"
	}), K.addToken(/\(\?P?<((?:[\$A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2-\uDFF6]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])(?:[\$0-9A-Z_a-z\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05EF-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u07FD\u0800-\u082D\u0840-\u085B\u0860-\u086A\u0870-\u0887\u0889-\u088F\u0897-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u09FE\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3C-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C5C\u0C5D\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDC-\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1-\u0CF3\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECE\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1715\u171F-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u1820-\u1878\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1ABF-\u1ADD\u1AE0-\u1AEB\u1B00-\u1B4C\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CD0-\u1CD2\u1CD4-\u1CFA\u1D00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA827\uA82C\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF65-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDD30-\uDD39\uDD40-\uDD65\uDD69-\uDD6D\uDD6F-\uDD85\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDEC2-\uDEC7\uDEFA-\uDF1C\uDF27\uDF30-\uDF50\uDF70-\uDF85\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC46\uDC66-\uDC75\uDC7F-\uDCBA\uDCC2\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD44-\uDD47\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDC9-\uDDCC\uDDCE-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E-\uDE41\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3B-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7-\uDFC0\uDFC2\uDFC5\uDFC7-\uDFCA\uDFCC-\uDFD3\uDFE1\uDFE2]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC5E-\uDC61\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB8\uDEC0-\uDEC9\uDED0-\uDEE3\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF39\uDF40-\uDF46]|\uD806[\uDC00-\uDC3A\uDCA0-\uDCE9\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD43\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE1\uDDE3\uDDE4\uDE00-\uDE3E\uDE47\uDE50-\uDE99\uDE9D\uDEB0-\uDEF8\uDF60-\uDF67\uDFC0-\uDFE0\uDFF0-\uDFF9]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9\uDDB0-\uDDDB\uDDE0-\uDDE9\uDEE0-\uDEF6\uDF00-\uDF10\uDF12-\uDF3A\uDF3E-\uDF42\uDF50-\uDF5A\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC40-\uDC55\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD39]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDD70-\uDD79\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFE4\uDFF0-\uDFF6]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD833[\uDCF0-\uDCF9\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC30-\uDC6D\uDC8F\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAE\uDEC0-\uDEF9]|\uD839[\uDCD0-\uDCF9\uDDD0-\uDDFA\uDEC0-\uDEDE\uDEE0-\uDEF5\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4B\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]|\uDB40[\uDD00-\uDDEF])*)>/, function(e) {
		var t;
		if (!K.isInstalled("namespacing") && (e[1] === "length" || e[1] === "__proto__")) throw SyntaxError(`Cannot use reserved word as capture name ${e[0]}`);
		if ((0, g.default)(t = this.captureNames).call(t, e[1]) !== -1) throw SyntaxError(`Cannot use same name for multiple groups ${e[0]}`);
		return this.captureNames.push(e[1]), this.hasNamedCapture = !0, "(";
	}, { leadChar: "(" }), K.addToken(/\((?!\?)/, function(e, t, n) {
		return (0, g.default)(n).call(n, "n") === -1 ? (this.captureNames.push(null), "(") : "(?:";
	}, {
		optionalFlags: "n",
		leadChar: "("
	}), e.default = K, t.exports = e.default;
})), Ni = /* @__PURE__ */ O(((e, t) => {
	var n = G(), r = ve(), i = V(), a = Ke(), o = TypeError, s = "Reduce of empty array with no initial value", c = function(e) {
		return function(t, c, l, u) {
			var d = r(t), f = i(d), p = a(d);
			if (n(c), p === 0 && l < 2) throw new o(s);
			var m = e ? p - 1 : 0, h = e ? -1 : 1;
			if (l < 2) for (;;) {
				if (m in f) {
					u = f[m], m += h;
					break;
				}
				if (m += h, e ? m < 0 : p <= m) throw new o(s);
			}
			for (; e ? m >= 0 : p > m; m += h) m in f && (u = c(u, f[m], m, d));
			return u;
		};
	};
	t.exports = {
		left: c(!1),
		right: c(!0)
	};
})), Pi = /* @__PURE__ */ O(((e, t) => {
	var n = M(), r = se(), i = te(), a = function(e) {
		return r.slice(0, e.length) === e;
	};
	t.exports = (function() {
		return a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : n.Bun && typeof Bun.version == "string" ? "BUN" : n.Deno && typeof Deno.version == "object" ? "DENO" : i(n.process) === "process" ? "NODE" : n.window && n.document ? "BROWSER" : "REST";
	})();
})), Fi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Pi() === "NODE";
})), Ii = /* @__PURE__ */ O((() => {
	var e = q(), t = Ni().left, n = ei(), r = ce();
	e({
		target: "Array",
		proto: !0,
		forced: !Fi() && r > 79 && r < 83 || !n("reduce")
	}, { reduce: function(e) {
		var n = arguments.length;
		return t(this, e, n, n > 1 ? arguments[1] : void 0);
	} });
})), Li = /* @__PURE__ */ O(((e, t) => {
	Ii(), t.exports = Qe()("Array", "reduce");
})), Ri = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Li(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.reduce;
		return e === i || n(i, e) && t === i.reduce ? r : t;
	};
})), zi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ri();
})), Bi = /* @__PURE__ */ O(((e, t) => {
	t.exports = zi();
})), Vi = /* @__PURE__ */ O((() => {
	var e = q(), t = tn().map;
	e({
		target: "Array",
		proto: !0,
		forced: !Ye()("map")
	}, { map: function(e) {
		return t(this, e, arguments.length > 1 ? arguments[1] : void 0);
	} });
})), Hi = /* @__PURE__ */ O(((e, t) => {
	Vi(), t.exports = Qe()("Array", "map");
})), Ui = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Hi(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.map;
		return e === i || n(i, e) && t === i.map ? r : t;
	};
})), Wi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ui();
})), Gi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Wi();
})), Ki = /* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Bi()), a = r(Gi()), o = r(bi()), s = r(ji());
	e.default = function(e) {
		var t = "xregexp", n = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, r = e.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, n], "g", { conjunction: "or" });
		function c(e) {
			var t = /^(?:\(\?:\))*\^/, n = /\$(?:\(\?:\))*$/;
			return t.test(e) && n.test(e) && n.test(e.replace(/\\[\s\S]/g, "")) ? e.replace(t, "").replace(n, "") : e;
		}
		function l(n, r) {
			var i = r ? "x" : "";
			return e.isRegExp(n) ? n[t] && n[t].captureNames ? n : e(n.source, i) : e(n, i);
		}
		function u(t) {
			return t instanceof RegExp ? t : e.escape(t);
		}
		function d(e, t, n) {
			return e[`subpattern${n}`] = t, e;
		}
		function f(e, t, n) {
			return e + (t < n.length - 1 ? `{{subpattern${t}}}` : "");
		}
		e.tag = function(t) {
			return function(n) {
				var r, o, s = [...arguments].slice(1), c = (0, i.default)(r = (0, a.default)(s).call(s, u)).call(r, d, {}), l = (0, a.default)(o = n.raw).call(o, f).join("");
				return e.build(l, c, t);
			};
		}, e.build = function(i, a, u) {
			u = u || "";
			var d = (0, o.default)(u).call(u, "x") !== -1, f = /^\(\?([\w$]+)\)/.exec(i);
			f && (u = e._clipDuplicates(u + f[1]));
			var p = {};
			for (var m in a) if (a.hasOwnProperty(m)) {
				var h = l(a[m], d);
				p[m] = {
					pattern: c(h.source),
					names: h[t].captureNames || []
				};
			}
			var g = l(i, d), _ = 0, v, y = 0, b = [0], x = g[t].captureNames || [];
			return e(g.source.replace(r, function(e, t, r, i, a) {
				var o = t || r, c, l, u;
				if (o) {
					var d;
					if (!p.hasOwnProperty(o)) throw ReferenceError(`Undefined property ${e}`);
					t ? (c = x[y], b[++y] = ++_, l = `(?<${c || o}>`) : l = "(?:", v = _;
					var f = p[o].pattern.replace(n, function(e, t, n) {
						if (t) {
							if (c = p[o].names[_ - v], ++_, c) return `(?<${c}>`;
						} else if (n) return u = n - 1, p[o].names[u] ? `\\k<${p[o].names[u]}>` : `\\${+n + v}`;
						return e;
					});
					return (0, s.default)(d = `${l}`).call(d, f, ")");
				}
				if (i) {
					if (c = x[y], b[++y] = ++_, c) return `(?<${c}>`;
				} else if (a) return u = a - 1, x[u] ? `\\k<${x[u]}>` : `\\${b[+a]}`;
				return e;
			}), u);
		};
	}, t.exports = e.default;
})), qi = /* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(bi()), a = r(ji()), o = r(nt());
	e.default = function(e) {
		function t(e, t, n, r) {
			return {
				name: e,
				value: t,
				start: n,
				end: r
			};
		}
		e.matchRecursive = function(n, r, s, c, l) {
			c = c || "", l = l || {};
			var u = (0, i.default)(c).call(c, "g") !== -1, d = (0, i.default)(c).call(c, "y") !== -1, f = c.replace(/y/g, "");
			r = e(r, f), s = e(s, f);
			var p, m = l.escapeChar;
			if (m) {
				var h, g;
				if (m.length > 1) throw Error("Cannot use more than one escape character");
				m = e.escape(m), p = new RegExp((0, a.default)(h = (0, a.default)(g = `(?:${m}[\\S\\s]|(?:(?!`).call(g, e.union([r, s], "", { conjunction: "or" }).source, ")[^")).call(h, m, "])+)+"), c.replace(e._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, ""));
			}
			for (var _ = 0, v = 0, y = 0, b = 0, x, S, C, w, T = l.valueNames, E = [];;) {
				if (m && (y += (e.exec(n, p, y, "sticky") || [""])[0].length), C = e.exec(n, r, y), w = e.exec(n, s, y), C && w && (C.index <= w.index ? w = null : C = null), C || w) v = (C || w).index, y = v + (C || w)[0].length;
				else if (!_) break;
				if (d && !_ && v > b) break;
				if (C) _ || (x = v, S = y), _ += 1;
				else if (w && _) {
					if (--_, !_ && (T ? (T[0] && x > b && E.push(t(T[0], (0, o.default)(n).call(n, b, x), b, x)), T[1] && E.push(t(T[1], (0, o.default)(n).call(n, x, S), x, S)), T[2] && E.push(t(T[2], (0, o.default)(n).call(n, S, v), S, v)), T[3] && E.push(t(T[3], (0, o.default)(n).call(n, v, y), v, y))) : E.push((0, o.default)(n).call(n, S, v)), b = y, !u)) break;
				} else {
					var D = l.unbalanced || "error";
					if (D === "skip" || D === "skip-lazy") {
						if (w) w = null;
						else {
							if (D === "skip") {
								var O = e.exec(n, r, x, "sticky")[0].length;
								y = x + (O || 1);
							} else y = x + 1;
							_ = 0;
						}
					} else if (D === "error") {
						var k, A = w ? "right" : "left", j = w ? v : x;
						throw Error((0, a.default)(k = `Unbalanced ${A} delimiter found in string at position `).call(k, j));
					} else throw Error(`Unsupported value for unbalanced: ${D}`);
				}
				v === y && (y += 1);
			}
			return u && E.length > 0 && !d && T && T[0] && n.length > b && E.push(t(T[0], (0, o.default)(n).call(n, b), b, n.length)), E;
		};
	}, t.exports = e.default;
})), Ji = /* @__PURE__ */ O(((e, t) => {
	var n = nt(), r = Ht(), i = Rn(), a = Wn(), o = Jn(), s = Fe(), c = Ie();
	s(e, "__esModule", { value: !0 }), e.default = void 0;
	var l = c(Fr()), u = c(Di()), d = c(ji()), f = c(bi());
	function p(e, t) {
		var n = i !== void 0 && a(e) || e["@@iterator"];
		if (!n) {
			if (o(e) || (n = m(e)) || t && e && typeof e.length == "number") {
				n && (e = n);
				var r = 0, s = function() {};
				return {
					s,
					n: function() {
						return r >= e.length ? { done: !0 } : {
							done: !1,
							value: e[r++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: s
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var c, l = !0, u = !1;
		return {
			s: function() {
				n = n.call(e);
			},
			n: function() {
				var e = n.next();
				return l = e.done, e;
			},
			e: function(e) {
				u = !0, c = e;
			},
			f: function() {
				try {
					l || n.return == null || n.return();
				} finally {
					if (u) throw c;
				}
			}
		};
	}
	function m(e, t) {
		if (e) {
			var i;
			if (typeof e == "string") return h(e, t);
			var a = n(i = {}.toString.call(e)).call(i, 8, -1);
			return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? r(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? h(e, t) : void 0;
		}
	}
	function h(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	e.default = function(e) {
		var t = {}, n = {}, r = e._dec, i = e._hex, a = e._pad4;
		function o(e) {
			return e.replace(/[- _]+/g, "").toLowerCase();
		}
		function s(e) {
			var t = /^\\[xu](.+)/.exec(e);
			return t ? r(t[1]) : e.charCodeAt(+(e[0] === "\\"));
		}
		function c(t) {
			var n = "", r = -1;
			return (0, u.default)(e).call(e, t, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function(e) {
				var t = s(e[1]);
				t > r + 1 && (n += `\\u${a(i(r + 1))}`, t > r + 2 && (n += `-\\u${a(i(t - 1))}`)), r = s(e[2] || e[1]);
			}), r < 65535 && (n += `\\u${a(i(r + 1))}`, r < 65534 && (n += "-\\uFFFF")), n;
		}
		function m(e) {
			var n = "b!";
			return t[e][n] || (t[e][n] = c(t[e].bmp));
		}
		function h(e, n) {
			var r = t[e], i = "";
			if (r.bmp && !r.isBmpLast) {
				var a;
				i = (0, d.default)(a = `[${r.bmp}]`).call(a, r.astral ? "|" : "");
			}
			if (r.astral && (i += r.astral), r.isBmpLast && r.bmp) {
				var o;
				i += (0, d.default)(o = `${r.astral ? "|" : ""}[`).call(o, r.bmp, "]");
			}
			return n ? `(?:(?!${i})(?:[�d800-�dbff][�dc00-�dfff]|[ -￿]))` : `(?:${i})`;
		}
		function g(e, n) {
			var r = n ? "a!" : "a=";
			return t[e][r] || (t[e][r] = h(e, n));
		}
		e.addToken(/\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/, function(e, r, i) {
			var a = "Invalid double negation ", s = "Unknown Unicode token ", c = "Unicode token missing data ", u = "Astral mode required for Unicode token ", p = "Astral mode does not support Unicode tokens within character classes", h = (0, l.default)(e, 6), _ = h[0], v = h[1], y = h[2], b = h[3], x = h[4], S = h[5], C = v === "P" || !!y, w = (0, f.default)(i).call(i, "A") !== -1, T = o(S || x), E = t[T];
			if (v === "P" && y) throw SyntaxError(a + _);
			if (!t.hasOwnProperty(T) || b && !(n[b] && n[b][T])) throw SyntaxError(s + _);
			if (E.inverseOf) {
				if (T = o(E.inverseOf), !t.hasOwnProperty(T)) {
					var D;
					throw ReferenceError((0, d.default)(D = `${c + _} -> `).call(D, E.inverseOf));
				}
				E = t[T], C = !C;
			}
			if (!(E.bmp || w)) throw SyntaxError(u + _);
			if (w) {
				if (r === "class") throw SyntaxError(p);
				return g(T, C);
			}
			return r === "class" ? C ? m(T) : E.bmp : `${(C ? "[^" : "[") + E.bmp}]`;
		}, {
			scope: "all",
			optionalFlags: "A",
			leadChar: "\\"
		}), e.addUnicodeData = function(r, i) {
			var a = "Unicode token requires name", s = "Unicode token has no character data ";
			i && (n[i] = {});
			var c = p(r), l;
			try {
				for (c.s(); !(l = c.n()).done;) {
					var u = l.value;
					if (!u.name) throw Error(a);
					if (!(u.inverseOf || u.bmp || u.astral)) throw Error(s + u.name);
					var d = o(u.name);
					if (t[d] = u, i && (n[i][d] = !0), u.alias) {
						var f = o(u.alias);
						t[f] = u, i && (n[i][f] = !0);
					}
				}
			} catch (e) {
				c.e(e);
			} finally {
				c.f();
			}
			e.cache.flush("patterns");
		}, e._getUnicodeProperty = function(e) {
			return t[o(e)];
		};
	}, t.exports = e.default;
})), Yi = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "C",
			alias: "Other",
			isBmpLast: !0,
			bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
			astral: "\ud800[\udc0c\udc27\udc3b\udc3e\udc4e\udc4f\udc5e-\udc7f\udcfb-\udcff\udd03-\udd06\udd34-\udd36\udd8f\udd9d-\udd9f\udda1-\uddcf\uddfe-\ude7f\ude9d-\ude9f\uded1-\udedf\udefc-\udeff\udf24-\udf2c\udf4b-\udf4f\udf7b-\udf7f\udf9e\udfc4-\udfc7\udfd6-\udfff]|\ud801[\udc9e\udc9f\udcaa-\udcaf\udcd4-\udcd7\udcfc-\udcff\udd28-\udd2f\udd64-\udd6e\udd7b\udd8b\udd93\udd96\udda2\uddb2\uddba\uddbd-\uddff\udf37-\udf3f\udf56-\udf5f\udf68-\udf7f\udf86\udfb1\udfbb-\udfff]|\ud802[\udc06\udc07\udc09\udc36\udc39-\udc3b\udc3d\udc3e\udc56\udc9f-\udca6\udcb0-\udcdf\udcf3\udcf6-\udcfa\udd1c-\udd1e\udd3a-\udd3e\udd40-\udd7f\uddb8-\uddbb\uddd0\uddd1\ude04\ude07-\ude0b\ude14\ude18\ude36\ude37\ude3b-\ude3e\ude49-\ude4f\ude59-\ude5f\udea0-\udebf\udee7-\udeea\udef7-\udeff\udf36-\udf38\udf56\udf57\udf73-\udf77\udf92-\udf98\udf9d-\udfa8\udfb0-\udfff]|\ud803[\udc49-\udc7f\udcb3-\udcbf\udcf3-\udcf9\udd28-\udd2f\udd3a-\ude5f\ude7f\udeaa\udeae\udeaf\udeb2-\udeff\udf28-\udf2f\udf5a-\udf6f\udf8a-\udfaf\udfcc-\udfdf\udff7-\udfff]|\ud804[\udc4e-\udc51\udc76-\udc7e\udcbd\udcc3-\udccf\udce9-\udcef\udcfa-\udcff\udd35\udd48-\udd4f\udd77-\udd7f\udde0\uddf5-\uddff\ude12\ude3f-\ude7f\ude87\ude89\ude8e\ude9e\udeaa-\udeaf\udeeb-\udeef\udefa-\udeff\udf04\udf0d\udf0e\udf11\udf12\udf29\udf31\udf34\udf3a\udf45\udf46\udf49\udf4a\udf4e\udf4f\udf51-\udf56\udf58-\udf5c\udf64\udf65\udf6d-\udf6f\udf75-\udfff]|\ud805[\udc5c\udc62-\udc7f\udcc8-\udccf\udcda-\udd7f\uddb6\uddb7\uddde-\uddff\ude45-\ude4f\ude5a-\ude5f\ude6d-\ude7f\udeba-\udebf\udeca-\udeff\udf1b\udf1c\udf2c-\udf2f\udf47-\udfff]|\ud806[\udc3c-\udc9f\udcf3-\udcfe\udd07\udd08\udd0a\udd0b\udd14\udd17\udd36\udd39\udd3a\udd47-\udd4f\udd5a-\udd9f\udda8\udda9\uddd8\uddd9\udde5-\uddff\ude48-\ude4f\udea3-\udeaf\udef9-\udfff]|\ud807[\udc09\udc37\udc46-\udc4f\udc6d-\udc6f\udc90\udc91\udca8\udcb7-\udcff\udd07\udd0a\udd37-\udd39\udd3b\udd3e\udd48-\udd4f\udd5a-\udd5f\udd66\udd69\udd8f\udd92\udd99-\udd9f\uddaa-\udedf\udef9-\udfaf\udfb1-\udfbf\udff2-\udffe]|\ud808[\udf9a-\udfff]|\ud809[\udc6f\udc75-\udc7f\udd44-\udfff]|[\ud80a\ud80e-\ud810\ud812-\ud819\ud824-\ud82a\ud82d\ud82e\ud830-\ud832\ud83f\ud87b-\ud87d\ud87f\ud885-\udb3f\udb41-\udbff][\udc00-\udfff]|\ud80b[\udc00-\udf8f\udff3-\udfff]|\ud80d[\udc2f-\udfff]|\ud811[\ude47-\udfff]|\ud81a[\ude39-\ude3f\ude5f\ude6a-\ude6d\udebf\udeca-\udecf\udeee\udeef\udef6-\udeff\udf46-\udf4f\udf5a\udf62\udf78-\udf7c\udf90-\udfff]|\ud81b[\udc00-\ude3f\ude9b-\udeff\udf4b-\udf4e\udf88-\udf8e\udfa0-\udfdf\udfe5-\udfef\udff2-\udfff]|\ud821[\udff8-\udfff]|\ud823[\udcd6-\udcff\udd09-\udfff]|\ud82b[\udc00-\udfef\udff4\udffc\udfff]|\ud82c[\udd23-\udd4f\udd53-\udd63\udd68-\udd6f\udefc-\udfff]|\ud82f[\udc6b-\udc6f\udc7d-\udc7f\udc89-\udc8f\udc9a\udc9b\udca0-\udfff]|\ud833[\udc00-\udeff\udf2e\udf2f\udf47-\udf4f\udfc4-\udfff]|\ud834[\udcf6-\udcff\udd27\udd28\udd73-\udd7a\uddeb-\uddff\ude46-\udedf\udef4-\udeff\udf57-\udf5f\udf79-\udfff]|\ud835[\udc55\udc9d\udca0\udca1\udca3\udca4\udca7\udca8\udcad\udcba\udcbc\udcc4\udd06\udd0b\udd0c\udd15\udd1d\udd3a\udd3f\udd45\udd47-\udd49\udd51\udea6\udea7\udfcc\udfcd]|\ud836[\ude8c-\ude9a\udea0\udeb0-\udfff]|\ud837[\udc00-\udeff\udf1f-\udfff]|\ud838[\udc07\udc19\udc1a\udc22\udc25\udc2b-\udcff\udd2d-\udd2f\udd3e\udd3f\udd4a-\udd4d\udd50-\ude8f\udeaf-\udebf\udefa-\udefe\udf00-\udfff]|\ud839[\udc00-\udfdf\udfe7\udfec\udfef\udfff]|\ud83a[\udcc5\udcc6\udcd7-\udcff\udd4c-\udd4f\udd5a-\udd5d\udd60-\udfff]|\ud83b[\udc00-\udc70\udcb5-\udd00\udd3e-\uddff\ude04\ude20\ude23\ude25\ude26\ude28\ude33\ude38\ude3a\ude3c-\ude41\ude43-\ude46\ude48\ude4a\ude4c\ude50\ude53\ude55\ude56\ude58\ude5a\ude5c\ude5e\ude60\ude63\ude65\ude66\ude6b\ude73\ude78\ude7d\ude7f\ude8a\ude9c-\udea0\udea4\udeaa\udebc-\udeef\udef2-\udfff]|\ud83c[\udc2c-\udc2f\udc94-\udc9f\udcaf\udcb0\udcc0\udcd0\udcf6-\udcff\uddae-\udde5\ude03-\ude0f\ude3c-\ude3f\ude49-\ude4f\ude52-\ude5f\ude66-\udeff]|\ud83d[\uded8-\udedc\udeed-\udeef\udefd-\udeff\udf74-\udf7f\udfd9-\udfdf\udfec-\udfef\udff1-\udfff]|\ud83e[\udc0c-\udc0f\udc48-\udc4f\udc5a-\udc5f\udc88-\udc8f\udcae\udcaf\udcb2-\udcff\ude54-\ude5f\ude6e\ude6f\ude75-\ude77\ude7d-\ude7f\ude87-\ude8f\udead-\udeaf\udebb-\udebf\udec6-\udecf\udeda-\udedf\udee8-\udeef\udef7-\udeff\udf93\udfcb-\udfef\udffa-\udfff]|\ud869[\udee0-\udeff]|\ud86d[\udf39-\udf3f]|\ud86e[\udc1e\udc1f]|\ud873[\udea2-\udeaf]|\ud87a[\udfe1-\udfff]|\ud87e[\ude1e-\udfff]|\ud884[\udf4b-\udfff]|\udb40[\udc00-\udcff\uddf0-\udfff]"
		},
		{
			name: "Cc",
			alias: "Control",
			bmp: "\0--"
		},
		{
			name: "Cf",
			alias: "Format",
			bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯﻿￹-￻",
			astral: "\ud804[\udcbd\udccd]|\ud80d[\udc30-\udc38]|\ud82f[\udca0-\udca3]|\ud834[\udd73-\udd7a]|\udb40[\udc01\udc20-\udc7f]"
		},
		{
			name: "Cn",
			alias: "Unassigned",
			bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
			astral: "\ud800[\udc0c\udc27\udc3b\udc3e\udc4e\udc4f\udc5e-\udc7f\udcfb-\udcff\udd03-\udd06\udd34-\udd36\udd8f\udd9d-\udd9f\udda1-\uddcf\uddfe-\ude7f\ude9d-\ude9f\uded1-\udedf\udefc-\udeff\udf24-\udf2c\udf4b-\udf4f\udf7b-\udf7f\udf9e\udfc4-\udfc7\udfd6-\udfff]|\ud801[\udc9e\udc9f\udcaa-\udcaf\udcd4-\udcd7\udcfc-\udcff\udd28-\udd2f\udd64-\udd6e\udd7b\udd8b\udd93\udd96\udda2\uddb2\uddba\uddbd-\uddff\udf37-\udf3f\udf56-\udf5f\udf68-\udf7f\udf86\udfb1\udfbb-\udfff]|\ud802[\udc06\udc07\udc09\udc36\udc39-\udc3b\udc3d\udc3e\udc56\udc9f-\udca6\udcb0-\udcdf\udcf3\udcf6-\udcfa\udd1c-\udd1e\udd3a-\udd3e\udd40-\udd7f\uddb8-\uddbb\uddd0\uddd1\ude04\ude07-\ude0b\ude14\ude18\ude36\ude37\ude3b-\ude3e\ude49-\ude4f\ude59-\ude5f\udea0-\udebf\udee7-\udeea\udef7-\udeff\udf36-\udf38\udf56\udf57\udf73-\udf77\udf92-\udf98\udf9d-\udfa8\udfb0-\udfff]|\ud803[\udc49-\udc7f\udcb3-\udcbf\udcf3-\udcf9\udd28-\udd2f\udd3a-\ude5f\ude7f\udeaa\udeae\udeaf\udeb2-\udeff\udf28-\udf2f\udf5a-\udf6f\udf8a-\udfaf\udfcc-\udfdf\udff7-\udfff]|\ud804[\udc4e-\udc51\udc76-\udc7e\udcc3-\udccc\udcce\udccf\udce9-\udcef\udcfa-\udcff\udd35\udd48-\udd4f\udd77-\udd7f\udde0\uddf5-\uddff\ude12\ude3f-\ude7f\ude87\ude89\ude8e\ude9e\udeaa-\udeaf\udeeb-\udeef\udefa-\udeff\udf04\udf0d\udf0e\udf11\udf12\udf29\udf31\udf34\udf3a\udf45\udf46\udf49\udf4a\udf4e\udf4f\udf51-\udf56\udf58-\udf5c\udf64\udf65\udf6d-\udf6f\udf75-\udfff]|\ud805[\udc5c\udc62-\udc7f\udcc8-\udccf\udcda-\udd7f\uddb6\uddb7\uddde-\uddff\ude45-\ude4f\ude5a-\ude5f\ude6d-\ude7f\udeba-\udebf\udeca-\udeff\udf1b\udf1c\udf2c-\udf2f\udf47-\udfff]|\ud806[\udc3c-\udc9f\udcf3-\udcfe\udd07\udd08\udd0a\udd0b\udd14\udd17\udd36\udd39\udd3a\udd47-\udd4f\udd5a-\udd9f\udda8\udda9\uddd8\uddd9\udde5-\uddff\ude48-\ude4f\udea3-\udeaf\udef9-\udfff]|\ud807[\udc09\udc37\udc46-\udc4f\udc6d-\udc6f\udc90\udc91\udca8\udcb7-\udcff\udd07\udd0a\udd37-\udd39\udd3b\udd3e\udd48-\udd4f\udd5a-\udd5f\udd66\udd69\udd8f\udd92\udd99-\udd9f\uddaa-\udedf\udef9-\udfaf\udfb1-\udfbf\udff2-\udffe]|\ud808[\udf9a-\udfff]|\ud809[\udc6f\udc75-\udc7f\udd44-\udfff]|[\ud80a\ud80e-\ud810\ud812-\ud819\ud824-\ud82a\ud82d\ud82e\ud830-\ud832\ud83f\ud87b-\ud87d\ud87f\ud885-\udb3f\udb41-\udb7f][\udc00-\udfff]|\ud80b[\udc00-\udf8f\udff3-\udfff]|\ud80d[\udc2f\udc39-\udfff]|\ud811[\ude47-\udfff]|\ud81a[\ude39-\ude3f\ude5f\ude6a-\ude6d\udebf\udeca-\udecf\udeee\udeef\udef6-\udeff\udf46-\udf4f\udf5a\udf62\udf78-\udf7c\udf90-\udfff]|\ud81b[\udc00-\ude3f\ude9b-\udeff\udf4b-\udf4e\udf88-\udf8e\udfa0-\udfdf\udfe5-\udfef\udff2-\udfff]|\ud821[\udff8-\udfff]|\ud823[\udcd6-\udcff\udd09-\udfff]|\ud82b[\udc00-\udfef\udff4\udffc\udfff]|\ud82c[\udd23-\udd4f\udd53-\udd63\udd68-\udd6f\udefc-\udfff]|\ud82f[\udc6b-\udc6f\udc7d-\udc7f\udc89-\udc8f\udc9a\udc9b\udca4-\udfff]|\ud833[\udc00-\udeff\udf2e\udf2f\udf47-\udf4f\udfc4-\udfff]|\ud834[\udcf6-\udcff\udd27\udd28\uddeb-\uddff\ude46-\udedf\udef4-\udeff\udf57-\udf5f\udf79-\udfff]|\ud835[\udc55\udc9d\udca0\udca1\udca3\udca4\udca7\udca8\udcad\udcba\udcbc\udcc4\udd06\udd0b\udd0c\udd15\udd1d\udd3a\udd3f\udd45\udd47-\udd49\udd51\udea6\udea7\udfcc\udfcd]|\ud836[\ude8c-\ude9a\udea0\udeb0-\udfff]|\ud837[\udc00-\udeff\udf1f-\udfff]|\ud838[\udc07\udc19\udc1a\udc22\udc25\udc2b-\udcff\udd2d-\udd2f\udd3e\udd3f\udd4a-\udd4d\udd50-\ude8f\udeaf-\udebf\udefa-\udefe\udf00-\udfff]|\ud839[\udc00-\udfdf\udfe7\udfec\udfef\udfff]|\ud83a[\udcc5\udcc6\udcd7-\udcff\udd4c-\udd4f\udd5a-\udd5d\udd60-\udfff]|\ud83b[\udc00-\udc70\udcb5-\udd00\udd3e-\uddff\ude04\ude20\ude23\ude25\ude26\ude28\ude33\ude38\ude3a\ude3c-\ude41\ude43-\ude46\ude48\ude4a\ude4c\ude50\ude53\ude55\ude56\ude58\ude5a\ude5c\ude5e\ude60\ude63\ude65\ude66\ude6b\ude73\ude78\ude7d\ude7f\ude8a\ude9c-\udea0\udea4\udeaa\udebc-\udeef\udef2-\udfff]|\ud83c[\udc2c-\udc2f\udc94-\udc9f\udcaf\udcb0\udcc0\udcd0\udcf6-\udcff\uddae-\udde5\ude03-\ude0f\ude3c-\ude3f\ude49-\ude4f\ude52-\ude5f\ude66-\udeff]|\ud83d[\uded8-\udedc\udeed-\udeef\udefd-\udeff\udf74-\udf7f\udfd9-\udfdf\udfec-\udfef\udff1-\udfff]|\ud83e[\udc0c-\udc0f\udc48-\udc4f\udc5a-\udc5f\udc88-\udc8f\udcae\udcaf\udcb2-\udcff\ude54-\ude5f\ude6e\ude6f\ude75-\ude77\ude7d-\ude7f\ude87-\ude8f\udead-\udeaf\udebb-\udebf\udec6-\udecf\udeda-\udedf\udee8-\udeef\udef7-\udeff\udf93\udfcb-\udfef\udffa-\udfff]|\ud869[\udee0-\udeff]|\ud86d[\udf39-\udf3f]|\ud86e[\udc1e\udc1f]|\ud873[\udea2-\udeaf]|\ud87a[\udfe1-\udfff]|\ud87e[\ude1e-\udfff]|\ud884[\udf4b-\udfff]|\udb40[\udc00\udc02-\udc1f\udc80-\udcff\uddf0-\udfff]|[\udbbf\udbff][\udffe\udfff]"
		},
		{
			name: "Co",
			alias: "Private_Use",
			bmp: "-",
			astral: "[\udb80-\udbbe\udbc0-\udbfe][\udc00-\udfff]|[\udbbf\udbff][\udc00-\udffd]"
		},
		{
			name: "Cs",
			alias: "Surrogate",
			bmp: "\ud800-\udfff"
		},
		{
			name: "L",
			alias: "Letter",
			bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf40\udf42-\udf49\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\ude00-\udf36\udf40-\udf55\udf60-\udf67\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd23\ude80-\udea9\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc03-\udc37\udc71\udc72\udc75\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd47\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f-\udc61\udc80-\udcaf\udcc4\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a\udf40-\udf46]|\ud806[\udc00-\udc2b\udca0-\udcdf\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd2f\udd3f\udd41\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67\udd68\udd6a-\udd89\udd98\udee0-\udef2\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf50\udf93-\udf9f\udfe0\udfe1\udfe3]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf1e]|\ud838[\udd00-\udd2c\udd37-\udd3d\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "LC",
			alias: "Cased_Letter",
			bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
			astral: "\ud801[\udc00-\udc4f\udcb0-\udcd3\udcd8-\udcfb\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]|\ud803[\udc80-\udcb2\udcc0-\udcf2]|\ud806[\udca0-\udcdf]|\ud81b[\ude40-\ude7f]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd00-\udd43]"
		},
		{
			name: "Ll",
			alias: "Lowercase_Letter",
			bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
			astral: "\ud801[\udc28-\udc4f\udcd8-\udcfb\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]|\ud803[\udcc0-\udcf2]|\ud806[\udcc0-\udcdf]|\ud81b[\ude60-\ude7f]|\ud835[\udc1a-\udc33\udc4e-\udc54\udc56-\udc67\udc82-\udc9b\udcb6-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udccf\udcea-\udd03\udd1e-\udd37\udd52-\udd6b\udd86-\udd9f\uddba-\uddd3\uddee-\ude07\ude22-\ude3b\ude56-\ude6f\ude8a-\udea5\udec2-\udeda\udedc-\udee1\udefc-\udf14\udf16-\udf1b\udf36-\udf4e\udf50-\udf55\udf70-\udf88\udf8a-\udf8f\udfaa-\udfc2\udfc4-\udfc9\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd22-\udd43]"
		},
		{
			name: "Lm",
			alias: "Modifier_Letter",
			bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
			astral: "\ud801[\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud81a[\udf40-\udf43]|\ud81b[\udf93-\udf9f\udfe0\udfe1\udfe3]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud838[\udd37-\udd3d]|𞥋"
		},
		{
			name: "Lo",
			alias: "Other_Letter",
			bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf40\udf42-\udf49\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc50-\udc9d\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udd00-\udd23\ude80-\udea9\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc03-\udc37\udc71\udc72\udc75\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd47\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f-\udc61\udc80-\udcaf\udcc4\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a\udf40-\udf46]|\ud806[\udc00-\udc2b\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd2f\udd3f\udd41\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67\udd68\udd6a-\udd89\udd98\udee0-\udef2\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf63-\udf77\udf7d-\udf8f]|\ud81b[\udf00-\udf4a\udf50]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|𝼊|\ud838[\udd00-\udd2c\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Lt",
			alias: "Titlecase_Letter",
			bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
		},
		{
			name: "Lu",
			alias: "Uppercase_Letter",
			bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
			astral: "\ud801[\udc00-\udc27\udcb0-\udcd3\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95]|\ud803[\udc80-\udcb2]|\ud806[\udca0-\udcbf]|\ud81b[\ude40-\ude5f]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]|\ud83a[\udd00-\udd21]"
		},
		{
			name: "M",
			alias: "Mark",
			bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
			astral: "\ud800[\uddfd\udee0\udf76-\udf7a]|\ud802[\ude01-\ude03\ude05\ude06\ude0c-\ude0f\ude38-\ude3a\ude3f\udee5\udee6]|\ud803[\udd24-\udd27\udeab\udeac\udf46-\udf50\udf82-\udf85]|\ud804[\udc00-\udc02\udc38-\udc46\udc70\udc73\udc74\udc7f-\udc82\udcb0-\udcba\udcc2\udd00-\udd02\udd27-\udd34\udd45\udd46\udd73\udd80-\udd82\uddb3-\uddc0\uddc9-\uddcc\uddce\uddcf\ude2c-\ude37\ude3e\udedf-\udeea\udf00-\udf03\udf3b\udf3c\udf3e-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf62\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc35-\udc46\udc5e\udcb0-\udcc3\uddaf-\uddb5\uddb8-\uddc0\udddc\udddd\ude30-\ude40\udeab-\udeb7\udf1d-\udf2b]|\ud806[\udc2c-\udc3a\udd30-\udd35\udd37\udd38\udd3b-\udd3e\udd40\udd42\udd43\uddd1-\uddd7\uddda-\udde0\udde4\ude01-\ude0a\ude33-\ude39\ude3b-\ude3e\ude47\ude51-\ude5b\ude8a-\ude99]|\ud807[\udc2f-\udc36\udc38-\udc3f\udc92-\udca7\udca9-\udcb6\udd31-\udd36\udd3a\udd3c\udd3d\udd3f-\udd45\udd47\udd8a-\udd8e\udd90\udd91\udd93-\udd97\udef3-\udef6]|\ud81a[\udef0-\udef4\udf30-\udf36]|\ud81b[\udf4f\udf51-\udf87\udf8f-\udf92\udfe4\udff0\udff1]|\ud82f[\udc9d\udc9e]|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd30-\udd36\udeae\udeec-\udeef]|\ud83a[\udcd0-\udcd6\udd44-\udd4a]|\udb40[\udd00-\uddef]"
		},
		{
			name: "Mc",
			alias: "Spacing_Mark",
			bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
			astral: "\ud804[\udc00\udc02\udc82\udcb0-\udcb2\udcb7\udcb8\udd2c\udd45\udd46\udd82\uddb3-\uddb5\uddbf\uddc0\uddce\ude2c-\ude2e\ude32\ude33\ude35\udee0-\udee2\udf02\udf03\udf3e\udf3f\udf41-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf62\udf63]|\ud805[\udc35-\udc37\udc40\udc41\udc45\udcb0-\udcb2\udcb9\udcbb-\udcbe\udcc1\uddaf-\uddb1\uddb8-\uddbb\uddbe\ude30-\ude32\ude3b\ude3c\ude3e\udeac\udeae\udeaf\udeb6\udf20\udf21\udf26]|\ud806[\udc2c-\udc2e\udc38\udd30-\udd35\udd37\udd38\udd3d\udd40\udd42\uddd1-\uddd3\udddc-\udddf\udde4\ude39\ude57\ude58\ude97]|\ud807[\udc2f\udc3e\udca9\udcb1\udcb4\udd8a-\udd8e\udd93\udd94\udd96\udef5\udef6]|\ud81b[\udf51-\udf87\udff0\udff1]|\ud834[\udd65\udd66\udd6d-\udd72]"
		},
		{
			name: "Me",
			alias: "Enclosing_Mark",
			bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
		},
		{
			name: "Mn",
			alias: "Nonspacing_Mark",
			bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
			astral: "\ud800[\uddfd\udee0\udf76-\udf7a]|\ud802[\ude01-\ude03\ude05\ude06\ude0c-\ude0f\ude38-\ude3a\ude3f\udee5\udee6]|\ud803[\udd24-\udd27\udeab\udeac\udf46-\udf50\udf82-\udf85]|\ud804[\udc01\udc38-\udc46\udc70\udc73\udc74\udc7f-\udc81\udcb3-\udcb6\udcb9\udcba\udcc2\udd00-\udd02\udd27-\udd2b\udd2d-\udd34\udd73\udd80\udd81\uddb6-\uddbe\uddc9-\uddcc\uddcf\ude2f-\ude31\ude34\ude36\ude37\ude3e\udedf\udee3-\udeea\udf00\udf01\udf3b\udf3c\udf40\udf66-\udf6c\udf70-\udf74]|\ud805[\udc38-\udc3f\udc42-\udc44\udc46\udc5e\udcb3-\udcb8\udcba\udcbf\udcc0\udcc2\udcc3\uddb2-\uddb5\uddbc\uddbd\uddbf\uddc0\udddc\udddd\ude33-\ude3a\ude3d\ude3f\ude40\udeab\udead\udeb0-\udeb5\udeb7\udf1d-\udf1f\udf22-\udf25\udf27-\udf2b]|\ud806[\udc2f-\udc37\udc39\udc3a\udd3b\udd3c\udd3e\udd43\uddd4-\uddd7\uddda\udddb\udde0\ude01-\ude0a\ude33-\ude38\ude3b-\ude3e\ude47\ude51-\ude56\ude59-\ude5b\ude8a-\ude96\ude98\ude99]|\ud807[\udc30-\udc36\udc38-\udc3d\udc3f\udc92-\udca7\udcaa-\udcb0\udcb2\udcb3\udcb5\udcb6\udd31-\udd36\udd3a\udd3c\udd3d\udd3f-\udd45\udd47\udd90\udd91\udd95\udd97\udef3\udef4]|\ud81a[\udef0-\udef4\udf30-\udf36]|\ud81b[\udf4f\udf8f-\udf92\udfe4]|\ud82f[\udc9d\udc9e]|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd67-\udd69\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd30-\udd36\udeae\udeec-\udeef]|\ud83a[\udcd0-\udcd6\udd44-\udd4a]|\udb40[\udd00-\uddef]"
		},
		{
			name: "N",
			alias: "Number",
			bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
			astral: "\ud800[\udd07-\udd33\udd40-\udd78\udd8a\udd8b\udee1-\udefb\udf20-\udf23\udf41\udf4a\udfd1-\udfd5]|\ud801[\udca0-\udca9]|\ud802[\udc58-\udc5f\udc79-\udc7f\udca7-\udcaf\udcfb-\udcff\udd16-\udd1b\uddbc\uddbd\uddc0-\uddcf\uddd2-\uddff\ude40-\ude48\ude7d\ude7e\ude9d-\ude9f\udeeb-\udeef\udf58-\udf5f\udf78-\udf7f\udfa9-\udfaf]|\ud803[\udcfa-\udcff\udd30-\udd39\ude60-\ude7e\udf1d-\udf26\udf51-\udf54\udfc5-\udfcb]|\ud804[\udc52-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udde1-\uddf4\udef0-\udef9]|\ud805[\udc50-\udc59\udcd0-\udcd9\ude50-\ude59\udec0-\udec9\udf30-\udf3b]|\ud806[\udce0-\udcf2\udd50-\udd59]|\ud807[\udc50-\udc6c\udd50-\udd59\udda0-\udda9\udfc0-\udfd4]|\ud809[\udc00-\udc6e]|\ud81a[\ude60-\ude69\udec0-\udec9\udf50-\udf59\udf5b-\udf61]|\ud81b[\ude80-\ude96]|\ud834[\udee0-\udef3\udf60-\udf78]|\ud835[\udfce-\udfff]|\ud838[\udd40-\udd49\udef0-\udef9]|\ud83a[\udcc7-\udccf\udd50-\udd59]|\ud83b[\udc71-\udcab\udcad-\udcaf\udcb1-\udcb4\udd01-\udd2d\udd2f-\udd3d]|\ud83c[\udd00-\udd0c]|\ud83e[\udff0-\udff9]"
		},
		{
			name: "Nd",
			alias: "Decimal_Number",
			bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
			astral: "\ud801[\udca0-\udca9]|\ud803[\udd30-\udd39]|\ud804[\udc66-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udef0-\udef9]|\ud805[\udc50-\udc59\udcd0-\udcd9\ude50-\ude59\udec0-\udec9\udf30-\udf39]|\ud806[\udce0-\udce9\udd50-\udd59]|\ud807[\udc50-\udc59\udd50-\udd59\udda0-\udda9]|\ud81a[\ude60-\ude69\udec0-\udec9\udf50-\udf59]|\ud835[\udfce-\udfff]|\ud838[\udd40-\udd49\udef0-\udef9]|\ud83a[\udd50-\udd59]|\ud83e[\udff0-\udff9]"
		},
		{
			name: "Nl",
			alias: "Letter_Number",
			bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
			astral: "\ud800[\udd40-\udd74\udf41\udf4a\udfd1-\udfd5]|\ud809[\udc00-\udc6e]"
		},
		{
			name: "No",
			alias: "Other_Number",
			bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
			astral: "\ud800[\udd07-\udd33\udd75-\udd78\udd8a\udd8b\udee1-\udefb\udf20-\udf23]|\ud802[\udc58-\udc5f\udc79-\udc7f\udca7-\udcaf\udcfb-\udcff\udd16-\udd1b\uddbc\uddbd\uddc0-\uddcf\uddd2-\uddff\ude40-\ude48\ude7d\ude7e\ude9d-\ude9f\udeeb-\udeef\udf58-\udf5f\udf78-\udf7f\udfa9-\udfaf]|\ud803[\udcfa-\udcff\ude60-\ude7e\udf1d-\udf26\udf51-\udf54\udfc5-\udfcb]|\ud804[\udc52-\udc65\udde1-\uddf4]|\ud805[\udf3a\udf3b]|\ud806[\udcea-\udcf2]|\ud807[\udc5a-\udc6c\udfc0-\udfd4]|\ud81a[\udf5b-\udf61]|\ud81b[\ude80-\ude96]|\ud834[\udee0-\udef3\udf60-\udf78]|\ud83a[\udcc7-\udccf]|\ud83b[\udc71-\udcab\udcad-\udcaf\udcb1-\udcb4\udd01-\udd2d\udd2f-\udd3d]|\ud83c[\udd00-\udd0c]"
		},
		{
			name: "P",
			alias: "Punctuation",
			bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
			astral: "\ud800[\udd00-\udd02\udf9f\udfd0]|𐕯|\ud802[\udc57\udd1f\udd3f\ude50-\ude58\ude7f\udef0-\udef6\udf39-\udf3f\udf99-\udf9c]|\ud803[\udead\udf55-\udf59\udf86-\udf89]|\ud804[\udc47-\udc4d\udcbb\udcbc\udcbe-\udcc1\udd40-\udd43\udd74\udd75\uddc5-\uddc8\uddcd\udddb\udddd-\udddf\ude38-\ude3d\udea9]|\ud805[\udc4b-\udc4f\udc5a\udc5b\udc5d\udcc6\uddc1-\uddd7\ude41-\ude43\ude60-\ude6c\udeb9\udf3c-\udf3e]|\ud806[\udc3b\udd44-\udd46\udde2\ude3f-\ude46\ude9a-\ude9c\ude9e-\udea2]|\ud807[\udc41-\udc45\udc70\udc71\udef7\udef8\udfff]|\ud809[\udc70-\udc74]|\ud80b[\udff1\udff2]|\ud81a[\ude6e\ude6f\udef5\udf37-\udf3b\udf44]|\ud81b[\ude97-\ude9a\udfe2]|𛲟|\ud836[\ude87-\ude8b]|\ud83a[\udd5e\udd5f]"
		},
		{
			name: "Pc",
			alias: "Connector_Punctuation",
			bmp: "_‿⁀⁔︳︴﹍-﹏＿"
		},
		{
			name: "Pd",
			alias: "Dash_Punctuation",
			bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
			astral: "𐺭"
		},
		{
			name: "Pe",
			alias: "Close_Punctuation",
			bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
		},
		{
			name: "Pf",
			alias: "Final_Punctuation",
			bmp: "»’”›⸃⸅⸊⸍⸝⸡"
		},
		{
			name: "Pi",
			alias: "Initial_Punctuation",
			bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
		},
		{
			name: "Po",
			alias: "Other_Punctuation",
			bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
			astral: "\ud800[\udd00-\udd02\udf9f\udfd0]|𐕯|\ud802[\udc57\udd1f\udd3f\ude50-\ude58\ude7f\udef0-\udef6\udf39-\udf3f\udf99-\udf9c]|\ud803[\udf55-\udf59\udf86-\udf89]|\ud804[\udc47-\udc4d\udcbb\udcbc\udcbe-\udcc1\udd40-\udd43\udd74\udd75\uddc5-\uddc8\uddcd\udddb\udddd-\udddf\ude38-\ude3d\udea9]|\ud805[\udc4b-\udc4f\udc5a\udc5b\udc5d\udcc6\uddc1-\uddd7\ude41-\ude43\ude60-\ude6c\udeb9\udf3c-\udf3e]|\ud806[\udc3b\udd44-\udd46\udde2\ude3f-\ude46\ude9a-\ude9c\ude9e-\udea2]|\ud807[\udc41-\udc45\udc70\udc71\udef7\udef8\udfff]|\ud809[\udc70-\udc74]|\ud80b[\udff1\udff2]|\ud81a[\ude6e\ude6f\udef5\udf37-\udf3b\udf44]|\ud81b[\ude97-\ude9a\udfe2]|𛲟|\ud836[\ude87-\ude8b]|\ud83a[\udd5e\udd5f]"
		},
		{
			name: "Ps",
			alias: "Open_Punctuation",
			bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
		},
		{
			name: "S",
			alias: "Symbol",
			bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
			astral: "\ud800[\udd37-\udd3f\udd79-\udd89\udd8c-\udd8e\udd90-\udd9c\udda0\uddd0-\uddfc]|\ud802[\udc77\udc78\udec8]|𑜿|\ud807[\udfd5-\udff1]|\ud81a[\udf3c-\udf3f\udf45]|𛲜|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83\udd84\udd8c-\udda9\uddae-\uddea\ude00-\ude41\ude45\udf00-\udf56]|\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud836[\udc00-\uddff\ude37-\ude3a\ude6d-\ude74\ude76-\ude83\ude85\ude86]|\ud838[\udd4f\udeff]|\ud83b[\udcac\udcb0\udd2e\udef0\udef1]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd0d-\uddad\udde6-\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udfff]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca]"
		},
		{
			name: "Sc",
			alias: "Currency_Symbol",
			bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
			astral: "\ud807[\udfdd-\udfe0]|𞋿|𞲰"
		},
		{
			name: "Sk",
			alias: "Modifier_Symbol",
			bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
			astral: "\ud83c[\udffb-\udfff]"
		},
		{
			name: "Sm",
			alias: "Math_Symbol",
			bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
			astral: "\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud83b[\udef0\udef1]"
		},
		{
			name: "So",
			alias: "Other_Symbol",
			bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
			astral: "\ud800[\udd37-\udd3f\udd79-\udd89\udd8c-\udd8e\udd90-\udd9c\udda0\uddd0-\uddfc]|\ud802[\udc77\udc78\udec8]|𑜿|\ud807[\udfd5-\udfdc\udfe1-\udff1]|\ud81a[\udf3c-\udf3f\udf45]|𛲜|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83\udd84\udd8c-\udda9\uddae-\uddea\ude00-\ude41\ude45\udf00-\udf56]|\ud836[\udc00-\uddff\ude37-\ude3a\ude6d-\ude74\ude76-\ude83\ude85\ude86]|𞅏|\ud83b[\udcac\udd2e]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd0d-\uddad\udde6-\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udffa]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca]"
		},
		{
			name: "Z",
			alias: "Separator",
			bmp: " \xA0  - \u2028\u2029  　"
		},
		{
			name: "Zl",
			alias: "Line_Separator",
			bmp: "\u2028"
		},
		{
			name: "Zp",
			alias: "Paragraph_Separator",
			bmp: "\u2029"
		},
		{
			name: "Zs",
			alias: "Space_Separator",
			bmp: " \xA0  -   　"
		}
	];
})), Xi = /* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Yi());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Categories");
		e.addUnicodeData(i.default);
	}, t.exports = e.default;
})), Zi = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "ASCII",
			bmp: "\0-"
		},
		{
			name: "Alphabetic",
			bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\ude00-\udf36\udf40-\udf55\udf60-\udf67\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd27\ude80-\udea9\udeab\udeac\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc00-\udc45\udc71-\udc75\udc82-\udcb8\udcc2\udcd0-\udce8\udd00-\udd32\udd44-\udd47\udd50-\udd72\udd76\udd80-\uddbf\uddc1-\uddc4\uddce\uddcf\uddda\udddc\ude00-\ude11\ude13-\ude34\ude37\ude3e\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udee8\udf00-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d-\udf44\udf47\udf48\udf4b\udf4c\udf50\udf57\udf5d-\udf63]|\ud805[\udc00-\udc41\udc43-\udc45\udc47-\udc4a\udc5f-\udc61\udc80-\udcc1\udcc4\udcc5\udcc7\udd80-\uddb5\uddb8-\uddbe\uddd8-\udddd\ude00-\ude3e\ude40\ude44\ude80-\udeb5\udeb8\udf00-\udf1a\udf1d-\udf2a\udf40-\udf46]|\ud806[\udc00-\udc38\udca0-\udcdf\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd35\udd37\udd38\udd3b\udd3c\udd3f-\udd42\udda0-\udda7\uddaa-\uddd7\uddda-\udddf\udde1\udde3\udde4\ude00-\ude32\ude35-\ude3e\ude50-\ude97\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc3e\udc40\udc72-\udc8f\udc92-\udca7\udca9-\udcb6\udd00-\udd06\udd08\udd09\udd0b-\udd36\udd3a\udd3c\udd3d\udd3f-\udd41\udd43\udd46\udd47\udd60-\udd65\udd67\udd68\udd6a-\udd8e\udd90\udd91\udd93-\udd96\udd98\udee0-\udef6\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f\udfe0\udfe1\udfe3\udff0\udff1]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9e]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf1e]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd00-\udd2c\udd37-\udd3d\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd47\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud83c[\udd30-\udd49\udd50-\udd69\udd70-\udd89]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Any",
			isBmpLast: !0,
			bmp: "\0-￿",
			astral: "[\ud800-\udbff][\udc00-\udfff]"
		},
		{
			name: "Default_Ignorable_Code_Point",
			bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️﻿ﾠ￰-￸",
			astral: "\ud82f[\udca0-\udca3]|\ud834[\udd73-\udd7a]|[\udb40-\udb43][\udc00-\udfff]"
		},
		{
			name: "Lowercase",
			bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
			astral: "\ud801[\udc28-\udc4f\udcd8-\udcfb\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\udf80\udf83-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud803[\udcc0-\udcf2]|\ud806[\udcc0-\udcdf]|\ud81b[\ude60-\ude7f]|\ud835[\udc1a-\udc33\udc4e-\udc54\udc56-\udc67\udc82-\udc9b\udcb6-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udccf\udcea-\udd03\udd1e-\udd37\udd52-\udd6b\udd86-\udd9f\uddba-\uddd3\uddee-\ude07\ude22-\ude3b\ude56-\ude6f\ude8a-\udea5\udec2-\udeda\udedc-\udee1\udefc-\udf14\udf16-\udf1b\udf36-\udf4e\udf50-\udf55\udf70-\udf88\udf8a-\udf8f\udfaa-\udfc2\udfc4-\udfc9\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd22-\udd43]"
		},
		{
			name: "Noncharacter_Code_Point",
			bmp: "﷐-﷯￾￿",
			astral: "[\ud83f\ud87f\ud8bf\ud8ff\ud93f\ud97f\ud9bf\ud9ff\uda3f\uda7f\udabf\udaff\udb3f\udb7f\udbbf\udbff][\udffe\udfff]"
		},
		{
			name: "Uppercase",
			bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
			astral: "\ud801[\udc00-\udc27\udcb0-\udcd3\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95]|\ud803[\udc80-\udcb2]|\ud806[\udca0-\udcbf]|\ud81b[\ude40-\ude5f]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]|\ud83a[\udd00-\udd21]|\ud83c[\udd30-\udd49\udd50-\udd69\udd70-\udd89]"
		},
		{
			name: "White_Space",
			bmp: "	-\r \xA0  - \u2028\u2029  　"
		}
	];
})), Qi = /* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Zi());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Properties");
		var t = i.default;
		t.push({
			name: "Assigned",
			inverseOf: "Cn"
		}), e.addUnicodeData(t);
	}, t.exports = e.default;
})), $i = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "Adlam",
			astral: "\ud83a[\udd00-\udd4b\udd50-\udd59\udd5e\udd5f]"
		},
		{
			name: "Ahom",
			astral: "\ud805[\udf00-\udf1a\udf1d-\udf2b\udf30-\udf46]"
		},
		{
			name: "Anatolian_Hieroglyphs",
			astral: "\ud811[\udc00-\ude46]"
		},
		{
			name: "Arabic",
			bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
			astral: "\ud803[\ude60-\ude7e]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb\udef0\udef1]"
		},
		{
			name: "Armenian",
			bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
		},
		{
			name: "Avestan",
			astral: "\ud802[\udf00-\udf35\udf39-\udf3f]"
		},
		{
			name: "Balinese",
			bmp: "ᬀ-ᭌ᭐-᭾"
		},
		{
			name: "Bamum",
			bmp: "ꚠ-꛷",
			astral: "\ud81a[\udc00-\ude38]"
		},
		{
			name: "Bassa_Vah",
			astral: "\ud81a[\uded0-\udeed\udef0-\udef5]"
		},
		{
			name: "Batak",
			bmp: "ᯀ-᯳᯼-᯿"
		},
		{
			name: "Bengali",
			bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
		},
		{
			name: "Bhaiksuki",
			astral: "\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc45\udc50-\udc6c]"
		},
		{
			name: "Bopomofo",
			bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
		},
		{
			name: "Brahmi",
			astral: "\ud804[\udc00-\udc4d\udc52-\udc75\udc7f]"
		},
		{
			name: "Braille",
			bmp: "⠀-⣿"
		},
		{
			name: "Buginese",
			bmp: "ᨀ-ᨛ᨞᨟"
		},
		{
			name: "Buhid",
			bmp: "ᝀ-ᝓ"
		},
		{
			name: "Canadian_Aboriginal",
			bmp: "᐀-ᙿᢰ-ᣵ",
			astral: "\ud806[\udeb0-\udebf]"
		},
		{
			name: "Carian",
			astral: "\ud800[\udea0-\uded0]"
		},
		{
			name: "Caucasian_Albanian",
			astral: "\ud801[\udd30-\udd63\udd6f]"
		},
		{
			name: "Chakma",
			astral: "\ud804[\udd00-\udd34\udd36-\udd47]"
		},
		{
			name: "Cham",
			bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
		},
		{
			name: "Cherokee",
			bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
		},
		{
			name: "Chorasmian",
			astral: "\ud803[\udfb0-\udfcb]"
		},
		{
			name: "Common",
			bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫﻿！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
			astral: "\ud800[\udd00-\udd02\udd07-\udd33\udd37-\udd3f\udd90-\udd9c\uddd0-\uddfc\udee1-\udefb]|\ud82f[\udca0-\udca3]|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd66\udd6a-\udd7a\udd83\udd84\udd8c-\udda9\uddae-\uddea\udee0-\udef3\udf00-\udf56\udf60-\udf78]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udfcb\udfce-\udfff]|\ud83b[\udc71-\udcb4\udd01-\udd3d]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd00-\uddad\udde6-\uddff\ude01\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udfff]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca\udff0-\udff9]|\udb40[\udc01\udc20-\udc7f]"
		},
		{
			name: "Coptic",
			bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
		},
		{
			name: "Cuneiform",
			astral: "\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc70-\udc74\udc80-\udd43]"
		},
		{
			name: "Cypriot",
			astral: "\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f]"
		},
		{
			name: "Cypro_Minoan",
			astral: "\ud80b[\udf90-\udff2]"
		},
		{
			name: "Cyrillic",
			bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
		},
		{
			name: "Deseret",
			astral: "\ud801[\udc00-\udc4f]"
		},
		{
			name: "Devanagari",
			bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
		},
		{
			name: "Dives_Akuru",
			astral: "\ud806[\udd00-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd35\udd37\udd38\udd3b-\udd46\udd50-\udd59]"
		},
		{
			name: "Dogra",
			astral: "\ud806[\udc00-\udc3b]"
		},
		{
			name: "Duployan",
			astral: "\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9c-\udc9f]"
		},
		{
			name: "Egyptian_Hieroglyphs",
			astral: "\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e\udc30-\udc38]"
		},
		{
			name: "Elbasan",
			astral: "\ud801[\udd00-\udd27]"
		},
		{
			name: "Elymaic",
			astral: "\ud803[\udfe0-\udff6]"
		},
		{
			name: "Ethiopic",
			bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
			astral: "\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]"
		},
		{
			name: "Georgian",
			bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
		},
		{
			name: "Glagolitic",
			bmp: "Ⰰ-ⱟ",
			astral: "\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a]"
		},
		{
			name: "Gothic",
			astral: "\ud800[\udf30-\udf4a]"
		},
		{
			name: "Grantha",
			astral: "\ud804[\udf00-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3c-\udf44\udf47\udf48\udf4b-\udf4d\udf50\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]"
		},
		{
			name: "Greek",
			bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
			astral: "\ud800[\udd40-\udd8e\udda0]|\ud834[\ude00-\ude45]"
		},
		{
			name: "Gujarati",
			bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
		},
		{
			name: "Gunjala_Gondi",
			astral: "\ud807[\udd60-\udd65\udd67\udd68\udd6a-\udd8e\udd90\udd91\udd93-\udd98\udda0-\udda9]"
		},
		{
			name: "Gurmukhi",
			bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
		},
		{
			name: "Han",
			bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
			astral: "\ud81b[\udfe2\udfe3\udff0\udff1]|[\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Hangul",
			bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
		},
		{
			name: "Hanifi_Rohingya",
			astral: "\ud803[\udd00-\udd27\udd30-\udd39]"
		},
		{
			name: "Hanunoo",
			bmp: "ᜠ-᜴"
		},
		{
			name: "Hatran",
			astral: "\ud802[\udce0-\udcf2\udcf4\udcf5\udcfb-\udcff]"
		},
		{
			name: "Hebrew",
			bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
		},
		{
			name: "Hiragana",
			bmp: "ぁ-ゖゝ-ゟ",
			astral: "\ud82c[\udc01-\udd1f\udd50-\udd52]|🈀"
		},
		{
			name: "Imperial_Aramaic",
			astral: "\ud802[\udc40-\udc55\udc57-\udc5f]"
		},
		{
			name: "Inherited",
			bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
			astral: "\ud800[\uddfd\udee0]|𑌻|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd67-\udd69\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad]|\udb40[\udd00-\uddef]"
		},
		{
			name: "Inscriptional_Pahlavi",
			astral: "\ud802[\udf60-\udf72\udf78-\udf7f]"
		},
		{
			name: "Inscriptional_Parthian",
			astral: "\ud802[\udf40-\udf55\udf58-\udf5f]"
		},
		{
			name: "Javanese",
			bmp: "ꦀ-꧍꧐-꧙꧞꧟"
		},
		{
			name: "Kaithi",
			astral: "\ud804[\udc80-\udcc2\udccd]"
		},
		{
			name: "Kannada",
			bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
		},
		{
			name: "Katakana",
			bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
			astral: "\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00\udd20-\udd22\udd64-\udd67]"
		},
		{
			name: "Kayah_Li",
			bmp: "꤀-꤭꤯"
		},
		{
			name: "Kharoshthi",
			astral: "\ud802[\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude38-\ude3a\ude3f-\ude48\ude50-\ude58]"
		},
		{
			name: "Khitan_Small_Script",
			astral: "𖿤|\ud822[\udf00-\udfff]|\ud823[\udc00-\udcd5]"
		},
		{
			name: "Khmer",
			bmp: "ក-៝០-៩៰-៹᧠-᧿"
		},
		{
			name: "Khojki",
			astral: "\ud804[\ude00-\ude11\ude13-\ude3e]"
		},
		{
			name: "Khudawadi",
			astral: "\ud804[\udeb0-\udeea\udef0-\udef9]"
		},
		{
			name: "Lao",
			bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
		},
		{
			name: "Latin",
			bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
			astral: "\ud801[\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud837[\udf00-\udf1e]"
		},
		{
			name: "Lepcha",
			bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
		},
		{
			name: "Limbu",
			bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
		},
		{
			name: "Linear_A",
			astral: "\ud801[\ude00-\udf36\udf40-\udf55\udf60-\udf67]"
		},
		{
			name: "Linear_B",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa]"
		},
		{
			name: "Lisu",
			bmp: "ꓐ-꓿",
			astral: "𑾰"
		},
		{
			name: "Lycian",
			astral: "\ud800[\ude80-\ude9c]"
		},
		{
			name: "Lydian",
			astral: "\ud802[\udd20-\udd39\udd3f]"
		},
		{
			name: "Mahajani",
			astral: "\ud804[\udd50-\udd76]"
		},
		{
			name: "Makasar",
			astral: "\ud807[\udee0-\udef8]"
		},
		{
			name: "Malayalam",
			bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
		},
		{
			name: "Mandaic",
			bmp: "ࡀ-࡛࡞"
		},
		{
			name: "Manichaean",
			astral: "\ud802[\udec0-\udee6\udeeb-\udef6]"
		},
		{
			name: "Marchen",
			astral: "\ud807[\udc70-\udc8f\udc92-\udca7\udca9-\udcb6]"
		},
		{
			name: "Masaram_Gondi",
			astral: "\ud807[\udd00-\udd06\udd08\udd09\udd0b-\udd36\udd3a\udd3c\udd3d\udd3f-\udd47\udd50-\udd59]"
		},
		{
			name: "Medefaidrin",
			astral: "\ud81b[\ude40-\ude9a]"
		},
		{
			name: "Meetei_Mayek",
			bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
		},
		{
			name: "Mende_Kikakui",
			astral: "\ud83a[\udc00-\udcc4\udcc7-\udcd6]"
		},
		{
			name: "Meroitic_Cursive",
			astral: "\ud802[\udda0-\uddb7\uddbc-\uddcf\uddd2-\uddff]"
		},
		{
			name: "Meroitic_Hieroglyphs",
			astral: "\ud802[\udd80-\udd9f]"
		},
		{
			name: "Miao",
			astral: "\ud81b[\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f]"
		},
		{
			name: "Modi",
			astral: "\ud805[\ude00-\ude44\ude50-\ude59]"
		},
		{
			name: "Mongolian",
			bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
			astral: "\ud805[\ude60-\ude6c]"
		},
		{
			name: "Mro",
			astral: "\ud81a[\ude40-\ude5e\ude60-\ude69\ude6e\ude6f]"
		},
		{
			name: "Multani",
			astral: "\ud804[\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea9]"
		},
		{
			name: "Myanmar",
			bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
		},
		{
			name: "Nabataean",
			astral: "\ud802[\udc80-\udc9e\udca7-\udcaf]"
		},
		{
			name: "Nandinagari",
			astral: "\ud806[\udda0-\udda7\uddaa-\uddd7\uddda-\udde4]"
		},
		{
			name: "New_Tai_Lue",
			bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
		},
		{
			name: "Newa",
			astral: "\ud805[\udc00-\udc5b\udc5d-\udc61]"
		},
		{
			name: "Nko",
			bmp: "߀-ߺ߽-߿"
		},
		{
			name: "Nushu",
			astral: "𖿡|\ud82c[\udd70-\udefb]"
		},
		{
			name: "Nyiakeng_Puachue_Hmong",
			astral: "\ud838[\udd00-\udd2c\udd30-\udd3d\udd40-\udd49\udd4e\udd4f]"
		},
		{
			name: "Ogham",
			bmp: " -᚜"
		},
		{
			name: "Ol_Chiki",
			bmp: "᱐-᱿"
		},
		{
			name: "Old_Hungarian",
			astral: "\ud803[\udc80-\udcb2\udcc0-\udcf2\udcfa-\udcff]"
		},
		{
			name: "Old_Italic",
			astral: "\ud800[\udf00-\udf23\udf2d-\udf2f]"
		},
		{
			name: "Old_North_Arabian",
			astral: "\ud802[\ude80-\ude9f]"
		},
		{
			name: "Old_Permic",
			astral: "\ud800[\udf50-\udf7a]"
		},
		{
			name: "Old_Persian",
			astral: "\ud800[\udfa0-\udfc3\udfc8-\udfd5]"
		},
		{
			name: "Old_Sogdian",
			astral: "\ud803[\udf00-\udf27]"
		},
		{
			name: "Old_South_Arabian",
			astral: "\ud802[\ude60-\ude7f]"
		},
		{
			name: "Old_Turkic",
			astral: "\ud803[\udc00-\udc48]"
		},
		{
			name: "Old_Uyghur",
			astral: "\ud803[\udf70-\udf89]"
		},
		{
			name: "Oriya",
			bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
		},
		{
			name: "Osage",
			astral: "\ud801[\udcb0-\udcd3\udcd8-\udcfb]"
		},
		{
			name: "Osmanya",
			astral: "\ud801[\udc80-\udc9d\udca0-\udca9]"
		},
		{
			name: "Pahawh_Hmong",
			astral: "\ud81a[\udf00-\udf45\udf50-\udf59\udf5b-\udf61\udf63-\udf77\udf7d-\udf8f]"
		},
		{
			name: "Palmyrene",
			astral: "\ud802[\udc60-\udc7f]"
		},
		{
			name: "Pau_Cin_Hau",
			astral: "\ud806[\udec0-\udef8]"
		},
		{
			name: "Phags_Pa",
			bmp: "ꡀ-꡷"
		},
		{
			name: "Phoenician",
			astral: "\ud802[\udd00-\udd1b\udd1f]"
		},
		{
			name: "Psalter_Pahlavi",
			astral: "\ud802[\udf80-\udf91\udf99-\udf9c\udfa9-\udfaf]"
		},
		{
			name: "Rejang",
			bmp: "ꤰ-꥓꥟"
		},
		{
			name: "Runic",
			bmp: "ᚠ-ᛪᛮ-ᛸ"
		},
		{
			name: "Samaritan",
			bmp: "ࠀ-࠭࠰-࠾"
		},
		{
			name: "Saurashtra",
			bmp: "ꢀ-ꣅ꣎-꣙"
		},
		{
			name: "Sharada",
			astral: "\ud804[\udd80-\udddf]"
		},
		{
			name: "Shavian",
			astral: "\ud801[\udc50-\udc7f]"
		},
		{
			name: "Siddham",
			astral: "\ud805[\udd80-\uddb5\uddb8-\udddd]"
		},
		{
			name: "SignWriting",
			astral: "\ud836[\udc00-\ude8b\ude9b-\ude9f\udea1-\udeaf]"
		},
		{
			name: "Sinhala",
			bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
			astral: "\ud804[\udde1-\uddf4]"
		},
		{
			name: "Sogdian",
			astral: "\ud803[\udf30-\udf59]"
		},
		{
			name: "Sora_Sompeng",
			astral: "\ud804[\udcd0-\udce8\udcf0-\udcf9]"
		},
		{
			name: "Soyombo",
			astral: "\ud806[\ude50-\udea2]"
		},
		{
			name: "Sundanese",
			bmp: "ᮀ-ᮿ᳀-᳇"
		},
		{
			name: "Syloti_Nagri",
			bmp: "ꠀ-꠬"
		},
		{
			name: "Syriac",
			bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
		},
		{
			name: "Tagalog",
			bmp: "ᜀ-᜕ᜟ"
		},
		{
			name: "Tagbanwa",
			bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
		},
		{
			name: "Tai_Le",
			bmp: "ᥐ-ᥭᥰ-ᥴ"
		},
		{
			name: "Tai_Tham",
			bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
		},
		{
			name: "Tai_Viet",
			bmp: "ꪀ-ꫂꫛ-꫟"
		},
		{
			name: "Takri",
			astral: "\ud805[\ude80-\udeb9\udec0-\udec9]"
		},
		{
			name: "Tamil",
			bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
			astral: "\ud807[\udfc0-\udff1\udfff]"
		},
		{
			name: "Tangsa",
			astral: "\ud81a[\ude70-\udebe\udec0-\udec9]"
		},
		{
			name: "Tangut",
			astral: "𖿠|[\ud81c-\ud820][\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udeff]|\ud823[\udd00-\udd08]"
		},
		{
			name: "Telugu",
			bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
		},
		{
			name: "Thaana",
			bmp: "ހ-ޱ"
		},
		{
			name: "Thai",
			bmp: "ก-ฺเ-๛"
		},
		{
			name: "Tibetan",
			bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
		},
		{
			name: "Tifinagh",
			bmp: "ⴰ-ⵧⵯ⵰⵿"
		},
		{
			name: "Tirhuta",
			astral: "\ud805[\udc80-\udcc7\udcd0-\udcd9]"
		},
		{
			name: "Toto",
			astral: "\ud838[\ude90-\udeae]"
		},
		{
			name: "Ugaritic",
			astral: "\ud800[\udf80-\udf9d\udf9f]"
		},
		{
			name: "Vai",
			bmp: "ꔀ-ꘫ"
		},
		{
			name: "Vithkuqi",
			astral: "\ud801[\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]"
		},
		{
			name: "Wancho",
			astral: "\ud838[\udec0-\udef9\udeff]"
		},
		{
			name: "Warang_Citi",
			astral: "\ud806[\udca0-\udcf2\udcff]"
		},
		{
			name: "Yezidi",
			astral: "\ud803[\ude80-\udea9\udeab-\udead\udeb0\udeb1]"
		},
		{
			name: "Yi",
			bmp: "ꀀ-ꒌ꒐-꓆"
		},
		{
			name: "Zanabazar_Square",
			astral: "\ud806[\ude00-\ude47]"
		}
	];
})), ea = /* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r($i());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Scripts");
		e.addUnicodeData(i.default, "Script");
	}, t.exports = e.default;
})), ta = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	var n = Fe(), r = Ie();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Mi()), a = r(Ki()), o = r(qi()), s = r(Ji()), c = r(Xi()), l = r(Qi()), u = r(ea());
	(0, a.default)(i.default), (0, o.default)(i.default), (0, s.default)(i.default), (0, c.default)(i.default), (0, l.default)(i.default), (0, u.default)(i.default), e.default = i.default, t.exports = e.default;
})))(), 1), na = (0, ta.default)(/@\[(\d+)\]\(([^)]+)\)+/i), ra = (0, ta.default)(/@\[(urn:li:(organization|person):[A-Za-z0-9\_\-]+)\]\(([^)]+)\)+/i), ia = (0, ta.default)(/(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i), aa = (0, ta.default)(/(?:@)([A-Za-z0-9_](?:[A-Za-z0-9_.]{0,28}(?:[A-Za-z0-9_]))?)/i), oa = (0, ta.default)(/(#+[a-zA-Z0-9(_)]{1,})/i);
//#endregion
//#region lib/components/SkedCaptionPreview/linkedinCaptionText.ts
function sa(e) {
	let t = [], n = 0, r = (n, r) => {
		r > n && t.push({
			text: e.slice(n, r),
			start: n,
			end: r
		});
	}, i = new RegExp(ra.source, "gi");
	for (let t of e.matchAll(i)) {
		let e = t.index;
		r(n, e);
		let i = e + t[0].indexOf("](") + 2;
		r(i, i + t[3].length), n = e + t[0].length;
	}
	return r(n, e.length), t;
}
function ca(e) {
	return sa(e).map(({ text: e }) => e).join("");
}
function la(e, t, n) {
	return e.map((e) => {
		let r = Math.max(t, e.start), i = Math.min(n, e.end);
		return i > r ? e.text.slice(r - e.start, i - e.start) : "";
	}).join("");
}
function ua(e, t, n) {
	let r = t;
	for (let t of e) {
		if (r < t.text.length || r === t.text.length && n === "end") return t.start + r;
		r -= t.text.length;
	}
	return e[e.length - 1]?.end ?? 0;
}
//#endregion
//#region lib/styled-comp-hack.js
var da = t;
!typeof t.div === "function" && (da = t.default);
var Y = da, fa = Y.div`
  font-family: Helvetica Neue;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 18px;\n          letter-spacing: -0.025em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 15px;\n          letter-spacing: -0.04em;\n          ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          white-space: pre-line;\n        ";
	}
}};
`, pa = Object.defineProperty, ma = (e, t) => pa(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ha(e, t) {
	let n = r.createContext(t);
	n.displayName = e + "Context";
	let i = /* @__PURE__ */ ma((e) => {
		let { children: t, ...i } = e, a = r.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ g(n.Provider, {
			value: a,
			children: t
		});
	}, "Provider");
	i.displayName = e + "Provider";
	function a(i, a = {}) {
		let { optional: o = !1 } = a, s = r.useContext(n);
		if (s) return s;
		if (t !== void 0) return t;
		if (!o) throw Error(`\`${i}\` must be used within \`${e}\``);
	}
	return ma(a, "useContext"), [i, a];
}
ma(ha, "createContext");
// @__NO_SIDE_EFFECTS__
function ga(e, t = []) {
	let n = [];
	function i(t, i) {
		let a = r.createContext(i);
		a.displayName = t + "Context";
		let o = n.length;
		n = [...n, i];
		let s = /* @__PURE__ */ ma((t) => {
			let { scope: n, children: i, ...s } = t, c = n?.[e]?.[o] || a, l = r.useMemo(() => s, Object.values(s));
			return /* @__PURE__ */ g(c.Provider, {
				value: l,
				children: i
			});
		}, "Provider");
		s.displayName = t + "Provider";
		function c(n, s, c = {}) {
			let { optional: l = !1 } = c, u = s?.[e]?.[o] || a, d = r.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return ma(c, "useContext"), [s, c];
	}
	ma(i, "createContext");
	let a = /* @__PURE__ */ ma(() => {
		let t = n.map((e) => r.createContext(e));
		return /* @__PURE__ */ ma(function(n) {
			let i = n?.[e] || t;
			return r.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: i
			} }), [n, i]);
		}, "useScope");
	}, "createScope");
	return a.scopeName = e, [i, _a(a, ...t)];
}
ma(ga, "createContextScope");
function _a(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ ma(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ ma(function(e) {
			let i = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return r.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
ma(_a, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.4_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var va = Object.defineProperty, ya = (e, t) => va(e, "name", {
	value: t,
	configurable: !0
});
function ba(e) {
	let t = r.useRef(e);
	return r.useEffect(() => {
		t.current = e;
	}), r.useMemo(() => ((...e) => t.current?.(...e)), []);
}
ya(ba, "useCallbackRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var xa = globalThis?.document ? r.useLayoutEffect : () => {}, Sa = Object.defineProperty, Ca = (e, t) => Sa(e, "name", {
	value: t,
	configurable: !0
});
function wa(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Ca(wa, "setRef");
function Ta(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = wa(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : wa(e[t], null);
			}
		};
	};
}
Ca(Ta, "composeRefs");
function Ea(...e) {
	return r.useCallback(Ta(...e), e);
}
Ca(Ea, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.3_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.mjs
var Da = Object.defineProperty, Oa = (e, t) => Da(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ka(e) {
	let t = r.forwardRef((t, n) => {
		let { children: i, ...a } = t, o = null, s = !1, c = [];
		La(i) && typeof Va == "function" && (i = Va(i._payload)), r.Children.forEach(i, (e) => {
			if (Fa(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				La(n) && typeof Va == "function" && (n = Va(n._payload)), o = Ma(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = r.cloneElement(o, void 0, c) : !s && r.Children.count(i) === 1 && r.isValidElement(i) && (o = i);
		let l = o ? Pa(o) : void 0, u = Ea(n, l);
		if (!o) {
			if (i || i === 0) throw Error(s ? Ba(e) : za(e));
			return i;
		}
		let d = Na(a, o.props ?? {});
		return o.type !== r.Fragment && (d.ref = n ? u : l), r.cloneElement(o, d);
	});
	return t.displayName = `${e}.Slot`, t;
}
Oa(ka, "createSlot");
var Aa = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function ja(e) {
	let t = /* @__PURE__ */ Oa((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = Aa, t;
}
Oa(ja, "createSlottable");
var Ma = /* @__PURE__ */ Oa((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return r.isValidElement(t) ? r.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return r.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Na(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
Oa(Na, "mergeProps");
function Pa(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Oa(Pa, "getElementRef");
function Fa(e) {
	return r.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Aa;
}
Oa(Fa, "isSlottable");
var Ia = Symbol.for("react.lazy");
function La(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Ia && "_payload" in e && Ra(e._payload);
}
Oa(La, "isLazyComponent");
function Ra(e) {
	return typeof e == "object" && !!e && "then" in e;
}
Oa(Ra, "isPromiseLike");
var za = /* @__PURE__ */ Oa((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Ba = /* @__PURE__ */ Oa((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Va = r.use, Ha = Object.defineProperty, Ua = (e, t) => Ha(e, "name", {
	value: t,
	configurable: !0
}), Wa = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ ka(`Primitive.${t}`), i = r.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(o, {
			...a,
			ref: r
		});
	});
	return i.displayName = `Primitive.${t}`, {
		...e,
		[t]: i
	};
}, {});
function Ga(e, t) {
	e && v.flushSync(() => e.dispatchEvent(t));
}
Ua(Ga, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-avatar@1.2.6_@types+react-dom@18.3.7_@types+react@18.3.31__@types+react_e6c996e5557b18a376135b2452a80188/node_modules/@radix-ui/react-avatar/dist/index.mjs
var Ka = Object.defineProperty, qa = (e, t) => Ka(e, "name", {
	value: t,
	configurable: !0
}), Ja = "Avatar", [Ya, Xa] = /* @__PURE__ */ ga(Ja), Za = [0, () => void 0], [Qa, $a] = Ya(Ja), eo = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ qa(function(e, t) {
	let { __scopeAvatar: n, ...i } = e, [a, o] = r.useState("idle"), [s, c] = so();
	return /* @__PURE__ */ g(Qa, {
		scope: n,
		imageLoadingStatus: a,
		setImageLoadingStatus: o,
		imageCount: s,
		setImageCount: c,
		children: /* @__PURE__ */ g(Wa.span, {
			...i,
			ref: t
		})
	});
}, "Avatar")), to = "AvatarImage", no = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ qa(function(e, t) {
	let { __scopeAvatar: n, src: i, onLoadingStatusChange: a, ...o } = e, s = $a(to, n);
	s.setImageCount;
	let c = ao(i, {
		referrerPolicy: o.referrerPolicy,
		crossOrigin: o.crossOrigin,
		loadingStatus: s.imageLoadingStatus,
		setLoadingStatus: s.setImageLoadingStatus
	}), l = ba((e) => {
		a?.(e);
	}), u = r.useRef(c);
	return xa(() => {
		let e = u.current;
		u.current = c, c !== e && l(c);
	}, [c, l]), c === "loaded" ? /* @__PURE__ */ g(Wa.img, {
		...o,
		ref: t,
		src: i
	}) : null;
}, "AvatarImage")), ro = "AvatarFallback", io = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ qa(function(e, t) {
	let { __scopeAvatar: n, delayMs: i, ...a } = e, o = $a(ro, n), [s, c] = r.useState(i === void 0);
	return r.useEffect(() => {
		if (i !== void 0) {
			let e = window.setTimeout(() => c(!0), i);
			return () => window.clearTimeout(e);
		}
	}, [i]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ g(Wa.span, {
		...a,
		ref: t
	}) : null;
}, "AvatarFallback"));
function ao(e, { loadingStatus: t, setLoadingStatus: n, referrerPolicy: r, crossOrigin: i }) {
	return xa(() => {
		if (!e) {
			n("error");
			return;
		}
		let t = new window.Image(), a = /* @__PURE__ */ qa((e) => {
			let t = e.currentTarget;
			n(oo(t));
		}, "handleLoad"), o = /* @__PURE__ */ qa(() => n("error"), "handleError");
		return t.addEventListener("load", a), t.addEventListener("error", o), r && (t.referrerPolicy = r), t.crossOrigin = i ?? null, t.src = e, n(oo(t)), () => {
			t.removeEventListener("load", a), t.removeEventListener("error", o), n("idle");
		};
	}, [
		e,
		i,
		r,
		n
	]), t;
}
qa(ao, "useImageLoadingStatus");
function oo(e) {
	return e.complete ? e.naturalWidth > 0 ? "loaded" : "error" : "loading";
}
qa(oo, "getImageLoadingStatus");
function so() {
	return Za;
}
qa(so, "useImageCount");
function co(e) {}
qa(co, "useUpdateImageCount");
//#endregion
//#region lib/components/Avatar.jsx
var lo = Y(eo)`
  display: grid;
  place-content: center;
  height: 100%;

  img {
    width: 100%;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
  }
`, uo = ({ src: e, alt: t, ...n }) => {
	let r = t.substring(0, 2).toUpperCase();
	return /* @__PURE__ */ _(lo, {
		...n,
		children: [/* @__PURE__ */ g(no, {
			src: e,
			alt: t
		}), /* @__PURE__ */ g(io, { children: r })]
	});
}, fo = ({ username: e, profilePicture: t, locationName: n, small: r, collabs: i }) => {
	if (Array.isArray(i) && i.length > 1) {
		let t = yo(i);
		return /* @__PURE__ */ g("div", {
			className: "sp-flex sp-items-center",
			children: /* @__PURE__ */ _(_o, { children: [
				/* @__PURE__ */ _(po, { children: [/* @__PURE__ */ g(ho, {
					src: i[1].profilePictureUrl,
					alt: e
				}), /* @__PURE__ */ g(go, {
					src: i[0].profilePictureUrl,
					alt: e
				})] }),
				" ",
				t
			] })
		});
	}
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-rounded-full sp-overflow-hidden sp-m-4",
			style: {
				width: "35px",
				height: "35px"
			},
			children: /* @__PURE__ */ g(uo, {
				src: t,
				alt: e
			})
		}), /* @__PURE__ */ _("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`,
			children: [/* @__PURE__ */ g(fa, {
				$variant: "heading",
				children: e
			}), n && /* @__PURE__ */ g(fa, {
				$variant: "subheading",
				children: n
			})]
		})]
	});
}, po = Y.div`
  overflow: hidden;
  margin-left: 10px;
  margin-right: 4px;
  width: 38px;
  height: 38px;
`, mo = Y(uo)`
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
`, ho = Y(mo)`
  left: 12px;

  > img {
    max-width: 24px;
    max-height: 24px;
  }
`, go = Y(mo)`
  top: -14px;
  > img {
    max-width: 24px;
    max-height: 24px;
    border: 1px solid white;
  }
`, _o = Y.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
`, vo = Y.span`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
function yo(e) {
	return e.length < 2 ? null : e.length === 2 ? /* @__PURE__ */ g(vo, { children: `${e[0].username} and ${e[1].username}` }) : /* @__PURE__ */ g(vo, { children: `${e[0].username} and ${e.length - 1} others` });
}
//#endregion
//#region lib/images/instagram/icon-product.svg?react
var bo = (e) => /* @__PURE__ */ g("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M15.2622 5.61017C15.2411 5.20965 14.9038 4.87236 14.4822 4.87236H11.9526V4.15563C11.9526 1.96327 10.2451 0.0871172 8.0527 0.0027957C5.75494 -0.0815258 3.85771 1.75247 3.85771 4.02915V4.87236H1.30698C1.11726 4.87236 0.927536 4.95668 0.779974 5.08316C0.611331 5.23073 0.527009 5.44153 0.527009 5.63125L0 18.6589C0 18.8697 0.0843216 19.0594 0.231884 19.207C0.379447 19.3546 0.56917 19.4389 0.779974 19.4389H15.22C15.4308 19.4389 15.6206 19.3546 15.7681 19.207C15.9157 19.0594 16 18.8486 16 18.6168L15.2622 5.61017ZM8.11594 1.56274C9.40184 1.68922 10.3505 2.80648 10.3505 4.11347V4.85128H5.43874V4.02915C5.41765 2.5746 6.6614 1.41518 8.11594 1.56274Z",
		fill: "white"
	})
}), xo = (e) => /* @__PURE__ */ g("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 108.56 122.88",
	style: { enableBackground: "new 0 0 108.56 122.88" },
	xmlSpace: "preserve",
	fill: "#fff",
	...e,
	children: /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("path", { d: "M30.47,16.05h12.47l-6.35-7.16c-1.96-2.21-1.75-5.59,0.46-7.55c2.21-1.96,5.59-1.75,7.55,0.46l9.11,10.27L62.81,1.8 c1.96-2.21,5.34-2.42,7.55-0.46c2.21,1.96,2.42,5.34,0.46,7.55l-6.35,7.16h13.62c8.4,0,16.04,3.43,21.57,8.96 c5.49,5.49,8.9,13.05,8.9,21.35v46.21c0,8.3-3.41,15.86-8.9,21.35c-5.53,5.53-13.16,8.96-21.57,8.96H30.47 c-8.4,0-16.04-3.43-21.57-8.96C3.41,108.43,0,100.87,0,92.57V46.36c0-8.3,3.41-15.86,8.9-21.35 C14.43,19.48,22.07,16.05,30.47,16.05L30.47,16.05z M27.88,75.18c-2.86,0.74-5.78-0.98-6.52-3.84c-0.74-2.86,0.98-5.78,3.84-6.52 l28.8-7.45c2.86-0.74,5.78,0.98,6.52,3.84c0.14,0.53,0.19,1.07,0.17,1.59l-0.32,6.38l19.17-5.52c2.84-0.81,5.79,0.83,6.61,3.67 c0.81,2.84-0.83,5.79-3.67,6.61l-26.02,7.5c-0.64,0.23-1.34,0.34-2.06,0.31c-2.95-0.14-5.23-2.65-5.1-5.6l0.33-6.58L27.88,75.18 L27.88,75.18z M78.09,26.48H30.47c-5.4,0-10.31,2.22-13.88,5.78c-3.6,3.6-5.84,8.59-5.84,14.1v46.21c0,5.51,2.24,10.5,5.84,14.1 c3.57,3.57,8.48,5.78,13.88,5.78h47.61c5.4,0,10.31-2.22,13.88-5.78c3.6-3.6,5.84-8.59,5.84-14.1V46.36c0-5.51-2.24-10.5-5.84-14.1 C88.4,28.69,83.49,26.48,78.09,26.48L78.09,26.48z" }) })
}), So = (e) => /* @__PURE__ */ g("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 122.14 122.88",
	style: { enableBackground: "new 0 0 122.14 122.88" },
	xmlSpace: "preserve",
	fill: "#fff",
	...e,
	children: /* @__PURE__ */ g("g", { children: /* @__PURE__ */ g("path", { d: "M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" }) })
}), Co = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("path", {
		d: "M0.003125 15.4988C0.04375 15.1957 0.075 14.8895 0.128125 14.5895C0.5375 12.3863 1.6875 10.6645 3.5125 9.36758C4.775 10.5645 6.2625 11.1957 8 11.1926C9.73125 11.1926 11.2156 10.5676 12.4906 9.36133C12.7438 9.56133 13.0094 9.75195 13.2531 9.96758C14.7906 11.3332 15.6969 13.0363 15.9438 15.0832C15.9594 15.2207 15.9812 15.3613 16 15.4988C16 15.6645 16 15.8332 16 15.9988C10.6656 15.9988 5.33437 15.9988 0 15.9988C0.003125 15.8332 0.003125 15.6645 0.003125 15.4988Z",
		fill: "white"
	}), /* @__PURE__ */ g("path", {
		d: "M8.37828 -0.000976562C8.69391 0.0615234 9.01578 0.102148 9.32203 0.189648C11.197 0.711523 12.5845 2.3709 12.7783 4.31152C13.047 7.00215 11.072 9.36465 8.36891 9.58652C5.93453 9.78965 3.69391 8.05527 3.28141 5.6459C2.83766 3.0709 4.44703 0.670898 7.00015 0.105273C7.2064 0.0583984 7.41891 0.0333984 7.62828 -0.000976562C7.87828 -0.000976563 8.12828 -0.000976562 8.37828 -0.000976562Z",
		fill: "white"
	})]
});
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function wo(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = wo(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function To() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = wo(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/tailwind-merge@3.6.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var Eo = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, Do = (e, t) => ({
	classGroupId: e,
	validator: t
}), Oo = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), ko = "-", Ao = [], jo = "arbitrary..", Mo = (e) => {
	let t = Fo(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Po(e);
			let n = e.split(ko);
			return No(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? Eo(i, t) : t : i || Ao;
			}
			return n[e] || Ao;
		}
	};
}, No = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = No(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(ko) : e.slice(t).join(ko), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Po = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? jo + r : void 0;
})(), Fo = (e) => {
	let { theme: t, classGroups: n } = e;
	return Io(n, t);
}, Io = (e, t) => {
	let n = Oo();
	for (let r in e) {
		let i = e[r];
		Lo(i, n, r, t);
	}
	return n;
}, Lo = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Ro(i, t, n, r);
	}
}, Ro = (e, t, n, r) => {
	if (typeof e == "string") {
		zo(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Bo(e, t, n, r);
		return;
	}
	Vo(e, t, n, r);
}, zo = (e, t, n) => {
	let r = e === "" ? t : Ho(t, e);
	r.classGroupId = n;
}, Bo = (e, t, n, r) => {
	if (Uo(e)) {
		Lo(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(Do(n, e));
}, Vo = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Lo(o, Ho(t, a), n, r);
	}
}, Ho = (e, t) => {
	let n = e, r = t.split(ko), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = Oo(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, Uo = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Wo = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, Go = "!", Ko = ":", qo = [], Jo = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), Yo = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === Ko) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(Go) ? (c = s.slice(0, -1), l = !0) : s.startsWith(Go) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Jo(t, l, c, u);
	};
	if (t) {
		let e = t + Ko, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Jo(qo, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Xo = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, Zo = (e) => ({
	cache: Wo(e.cacheSize),
	parseClassName: Yo(e),
	sortModifiers: Xo(e),
	postfixLookupClassGroupIds: Qo(e),
	...Mo(e)
}), Qo = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, $o = /\s+/, es = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split($o), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + Go : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, ts = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = ns(n)) && (i && (i += " "), i += r);
	return i;
}, ns = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = ns(e[r])) && (n && (n += " "), n += t);
	return n;
}, rs = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = Zo(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = es(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(ts(...e));
}, is = [], as = (e) => {
	let t = (t) => t[e] || is;
	return t.isThemeGetter = !0, t;
}, os = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, ss = /^\((?:(\w[\w-]*):)?(.+)\)$/i, cs = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, ls = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, us = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ds = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, fs = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ps = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ms = (e) => cs.test(e), X = (e) => !!e && !Number.isNaN(Number(e)), hs = (e) => !!e && Number.isInteger(Number(e)), gs = (e) => e.endsWith("%") && X(e.slice(0, -1)), _s = (e) => ls.test(e), vs = () => !0, ys = (e) => us.test(e) && !ds.test(e), bs = () => !1, xs = (e) => fs.test(e), Ss = (e) => ps.test(e), Cs = (e) => !Z(e) && !Q(e), ws = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Ts = (e) => Bs(e, Ws, bs), Z = (e) => os.test(e), Es = (e) => Bs(e, Gs, ys), Ds = (e) => Bs(e, Ks, X), Os = (e) => Bs(e, Js, vs), ks = (e) => Bs(e, qs, bs), As = (e) => Bs(e, Hs, bs), js = (e) => Bs(e, Us, Ss), Ms = (e) => Bs(e, Ys, xs), Q = (e) => ss.test(e), Ns = (e) => Vs(e, Gs), Ps = (e) => Vs(e, qs), Fs = (e) => Vs(e, Hs), Is = (e) => Vs(e, Ws), Ls = (e) => Vs(e, Us), Rs = (e) => Vs(e, Ys, !0), zs = (e) => Vs(e, Js, !0), Bs = (e, t, n) => {
	let r = os.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Vs = (e, t, n = !1) => {
	let r = ss.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Hs = (e) => e === "position" || e === "percentage", Us = (e) => e === "image" || e === "url", Ws = (e) => e === "length" || e === "size" || e === "bg-size", Gs = (e) => e === "length", Ks = (e) => e === "number", qs = (e) => e === "family-name", Js = (e) => e === "number" || e === "weight", Ys = (e) => e === "shadow", Xs = /*#__PURE__*/ rs(() => {
	let e = as("color"), t = as("font"), n = as("text"), r = as("font-weight"), i = as("tracking"), a = as("leading"), o = as("breakpoint"), s = as("container"), c = as("spacing"), l = as("radius"), u = as("shadow"), d = as("inset-shadow"), f = as("text-shadow"), p = as("drop-shadow"), m = as("blur"), h = as("perspective"), g = as("aspect"), _ = as("ease"), v = as("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		Q,
		Z
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		Q,
		Z,
		c
	], T = () => [
		ms,
		"full",
		"auto",
		...w()
	], E = () => [
		hs,
		"none",
		"subgrid",
		Q,
		Z
	], D = () => [
		"auto",
		{ span: [
			"full",
			hs,
			Q,
			Z
		] },
		hs,
		Q,
		Z
	], O = () => [
		hs,
		"auto",
		Q,
		Z
	], k = () => [
		"auto",
		"min",
		"max",
		"fr",
		Q,
		Z
	], A = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], j = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], M = () => ["auto", ...w()], N = () => [
		ms,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], P = () => [
		ms,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], ee = () => [
		ms,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], F = () => [
		e,
		Q,
		Z
	], te = () => [
		...b(),
		Fs,
		As,
		{ position: [Q, Z] }
	], ne = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], I = () => [
		"auto",
		"cover",
		"contain",
		Is,
		Ts,
		{ size: [Q, Z] }
	], L = () => [
		gs,
		Ns,
		Es
	], R = () => [
		"",
		"none",
		"full",
		l,
		Q,
		Z
	], z = () => [
		"",
		X,
		Ns,
		Es
	], B = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], V = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], H = () => [
		X,
		gs,
		Fs,
		As
	], re = () => [
		"",
		"none",
		m,
		Q,
		Z
	], ie = () => [
		"none",
		X,
		Q,
		Z
	], ae = () => [
		"none",
		X,
		Q,
		Z
	], oe = () => [
		X,
		Q,
		Z
	], U = () => [
		ms,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [_s],
			breakpoint: [_s],
			color: [vs],
			container: [_s],
			"drop-shadow": [_s],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Cs],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [_s],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [_s],
			shadow: [_s],
			spacing: ["px", X],
			text: [_s],
			"text-shadow": [_s],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				ms,
				Z,
				Q,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Q,
				Z
			] }],
			"container-named": [ws],
			columns: [{ columns: [
				X,
				Z,
				Q,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				hs,
				"auto",
				Q,
				Z
			] }],
			basis: [{ basis: [
				ms,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				X,
				ms,
				"auto",
				"initial",
				"none",
				Z
			] }],
			grow: [{ grow: [
				"",
				X,
				Q,
				Z
			] }],
			shrink: [{ shrink: [
				"",
				X,
				Q,
				Z
			] }],
			order: [{ order: [
				hs,
				"first",
				"last",
				"none",
				Q,
				Z
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": O() }],
			"col-end": [{ "col-end": O() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": O() }],
			"row-end": [{ "row-end": O() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": k() }],
			"auto-rows": [{ "auto-rows": k() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...A(), "normal"] }],
			"justify-items": [{ "justify-items": [...j(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...j()] }],
			"align-content": [{ content: ["normal", ...A()] }],
			"align-items": [{ items: [...j(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...j(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": A() }],
			"place-items": [{ "place-items": [...j(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...j()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: M() }],
			mx: [{ mx: M() }],
			my: [{ my: M() }],
			ms: [{ ms: M() }],
			me: [{ me: M() }],
			mbs: [{ mbs: M() }],
			mbe: [{ mbe: M() }],
			mt: [{ mt: M() }],
			mr: [{ mr: M() }],
			mb: [{ mb: M() }],
			ml: [{ ml: M() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: N() }],
			"inline-size": [{ inline: ["auto", ...P()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...P()] }],
			"max-inline-size": [{ "max-inline": ["none", ...P()] }],
			"block-size": [{ block: ["auto", ...ee()] }],
			"min-block-size": [{ "min-block": ["auto", ...ee()] }],
			"max-block-size": [{ "max-block": ["none", ...ee()] }],
			w: [{ w: [
				s,
				"screen",
				...N()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...N()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...N()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...N()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...N()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...N()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Ns,
				Es
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				zs,
				Os
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				gs,
				Z
			] }],
			"font-family": [{ font: [
				Ps,
				ks,
				t
			] }],
			"font-features": [{ "font-features": [Z] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Q,
				Z
			] }],
			"line-clamp": [{ "line-clamp": [
				X,
				"none",
				Q,
				Ds
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				Q,
				Z
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Q,
				Z
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: F() }],
			"text-color": [{ text: F() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...B(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				X,
				"from-font",
				"auto",
				Q,
				Es
			] }],
			"text-decoration-color": [{ decoration: F() }],
			"underline-offset": [{ "underline-offset": [
				X,
				"auto",
				Q,
				Z
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				hs,
				Q,
				Z
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Q,
				Z
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Q,
				Z
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: te() }],
			"bg-repeat": [{ bg: ne() }],
			"bg-size": [{ bg: I() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						hs,
						Q,
						Z
					],
					radial: [
						"",
						Q,
						Z
					],
					conic: [
						hs,
						Q,
						Z
					]
				},
				Ls,
				js
			] }],
			"bg-color": [{ bg: F() }],
			"gradient-from-pos": [{ from: L() }],
			"gradient-via-pos": [{ via: L() }],
			"gradient-to-pos": [{ to: L() }],
			"gradient-from": [{ from: F() }],
			"gradient-via": [{ via: F() }],
			"gradient-to": [{ to: F() }],
			rounded: [{ rounded: R() }],
			"rounded-s": [{ "rounded-s": R() }],
			"rounded-e": [{ "rounded-e": R() }],
			"rounded-t": [{ "rounded-t": R() }],
			"rounded-r": [{ "rounded-r": R() }],
			"rounded-b": [{ "rounded-b": R() }],
			"rounded-l": [{ "rounded-l": R() }],
			"rounded-ss": [{ "rounded-ss": R() }],
			"rounded-se": [{ "rounded-se": R() }],
			"rounded-ee": [{ "rounded-ee": R() }],
			"rounded-es": [{ "rounded-es": R() }],
			"rounded-tl": [{ "rounded-tl": R() }],
			"rounded-tr": [{ "rounded-tr": R() }],
			"rounded-br": [{ "rounded-br": R() }],
			"rounded-bl": [{ "rounded-bl": R() }],
			"border-w": [{ border: z() }],
			"border-w-x": [{ "border-x": z() }],
			"border-w-y": [{ "border-y": z() }],
			"border-w-s": [{ "border-s": z() }],
			"border-w-e": [{ "border-e": z() }],
			"border-w-bs": [{ "border-bs": z() }],
			"border-w-be": [{ "border-be": z() }],
			"border-w-t": [{ "border-t": z() }],
			"border-w-r": [{ "border-r": z() }],
			"border-w-b": [{ "border-b": z() }],
			"border-w-l": [{ "border-l": z() }],
			"divide-x": [{ "divide-x": z() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": z() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...B(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...B(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: F() }],
			"border-color-x": [{ "border-x": F() }],
			"border-color-y": [{ "border-y": F() }],
			"border-color-s": [{ "border-s": F() }],
			"border-color-e": [{ "border-e": F() }],
			"border-color-bs": [{ "border-bs": F() }],
			"border-color-be": [{ "border-be": F() }],
			"border-color-t": [{ "border-t": F() }],
			"border-color-r": [{ "border-r": F() }],
			"border-color-b": [{ "border-b": F() }],
			"border-color-l": [{ "border-l": F() }],
			"divide-color": [{ divide: F() }],
			"outline-style": [{ outline: [
				...B(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				X,
				Q,
				Z
			] }],
			"outline-w": [{ outline: [
				"",
				X,
				Ns,
				Es
			] }],
			"outline-color": [{ outline: F() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Rs,
				Ms
			] }],
			"shadow-color": [{ shadow: F() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Rs,
				Ms
			] }],
			"inset-shadow-color": [{ "inset-shadow": F() }],
			"ring-w": [{ ring: z() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: F() }],
			"ring-offset-w": [{ "ring-offset": [X, Es] }],
			"ring-offset-color": [{ "ring-offset": F() }],
			"inset-ring-w": [{ "inset-ring": z() }],
			"inset-ring-color": [{ "inset-ring": F() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Rs,
				Ms
			] }],
			"text-shadow-color": [{ "text-shadow": F() }],
			opacity: [{ opacity: [
				X,
				Q,
				Z
			] }],
			"mix-blend": [{ "mix-blend": [
				...V(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": V() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [X] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": H() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": H() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": F() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": F() }],
			"mask-image-t-from-pos": [{ "mask-t-from": H() }],
			"mask-image-t-to-pos": [{ "mask-t-to": H() }],
			"mask-image-t-from-color": [{ "mask-t-from": F() }],
			"mask-image-t-to-color": [{ "mask-t-to": F() }],
			"mask-image-r-from-pos": [{ "mask-r-from": H() }],
			"mask-image-r-to-pos": [{ "mask-r-to": H() }],
			"mask-image-r-from-color": [{ "mask-r-from": F() }],
			"mask-image-r-to-color": [{ "mask-r-to": F() }],
			"mask-image-b-from-pos": [{ "mask-b-from": H() }],
			"mask-image-b-to-pos": [{ "mask-b-to": H() }],
			"mask-image-b-from-color": [{ "mask-b-from": F() }],
			"mask-image-b-to-color": [{ "mask-b-to": F() }],
			"mask-image-l-from-pos": [{ "mask-l-from": H() }],
			"mask-image-l-to-pos": [{ "mask-l-to": H() }],
			"mask-image-l-from-color": [{ "mask-l-from": F() }],
			"mask-image-l-to-color": [{ "mask-l-to": F() }],
			"mask-image-x-from-pos": [{ "mask-x-from": H() }],
			"mask-image-x-to-pos": [{ "mask-x-to": H() }],
			"mask-image-x-from-color": [{ "mask-x-from": F() }],
			"mask-image-x-to-color": [{ "mask-x-to": F() }],
			"mask-image-y-from-pos": [{ "mask-y-from": H() }],
			"mask-image-y-to-pos": [{ "mask-y-to": H() }],
			"mask-image-y-from-color": [{ "mask-y-from": F() }],
			"mask-image-y-to-color": [{ "mask-y-to": F() }],
			"mask-image-radial": [{ "mask-radial": [Q, Z] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": H() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": H() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": F() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": F() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [X] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": H() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": H() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": F() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": F() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: te() }],
			"mask-repeat": [{ mask: ne() }],
			"mask-size": [{ mask: I() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Q,
				Z
			] }],
			filter: [{ filter: [
				"",
				"none",
				Q,
				Z
			] }],
			blur: [{ blur: re() }],
			brightness: [{ brightness: [
				X,
				Q,
				Z
			] }],
			contrast: [{ contrast: [
				X,
				Q,
				Z
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Rs,
				Ms
			] }],
			"drop-shadow-color": [{ "drop-shadow": F() }],
			grayscale: [{ grayscale: [
				"",
				X,
				Q,
				Z
			] }],
			"hue-rotate": [{ "hue-rotate": [
				X,
				Q,
				Z
			] }],
			invert: [{ invert: [
				"",
				X,
				Q,
				Z
			] }],
			saturate: [{ saturate: [
				X,
				Q,
				Z
			] }],
			sepia: [{ sepia: [
				"",
				X,
				Q,
				Z
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Q,
				Z
			] }],
			"backdrop-blur": [{ "backdrop-blur": re() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				X,
				Q,
				Z
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				X,
				Q,
				Z
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				X,
				Q,
				Z
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				X,
				Q,
				Z
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				X,
				Q,
				Z
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				X,
				Q,
				Z
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				X,
				Q,
				Z
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				X,
				Q,
				Z
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Q,
				Z
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				X,
				"initial",
				Q,
				Z
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				Q,
				Z
			] }],
			delay: [{ delay: [
				X,
				Q,
				Z
			] }],
			animate: [{ animate: [
				"none",
				v,
				Q,
				Z
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Q,
				Z
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ie() }],
			"rotate-x": [{ "rotate-x": ie() }],
			"rotate-y": [{ "rotate-y": ie() }],
			"rotate-z": [{ "rotate-z": ie() }],
			scale: [{ scale: ae() }],
			"scale-x": [{ "scale-x": ae() }],
			"scale-y": [{ "scale-y": ae() }],
			"scale-z": [{ "scale-z": ae() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: oe() }],
			"skew-x": [{ "skew-x": oe() }],
			"skew-y": [{ "skew-y": oe() }],
			transform: [{ transform: [
				Q,
				Z,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: U() }],
			"translate-x": [{ "translate-x": U() }],
			"translate-y": [{ "translate-y": U() }],
			"translate-z": [{ "translate-z": U() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				hs,
				Q,
				Z
			] }],
			accent: [{ accent: F() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: F() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Q,
				Z
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": F() }],
			"scrollbar-track-color": [{ "scrollbar-track": F() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Q,
				Z
			] }],
			fill: [{ fill: ["none", ...F()] }],
			"stroke-w": [{ stroke: [
				X,
				Ns,
				Es,
				Ds
			] }],
			stroke: [{ stroke: ["none", ...F()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region ../ui/dist/lib/utils.js
function $(...e) {
	return Xs(To(e));
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectWithoutPropertiesLoose.js
function Zs(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.includes(r)) continue;
		n[r] = e[r];
	}
	return n;
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectWithoutProperties.js
function Qs(e, t) {
	if (e == null) return {};
	var n, r, i = Zs(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/typeof.js
function $s(e) {
	"@babel/helpers - typeof";
	return $s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, $s(e);
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/toPrimitive.js
function ec(e, t) {
	if ($s(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if ($s(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/toPropertyKey.js
function tc(e) {
	var t = ec(e, "string");
	return $s(t) == "symbol" ? t : t + "";
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/defineProperty.js
function nc(e, t, n) {
	return (t = tc(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectSpread2.js
function rc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ic(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? rc(Object(n), !0).forEach(function(t) {
			nc(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectDestructuringEmpty.js
function ac(e) {
	if (e == null) throw TypeError("Cannot destructure " + e);
}
//#endregion
//#region ../ui/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/extends.js
function oc() {
	return oc = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, oc.apply(null, arguments);
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+primitive@1.1.7/node_modules/@radix-ui/primitive/dist/index.mjs
var sc = Object.defineProperty, cc = (e, t) => sc(e, "name", {
	value: t,
	configurable: !0
}), lc = !!(typeof window < "u" && window.document && window.document.createElement);
function uc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ cc(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
cc(uc, "composeEventHandlers");
function dc(e) {
	if (!lc) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
cc(dc, "getOwnerWindow");
function fc(e) {
	if (!lc) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
cc(fc, "getOwnerDocument");
function pc(e, t = !1) {
	let { activeElement: n } = fc(e);
	if (!n?.nodeName) return null;
	if (mc(n) && n.contentDocument) return pc(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = fc(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
cc(pc, "getActiveElement");
function mc(e) {
	return e.tagName === "IFRAME";
}
cc(mc, "isFrame");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-dismissable-layer@1.1.19_@types+react-dom@18.3.7_@types+react@18.3.31___4f2024a88a120e800aa2287adeb24710/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var hc = Object.defineProperty, gc = (e, t) => hc(e, "name", {
	value: t,
	configurable: !0
}), _c = "dismissableLayer.update", vc = "dismissableLayer.pointerDownOutside", yc = "dismissableLayer.focusOutside", bc, xc = r.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Sc = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ gc(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: i = !1, onEscapeKeyDown: a, onPointerDownOutside: o, onFocusOutside: s, onInteractOutside: c, onDismiss: l, ...u } = e, d = r.useContext(xc), [f, p] = r.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, h] = r.useState({}), _ = Ea(t, p), v = Array.from(d.layers), [y] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), b = y ? v.indexOf(y) : -1, x = f ? v.indexOf(f) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, w = r.useRef(!1), T = Tc((e) => {
		o?.(e), c?.(e), e.defaultPrevented || l?.();
	}, {
		ownerDocument: m,
		deferPointerDownOutside: i,
		isDeferredPointerDownOutsideRef: w,
		dismissableSurfaces: d.dismissableSurfaces,
		shouldHandlePointerDownOutside: r.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...d.branches].some((t) => t.contains(e));
			return C && !t;
		}, [d.branches, C])
	}), E = Ec((e) => {
		if (i && w.current) return;
		let t = e.target;
		[...d.branches].some((e) => e.contains(t)) || (s?.(e), c?.(e), e.defaultPrevented || l?.());
	}, m), D = f ? x === v.length - 1 : !1, O = ba((e) => {
		e.key === "Escape" && (a?.(e), !e.defaultPrevented && l && (e.preventDefault(), l()));
	});
	return r.useEffect(() => {
		if (D) return m.addEventListener("keydown", O, { capture: !0 }), () => m.removeEventListener("keydown", O, { capture: !0 });
	}, [
		m,
		D,
		O
	]), r.useEffect(() => {
		if (f) return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (bc = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), Dc(), () => {
			n && (d.layersWithOutsidePointerEventsDisabled.delete(f), d.layersWithOutsidePointerEventsDisabled.size === 0 && (m.body.style.pointerEvents = bc));
		};
	}, [
		f,
		m,
		n,
		d
	]), r.useEffect(() => () => {
		f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), Dc());
	}, [f, d]), r.useEffect(() => {
		let e = /* @__PURE__ */ gc(() => h({}), "handleUpdate");
		return document.addEventListener(_c, e), () => document.removeEventListener(_c, e);
	}, []), /* @__PURE__ */ g(Wa.div, {
		...u,
		ref: _,
		style: {
			pointerEvents: S ? C ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: uc(e.onFocusCapture, E.onFocusCapture),
		onBlurCapture: uc(e.onBlurCapture, E.onBlurCapture),
		onPointerDownCapture: uc(e.onPointerDownCapture, T.onPointerDownCapture)
	});
}, "DismissableLayer"));
function Cc() {
	let e = r.useContext(xc), [t, n] = r.useState(null);
	return r.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
gc(Cc, "useDismissableLayerSurface");
var wc = /* @__PURE__ */ gc(() => !0, "IS_TRUE");
function Tc(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: i = !1, isDeferredPointerDownOutsideRef: a, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = wc } = t, c = ba(e), l = r.useRef(!1), u = r.useRef(!1), d = r.useRef(/* @__PURE__ */ new Map()), f = r.useRef(() => {});
	return r.useEffect(() => {
		function e() {
			u.current = !1, a.current = !1, d.current.clear();
		}
		gc(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		gc(t, "isOutsideInteractionIntercepted");
		function r(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && f.current();
			}, 0);
		}
		gc(r, "handleInteractionCapture");
		function p(e) {
			u.current && d.current.set(e.type, !1);
		}
		gc(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ gc((r) => {
			if (r.target && !l.current) {
				let o = function() {
					n.removeEventListener("click", f.current);
					let r = t();
					e(), r || Oc(vc, c, p, { discrete: !0 });
				};
				if (gc(o, "handleAndDispatchPointerDownOutsideEvent"), !s(r.target)) {
					n.removeEventListener("click", f.current), e(), l.current = !1;
					return;
				}
				let p = { originalEvent: r };
				u.current = !0, a.current = i && r.button === 0, d.current.clear(), !i || r.button !== 0 ? o() : (n.removeEventListener("click", f.current), f.current = o, n.addEventListener("click", f.current, { once: !0 }));
			} else n.removeEventListener("click", f.current), e();
			l.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, r, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", f.current);
			for (let e of h) n.removeEventListener(e, r, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		c,
		i,
		a,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ gc(() => l.current = !0, "onPointerDownCapture") };
}
gc(Tc, "usePointerDownOutside");
function Ec(e, t = globalThis?.document) {
	let n = ba(e), i = r.useRef(!1);
	return r.useEffect(() => {
		let e = /* @__PURE__ */ gc((e) => {
			e.target && !i.current && Oc(yc, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ gc(() => i.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ gc(() => i.current = !1, "onBlurCapture")
	};
}
gc(Ec, "useFocusOutside");
function Dc() {
	let e = new CustomEvent(_c);
	document.dispatchEvent(e);
}
gc(Dc, "dispatchUpdate");
function Oc(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? Ga(i, a) : i.dispatchEvent(a);
}
gc(Oc, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-id@1.1.4_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-id/dist/index.mjs
var kc = Object.defineProperty, Ac = (e, t) => kc(e, "name", {
	value: t,
	configurable: !0
}), jc = r.useId || (() => void 0), Mc = 0;
function Nc(e) {
	let [t, n] = r.useState(jc());
	return xa(() => {
		e || n((e) => e ?? String(Mc++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
Ac(Nc, "useId");
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var Pc = [
	"top",
	"right",
	"bottom",
	"left"
], Fc = Math.min, Ic = Math.max, Lc = Math.round, Rc = Math.floor, zc = (e) => ({
	x: e,
	y: e
}), Bc = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function Vc(e, t, n) {
	return Ic(e, Fc(t, n));
}
function Hc(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Uc(e) {
	return e.split("-")[0];
}
function Wc(e) {
	return e.split("-")[1];
}
function Gc(e) {
	return e === "x" ? "y" : "x";
}
function Kc(e) {
	return e === "y" ? "height" : "width";
}
function qc(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function Jc(e) {
	return Gc(qc(e));
}
function Yc(e, t, n) {
	n === void 0 && (n = !1);
	let r = Wc(e), i = Jc(e), a = Kc(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = il(o)), [o, il(o)];
}
function Xc(e) {
	let t = il(e);
	return [
		Zc(e),
		t,
		Zc(t)
	];
}
function Zc(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var Qc = ["left", "right"], $c = ["right", "left"], el = ["top", "bottom"], tl = ["bottom", "top"];
function nl(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? $c : Qc : t ? Qc : $c;
		case "left":
		case "right": return t ? el : tl;
		default: return [];
	}
}
function rl(e, t, n, r) {
	let i = Wc(e), a = nl(Uc(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Zc)))), a;
}
function il(e) {
	let t = Uc(e);
	return Bc[t] + e.slice(t.length);
}
function al(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function ol(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : al(e);
}
function sl(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function cl(e, t, n) {
	let { reference: r, floating: i } = e, a = qc(t), o = Jc(t), s = Kc(o), c = Uc(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = Wc(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function ll(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Hc(t, e), p = ol(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = sl(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = sl(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var ul = 50, dl = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: ll
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = cl(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < ul && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = cl(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, fl = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = Hc(e, t) || {};
		if (l == null) return {};
		let d = ol(u), f = {
			x: n,
			y: r
		}, p = Jc(i), m = Kc(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = Fc(d[_], T), D = Fc(d[v], T), O = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = Vc(E, k, O), j = !c.arrow && Wc(i) != null && k !== A && a.reference[m] / 2 - (k < E ? E : D) - h[m] / 2 < 0, M = j ? k < E ? k - E : k - O : 0;
		return {
			[p]: f[p] + M,
			data: {
				[p]: A,
				centerOffset: k - A - M,
				...j && { alignmentOffset: M }
			},
			reset: j
		};
	}
}), pl = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Hc(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = Uc(r), _ = qc(o), v = Uc(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [il(o)] : Xc(o)), x = p !== "none";
			!d && x && b.push(...rl(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Yc(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === qc(t) || T.every((e) => qc(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = qc(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function ml(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function hl(e) {
	return Pc.some((t) => e[t] >= 0);
}
var gl = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = Hc(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = ml(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: hl(e)
					} };
				}
				case "escaped": {
					let e = ml(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: hl(e)
					} };
				}
				default: return {};
			}
		}
	};
}, _l = /*#__PURE__*/ new Set(["left", "top"]);
async function vl(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Uc(n), s = Wc(n), c = qc(n) === "y", l = _l.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Hc(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var yl = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await vl(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, bl = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = Hc(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = qc(i), p = Gc(f), m = u[p], h = u[f], g = (e, t) => Vc(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, xl = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Hc(e, t), u = {
				x: n,
				y: r
			}, d = qc(i), f = Gc(d), p = u[f], m = u[d], h = Hc(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: h.mainAxis ?? 0,
				crossAxis: h.crossAxis ?? 0
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = _l.has(Uc(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Sl = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = Hc(e, t), c = await i.detectOverflow(t, s), l = Uc(n), u = Wc(n), d = qc(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c.top - c.bottom, _ = f - c.left - c.right, v = Fc(p - c[m], g), y = Fc(f - c[h], _), b = t.middlewareData.shift, x = !b, S = v, C = y;
			b != null && b.enabled.x && (C = _), b != null && b.enabled.y && (S = g), x && !u && (d ? C = f - 2 * Ic(c.left, c.right) : S = p - 2 * Ic(c.top, c.bottom)), await o({
				...t,
				availableWidth: C,
				availableHeight: S
			});
			let w = await i.getDimensions(a.floating);
			return f !== w.width || p !== w.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Cl() {
	return typeof window < "u";
}
function wl(e) {
	return Dl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tl(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function El(e) {
	return ((Dl(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Dl(e) {
	return Cl() ? e instanceof Node || e instanceof Tl(e).Node : !1;
}
function Ol(e) {
	return Cl() ? e instanceof Element || e instanceof Tl(e).Element : !1;
}
function kl(e) {
	return Cl() ? e instanceof HTMLElement || e instanceof Tl(e).HTMLElement : !1;
}
function Al(e) {
	return !Cl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tl(e).ShadowRoot;
}
function jl(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Hl(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function Ml(e) {
	return /^(table|td|th)$/.test(wl(e));
}
function Nl(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Pl = /transform|translate|scale|rotate|perspective|filter/, Fl = /paint|layout|strict|content/, Il = (e) => !!e && e !== "none", Ll;
function Rl(e) {
	let t = Ol(e) ? Hl(e) : e;
	return Il(t.transform) || Il(t.translate) || Il(t.scale) || Il(t.rotate) || Il(t.perspective) || !Bl() && (Il(t.backdropFilter) || Il(t.filter)) || Pl.test(t.willChange || "") || Fl.test(t.contain || "");
}
function zl(e) {
	let t = Wl(e);
	for (; kl(t) && !Vl(t);) {
		if (Rl(t)) return t;
		if (Nl(t)) return null;
		t = Wl(t);
	}
	return null;
}
function Bl() {
	return Ll ?? (Ll = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ll;
}
function Vl(e) {
	return /^(html|body|#document)$/.test(wl(e));
}
function Hl(e) {
	return Tl(e).getComputedStyle(e);
}
function Ul(e) {
	return Ol(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Wl(e) {
	if (wl(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Al(e) && e.host || El(e);
	return Al(t) ? t.host : t;
}
function Gl(e) {
	let t = Wl(e);
	return Vl(t) ? (e.ownerDocument || e).body : kl(t) && jl(t) ? t : Gl(t);
}
function Kl(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Gl(e), i = r === e.ownerDocument?.body, a = Tl(r);
	if (i) {
		let e = ql(a);
		return t.concat(a, a.visualViewport || [], jl(r) ? r : [], e && n ? Kl(e) : []);
	}
	return t.concat(r, Kl(r, [], n));
}
function ql(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function Jl(e) {
	let t = Hl(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = kl(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Lc(n) !== a || Lc(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Yl(e) {
	return Ol(e) ? e : e.contextElement;
}
function Xl(e) {
	let t = Yl(e);
	if (!kl(t)) return zc(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = Jl(t), o = (a ? Lc(n.width) : n.width) / r, s = (a ? Lc(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var Zl = /*#__PURE__*/ zc(0);
function Ql(e) {
	let t = Tl(e);
	return !Bl() || !t.visualViewport ? Zl : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function $l(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === Tl(e);
}
function eu(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Yl(e), o = zc(1);
	t && (r ? Ol(r) && (o = Xl(r)) : o = Xl(e));
	let s = $l(a, n, r) ? Ql(a) : zc(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = Tl(a), t = Ol(r) ? Tl(r) : r, n = e, i = ql(n);
		for (; i && t !== n;) {
			let e = Xl(i), t = i.getBoundingClientRect(), r = Hl(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Tl(i), i = ql(n);
		}
	}
	return sl({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function tu(e, t) {
	let n = Ul(e).scrollLeft;
	return t ? t.left + n : eu(El(e)).left + n;
}
function nu(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - tu(e, n),
		y: n.top + t.scrollTop
	};
}
function ru(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = El(r), s = t ? Nl(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = zc(1), u = zc(0), d = kl(r);
	if ((d || !a) && ((wl(r) !== "body" || jl(o)) && (c = Ul(r)), d)) {
		let e = eu(r);
		l = Xl(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? nu(o, c) : zc(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function iu(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function au(e) {
	let t = Ul(e), n = e.ownerDocument.body, r = Ic(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = Ic(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + tu(e), o = -t.scrollTop;
	return Hl(n).direction === "rtl" && (a += Ic(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var ou = 25;
function su(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = Tl(e), a = El(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !Bl() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (tu(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= ou && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function cu(e, t) {
	let n = eu(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Xl(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function lu(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = su(e, n, t);
	else if (t === "document") r = au(El(e));
	else if (Ol(t)) r = cu(t, n);
	else {
		let n = Ql(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return sl(r);
}
function uu(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Kl(e, [], !1).filter((e) => Ol(e) && wl(e) !== "body"), i = null, a = Hl(e).position === "fixed", o = a ? Wl(e) : e;
	for (; Ol(o) && !Vl(o);) {
		let e = Hl(o), t = Rl(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = Wl(o);
	}
	return t.set(e, r), r;
}
function du(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Nl(t) ? [] : uu(t, this._c) : [].concat(n), r], o = lu(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = lu(t, a[e], i);
		s = Ic(n.top, s), c = Fc(n.right, c), l = Fc(n.bottom, l), u = Ic(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function fu(e) {
	let { width: t, height: n } = Jl(e);
	return {
		width: t,
		height: n
	};
}
function pu(e, t, n) {
	let r = kl(t), i = El(t), a = n === "fixed", o = eu(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = zc(0);
	if ((r || !a) && ((wl(t) !== "body" || jl(i)) && (s = Ul(t)), r)) {
		let e = eu(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = tu(i));
	let l = i && !r && !a ? nu(i, s) : zc(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function mu(e) {
	return Hl(e).position === "static";
}
function hu(e, t) {
	if (!kl(e) || Hl(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return El(e) === n && (n = n.ownerDocument.body), n;
}
function gu(e, t) {
	let n = Tl(e);
	if (Nl(e)) return n;
	if (!kl(e)) {
		let t = Wl(e);
		for (; t && !Vl(t);) {
			if (Ol(t) && !mu(t)) return t;
			t = Wl(t);
		}
		return n;
	}
	let r = hu(e, t);
	for (; r && Ml(r) && mu(r);) r = hu(r, t);
	return r && Vl(r) && mu(r) && !Rl(r) ? n : r || zl(e) || n;
}
var _u = async function(e) {
	let t = this.getOffsetParent || gu, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: pu(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function vu(e) {
	return Hl(e).direction === "rtl";
}
var yu = {
	convertOffsetParentRelativeRectToViewportRelativeRect: ru,
	getDocumentElement: El,
	getClippingRect: du,
	getOffsetParent: gu,
	getElementRects: _u,
	getClientRects: iu,
	getDimensions: fu,
	getScale: Xl,
	isElement: Ol,
	isRTL: vu
};
function bu(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function xu(e, t, n) {
	let r = null, i, a = El(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = Rc(d), h = Rc(a.clientWidth - (u + f)), g = Rc(a.clientHeight - (d + p)), _ = Rc(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: Ic(0, Fc(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!bu(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = Tl(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function Su(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Yl(e), u = i || a ? [...l ? Kl(l) : [], ...t ? Kl(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? xu(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? eu(e) : null;
	c && g();
	function g() {
		let t = eu(e);
		h && !bu(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Cu = yl, wu = bl, Tu = pl, Eu = Sl, Du = gl, Ou = fl, ku = xl, Au = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...yu,
		...i.platform,
		_c: r
	};
	return dl(e, t, {
		...i,
		platform: a
	});
}, ju = typeof document < "u" ? d : function() {};
function Mu(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!Mu(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Mu(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Nu(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Pu(e, t) {
	let n = Nu(e);
	return Math.round(t * n) / n;
}
function Fu(e) {
	let t = r.useRef(e);
	return ju(() => {
		t.current = e;
	}), t;
}
function Iu(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: l, open: u } = e, [d, f] = r.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = r.useState(i);
	Mu(p, i) || m(i);
	let [h, g] = r.useState(null), [_, y] = r.useState(null), b = r.useCallback((e) => {
		e !== w.current && (w.current = e, g(e));
	}, []), x = r.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = o || h, C = s || _, w = r.useRef(null), T = r.useRef(null), E = r.useRef(d), D = l != null, O = Fu(l), k = Fu(a), A = Fu(u), j = r.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: p
		};
		k.current && (e.platform = k.current), Au(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !Mu(E.current, t) && (E.current = t, v.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		t,
		n,
		k,
		A
	]);
	ju(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let M = r.useRef(!1);
	ju(() => (M.current = !0, () => {
		M.current = !1;
	}), []), ju(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (O.current) return O.current(S, C, j);
			j();
		}
	}, [
		S,
		C,
		j,
		O,
		D
	]);
	let N = r.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), P = r.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), ee = r.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!P.floating) return e;
		let t = Pu(P.floating, d.x), r = Pu(P.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...Nu(P.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		c,
		P.floating,
		d.x,
		d.y
	]);
	return r.useMemo(() => ({
		...d,
		update: j,
		refs: N,
		elements: P,
		floatingStyles: ee
	}), [
		d,
		j,
		N,
		P,
		ee
	]);
}
var Lu = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Ou({
				element: r.current,
				padding: i
			}).fn(n) : r ? Ou({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Ru = (e, t) => {
	let n = Cu(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, zu = (e, t) => {
	let n = wu(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Bu = (e, t) => ({
	fn: ku(e).fn,
	options: [e, t]
}), Vu = (e, t) => {
	let n = Tu(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Hu = (e, t) => {
	let n = Eu(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Uu = (e, t) => {
	let n = Du(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Wu = (e, t) => {
	let n = Lu(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Gu = Object.defineProperty, Ku = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ ((e, t) => Gu(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { children: n, width: r = 10, height: i = 5, ...a } = e;
	return /* @__PURE__ */ g(Wa.svg, {
		...a,
		ref: t,
		width: r,
		height: i,
		viewBox: "0 0 30 10",
		preserveAspectRatio: "none",
		children: e.asChild ? n : /* @__PURE__ */ g("polygon", { points: "0,0 30,0 15,10" })
	});
}, "Arrow")), qu = Object.defineProperty, Ju = (e, t) => qu(e, "name", {
	value: t,
	configurable: !0
});
function Yu(e) {
	let [t, n] = r.useState(void 0);
	return xa(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		}
		n(void 0);
	}, [e]), t;
}
Ju(Yu, "useSize");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-popper@1.3.7_@types+react-dom@18.3.7_@types+react@18.3.31__@types+react_eb61390ffeb98719c4501fa966467838/node_modules/@radix-ui/react-popper/dist/index.mjs
var Xu = Object.defineProperty, Zu = (e, t) => Xu(e, "name", {
	value: t,
	configurable: !0
}), Qu = "Popper", [$u, ed] = /* @__PURE__ */ ga(Qu), [td, nd] = $u(Qu), rd = /* @__PURE__ */ Zu((e) => {
	let { __scopePopper: t, children: n } = e, [i, a] = r.useState(null), [o, s] = r.useState(void 0);
	return /* @__PURE__ */ g(td, {
		scope: t,
		anchor: i,
		onAnchorChange: a,
		placementState: o,
		setPlacementState: s,
		children: n
	});
}, "Popper"), id = "PopperAnchor", ad = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Zu(function(e, t) {
	let { __scopePopper: n, virtualRef: i, ...a } = e, o = nd(id, n), s = r.useRef(null), c = o.onAnchorChange, l = Ea(t, r.useCallback((e) => {
		s.current = e, e && c(e);
	}, [c])), u = r.useRef(null);
	r.useEffect(() => {
		if (!i) return;
		let e = u.current;
		u.current = i.current, e !== u.current && c(u.current);
	});
	let d = o.placementState && hd(o.placementState), f = d?.[0], p = d?.[1];
	return i ? null : /* @__PURE__ */ g(Wa.div, {
		"data-radix-popper-side": f,
		"data-radix-popper-align": p,
		...a,
		ref: l
	});
}, "PopperAnchor")), od = "PopperContent", [sd, cd] = $u(od), ld = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Zu(function(e, t) {
	let { __scopePopper: n, side: i = "bottom", sideOffset: a = 0, align: o = "center", alignOffset: s = 0, arrowPadding: c = 0, avoidCollisions: l = !0, collisionBoundary: u = [], collisionPadding: d = 0, sticky: f = "partial", hideWhenDetached: p = !1, updatePositionStrategy: m = "optimized", onPlaced: h, ..._ } = e, v = nd(od, n), [y, b] = r.useState(null), x = Ea(t, b), [S, C] = r.useState(null), w = Yu(S), T = w?.width ?? 0, E = w?.height ?? 0, D = i + (o === "center" ? "" : "-" + o), O = typeof d == "number" ? d : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...d
	}, k = Array.isArray(u) ? u : [u], A = k.length > 0, j = {
		padding: O,
		boundary: k.filter(pd),
		altBoundary: A
	}, { refs: M, floatingStyles: N, placement: P, isPositioned: ee, middlewareData: F } = Iu({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: /* @__PURE__ */ Zu((...e) => Su(...e, { animationFrame: m === "always" }), "whileElementsMounted"),
		elements: { reference: v.anchor },
		middleware: [
			Ru({
				mainAxis: a + E,
				alignmentAxis: s
			}),
			l && zu({
				mainAxis: !0,
				crossAxis: !1,
				limiter: f === "partial" ? Bu() : void 0,
				...j
			}),
			l && Vu({ ...j }),
			Hu({
				...j,
				apply: /* @__PURE__ */ Zu(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			S && Wu({
				element: S,
				padding: c
			}),
			md({
				arrowWidth: T,
				arrowHeight: E
			}),
			p && Uu({
				strategy: "referenceHidden",
				...j,
				boundary: A ? j.boundary : void 0
			})
		]
	}), te = v.setPlacementState;
	xa(() => (te(P), () => {
		te(void 0);
	}), [P, te]);
	let [ne, I] = hd(P), L = ba(h);
	xa(() => {
		ee && L?.();
	}, [ee, L]);
	let R = F.arrow?.x, z = F.arrow?.y, B = F.arrow?.centerOffset !== 0, [V, H] = r.useState();
	return xa(() => {
		y && H(window.getComputedStyle(y).zIndex);
	}, [y]), /* @__PURE__ */ g("div", {
		ref: M.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...N,
			transform: ee ? N.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: V,
			"--radix-popper-transform-origin": [F.transformOrigin?.x, F.transformOrigin?.y].join(" "),
			...F.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: e.dir,
		children: /* @__PURE__ */ g(sd, {
			scope: n,
			placedSide: ne,
			placedAlign: I,
			onArrowChange: C,
			arrowX: R,
			arrowY: z,
			shouldHideArrow: B,
			children: /* @__PURE__ */ g(Wa.div, {
				"data-side": ne,
				"data-align": I,
				..._,
				ref: x,
				style: {
					..._.style,
					animation: ee ? _.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent")), ud = "PopperArrow", dd = {
	top: "bottom",
	right: "left",
	bottom: "top",
	left: "right"
}, fd = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Zu(function(e, t) {
	let { __scopePopper: n, ...r } = e, i = cd(ud, n), a = dd[i.placedSide];
	return /* @__PURE__ */ g("span", {
		ref: i.onArrowChange,
		style: {
			position: "absolute",
			left: i.arrowX,
			top: i.arrowY,
			[a]: 0,
			transformOrigin: {
				top: "",
				right: "0 0",
				bottom: "center 0",
				left: "100% 0"
			}[i.placedSide],
			transform: {
				top: "translateY(100%)",
				right: "translateY(50%) rotate(90deg) translateX(-50%)",
				bottom: "rotate(180deg)",
				left: "translateY(50%) rotate(-90deg) translateX(50%)"
			}[i.placedSide],
			visibility: i.shouldHideArrow ? "hidden" : void 0
		},
		children: /* @__PURE__ */ g(Ku, {
			...r,
			ref: t,
			style: {
				...r.style,
				display: "block"
			}
		})
	});
}, "PopperArrow"));
function pd(e) {
	return e !== null;
}
Zu(pd, "isNotNull");
var md = /* @__PURE__ */ Zu((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = hd(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function hd(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
Zu(hd, "getSideAndAlignFromPlacement");
var gd = rd, _d = ad, vd = ld, yd = fd, bd = Object.defineProperty, xd = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ ((e, t) => bd(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...i } = e, [a, o] = r.useState(!1);
	xa(() => o(!0), []);
	let s = n || a && globalThis?.document?.body;
	return s ? v.createPortal(/* @__PURE__ */ g(Wa.div, {
		...i,
		ref: t
	}), s) : null;
}, "Portal")), Sd = Object.defineProperty, Cd = (e, t) => Sd(e, "name", {
	value: t,
	configurable: !0
});
function wd(e, t) {
	return r.useReducer((e, n) => t[e][n] ?? e, e);
}
Cd(wd, "useStateMachine");
var Td = /* @__PURE__ */ Cd((e) => {
	let { present: t, children: n } = e, i = Ed(t), a = typeof n == "function" ? n({ present: i.isPresent }) : r.Children.only(n), o = Od(i.ref, Ad(a));
	return typeof n == "function" || i.isPresent ? r.cloneElement(a, { ref: o }) : null;
}, "Presence");
function Ed(e) {
	let [t, n] = r.useState(), i = r.useRef(null), a = r.useRef(e), o = r.useRef("none"), s = r.useRef(void 0), [c, l] = wd(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return r.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? kd(i.current), s.current = void 0) : o.current = "none";
	}, [c]), xa(() => {
		let t = i.current, n = a.current;
		if (n !== e) {
			let r = o.current, i = kd(t);
			e ? (s.current = i, l("MOUNT")) : i === "none" || t?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
		}
	}, [e, l]), xa(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ Cd((r) => {
				let o = kd(i.current).includes(CSS.escape(r.animationName));
				if (r.target === t && o && (l("ANIMATION_END"), !a.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Cd((e) => {
				e.target === t && (o.current = kd(i.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", r), t.addEventListener("animationend", r), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", r), t.removeEventListener("animationend", r);
			};
		}
		l("ANIMATION_END");
	}, [t, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: r.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = kd(t);
			} else i.current = null;
			n(e);
		}, [])
	};
}
Cd(Ed, "usePresence");
function Dd(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Cd(Dd, "setRef");
function Od(...e) {
	let t = r.useRef(e);
	return t.current = e, r.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = Dd(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : Dd(n[e], null);
			}
		};
	}, []);
}
Cd(Od, "useStableComposedRefs");
function kd(e) {
	return e?.animationName || "none";
}
Cd(kd, "getAnimationName");
function Ad(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Cd(Ad, "getElementRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-effect-event@0.0.5_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var jd = Object.defineProperty, Md = (e, t) => jd(e, "name", {
	value: t,
	configurable: !0
}), Nd = r.useEffectEvent, Pd = r.useInsertionEffect;
function Fd(e) {
	if (typeof Nd == "function") return Nd(e);
	let t = r.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof Pd == "function" ? Pd(() => {
		t.current = e;
	}) : xa(() => {
		t.current = e;
	}), r.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Md(Fd, "useEffectEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.6_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Id = Object.defineProperty, Ld = (e, t) => Id(e, "name", {
	value: t,
	configurable: !0
}), Rd = r.useInsertionEffect || xa;
function zd({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ Ld(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = Bd({
		defaultProp: t,
		onChange: n
	}), c = e !== void 0;
	return [c ? e : a, r.useCallback((t) => {
		if (c) {
			let n = Vd(t) ? t(e) : t;
			n !== e && s.current?.(n);
		} else o(t);
	}, [
		c,
		e,
		o,
		s
	])];
}
Ld(zd, "useControllableState");
function Bd({ defaultProp: e, onChange: t }) {
	let [n, i] = r.useState(e), a = r.useRef(n), o = r.useRef(t);
	return Rd(() => {
		o.current = t;
	}, [t]), r.useEffect(() => {
		a.current !== n && (o.current?.(n), a.current = n);
	}, [n, a]), [
		n,
		i,
		o
	];
}
Ld(Bd, "useUncontrolledState");
function Vd(e) {
	return typeof e == "function";
}
Ld(Vd, "isFunction");
var Hd = Symbol("RADIX:SYNC_STATE");
function Ud(e, t, n, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = t, l = a !== void 0, u = Fd(s), d = [{
		...n,
		state: o
	}];
	i && d.push(i);
	let [f, p] = r.useReducer((t, n) => {
		if (n.type === Hd) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return l && !Object.is(r.state, t.state) && u(r.state), r;
	}, ...d), m = f.state, h = r.useRef(m);
	r.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = r.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return r.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: Hd,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
Ld(Ud, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-visually-hidden@1.2.11_@types+react-dom@18.3.7_@types+react@18.3.31__@t_642d100dd60f054d3c0d9c38ece6c812/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var Wd = Object.defineProperty, Gd = (e, t) => Wd(e, "name", {
	value: t,
	configurable: !0
}), Kd = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), qd = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Gd(function(e, t) {
	return /* @__PURE__ */ g(Wa.span, {
		...e,
		ref: t,
		style: {
			...Kd,
			...e.style
		}
	});
}, "VisuallyHidden")), Jd = Object.defineProperty, Yd = (e, t) => Jd(e, "name", {
	value: t,
	configurable: !0
}), [Xd, Zd] = /* @__PURE__ */ ga("Tooltip", [ed]), Qd = ed(), $d = "TooltipProvider", ef = 700, tf = "tooltip.open", [nf, rf] = Xd($d), af = /* @__PURE__ */ Yd((e) => {
	let { __scopeTooltip: t, delayDuration: n = ef, skipDelayDuration: i = 300, disableHoverableContent: a = !1, children: o } = e, s = r.useRef(!0), c = r.useRef(!1), l = r.useRef(0);
	return r.useEffect(() => {
		let e = l.current;
		return () => window.clearTimeout(e);
	}, []), /* @__PURE__ */ g(nf, {
		scope: t,
		isOpenDelayedRef: s,
		delayDuration: n,
		onOpen: r.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), s.current = !1);
		}, [i]),
		onClose: r.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), l.current = window.setTimeout(() => s.current = !0, i));
		}, [i]),
		isPointerInTransitRef: c,
		onPointerInTransitChange: r.useCallback((e) => {
			c.current = e;
		}, []),
		disableHoverableContent: a,
		children: o
	});
}, "TooltipProvider"), of = "Tooltip", [sf, cf] = Xd(of), lf = /* @__PURE__ */ Yd((e) => {
	let { __scopeTooltip: t, children: n, open: i, defaultOpen: a, onOpenChange: o, disableHoverableContent: s, delayDuration: c } = e, l = rf(of, e.__scopeTooltip), u = Qd(t), [d, f] = r.useState(null), [p, m] = r.useState(void 0), h = Nc(), _ = r.useRef(0), v = s ?? l.disableHoverableContent, y = c ?? l.delayDuration, b = r.useRef(!1), [x, S] = zd({
		prop: i,
		defaultProp: a ?? !1,
		onChange: /* @__PURE__ */ Yd((e) => {
			e ? (l.onOpen(), document.dispatchEvent(new CustomEvent(tf))) : l.onClose(), o?.(e);
		}, "onChange"),
		caller: of
	}), C = r.useMemo(() => x ? b.current ? "delayed-open" : "instant-open" : "closed", [x]), w = r.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, b.current = !1, S(!0);
	}, [S]), T = r.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, S(!1);
	}, [S]), E = r.useCallback(() => {
		window.clearTimeout(_.current), _.current = window.setTimeout(() => {
			b.current = !0, S(!0), _.current = 0;
		}, y);
	}, [y, S]);
	r.useEffect(() => () => {
		_.current && (window.clearTimeout(_.current), _.current = 0);
	}, []);
	let D = p ?? h;
	return /* @__PURE__ */ g(gd, {
		...u,
		children: /* @__PURE__ */ g(sf, {
			scope: t,
			contentId: D,
			setContentId: m,
			open: x,
			stateAttribute: C,
			trigger: d,
			onTriggerChange: f,
			onTriggerEnter: r.useCallback(() => {
				l.isOpenDelayedRef.current ? E() : w();
			}, [
				l.isOpenDelayedRef,
				E,
				w
			]),
			onTriggerLeave: r.useCallback(() => {
				v ? T() : (window.clearTimeout(_.current), _.current = 0);
			}, [T, v]),
			onOpen: w,
			onClose: T,
			disableHoverableContent: v,
			children: n
		})
	});
}, "Tooltip"), uf = "TooltipTrigger", df = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Yd(function(e, t) {
	let { __scopeTooltip: n, ...i } = e, a = cf(uf, n), o = rf(uf, n), s = Qd(n), c = Ea(t, r.useRef(null), a.onTriggerChange), l = r.useRef(!1), u = r.useRef(!1), d = r.useCallback(() => l.current = !1, []);
	return r.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ g(_d, {
		asChild: !0,
		...s,
		children: /* @__PURE__ */ g(Wa.button, {
			"aria-describedby": a.open ? a.contentId : void 0,
			"data-state": a.stateAttribute,
			...i,
			ref: c,
			onPointerMove: uc(e.onPointerMove, (e) => {
				e.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (a.onTriggerEnter(), u.current = !0);
			}),
			onPointerLeave: uc(e.onPointerLeave, () => {
				a.onTriggerLeave(), u.current = !1;
			}),
			onPointerDown: uc(e.onPointerDown, () => {
				a.open && a.onClose(), l.current = !0, document.addEventListener("pointerup", d, { once: !0 });
			}),
			onFocus: uc(e.onFocus, () => {
				l.current || a.onOpen();
			}),
			onBlur: uc(e.onBlur, a.onClose),
			onClick: uc(e.onClick, a.onClose)
		})
	});
}, "TooltipTrigger")), ff = "TooltipPortal", [pf, mf] = Xd(ff, { forceMount: void 0 }), hf = /* @__PURE__ */ Yd((e) => {
	let { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = cf(ff, t);
	return /* @__PURE__ */ g(pf, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ g(Td, {
			present: n || a.open,
			children: /* @__PURE__ */ g(xd, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "TooltipPortal"), gf = "TooltipContent", _f = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Yd(function(e, t) {
	let n = mf(gf, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = cf(gf, e.__scopeTooltip);
	return /* @__PURE__ */ g(Td, {
		present: r || o.open,
		children: o.disableHoverableContent ? /* @__PURE__ */ g(bf, {
			side: i,
			...a,
			ref: t
		}) : /* @__PURE__ */ g(vf, {
			side: i,
			...a,
			ref: t
		})
	});
}, "TooltipContent")), vf = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Yd(function(e, t) {
	let n = cf(gf, e.__scopeTooltip), i = rf(gf, e.__scopeTooltip), a = r.useRef(null), o = Ea(t, a), [s, c] = r.useState(null), { trigger: l, onClose: u } = n, d = a.current, { onPointerInTransitChange: f } = i, p = r.useCallback(() => {
		c(null), f(!1);
	}, [f]), m = r.useCallback((e, t) => {
		let n = e.currentTarget, r = {
			x: e.clientX,
			y: e.clientY
		}, i = Cf(r, Sf(r, n.getBoundingClientRect())), a = wf(t.getBoundingClientRect()), o = Ef([...i, ...a]);
		c(o), f(!0);
	}, [f]);
	return r.useEffect(() => () => p(), [p]), r.useEffect(() => {
		if (l && d) {
			let e = /* @__PURE__ */ Yd((e) => m(e, d), "handleTriggerLeave"), t = /* @__PURE__ */ Yd((e) => m(e, l), "handleContentLeave");
			return l.addEventListener("pointerleave", e), d.addEventListener("pointerleave", t), () => {
				l.removeEventListener("pointerleave", e), d.removeEventListener("pointerleave", t);
			};
		}
	}, [
		l,
		d,
		m,
		p
	]), r.useEffect(() => {
		if (s) {
			let e = /* @__PURE__ */ Yd((e) => {
				let t = e.target, n = {
					x: e.clientX,
					y: e.clientY
				}, r = l?.contains(t) || d?.contains(t), i = !Tf(n, s);
				r ? p() : i && (p(), u());
			}, "handleTrackPointerGrace");
			return document.addEventListener("pointermove", e), () => document.removeEventListener("pointermove", e);
		}
	}, [
		l,
		d,
		s,
		u,
		p
	]), /* @__PURE__ */ g(bf, {
		...e,
		ref: o
	});
}, "TooltipContentHoverable")), yf = /* @__PURE__ */ ja("TooltipContent"), bf = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Yd(function(e, t) {
	let { __scopeTooltip: n, children: i, "aria-label": a, id: o, onEscapeKeyDown: s, onPointerDownOutside: c, ...l } = e, u = cf(gf, n), d = Qd(n), { onClose: f } = u;
	r.useEffect(() => (document.addEventListener(tf, f), () => document.removeEventListener(tf, f)), [f]), r.useEffect(() => {
		if (u.trigger) {
			let e = /* @__PURE__ */ Yd((e) => {
				e.target instanceof Node && e.target.contains(u.trigger) && f();
			}, "handleScroll");
			return window.addEventListener("scroll", e, { capture: !0 }), () => window.removeEventListener("scroll", e, { capture: !0 });
		}
	}, [u.trigger, f]);
	let { setContentId: p } = u;
	return xa(() => (p(o), () => {
		p(void 0);
	}), [o, p]), /* @__PURE__ */ g(Sc, {
		asChild: !0,
		disableOutsidePointerEvents: !1,
		onEscapeKeyDown: s,
		onPointerDownOutside: c,
		onFocusOutside: (e) => e.preventDefault(),
		onDismiss: f,
		children: /* @__PURE__ */ _(vd, {
			"data-state": u.stateAttribute,
			role: a ? void 0 : "tooltip",
			id: a ? void 0 : u.contentId,
			...d,
			...l,
			ref: t,
			style: {
				...l.style,
				"--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
				"--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
				"--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
				"--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
				"--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
			},
			children: [/* @__PURE__ */ g(yf, { children: i }), a ? /* @__PURE__ */ g(qd, {
				id: u.contentId,
				role: "tooltip",
				children: a
			}) : null]
		})
	});
}, "TooltipContentImpl")), xf = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Yd(function(e, t) {
	let { __scopeTooltip: n, ...r } = e, i = Qd(n);
	return /* @__PURE__ */ g(yd, {
		...i,
		...r,
		ref: t
	});
}, "TooltipArrow"));
function Sf(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
Yd(Sf, "getExitSideFromRect");
function Cf(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right": r.push({
			x: e.x - n,
			y: e.y - n
		}, {
			x: e.x - n,
			y: e.y + n
		});
	}
	return r;
}
Yd(Cf, "getPaddedExitPoints");
function wf(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
Yd(wf, "getPointsFromRect");
function Tf(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
Yd(Tf, "isPointInPolygon");
function Ef(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), Df(t);
}
Yd(Ef, "getHull");
function Df(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t[t.length - 1], n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n[n.length - 1], t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
Yd(Df, "getHullPresorted");
var Of = af, kf = lf, Af = df, jf = hf, Mf = _f, Nf = xf, Pf = ["delayDuration"], Ff = [
	"className",
	"sideOffset",
	"children"
];
function If(e) {
	let { delayDuration: t = 0 } = e, n = Qs(e, Pf);
	return /* @__PURE__ */ g(Of, ic({
		"data-slot": "tooltip-provider",
		delayDuration: t
	}, n));
}
function Lf(e) {
	let t = oc({}, (ac(e), e));
	return /* @__PURE__ */ g(If, { children: /* @__PURE__ */ g(kf, ic({ "data-slot": "tooltip" }, t)) });
}
function Rf(e) {
	let t = oc({}, (ac(e), e));
	return /* @__PURE__ */ g(Af, ic({ "data-slot": "tooltip-trigger" }, t));
}
function zf(e) {
	let { className: t, sideOffset: n = 8, children: r } = e, i = Qs(e, Ff);
	return /* @__PURE__ */ g(jf, { children: /* @__PURE__ */ _(Mf, ic(ic({
		"data-slot": "tooltip-content",
		sideOffset: n,
		className: $("z-50 rounded-lg bg-[#1a1a1a] px-3 py-2 text-xs font-semibold leading-4 text-white text-center", "animate-in fade-in-0 zoom-in-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", t)
	}, i), {}, { children: [r, /* @__PURE__ */ g(Nf, { className: "fill-[#1a1a1a]" })] })) });
}
//#endregion
//#region lib/components/SkedCaptionPreview/CaptionCopyContext.tsx
var Bf = o({}), Vf = ({ children: e, value: t }) => {
	let n = { ...c(Bf) };
	for (let [e, r] of Object.entries(t)) r !== void 0 && (n[e] = r);
	return /* @__PURE__ */ g(Bf.Provider, {
		value: n,
		children: e
	});
}, Hf = () => c(Bf);
//#endregion
//#region ../../node_modules/.pnpm/interweave@13.1.1_react@18.3.1/node_modules/interweave/esm/bundle-7aab7250.js
function Uf(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var Wf = {
	a: {
		content: 9,
		self: !1,
		type: 105
	},
	address: {
		invalid: [
			"h1",
			"h2",
			"h3",
			"h4",
			"h5",
			"h6",
			"address",
			"article",
			"aside",
			"section",
			"div",
			"header",
			"footer"
		],
		self: !1
	},
	audio: { children: ["track", "source"] },
	br: {
		type: 9,
		void: !0
	},
	body: { content: 127 },
	button: {
		content: 8,
		type: 105
	},
	caption: {
		content: 1,
		parent: ["table"]
	},
	col: {
		parent: ["colgroup"],
		void: !0
	},
	colgroup: {
		children: ["col"],
		parent: ["table"]
	},
	details: {
		children: ["summary"],
		type: 97
	},
	dd: {
		content: 1,
		parent: ["dl"]
	},
	dl: {
		children: ["dt", "dd"],
		type: 1
	},
	dt: {
		content: 1,
		invalid: ["footer", "header"],
		parent: ["dl"]
	},
	figcaption: {
		content: 1,
		parent: ["figure"]
	},
	footer: { invalid: ["footer", "header"] },
	header: { invalid: ["footer", "header"] },
	hr: {
		type: 1,
		void: !0
	},
	img: { void: !0 },
	li: {
		content: 1,
		parent: [
			"ul",
			"ol",
			"menu"
		]
	},
	main: { self: !1 },
	ol: {
		children: ["li"],
		type: 1
	},
	picture: {
		children: ["source", "img"],
		type: 25
	},
	rb: { parent: ["ruby", "rtc"] },
	rp: { parent: ["ruby", "rtc"] },
	rt: {
		content: 8,
		parent: ["ruby", "rtc"]
	},
	rtc: {
		content: 8,
		parent: ["ruby"]
	},
	ruby: { children: [
		"rb",
		"rp",
		"rt",
		"rtc"
	] },
	source: {
		parent: [
			"audio",
			"video",
			"picture"
		],
		void: !0
	},
	summary: {
		content: 8,
		parent: ["details"]
	},
	table: {
		children: [
			"caption",
			"colgroup",
			"thead",
			"tbody",
			"tfoot",
			"tr"
		],
		type: 1
	},
	tbody: {
		parent: ["table"],
		children: ["tr"]
	},
	td: {
		content: 1,
		parent: ["tr"]
	},
	tfoot: {
		parent: ["table"],
		children: ["tr"]
	},
	th: {
		content: 1,
		parent: ["tr"]
	},
	thead: {
		parent: ["table"],
		children: ["tr"]
	},
	tr: {
		parent: [
			"table",
			"tbody",
			"thead",
			"tfoot"
		],
		children: ["th", "td"]
	},
	track: {
		parent: ["audio", "video"],
		void: !0
	},
	ul: {
		children: ["li"],
		type: 1
	},
	video: { children: ["track", "source"] },
	wbr: {
		type: 9,
		void: !0
	}
};
function Gf(e) {
	return (t) => {
		Wf[t] = {
			...e,
			...Wf[t]
		};
	};
}
[
	"address",
	"main",
	"div",
	"figure",
	"p",
	"pre"
].forEach(Gf({
	content: 1,
	type: 65
})), [
	"abbr",
	"b",
	"bdi",
	"bdo",
	"cite",
	"code",
	"data",
	"dfn",
	"em",
	"i",
	"kbd",
	"mark",
	"q",
	"ruby",
	"samp",
	"strong",
	"sub",
	"sup",
	"time",
	"u",
	"var"
].forEach(Gf({
	content: 8,
	type: 73
})), ["p", "pre"].forEach(Gf({
	content: 8,
	type: 65
})), [
	"s",
	"small",
	"span",
	"del",
	"ins"
].forEach(Gf({
	content: 8,
	type: 9
})), [
	"article",
	"aside",
	"footer",
	"header",
	"nav",
	"section",
	"blockquote"
].forEach(Gf({
	content: 1,
	type: 67
})), [
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6"
].forEach(Gf({
	content: 8,
	type: 69
})), [
	"audio",
	"canvas",
	"iframe",
	"img",
	"video"
].forEach(Gf({ type: 89 }));
var Kf = Object.freeze(Wf), qf = [
	"applet",
	"base",
	"body",
	"command",
	"embed",
	"frame",
	"frameset",
	"head",
	"html",
	"link",
	"meta",
	"noscript",
	"object",
	"script",
	"style",
	"title"
], Jf = Object.keys(Kf).filter((e) => e !== "canvas" && e !== "iframe"), Yf = Object.freeze({
	alt: 1,
	cite: 1,
	class: 1,
	colspan: 3,
	controls: 4,
	datetime: 1,
	default: 4,
	disabled: 4,
	dir: 1,
	height: 1,
	href: 1,
	id: 1,
	kind: 1,
	label: 1,
	lang: 1,
	loading: 1,
	loop: 4,
	media: 1,
	muted: 4,
	poster: 1,
	rel: 1,
	role: 1,
	rowspan: 3,
	scope: 1,
	sizes: 1,
	span: 3,
	start: 3,
	style: 5,
	src: 1,
	srclang: 1,
	srcset: 1,
	tabindex: 1,
	target: 1,
	title: 1,
	type: 1,
	width: 1
}), Xf = Object.freeze({
	class: "className",
	colspan: "colSpan",
	datetime: "dateTime",
	rowspan: "rowSpan",
	srclang: "srcLang",
	srcset: "srcSet",
	tabindex: "tabIndex"
});
function Zf() {
	return Zf = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Zf.apply(this, arguments);
}
function Qf({ attributes: e = {}, className: t, children: n = null, selfClose: r = !1, tagName: a }) {
	let o = a;
	return r ? /*#__PURE__*/ i.createElement(o, Zf({ className: t }, e)) : /*#__PURE__*/ i.createElement(o, Zf({ className: t }, e), n);
}
var $f = class {
	attribute(e, t) {
		return t;
	}
	node(e, t) {
		return t;
	}
};
function ep(e, t, n, r = !1) {
	let i = e.match(t instanceof RegExp ? t : new RegExp(t, "i"));
	return i ? {
		match: i[0],
		void: r,
		...n(i),
		index: i.index,
		length: i[0].length,
		valid: !0
	} : null;
}
var tp = class {
	constructor(e, t, n) {
		if (Uf(this, "greedy", !1), Uf(this, "options", void 0), Uf(this, "propName", void 0), Uf(this, "inverseName", void 0), Uf(this, "factory", void 0), process.env.NODE_ENV !== "production" && (!e || e.toLowerCase() === "html")) throw Error(`The matcher name "${e}" is not allowed.`);
		this.options = { ...t }, this.propName = e, this.inverseName = `no${e.charAt(0).toUpperCase() + e.slice(1)}`, this.factory = n ?? null;
	}
	createElement(e, t) {
		let n = this.factory ? /*#__PURE__*/ i.createElement(this.factory, t, e) : this.replaceWith(e, t);
		if (process.env.NODE_ENV !== "production" && typeof n != "string" && !/*#__PURE__*/ i.isValidElement(n)) throw Error(`Invalid React element created from ${this.constructor.name}.`);
		return n;
	}
	doMatch(e, t, n, r = !1) {
		return ep(e, t, n, r);
	}
	onBeforeParse(e, t) {
		return e;
	}
	onAfterParse(e, t) {
		return e;
	}
}, np = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	var n = /["'&<>]/;
	t.exports = r;
	function r(e) {
		var t = "" + e, r = n.exec(t);
		if (!r) return t;
		var i, a = "", o = 0, s = 0;
		for (o = r.index; o < t.length; o++) {
			switch (t.charCodeAt(o)) {
				case 34:
					i = "&quot;";
					break;
				case 38:
					i = "&amp;";
					break;
				case 39:
					i = "&#39;";
					break;
				case 60:
					i = "&lt;";
					break;
				case 62:
					i = "&gt;";
					break;
				default: continue;
			}
			s !== o && (a += t.substring(s, o)), s = o + 1, a += i;
		}
		return s === o ? a : a + t.substring(s, o);
	}
})))());
function rp(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var ip = /(url|image|image-set)\(/i, ap = class extends $f {
	attribute(e, t) {
		return e === "style" && Object.keys(t).forEach((e) => {
			String(t[e]).match(ip) && delete t[e];
		}), t;
	}
}, op = 1, sp = 3, cp = /^<(!doctype|(html|head|body)(\s|>))/i, lp = /^(aria-|data-|\w+:)/iu, up = /{{{(\w+)\/?}}}/;
function dp() {
	if (typeof window < "u" && typeof document < "u") return document.implementation.createHTMLDocument("Interweave");
}
var fp = class {
	constructor(e, t = {}, n = [], r = []) {
		if (rp(this, "allowed", void 0), rp(this, "banned", void 0), rp(this, "blocked", void 0), rp(this, "container", void 0), rp(this, "content", []), rp(this, "props", void 0), rp(this, "matchers", void 0), rp(this, "filters", void 0), rp(this, "keyIndex", void 0), process.env.NODE_ENV !== "production" && e && typeof e != "string") throw TypeError("Interweave parser requires a valid string.");
		this.props = t, this.matchers = n, this.filters = [...r, new ap()], this.keyIndex = -1, this.container = this.createContainer(e || ""), this.allowed = new Set(t.allowList ?? Jf), this.banned = new Set(qf), this.blocked = new Set(t.blockList);
	}
	applyAttributeFilters(e, t) {
		return this.filters.reduce((t, n) => t !== null && typeof n.attribute == "function" ? n.attribute(e, t) : t, t);
	}
	applyNodeFilters(e, t) {
		return this.filters.reduce((t, n) => t !== null && typeof n.node == "function" ? n.node(e, t) : t, t);
	}
	applyMatchers(e, t) {
		let n = {}, { props: r } = this, i = e, a = 0, o = null;
		return this.matchers.forEach((e) => {
			let s = e.asTag().toLowerCase(), c = this.getTagConfig(s);
			if (r[e.inverseName] || !this.isTagAllowed(s) || !this.canRenderChild(t, c)) return;
			let l = "";
			for (; i && (o = e.match(i));) {
				let { index: t, length: s, match: c, valid: u, void: d, ...f } = o, p = e.propName + String(a);
				t > 0 && (l += i.slice(0, t)), u ? (l += d ? `{{{${p}/}}}` : `{{{${p}}}}${c}{{{/${p}}}}`, this.keyIndex += 1, a += 1, n[p] = {
					children: c,
					matcher: e,
					props: {
						...r,
						...f,
						key: this.keyIndex
					}
				}) : l += c, e.greedy ? (i = l + i.slice(t + s), l = "") : i = i.slice(t + (s || c.length));
			}
			e.greedy || (i = l + i);
		}), a === 0 ? e : this.replaceTokens(i, n);
	}
	canRenderChild(e, t) {
		return !e.tagName || !t.tagName || e.void ? !1 : e.children.length > 0 ? e.children.includes(t.tagName) : e.invalid.length > 0 && e.invalid.includes(t.tagName) ? !1 : t.parent.length > 0 ? t.parent.includes(e.tagName) : !e.self && e.tagName === t.tagName ? !1 : !!(e && e.content & t.type);
	}
	convertLineBreaks(e) {
		let { noHtml: t, disableLineBreaks: n } = this.props;
		if (t || n || e.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi)) return e;
		let r = e.replace(/\r\n/g, "\n");
		return r = r.replace(/\n{3,}/g, "\n\n\n"), r = r.replace(/\n/g, "<br/>"), r;
	}
	createContainer(e) {
		let t = (typeof global < "u" && global.INTERWEAVE_SSR_POLYFILL || dp)();
		if (!t) return;
		let n = this.props.containerTagName ?? "body", r = n === "body" || n === "fragment" ? t.body : t.createElement(n);
		if (e.match(cp)) {
			if (process.env.NODE_ENV !== "production") throw Error("HTML documents as Interweave content are not supported.");
		} else r.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? (0, np.default)(e) : e);
		return r;
	}
	extractAttributes(e) {
		let { allowAttributes: t } = this.props, n = {}, r = 0;
		return e.nodeType !== op || !e.attributes || ([...e.attributes].forEach((i) => {
			let { name: a, value: o } = i, s = a.toLowerCase(), c = Yf[s] || Yf[a];
			if (!this.isSafe(e) || !s.match(lp) && (!t && (!c || c === 2) || s.startsWith("on") || o.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i))) return;
			let l = s === "style" ? this.extractStyleAttribute(e) : o;
			c === 4 ? l = !0 : c === 3 ? l = Number.parseFloat(String(l)) : c !== 5 && (l = String(l)), n[Xf[s] || s] = this.applyAttributeFilters(s, l), r += 1;
		}), r === 0) ? null : n;
	}
	extractStyleAttribute(e) {
		let t = {};
		return Array.from(e.style).forEach((n) => {
			let r = e.style[n];
			(typeof r == "string" || typeof r == "number") && (t[n.replace(/-([a-z])/g, (e, t) => String(t).toUpperCase())] = r);
		}), t;
	}
	getTagConfig(e) {
		let t = {
			children: [],
			content: 0,
			invalid: [],
			parent: [],
			self: !0,
			tagName: "",
			type: 0,
			void: !1
		};
		return Kf[e] ? {
			...t,
			...Kf[e],
			tagName: e
		} : t;
	}
	isSafe(e) {
		if (typeof HTMLAnchorElement < "u" && e instanceof HTMLAnchorElement) {
			let t = e.getAttribute("href");
			if (t != null && t.startsWith("#")) return !0;
			let n = e.protocol.toLowerCase();
			return n === ":" || n === "http:" || n === "https:" || n === "mailto:" || n === "tel:";
		}
		return !0;
	}
	isTagAllowed(e) {
		return this.banned.has(e) || this.blocked.has(e) ? !1 : this.props.allowElements || this.allowed.has(e);
	}
	parse() {
		return this.container ? this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase())) : [];
	}
	parseNode(e, t) {
		let { noHtml: n, noHtmlExceptMatchers: r, allowElements: a, transform: o, transformOnlyAllowList: s } = this.props, c = [], l = "";
		return [...e.childNodes].forEach((e) => {
			if (e.nodeType === op) {
				let u = e.nodeName.toLowerCase(), d = this.getTagConfig(u);
				l && (c.push(l), l = "");
				let f = this.applyNodeFilters(u, e);
				if (!f) return;
				let p;
				if (o && (!s || this.isTagAllowed(u))) {
					this.keyIndex += 1;
					let e = this.keyIndex;
					p = this.parseNode(f, d);
					let t = o(f, p, d);
					if (t === null) return;
					if (t !== void 0) {
						c.push(/*#__PURE__*/ i.cloneElement(t, { key: e }));
						return;
					}
					this.keyIndex = e - 1;
				}
				if (this.banned.has(u)) return;
				if (!(n || r && u !== "br") && this.isTagAllowed(u) && (a || this.canRenderChild(t, d))) {
					this.keyIndex += 1;
					let e = this.extractAttributes(f), t = { tagName: u };
					e && (t.attributes = e), d.void && (t.selfClose = d.void), c.push(/*#__PURE__*/ i.createElement(Qf, {
						...t,
						key: this.keyIndex
					}, p ?? this.parseNode(f, d)));
				} else c = [...c, ...this.parseNode(f, d.tagName ? d : t)];
			} else if (e.nodeType === sp) {
				let i = n && !r ? e.textContent : this.applyMatchers(e.textContent || "", t);
				Array.isArray(i) ? c = [...c, ...i] : l += i;
			}
		}), l && c.push(l), c;
	}
	replaceTokens(e, t) {
		if (!e.includes("{{{")) return e;
		let n = [], r = e, i = null;
		for (; i = r.match(up);) {
			let [e, a] = i, o = i.index, s = e.includes("/");
			if (process.env.NODE_ENV !== "production" && !t[a]) throw Error(`Token "${a}" found but no matching element to replace with.`);
			o > 0 && (n.push(r.slice(0, o)), r = r.slice(o));
			let { children: c, matcher: l, props: u } = t[a], d;
			if (s) d = e.length, n.push(l.createElement(c, u));
			else {
				let i = r.match(RegExp(`{{{/${a}}}}`));
				if (process.env.NODE_ENV !== "production" && !i) throw Error(`Closing token missing for interpolated element "${a}".`);
				d = i.index + i[0].length, n.push(l.createElement(this.replaceTokens(r.slice(e.length, i.index), t), u));
			}
			r = r.slice(d);
		}
		return r.length > 0 && n.push(r), n.length === 0 ? "" : n.length === 1 && typeof n[0] == "string" ? n[0] : n;
	}
};
function pp(e) {
	let { attributes: t, className: n, containerTagName: r, content: a, emptyContent: o, parsedContent: s, tagName: c, noWrap: l } = e, u = r ?? c ?? "span", d = u === "fragment" || l, f;
	if (s) f = s;
	else {
		let t = new fp(a ?? "", e).parse();
		t.length > 0 && (f = t);
	}
	return f || (f = o), d ? /*#__PURE__*/ i.createElement(i.Fragment, null, f) : /*#__PURE__*/ i.createElement(Qf, {
		attributes: t,
		className: n,
		tagName: u
	}, f);
}
function mp(e) {
	let { attributes: t, className: n, content: r = "", disableFilters: a = !1, disableMatchers: o = !1, emptyContent: s = null, filters: c = [], matchers: l = [], onAfterParse: u = null, onBeforeParse: d = null, tagName: f = "span", noWrap: p = !1, ...m } = e, h = o ? [] : l, g = a ? [] : c, _ = d ? [d] : [], v = u ? [u] : [];
	h.forEach((e) => {
		e.onBeforeParse && _.push(e.onBeforeParse.bind(e)), e.onAfterParse && v.push(e.onAfterParse.bind(e));
	});
	let y = new fp(_.reduce((t, n) => {
		let r = n(t, e);
		if (process.env.NODE_ENV !== "production" && typeof r != "string") throw TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
		return r;
	}, r ?? ""), m, h, g), b = v.reduce((t, n) => {
		let r = n(t, e);
		if (process.env.NODE_ENV !== "production" && !Array.isArray(r)) throw TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
		return r;
	}, y.parse());
	return /*#__PURE__*/ i.createElement(pp, {
		attributes: t,
		className: n,
		containerTagName: e.containerTagName,
		emptyContent: s,
		noWrap: p,
		parsedContent: b.length === 0 ? void 0 : b,
		tagName: f
	});
}
//#endregion
//#region ../../node_modules/.pnpm/interweave-autolink@5.1.2_interweave@13.1.1_react@18.3.1__react@18.3.1/node_modules/interweave-autolink/esm/index.js
function hp(e, t = {}) {
	let n = e.map((e) => e.source).join(t.join ?? "");
	return t.capture ? n = `(${n})` : t.nonCapture && (n = `(?:${n})`), t.match && (n += t.match), new RegExp(n, t.flags ?? "");
}
var gp = /[a-z0-9]/, _p = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/, vp = /(https?:\/\/)?/, yp = hp([/[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/, /@/], {
	capture: !0,
	match: "?"
}), bp = hp([
	/(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/,
	/(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/,
	/(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/
], { capture: !0 }), xp = /(?::(\d{1,5}))?/, Sp = hp([/\//, hp([/[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/, /[-+a-z0-9/]/], {
	match: "*",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), Cp = hp([/\?/, hp([_p, /[a-z0-9_&=]/], {
	match: "?",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), wp = hp([/#/, hp([_p, /[a-z0-9]/], {
	match: "?",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), Tp = hp([
	vp,
	yp,
	bp,
	xp,
	Sp,
	Cp,
	wp
], { flags: "i" }), Ep = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
hp([
	vp,
	yp,
	hp([
		Ep,
		Ep,
		Ep,
		Ep
	], {
		capture: !0,
		join: "\\."
	}),
	xp,
	Sp,
	Cp,
	wp
], { flags: "i" }), hp([/#/, hp([
	/[\d_\u4E00-\u9FFF-]+/,
	/[\d_\u3000-\u30FF-]+/,
	/[\d_\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7FF-]+/,
	/[\d_\u0E00-\u0E7F-]+/,
	/[\d_a-z\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F-]+/,
	/[\d_a-z\u0080-\u00FF\u0100-\u017F\u0180-\u024F-]+/
], {
	capture: !0,
	join: "|"
})], { flags: "i" });
var Dp = hp([hp([
	gp,
	/[.a-z0-9!#$%&?*+=_{|}~-]*/,
	gp
], { capture: !0 }), bp], {
	flags: "i",
	join: "@"
}), Op = RegExp(`^${Dp.source}$`, Dp.flags), kp = /* @__PURE__ */ "com.org.net.int.edu.gov.mil.aero.asia.biz.cat.coop.jobs.mobi.museum.post.tel.travel.xxx.app.arpa.test.ac.ad.ae.af.ag.ai.al.am.an.ao.aq.ar.as.at.au.aw.ax.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bl.bm.bn.bo.bq.br.bs.bt.bv.bw.by.bz.ca.cc.cd.cf.cg.ch.ci.ck.cl.cm.cn.co.cr.cu.cv.cw.cx.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.eh.er.es.et.eu.fi.fj.fk.fm.fo.fr.ga.gb.gd.ge.gf.gg.gh.gi.gl.gm.gn.gp.gq.gr.gs.gt.gu.gw.gy.hk.hm.hn.hr.ht.hu.id.ie.il.im.in.io.iq.ir.is.it.je.jm.jo.jp.ke.kg.kh.ki.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.lr.ls.lt.lu.lv.ly.ma.mc.md.me.mf.mg.mh.mk.ml.mm.mn.mo.mp.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.no.np.nr.nu.nz.om.pa.pe.pf.pg.ph.pk.pl.pm.pn.pr.ps.pt.pw.py.qa.re.ro.rs.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sj.sk.sl.sm.sn.so.sr.st.su.sv.sx.sy.sz.tc.td.tf.tg.th.tj.tk.tl.tm.tn.to.tp.tr.tt.tv.tw.tz.ua.ug.uk.um.us.uy.uz.va.vc.ve.vg.vi.vn.vu.wf.ws.ye.yt.za.zm.zw".split(".");
function Ap() {
	return Ap = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Ap.apply(this, arguments);
}
function jp({ children: e, href: t, onClick: n, newWindow: r }) {
	return /*#__PURE__*/ i.createElement("a", {
		href: t,
		rel: "noopener noreferrer",
		target: r ? "_blank" : void 0,
		onClick: n
	}, e);
}
function Mp({ children: e, url: t, urlParts: n, ...r }) {
	let a = t;
	return a.match(/^https?:\/\//) || (a = `http://${a}`), /*#__PURE__*/ i.createElement(jp, Ap({}, r, { href: a }), e);
}
var Np = class extends tp {
	constructor(e, t, n) {
		super(e, {
			customTLDs: [],
			validateTLD: !0,
			...t
		}, n);
	}
	replaceWith(e, t) {
		return /*#__PURE__*/ i.createElement(Mp, t, e);
	}
	asTag() {
		return "a";
	}
	match(e) {
		let t = this.doMatch(e, Tp, this.handleMatches);
		if (t != null && t.match.match(Op) && (t.valid = !1), t != null && t.valid && this.options.validateTLD) {
			let { host: e } = t.urlParts, n = [...kp, ...this.options.customTLDs ?? []], r = e.slice(e.lastIndexOf(".") + 1).toLowerCase();
			if (!n.includes(r)) return null;
		}
		return t;
	}
	handleMatches(e) {
		return {
			url: e[0],
			urlParts: {
				auth: e[2] ? e[2].slice(0, -1) : "",
				fragment: e[7] || "",
				host: e[3],
				path: e[5] || "",
				port: e[4] ? e[4] : "",
				query: e[6] || "",
				scheme: e[1] ? e[1].replace("://", "") : "http"
			}
		};
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagTag.tsx
function Pp({ host: e, tag: t, label: n }) {
	return /* @__PURE__ */ g("a", {
		className: "sked-mention sked-mention-link",
		target: "_blank",
		rel: "noreferrer",
		href: `${e}${t}`,
		children: n
	});
}
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagTagWrongPlatform.tsx
function Fp({ label: e }) {
	return /* @__PURE__ */ g("span", { children: e }, `unknown-${e}`);
}
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagMatcher.ts
var Ip = class extends tp {
	constructor(t, n) {
		super(t), e(this, "targetPlatform", void 0), this.targetPlatform = n;
	}
	match(e) {
		let t = e.match(oa);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			urn: t[0],
			label: t[0],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { label: n } = t, r = n.replace("#", ""), a;
		switch (this.targetPlatform) {
			case "IG":
				a = "https://www.instagram.com/explore/tags/";
				break;
			case "TW":
				a = "https://twitter.com/hashtag/";
				break;
			case "TH":
				a = "https://threads.net/search?q=", n = n.replace("#", "");
				break;
			case "LI":
				a = "https://www.linkedin.com/feed/hashtag/";
				break;
			case "TT":
				a = "https://www.tiktok.com/tag/";
				break;
			case "FB":
				a = "https://www.facebook.com/hashtag/";
				break;
			default: a = null;
		}
		return a ? i.createElement(Pp, {
			key: t.key,
			tag: r,
			host: a,
			label: n
		}, e) : i.createElement(Fp, {
			key: t.key,
			label: n
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/insta-tw-tt-matcher/InstaTwitterTag.tsx
function Lp({ host: e, username: t, label: n }) {
	return /* @__PURE__ */ g("a", {
		className: "sked-mention sked-mention-link",
		target: "_blank",
		rel: "noreferrer",
		href: `${e}/${t}`,
		children: n
	}, n);
}
//#endregion
//#region lib/components/SkedCaptionPreview/insta-tw-tt-matcher/InstagramTwitterTikTokMatcher.ts
var Rp = class extends tp {
	constructor(t, n) {
		if (super(t), e(this, "targetPlatform", void 0), e(this, "platformHosts", void 0), this.targetPlatform = n, this.platformHosts = {
			IG: "https://instagram.com",
			TW: "https://twitter.com",
			TH: "https://threads.net",
			TT: "https://tiktok.com",
			PI: "https://pinterest.com"
		}, !this.platformHosts[n]) throw Error(`Unsupported "targetPlatform": ${n}`);
	}
	match(e) {
		let t = this.targetPlatform === "TT" ? aa : ia, n = e.match(t);
		if (!n || n.index === void 0) return null;
		let r = this.targetPlatform === "IG" ? n[0].replace("@", "") : n[0];
		return {
			index: n.index,
			length: n[0].length,
			match: n[0],
			urn: r,
			label: n[0],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { label: n } = t;
		if (!n) throw Error("Username is required.");
		let r = this.platformHosts[this.targetPlatform], a = this.targetPlatform === "IG" ? n.replace(/^@/, "") : n;
		return i.createElement(Lp, {
			...t,
			key: t.key,
			host: r,
			username: a
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInTag.tsx
function zp({ urn: e, label: t, orgId: n, trackEvent: r }) {
	return /* @__PURE__ */ g("span", {
		className: "sked-mention sked-mention-linkedin",
		"data-sked-caption-interactive": "true",
		title: `LinkedIn organization: ${e}`,
		onClick: () => {
			r && r("link-preview-clicked"), window.open(`https://www.linkedin.com/company/${n}`, "_blank");
		},
		children: t
	}, e);
}
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInUnknownPlatformTag.tsx
function Bp({ label: e, urn: t }) {
	return /* @__PURE__ */ g("span", {
		className: "sked-mention sked-mention-linkedin",
		title: `Person mention for ${e}. Sked currently can't link you directly to the person's profile.`,
		children: e
	}, `unknown-${t}${e}`);
}
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInMentionMatcher.ts
var Vp = class extends tp {
	constructor(t, n, r) {
		super(t), e(this, "targetPlatform", void 0), e(this, "trackEvent", void 0), this.targetPlatform = n, this.trackEvent = r;
	}
	match(e) {
		let t = e.match(ra);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			urn: t[1],
			label: t[3],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { urn: n, label: r } = t;
		if (this.targetPlatform === "LI" && n.includes("organization")) {
			let a = n.split(":").pop();
			return i.createElement(zp, {
				key: t.key,
				urn: n,
				label: r,
				orgId: a,
				trackEvent: this.trackEvent
			}, e);
		}
		return i.createElement(Bp, {
			key: t.key,
			urn: n,
			label: r,
			trackEvent: this.trackEvent
		}, e);
	}
	asTag() {
		return "span";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/facebook-matcher/FacebookTag.tsx
function Hp({ id: e, label: t }) {
	return /* @__PURE__ */ g("a", {
		className: "sked-mention sked-mention-link sked-mention-facebook",
		target: "_blank",
		rel: "noreferrer",
		href: `https://www.facebook.com/${e}`,
		children: t
	}, t);
}
//#endregion
//#region lib/components/SkedCaptionPreview/facebook-matcher/FacebookMentionMatcher.ts
var Up = class extends tp {
	constructor(e) {
		super(e);
	}
	match(e) {
		let t = e.match(na);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			id: t[1],
			label: t[2],
			valid: !0
		};
	}
	replaceWith(e, t) {
		return i.createElement(Hp, {
			...t,
			key: t.key
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/getMatchers.ts
function Wp(e, t) {
	e === void 0 && (e = "");
	let n = [new Np("url"), new Ip("hashtag", e)];
	switch (e) {
		case "IG":
		case "TW":
		case "TT":
		case "TH":
		case "PI": return [new Rp("socialLink", e), ...n];
		default: return [
			new Up("fb"),
			new Vp("li", e, t),
			...n
		];
	}
}
//#endregion
//#region lib/components/SkedCaptionPreview/RenderSkedCaption.tsx
function Gp({ caption: e, targetPlatform: t, trackEvent: n }) {
	let r = e, i = Wp(t, n);
	return /* @__PURE__ */ g(mp, {
		content: r,
		matchers: i,
		newWindow: !0
	});
}
//#endregion
//#region lib/components/SkedCaptionPreview/CopyableSkedCaption.tsx
var Kp = 5, qp = 500, Jp = "a, button, [data-sked-caption-interactive=\"true\"]", Yp = (e, t, n, r) => Math.hypot(n - e, r - t) > Kp, Xp = (e) => {
	let t = Hf();
	return e.captionCopyEnabled ?? t.captionCopyEnabled ?? !1 ? /* @__PURE__ */ g($p, { ...e }) : e.children;
}, Zp = (e) => {
	let t = window.getSelection?.();
	if (!t || t.isCollapsed || t.rangeCount === 0) return !1;
	for (let n = 0; n < t.rangeCount; n += 1) try {
		if (t.getRangeAt(n).intersectsNode(e)) return !0;
	} catch {}
	return !1;
}, Qp = () => {
	let [e, t] = m(!1);
	return l(() => {
		if (typeof window.matchMedia != "function") return;
		let e = window.matchMedia("(any-hover: hover) and (any-pointer: fine)"), n = () => t(e.matches);
		return n(), e.addEventListener?.("change", n), () => e.removeEventListener?.("change", n);
	}, []), e;
}, $p = ({ caption: e, children: t, onCaptionCopyError: n, onCaptionCopySuccess: r }) => {
	let i = Hf(), a = p(null), o = p(null), s = p(() => void 0), c = Qp(), u = r ?? i.onCaptionCopySuccess, d = n ?? i.onCaptionCopyError, [f, h] = m(!1), [v, y] = m(!1), b = p(null);
	l(() => () => {
		b.current && clearTimeout(b.current);
	}, []);
	let x = () => {
		h(!0), b.current && clearTimeout(b.current), b.current = setTimeout(() => h(!1), 1600);
		try {
			u?.(e);
		} catch {}
	}, S = (e) => {
		try {
			d?.(e);
		} catch {}
	}, C = () => {
		try {
			if (!navigator.clipboard?.writeText) throw Error("Clipboard API is unavailable");
			let t = navigator.clipboard.writeText(e);
			Promise.resolve(t).then(x, S);
		} catch (e) {
			S(e);
		}
	};
	l(() => () => {
		s.current();
	}, []);
	let w = (e) => {
		s.current();
		let t, n = () => {
			t !== void 0 && window.clearTimeout(t), document.removeEventListener("pointermove", i, !0), document.removeEventListener("pointerup", c, !0), document.removeEventListener("pointercancel", l, !0), document.removeEventListener("click", u, !0), s.current = () => void 0;
		}, r = (e) => {
			let t = o.current;
			t && t.pointerId === e.pointerId && Yp(t.x, t.y, e.clientX, e.clientY) && (t.moved = !0);
		};
		function i(e) {
			r(e);
		}
		function c(i) {
			if (i.pointerId !== e) return;
			r(i);
			let a = o.current?.pointerType === "touch" ? qp : 0;
			t = window.setTimeout(() => {
				o.current = null, n();
			}, a);
		}
		function l(t) {
			t.pointerId === e && (o.current = null, n());
		}
		function u(e) {
			let t = o.current, r = a.current, i = e.target, s = i instanceof Node && r?.contains(i);
			(t?.moved || !s || r && Zp(r)) && (e.stopPropagation(), o.current = null), n();
		}
		document.addEventListener("pointermove", i, !0), document.addEventListener("pointerup", c, !0), document.addEventListener("pointercancel", l, !0), document.addEventListener("click", u, !0), s.current = n;
	};
	return /* @__PURE__ */ _(Lf, {
		onOpenChange: y,
		open: f || c && v,
		children: [/* @__PURE__ */ g(Rf, {
			asChild: !0,
			children: /* @__PURE__ */ g("span", {
				className: "sp-cursor-text sp-select-text",
				"data-sked-copyable-caption": "true",
				"data-sked-caption-copy-state": f ? "copied" : "idle",
				onClick: (e) => {
					e.stopPropagation();
					let t = o.current;
					o.current = null;
					let n = e.target;
					!(n instanceof Element) || n.closest(Jp) || e.detail === 0 || !t || t.moved || Yp(t.x, t.y, e.clientX, e.clientY) || t.pointerType === "touch" && Date.now() - t.startedAt >= qp || a.current && Zp(a.current) || C();
				},
				onDoubleClick: (e) => e.stopPropagation(),
				onPointerCancel: (e) => {
					e.stopPropagation(), o.current = null;
				},
				onPointerDown: (e) => {
					if (e.stopPropagation(), !e.isPrimary || e.pointerType === "mouse" && e.button !== 0) {
						o.current = null;
						return;
					}
					o.current = {
						moved: !1,
						pointerId: e.pointerId,
						pointerType: e.pointerType,
						startedAt: Date.now(),
						x: e.clientX,
						y: e.clientY
					}, w(e.pointerId);
				},
				onPointerMove: (e) => {
					e.stopPropagation();
					let t = o.current;
					t && t.pointerId === e.pointerId && Yp(t.x, t.y, e.clientX, e.clientY) && (t.moved = !0);
				},
				ref: a,
				style: {
					WebkitUserSelect: "text",
					cursor: "text",
					userSelect: "text"
				},
				children: t
			})
		}), /* @__PURE__ */ g(zf, {
			"aria-live": "polite",
			className: "z-[1200] sp-pointer-events-none",
			side: "right",
			style: {
				fontFamily: "Inter, Helvetica, Arial, sans-serif",
				zIndex: 1200
			},
			children: f ? /* @__PURE__ */ _("span", {
				className: "sp-inline-flex sp-items-center sp-gap-1.5",
				children: [/* @__PURE__ */ g(tm, {}), "Copied"]
			}) : "Click to copy"
		})]
	});
}, em = ({ caption: e, captionCopyEnabled: t, displayedCaption: n, onCaptionCopyError: r, onCaptionCopySuccess: i, targetPlatform: a, trackEvent: o }) => /* @__PURE__ */ g(Xp, {
	caption: e,
	captionCopyEnabled: t,
	onCaptionCopyError: r,
	onCaptionCopySuccess: i,
	children: /* @__PURE__ */ g("span", { children: /* @__PURE__ */ g(Gp, {
		caption: n ?? e,
		targetPlatform: a,
		trackEvent: o
	}) })
}), tm = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "12",
	viewBox: "0 0 12 12",
	width: "12",
	children: /* @__PURE__ */ g("path", {
		d: "M2.5 6.25 4.75 8.5 9.5 3.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.75"
	})
});
//#endregion
//#region lib/components/SkedCaptionPreview/SkedCaptionPreview.tsx
function nm({ caption: e, targetPlatform: t }) {
	return /* @__PURE__ */ g(rm, { children: /* @__PURE__ */ g(em, {
		caption: e,
		targetPlatform: t
	}) });
}
var rm = Y.div`
  .sked-mention {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, im = Y.a`
  display: ${(e) => e.$isFlex ? "flex" : "inline-flex"};
  width: 100%;
  margin: auto;
`, am = o({ post: null }), om = (e) => e || void 0, sm = ({ contextVideoCoverPreview: e, videoCoverPreviewOverride: t, fallbackToContext: n = !0 }) => {
	let r = om(t), i = om(e);
	return n ? r ?? i : r;
}, cm = ({ usePostTypeCheck: e, videoCoverPreview: t, post: n }) => t === void 0 ? !1 : !e || n?.type === "reel" || n?.storyType === "reel" || n?.type === "video", lm = (e = {}) => {
	let [t, n] = m(!1), [r, i] = m(!1), [a, o] = m(0), { videoCoverPreview: s, post: u } = c(am), { usePostTypeCheck: d = !0, videoCoverPreviewOverride: f, fallbackToContext: p = !0 } = e, h = sm({
		contextVideoCoverPreview: s,
		videoCoverPreviewOverride: f,
		fallbackToContext: p
	});
	l(() => {
		h && (n(!1), i(!1), o((e) => e + 1));
	}, [h]);
	let g = cm({
		usePostTypeCheck: d,
		videoCoverPreview: h,
		post: u
	});
	return {
		isPlaying: t,
		hasPlayed: r,
		vid: a,
		videoCoverPreview: h,
		showVideoCover: g,
		resetVideo: () => {
			n(!1), i(!1), o((e) => e + 1);
		},
		handlePlay: () => {
			n(!0), i(!0);
		},
		handlePause: () => {
			n(!1);
		},
		showResetButton: g && !t && r
	};
}, um = (e) => /* @__PURE__ */ g("svg", {
	width: 36,
	height: 34,
	viewBox: "0 0 36 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M2.33301 13.6667C2.33301 13.6667 5.67464 9.1137 8.3894 6.39707C11.1042 3.68045 14.8557 2 18.9997 2C27.2839 2 33.9997 8.71573 33.9997 17C33.9997 25.2843 27.2839 32 18.9997 32C12.1612 32 6.39153 27.4238 4.58595 21.1667M2.33301 13.6667V3.66667M2.33301 13.6667H12.333",
		stroke: "white",
		strokeWidth: 3.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dm = Y.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, fm = Y.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100% !important;
  background-color: ${(e) => e.$backgroundColor || "transparent"};

  .react-player video {
    object-fit: ${(e) => e.$videoObjectFit || "contain"};
  }

  ${(e) => e.$showVideoCover && n`
      .react-player__preview {
        width: 100%;
        height: 100%;
        background-color: ${e.$backgroundColor || "transparent"} !important;
        background-size: ${e.$videoCoverObjectFit || "cover"} !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
      }
    `}
`, pm = Y.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: ${(e) => e.$backgroundColor || "transparent"};
  object-fit: ${(e) => e.$objectFit || "cover"};
  z-index: 2;
  pointer-events: none;
`, mm = Y.div`
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 711px;
  width: 100%;
  height: 100%;
  background: ${(e) => e.$backgroundColor || "grey"};
  display: flex;
`, hm = ({ onClick: e }) => /* @__PURE__ */ g(dm, {
	onClick: e,
	children: /* @__PURE__ */ g(um, {})
}), gm = Y.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`, _m = Y.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(e) => +!!e.$visible};
  transition: opacity 0.2s ease;
  pointer-events: none;
`, vm = () => /* @__PURE__ */ g("svg", {
	width: "24",
	height: "28",
	viewBox: "0 0 24 28",
	fill: "none",
	children: /* @__PURE__ */ g("path", {
		d: "M22 14L2 26V2L22 14Z",
		fill: "white"
	})
}), ym = () => /* @__PURE__ */ _("svg", {
	width: "20",
	height: "24",
	viewBox: "0 0 20 24",
	fill: "none",
	children: [/* @__PURE__ */ g("rect", {
		x: "1",
		y: "1",
		width: "6",
		height: "22",
		rx: "1",
		fill: "white"
	}), /* @__PURE__ */ g("rect", {
		x: "13",
		y: "1",
		width: "6",
		height: "22",
		rx: "1",
		fill: "white"
	})]
}), bm = ({ playing: e, onToggle: t }) => /* @__PURE__ */ g(gm, {
	onClick: t,
	children: /* @__PURE__ */ g(_m, {
		$visible: !e,
		children: g(e ? ym : vm, {})
	})
}), xm = ({ src: e, imageObjectFit: t, fillContainer: n = !1 }) => /* @__PURE__ */ g(wm, {
	$isFlex: !0,
	$fillContainer: n,
	href: e,
	children: /* @__PURE__ */ g(Tm, {
		src: e,
		$imageObjectFit: t,
		$fillContainer: n
	})
}), Sm = ({ url: e, thumbnailUrl: t, isActiveSlide: n = !0, videoRef: r, containerStyles: i, controls: a = !0, backgroundColor: o, videoCoverObjectFit: c, videoObjectFit: l }) => {
	let { vid: u, videoCoverPreview: d, showVideoCover: f, resetVideo: p, handlePlay: h, handlePause: v, showResetButton: b } = lm({
		usePostTypeCheck: !0,
		videoCoverPreviewOverride: t,
		fallbackToContext: !t
	}), [x, S] = m(!1), C = !a, w = C && f && !x, T = s((e) => {
		e && (t ? e.setAttribute("poster", t) : e.removeAttribute("poster"));
	}, [t]), E = () => {
		S(!1), p();
	};
	if (!n) return null;
	let D = /* @__PURE__ */ _(fm, {
		ref: r,
		style: i,
		$backgroundColor: o,
		$showVideoCover: f,
		$videoCoverObjectFit: c,
		$videoObjectFit: l,
		children: [
			b && /* @__PURE__ */ g(hm, { onClick: E }),
			w && d && /* @__PURE__ */ g(pm, {
				$backgroundColor: o,
				$objectFit: c,
				src: d,
				alt: ""
			}),
			C && /* @__PURE__ */ g(bm, {
				playing: x,
				onToggle: () => S((e) => !e)
			}),
			/* @__PURE__ */ g(y, {
				ref: T,
				playing: C ? x : !!d,
				onPlay: h,
				onPause: v,
				light: !C && f ? d : void 0,
				controls: a,
				src: e,
				playsInline: !0,
				preload: "metadata",
				className: "sp-relative sp-w-full react-player",
				width: "100%",
				height: "100%",
				style: f ? {
					minHeight: "500px",
					background: o || "grey",
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				} : {
					display: "flex",
					position: "absolute",
					top: 0,
					left: 0
				}
			}, u)
		]
	});
	return f ? /* @__PURE__ */ g(mm, {
		$backgroundColor: o,
		children: D
	}) : D;
}, Cm = ({ media: e, isActiveSlide: t = !0, videoRef: n, videoContainerStyles: r, controls: i, backgroundColor: a, videoCoverObjectFit: o, videoObjectFit: s, imageObjectFit: c, fillContainer: l = !1 }) => e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(Sm, {
	videoRef: n,
	url: e.url,
	thumbnailUrl: e.thumbnailUrl,
	isActiveSlide: t,
	containerStyles: r,
	controls: i,
	backgroundColor: a,
	videoCoverObjectFit: o,
	videoObjectFit: s
}) : /* @__PURE__ */ g(xm, {
	src: e.url,
	imageObjectFit: c,
	fillContainer: l
}), wm = Y(im)`
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
  align-items: center;
  justify-content: center;
`, Tm = Y.img`
  display: block;
  object-fit: ${(e) => e.$imageObjectFit || "cover"};
  position: relative;
  width: 100%;
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
`, Em = (e) => /* @__PURE__ */ g("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...e,
	children: /* @__PURE__ */ g("path", { d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z" })
}), Dm = (e) => /* @__PURE__ */ g("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...e,
	children: /* @__PURE__ */ g("path", { d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z" })
}), Om = ({ direction: e, onClick: t }) => /* @__PURE__ */ g(km, {
	direction: e,
	role: "button",
	"aria-label": e === "left" ? "Previous slide" : "Next slide",
	onClick: t,
	children: g(e === "left" ? Em : Dm, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" })
}), km = Y.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(e) => e.direction === "left" ? "left: 10px;" : "right: 10px;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.2);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, Am = ({ media: e, slideNo: t, isActiveSlide: n }) => {
	let r = {
		order: t,
		flex: "1 0 100%"
	}, i = e.isVideo || e.url?.includes(".mp4");
	return /* @__PURE__ */ g("div", {
		style: r,
		children: i ? /* @__PURE__ */ g("div", {
			className: "sp-relative sp-w-full sp-aspect-[2/3] sp-bg-[#f2f2f2] [@supports_not_(aspect-ratio:1/1)]:sp-h-0 [@supports_not_(aspect-ratio:1/1)]:sp-pb-[150%]",
			children: /* @__PURE__ */ g("div", {
				className: "sp-absolute sp-inset-0",
				children: /* @__PURE__ */ g(Cm, {
					media: e,
					isActiveSlide: n,
					videoObjectFit: "cover"
				})
			})
		}) : /* @__PURE__ */ g(Cm, {
			media: e,
			isActiveSlide: n,
			videoObjectFit: "cover"
		})
	});
}, jm = ({ medias: e, currentSlide: t }) => e.map((e, n) => /* @__PURE__ */ g(Am, {
	media: e,
	slideNo: n + 1,
	isActiveSlide: t === n + 1
}, n)), Mm = ({ current: e }) => /* @__PURE__ */ g("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), Nm = ({ count: e, current: t }) => /* @__PURE__ */ g("div", {
	className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4",
	style: {
		marginBottom: "-42px",
		height: "42px"
	},
	children: [...Array(e)].map((e, n) => /* @__PURE__ */ g(Mm, { current: n + 1 === t }, n))
}), Pm = ({ medias: e, count: t, getIsFirstSlide: n }) => {
	let [r, i] = m(1);
	l(() => {
		r > e.length && i(e.length);
	}, [e.length]);
	let a = {
		left: "100%",
		transform: `translateX(${r * -100}%)`
	};
	return l(() => {
		n && n(r === 1);
	}, [r]), /* @__PURE__ */ _("div", {
		className: "sp-relative",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden",
			children: [
				r !== 1 && /* @__PURE__ */ g(Om, {
					direction: "left",
					onClick: () => i(r - 1)
				}),
				/* @__PURE__ */ g("div", {
					className: "sp-flex sp-relative sp-items-center",
					style: a,
					children: /* @__PURE__ */ g(jm, {
						medias: e,
						currentSlide: r
					})
				}),
				r !== e.length && /* @__PURE__ */ g(Om, {
					direction: "right",
					onClick: () => i(r + 1)
				})
			]
		}), /* @__PURE__ */ g(Nm, {
			count: t,
			current: r
		})]
	});
}, Fm = () => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-w-full sp-justify-center sp-p-4 sp-text-gray-800",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-grow sp-items-center",
		children: [
			/* @__PURE__ */ g(Im, {
				icon: "icon-instagram-heart",
				className: "sp-mr-6"
			}),
			/* @__PURE__ */ g(Im, {
				icon: "icon-instagram-comment",
				className: "sp-mr-6"
			}),
			/* @__PURE__ */ g(Im, {
				icon: "icon-instagram-share",
				className: "sp-mr-6"
			})
		]
	}), /* @__PURE__ */ g(Im, { icon: "icon-instagram-bookmark" })]
}), Im = ({ icon: e, className: t }) => /* @__PURE__ */ g("div", {
	className: `sp-flex sp-items-center sp-justify-center ${t}`,
	children: /* @__PURE__ */ g("div", { className: `sp-text-2xl sp-font-normal ${e}` })
}), Lm = Y.button`
  border: none;
  display: flex;
  align-items: center;
  background: #504e4c;
  border-radius: 4px;
  padding: 9px 7px;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-width: 100px;
  justify-content: center;

  svg {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 500;
    color: white;
    font-size: 12px;
  }
`, Rm = Y.div`
  position: absolute;
  z-index: 2;
  top: ${(e) => e.top && e.top}%;
  left: ${(e) => e.left && e.left}%;
  font-family: Helvetica Neue;
  background: #504e4c;
  color: white;
  font-weight: 500;
  font-size: 14px;
  padding: 9px 13px;
  border-radius: 4px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #504e4c;
  }

  .sked-mention.sked-mention-link {
    color: white;
  }
`, zm = ({ medias: e, storyType: t, productTags: n, userTags: r }) => {
	let i = e.collection, a = i.length, o = a > 1, [s, c] = m(!0), l = n && n.length > 0 ? "productTags" : void 0;
	r && r.length > 0 && (l = "userTags");
	let u = l === "productTags" ? n : r, [d, f] = m(!1);
	return /* @__PURE__ */ _("div", { children: [/* @__PURE__ */ _("div", {
		className: "sp-relative",
		children: [
			t && t === "reel" && /* @__PURE__ */ _("div", {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50",
				children: [/* @__PURE__ */ g("div", {
					className: "sp-h-10 sp-w-10 sp-pr-2",
					children: /* @__PURE__ */ g(So, {})
				}), /* @__PURE__ */ _(fa, {
					$variant: "caption",
					className: "sp-text-2xl sp-text-white",
					children: [" ", "\xA0Reel"]
				})]
			}),
			t && t === "igtv" && /* @__PURE__ */ _("div", {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50",
				children: [/* @__PURE__ */ g("div", {
					className: "sp-h-10 sp-w-10 sp-pr-2",
					children: /* @__PURE__ */ g(xo, {})
				}), /* @__PURE__ */ _(fa, {
					$variant: "caption",
					className: "sp-text-2xl sp-text-white",
					children: [" ", "\xA0IGTV"]
				})]
			}),
			s && u.length > 0 && /* @__PURE__ */ _(Lm, {
				onClick: () => f((e) => !e),
				children: [l === "productTags" && /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(bo, {}), /* @__PURE__ */ _("p", { children: [d ? "Hide" : "Show", " product tags"] })] }), l === "userTags" && /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(Co, {}), /* @__PURE__ */ _("p", { children: [d ? "Hide" : "Show", " user tags"] })] })]
			}),
			u.length > 0 && d && /* @__PURE__ */ g("div", { children: u.map(({ top: e, left: t, value: n }) => /* @__PURE__ */ g(Rm, {
				top: e,
				left: t,
				children: l === "userTags" ? /* @__PURE__ */ g(Gp, {
					caption: `@${n}`,
					targetPlatform: "IG"
				}) : n
			}, n)) }),
			/* @__PURE__ */ g("div", {
				onClick: () => f(!1),
				children: o ? /* @__PURE__ */ g(Pm, {
					medias: i,
					count: a,
					getIsFirstSlide: (e) => {
						c(e);
					}
				}) : /* @__PURE__ */ g(Cm, { media: i[0] })
			})
		]
	}), /* @__PURE__ */ g("div", {
		className: "sp-flex sp-items-center sp-justify-between",
		children: /* @__PURE__ */ g(Fm, {})
	})] });
}, Bm = ({ post: e }) => {
	let t = e.comment?.trim();
	return /* @__PURE__ */ _("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-flex sp-flex-col",
		children: [
			/* @__PURE__ */ g(fo, {
				collabs: e.collaboratingIgUsers,
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ g(zm, {
				medias: e.medias,
				storyType: e.storyType || null,
				productTags: e.providedPost.productTags || [],
				userTags: e.providedPost.tags || []
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
				children: [/* @__PURE__ */ _(fa, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-mb-2 sp-break-words",
					children: [/* @__PURE__ */ g("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ g(em, {
						caption: e.caption,
						targetPlatform: "IG"
					})]
				}), t && /* @__PURE__ */ _(fa, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ g("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ g(Gp, {
						caption: t,
						targetPlatform: "IG"
					})]
				})]
			})
		]
	});
}, Vm = (e) => /* @__PURE__ */ g("svg", {
	viewBox: "0 0 33 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M13 0.463379L9 4.36582H3.23171C1.71834 4.36582 0.5 5.58417 0.5 7.09753L0.500002 27C0.500002 28.5134 1.71834 29.7317 3.23171 29.7317H29.7683C31.2817 29.7317 32.5 28.5134 32.5 27L32.5 7.09753C32.5 5.58417 31.2817 4.36582 29.7683 4.36582H24L20 0.463379H13ZM16.5 8.30487C21.0122 8.30487 24.6951 11.9878 24.6951 16.5C24.6951 21.0122 21.0122 24.6951 16.5 24.6951C11.9878 24.6951 8.30488 21.0122 8.30488 16.5C8.30488 11.9878 11.9879 8.30487 16.5 8.30487ZM16.5 10.6463C13.2533 10.6463 10.6463 13.2533 10.6463 16.5C10.6463 19.7467 13.2533 22.3537 16.5 22.3537C19.7468 22.3537 22.3537 19.7467 22.3537 16.5C22.3537 13.2533 19.7468 10.6463 16.5 10.6463Z",
		fill: "white"
	})
}), Hm = (e) => /* @__PURE__ */ g("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	fill: "#1a9bfb",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M 19.625 0.15625 C 17.996094 0.234375 16.429688 0.945313 15.21875 2.15625 L 10.46875 6.90625 C 11.214844 6.15625 13.984375 6.671875 14.65625 7.34375 L 17.53125 4.46875 C 18.167969 3.832031 18.964844 3.441406 19.78125 3.40625 C 20.335938 3.378906 21.121094 3.496094 21.8125 4.1875 C 22.457031 4.832031 22.59375 5.582031 22.59375 6.09375 C 22.59375 6.949219 22.203125 7.800781 21.53125 8.46875 L 16.53125 13.5 C 15.273438 14.757813 13.359375 14.859375 12.25 13.75 C 11.617188 13.117188 10.574219 13.113281 9.9375 13.75 C 9.300781 14.386719 9.300781 15.425781 9.9375 16.0625 C 11.078125 17.203125 12.578125 17.78125 14.125 17.78125 C 15.796875 17.78125 17.503906 17.097656 18.8125 15.78125 L 23.84375 10.78125 C 25.121094 9.507813 25.84375 7.804688 25.84375 6.09375 C 25.84375 4.503906 25.242188 2.992188 24.125 1.875 C 22.929688 0.679688 21.324219 0.078125 19.625 0.15625 Z M 11.875 8.21875 C 10.203125 8.21875 8.46875 8.90625 7.15625 10.21875 L 2.15625 15.21875 C 0.878906 16.492188 0.15625 18.195313 0.15625 19.90625 C 0.15625 21.496094 0.757813 23.007813 1.875 24.125 C 3.070313 25.320313 4.675781 25.921875 6.375 25.84375 C 8.003906 25.765625 9.570313 25.054688 10.78125 23.84375 L 15.53125 19.09375 C 14.78125 19.84375 12.015625 19.328125 11.34375 18.65625 L 8.46875 21.53125 C 7.832031 22.167969 7.035156 22.554688 6.21875 22.59375 C 5.664063 22.621094 4.878906 22.503906 4.1875 21.8125 C 3.542969 21.167969 3.40625 20.414063 3.40625 19.90625 C 3.40625 19.050781 3.796875 18.199219 4.46875 17.53125 L 9.46875 12.5 C 10.726563 11.242188 12.640625 11.144531 13.75 12.25 C 14.386719 12.886719 15.429688 12.886719 16.0625 12.25 C 16.699219 11.613281 16.699219 10.574219 16.0625 9.9375 C 14.921875 8.796875 13.417969 8.21875 11.875 8.21875 Z",
		fill: "#1a9bfb"
	})
}), Um = 6.5, Wm = 60, Gm = (e) => `calc(${(e ?? .8) * 100 + Um}% - ${Wm}px)`, Km = (e) => {
	try {
		let { hostname: t } = new URL(e);
		return t;
	} catch {
		return "Error";
	}
}, qm = () => /* @__PURE__ */ g("div", {
	className: "sp-w-full sp-h-2 sp-overflow-hidden",
	style: { backgroundColor: "rgba(181, 180, 176, 0.4)" },
	children: /* @__PURE__ */ g("span", {
		className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75",
		style: { width: "33%" },
		children: "\xA0"
	})
}), Jm = ({ username: e, profilePicture: t, locationName: n }) => /* @__PURE__ */ _("section", {
	className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-my-3 sp-mx-2",
		children: /* @__PURE__ */ g(qm, {})
	}), /* @__PURE__ */ g(fo, {
		username: e,
		profilePicture: t,
		locationName: n,
		small: !0
	})]
}), Ym = () => /* @__PURE__ */ g(mh, {
	className: "sp-text-white",
	children: /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-w-full",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2",
				style: { backgroundColor: "rgba(74, 85, 104, 0.7)" },
				children: /* @__PURE__ */ g(Vm, { className: "sp-h-20px sp-w-20px" })
			}), /* @__PURE__ */ g(fa, {
				$variant: "caption",
				className: "sp-font-bold sp-pl-4",
				children: "Send message"
			})]
		}), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-items-center sp-mx-8",
			children: [/* @__PURE__ */ g("div", { className: "sp-flex sp-fill-current sp-mr-3 icon-instagram-share sp-flex sp-text-4xl sp-mr-8" }), /* @__PURE__ */ g("div", {
				className: "sp-flex sp-flex sp-mr-3 sp-mr-4",
				children: [...[
					,
					,
					,
				]].map((e, t) => /* @__PURE__ */ g(lh, {}, t))
			})]
		})]
	})
}), Xm = ({ url: e, label: t, height: n }) => /* @__PURE__ */ g(ih, {
	className: "sp-bg-white sp-rounded-lg sp-absolute sp-z-10",
	$storyStickerHeight: n,
	children: /* @__PURE__ */ g(ah, {
		href: e,
		target: "_blank",
		rel: "noreferrer",
		children: /* @__PURE__ */ _(oh, { children: [/* @__PURE__ */ g(ch, { children: /* @__PURE__ */ g(Hm, {}) }), /* @__PURE__ */ g(sh, { children: t || Km(e) })] })
	})
}), Zm = 6.5, Qm = Y.div`
  top: calc(
    ${(e) => e.height ? `${e.height + Zm}% - ${e.height > 60 ? "140px" : "110px"}` : "0"}
  );
  position: absolute;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: ${(e) => e.height > 60 ? "column-reverse" : "column"};
`, $m = Y.div`
  width: 100%;
  height: 145px;
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
  display: flex;
  border-top: 1px dashed rgba(255, 255, 255, 0.2);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  div {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  }
`, eh = Y.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  margin: 10px 0;
`, th = Y.p`
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  margin: 0;
`, nh = Y.div`
  width: 18px;
  height: 18px;
  background: #333;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  margin-left: 8px;
  position: relative;
  :hover {
    cursor: pointer;
    div {
      visibility: visible;
    }
  }
`, rh = Y.div`
  visibility: hidden;
  width: 340px;
  background-color: rgba(51, 51, 51, 1);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: ${(e) => e.height > 60 ? "-38px" : "28px"};
  right: -62px;
  &::after {
    content: "";
    position: absolute;
    bottom: ${(e) => e.height > 60 ? "-10px" : "29px"};
    right: 66px;
    rotate: ${(e) => e.height > 60 ? "180deg" : "0"};
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 1) transparent;
  }
`, ih = Y.div`
  top: ${(e) => Gm(e.$storyStickerHeight)};
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  max-width: 95%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
`, ah = Y.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  &:hover {
    text-decoration: none;
  }
`, oh = Y.div`
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`, sh = Y.div`
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  color: #1a9bfb;
  font-size: clamp(20px, 2.4vw, 28px);
  line-height: 1.1;
  font-family: Aveny, "Apple Color Emoji", "Segoe UI Emoji", Arial, sans-serif;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translateY(4px);
`, ch = Y.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
`, lh = Y.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 2px;
`, uh = ({ post: e, media: t, isActiveSlide: n, env: r, showNote: i = !0 }) => /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g("div", {
	className: "sp-flex sp-flex-column sp-justify-center",
	children: /* @__PURE__ */ _(fh, { children: [
		/* @__PURE__ */ g(Jm, {
			username: e.username,
			profilePicture: e.profilePicture,
			locationName: e.locationName
		}),
		/* @__PURE__ */ _(ph, { children: [e.storyUrl && /* @__PURE__ */ _(h, { children: [r === "schedugram-client" && /* @__PURE__ */ _(Qm, {
			height: (e.storyStickerHeight ?? .8) * 100,
			children: [/* @__PURE__ */ g($m, { children: /* @__PURE__ */ g("div", {}) }), /* @__PURE__ */ _(eh, { children: [/* @__PURE__ */ g(th, { children: "Approx. Sticker placement area" }), /* @__PURE__ */ _(nh, { children: ["?", /* @__PURE__ */ g(rh, {
				height: (e.storyStickerHeight ?? .8) * 100,
				children: "Sticker position is approximate, to be used as a guide only."
			})] })] })]
		}), /* @__PURE__ */ g(Xm, {
			url: e.storyUrl,
			label: e.storyLabel,
			height: e.storyStickerHeight
		})] }), /* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-full sp-w-full sp-flex-col sp-justify-center sp-bg-black",
			children: /* @__PURE__ */ g(Cm, {
				media: t,
				isActiveSlide: n,
				imageObjectFit: "contain",
				fillContainer: !0,
				videoObjectFit: "contain"
			})
		})] }),
		/* @__PURE__ */ g(Ym, {})
	] })
}), i && e.caption && /* @__PURE__ */ _(dh, { children: [/* @__PURE__ */ g("strong", { children: "Notes for manual Publishing: " }), /* @__PURE__ */ g(em, {
	caption: e.caption,
	targetPlatform: "IG"
})] })] }), dh = Y.p`
  max-width: 358px;
  margin: 14px auto 0;
  font-size: 14px;
`, fh = Y.div`
  position: relative;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  background: #000;
  overflow: hidden;
`, ph = Y.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #000;
`, mh = Y.section`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 24px;
  z-index: 50;
`, hh = ({ post: e, media: t, slideNo: n, isActiveSlide: r, env: i }) => /* @__PURE__ */ g("div", {
	"data-ig-story-carousel-slide": n,
	style: {
		order: n,
		flex: "0 0 100%",
		minWidth: 0,
		overflow: "hidden",
		width: "100%"
	},
	children: /* @__PURE__ */ g(uh, {
		post: e,
		media: t,
		isActiveSlide: r,
		env: i,
		showNote: !1
	})
}), gh = ({ post: e, stories: t, currentSlide: n, env: r }) => t.map((t, i) => /* @__PURE__ */ g(hh, {
	post: e,
	media: t,
	slideNo: i + 1,
	isActiveSlide: n === i + 1,
	env: r
}, i)), _h = ({ post: e, stories: t, count: n, env: r }) => {
	let [i, a] = m(1), o = n;
	l(() => {
		a(1);
	}, [e]);
	let s = {
		transform: `translateX(-${(i - 1) * 100}%)`,
		width: "100%"
	};
	return /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden",
		"data-ig-story-carousel": !0,
		children: [
			i === 1 || /* @__PURE__ */ g(Om, {
				direction: "left",
				onClick: () => a(i - 1)
			}),
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-relative",
				"data-ig-story-carousel-track": !0,
				style: s,
				children: /* @__PURE__ */ g(gh, {
					post: e,
					stories: t,
					currentSlide: i,
					env: r
				})
			}),
			o === i || /* @__PURE__ */ g(Om, {
				direction: "right",
				onClick: () => a(i + 1)
			})
		]
	}), e.caption && /* @__PURE__ */ _(dh, { children: [/* @__PURE__ */ g("strong", { children: "Notes for manual Publishing: " }), /* @__PURE__ */ g(em, {
		caption: e.caption,
		targetPlatform: "IG"
	})] })] });
}, vh = ({ post: e, env: t }) => {
	let n = e.medias.collection, r = n.length;
	return /* @__PURE__ */ g("div", {
		className: "sp-pb-8",
		children: r > 1 ? /* @__PURE__ */ g(_h, {
			post: e,
			stories: n,
			count: r,
			env: t
		}) : /* @__PURE__ */ g(uh, {
			post: e,
			media: n[0],
			env: t
		})
	});
}, yh = ({ expanded: e, text: t }) => {
	let n = p(null), [r, i] = m(!1);
	return d(() => {
		let t = n.current;
		if (!t || e) return;
		let r = () => {
			i(t.scrollHeight > t.clientHeight + 1);
		};
		r();
		let a = typeof ResizeObserver == "function" ? new ResizeObserver(r) : void 0;
		a?.observe(t);
		let o = document.fonts;
		return o?.ready.then(r), o?.addEventListener?.("loadingdone", r), () => {
			a?.disconnect(), o?.removeEventListener?.("loadingdone", r);
		};
	}, [e, t]), {
		elementRef: n,
		isOverflowing: r
	};
}, bh = Y.div`
  display: flex;
  flex-direction: ${({ $direction: e = "row" }) => e};
  justify-content: ${({ $justify: e = "flex-start" }) => e};
  align-items: ${({ $align: e = "flex-start" }) => e};
  gap: ${({ $gap: e = 7 }) => `${e}px`};
  margin-top: ${({ $marginTop: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-bottom: ${({ $marginBottom: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-left: ${({ $marginLeft: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-right: ${({ $marginRight: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  width: ${({ $width: e = "auto" }) => e};
`, xh = ({ media: e, slideNo: t, isActiveSlide: n }) => /* @__PURE__ */ g("div", {
	style: {
		order: t,
		flex: "1 0 100%"
	},
	className: "sp-h-full",
	children: /* @__PURE__ */ g(Cm, {
		backgroundColor: "black",
		media: e,
		isActiveSlide: n,
		videoContainerStyles: { position: "relative" },
		videoCoverObjectFit: "contain",
		videoObjectFit: "contain",
		imageObjectFit: "contain",
		fillContainer: !0
	})
}), Sh = ({ medias: e, currentSlide: t }) => {
	let n = e.map((e, n) => /* @__PURE__ */ g(xh, {
		media: e,
		slideNo: n + 1,
		isActiveSlide: t === n + 1
	}, `slide-${n}`));
	return /* @__PURE__ */ g(h, { children: n });
}, Ch = ({ current: e }) => /* @__PURE__ */ g("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), wh = ({ count: e, current: t }) => /* @__PURE__ */ g(Eh, {
	className: "sp-flex sp-items-center sp-justify-center",
	children: [...Array(e)].map((e, n) => /* @__PURE__ */ g(Ch, { current: n + 1 === t }, `dot-${n}`))
}), Th = ({ medias: e, count: t }) => {
	let [n, r] = m(1);
	l(() => {
		n > e.length && r(e.length);
	}, [e.length, n]);
	let i = {
		left: "100%",
		transform: `translateX(${n * -100}%)`
	};
	return /* @__PURE__ */ _(bh, {
		$width: "100%",
		$direction: "column",
		$justify: "center",
		$align: "stretch",
		$gap: "0",
		className: "sp-relative",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-col sp-flex-1 sp-relative sp-overflow-hidden",
			children: [
				n !== 1 && /* @__PURE__ */ g(Om, {
					direction: "left",
					onClick: () => r(n - 1)
				}),
				/* @__PURE__ */ g("div", {
					className: "sp-flex sp-relative sp-items-stretch sp-h-full",
					style: i,
					children: /* @__PURE__ */ g(Sh, {
						medias: e,
						currentSlide: n
					})
				}),
				n !== e.length && /* @__PURE__ */ g(Om, {
					direction: "right",
					onClick: () => r(n + 1)
				})
			]
		}), /* @__PURE__ */ g(wh, {
			count: t,
			current: n
		})]
	});
}, Eh = Y.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
`, Dh = ({ medias: e }) => {
	let t = e.collection, n = t.length, r = n > 1;
	if (n === 0) return null;
	let i = t[0], a = !!i?.isVideo || i?.url?.includes(".mp4");
	return r ? /* @__PURE__ */ g(Th, {
		medias: t,
		count: n
	}) : /* @__PURE__ */ g(Cm, {
		backgroundColor: "black",
		media: i,
		controls: a,
		videoCoverObjectFit: "contain",
		videoObjectFit: "contain",
		imageObjectFit: "contain",
		fillContainer: !0
	});
}, Oh = Y.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, kh = (e) => /* @__PURE__ */ g("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9 14",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M0.285317 6.39974C0.194867 6.47853 0.123111 6.5721 0.0741546 6.6751C0.0251977 6.7781 6.52568e-07 6.8885 6.47695e-07 7C6.42821e-07 7.1115 0.0251977 7.2219 0.0741545 7.3249C0.123111 7.42789 0.194867 7.52146 0.285317 7.60026L7.33835 13.7514C7.52089 13.9106 7.76847 14 8.02663 14C8.28478 14 8.53236 13.9106 8.71491 13.7514C8.89745 13.5922 9 13.3762 9 13.1511C9 12.926 8.89745 12.71 8.71491 12.5508L2.35015 7L8.71491 1.44916C8.80529 1.37033 8.87699 1.27675 8.92591 1.17376C8.97482 1.07077 9 0.960378 9 0.848899C9 0.73742 8.97482 0.627033 8.92591 0.52404C8.87699 0.421046 8.80529 0.327465 8.71491 0.248637C8.62452 0.169809 8.51722 0.10728 8.39912 0.0646186C8.28103 0.0219574 8.15445 -3.86212e-08 8.02663 -4.25475e-08C7.8988 -4.64737e-08 7.77223 0.0219574 7.65413 0.0646186C7.53604 0.10728 7.42873 0.169809 7.33835 0.248637L0.285317 6.39974Z",
		fill: "white"
	})
}), Ah = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 21 17",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_85)",
		children: /* @__PURE__ */ g("path", {
			d: "M13.2308 23C11.4549 23 10 21.6081 10 19.9091V11.6667C10 9.96768 11.4549 8.57576 13.2308 8.57576H15.9567L17.0841 6.42661C17.1514 6.2982 17.2547 6.19026 17.3825 6.11491C17.5103 6.03955 17.6576 5.99976 17.8077 6H23.1923C23.3424 5.99976 23.4897 6.03955 23.6175 6.11491C23.7453 6.19026 23.8486 6.2982 23.9159 6.42661L25.0433 8.57576H27.7692C29.5451 8.57576 31 9.96768 31 11.6667V19.9091C31 21.6081 29.5451 23 27.7692 23H13.2308ZM13.2308 21.4545H27.7692C28.6781 21.4545 29.3846 20.7786 29.3846 19.9091V11.6667C29.3846 10.7972 28.6781 10.1212 27.7692 10.1212H24.5385C24.3883 10.1215 24.2411 10.0817 24.1133 10.0063C23.9855 9.93097 23.8822 9.82303 23.8149 9.69462L22.6875 7.54545H18.3125L17.1851 9.69462C17.1178 9.82303 17.0145 9.93097 16.8867 10.0063C16.7589 10.0817 16.6117 10.1215 16.4615 10.1212H13.2308C12.3219 10.1212 11.6154 10.7972 11.6154 11.6667V19.9091C11.6154 20.7786 12.3219 21.4545 13.2308 21.4545ZM20.5 20.1667C17.9818 20.1667 15.9231 18.1971 15.9231 15.7879C15.9231 13.3787 17.9818 11.4091 20.5 11.4091C23.0182 11.4091 25.0769 13.3787 25.0769 15.7879C25.0769 18.1971 23.0182 20.1667 20.5 20.1667ZM20.5 18.6212C22.1452 18.6212 23.4615 17.3618 23.4615 15.7879C23.4615 14.2139 22.1452 12.9546 20.5 12.9546C18.8549 12.9546 17.5385 14.2139 17.5385 15.7879C17.5385 17.3618 18.8549 18.6212 20.5 18.6212Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_85",
		x: 0,
		y: 0,
		width: 41,
		height: 37,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_85"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_85",
				result: "shape"
			})
		]
	}) })]
}), jh = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 8 8",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_80)",
		children: [
			/* @__PURE__ */ g("rect", {
				x: 10,
				y: 8,
				width: 2,
				height: 5,
				rx: 1,
				fill: "white"
			}),
			/* @__PURE__ */ g("rect", {
				x: 16,
				y: 8,
				width: 2,
				height: 5,
				rx: 1,
				fill: "white"
			}),
			/* @__PURE__ */ g("rect", {
				x: 13,
				y: 6,
				width: 2,
				height: 8,
				rx: 1,
				fill: "white"
			})
		]
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_80",
		x: 0,
		y: 0,
		width: 28,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_80"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_80",
				result: "shape"
			})
		]
	}) })]
}), Mh = Y.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`, Nh = Y.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 6px;
`, Ph = ({ profilePicture: e, username: t }) => /* @__PURE__ */ _(Mh, { children: [/* @__PURE__ */ g(Nh, { $profilePicture: e }), /* @__PURE__ */ _(Oh, {
	className: "sp-font-bold",
	children: [t, " • Follow"]
})] }), Fh = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 18",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_66)",
		children: /* @__PURE__ */ g("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.383 6C21.3618 6 20.0001 8.32683 20.0001 8.32683C20.0001 8.32683 18.6384 6 15.6171 6C12.5107 6 10.0001 8.80976 10.0001 12.278C10.0001 15.7463 12.5958 17.722 15.1916 20.0927C19.1064 23.6927 19.3618 24 20.0001 24C20.6384 24 20.8937 23.6927 24.8086 20.0927C27.4469 17.678 30.0001 15.7024 30.0001 12.278C30.0001 8.80976 27.4894 6 24.383 6ZM23.9575 19.0829C21.6596 21.1902 20.4256 22.3756 20.0001 22.639C19.5745 22.3317 18.0426 20.9268 16.0426 19.0829C13.7022 16.9317 11.2767 15.1317 11.2767 12.2341C11.2767 9.5122 13.2341 7.27317 15.6171 7.27317C17.3618 7.27317 18.2979 8.15122 18.9788 9.11707C20.5107 11.3561 19.4894 11.3561 21.0213 9.11707C21.7022 8.15122 22.6384 7.27317 24.383 7.27317C26.766 7.27317 28.7235 9.5122 28.7235 12.2341C28.7235 15.1756 26.2979 16.9756 23.9575 19.0829Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_66",
		x: 610352e-10,
		y: 0,
		width: 40,
		height: 38,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_66"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_66",
				result: "shape"
			})
		]
	}) })]
}), Ih = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 20",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_65)",
		children: /* @__PURE__ */ g("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.9868 25.3914L28.7961 20.7137C29.5615 19.3103 29.9868 17.6944 29.9868 15.9934C29.9868 10.4651 25.5216 6 19.9934 6C14.4651 6 10 10.4651 10 15.9934C10 21.5216 14.4651 25.9868 19.9934 25.9868C21.6944 25.9868 23.3103 25.5615 24.7137 24.7961L29.3914 25.9868C29.7316 26.0718 30.0718 25.7316 29.9868 25.3914ZM28.711 15.9934C28.711 17.6944 28.2858 18.9701 27.6054 20.2459C27.5203 20.416 27.4778 20.6286 27.5203 20.8412L28.4134 24.4134L24.8838 23.5203C24.6711 23.4778 24.4585 23.4778 24.2884 23.6054C23.523 24.0306 22.0771 24.711 20.0359 24.711C15.1881 24.711 11.2758 20.7987 11.2758 15.9934C11.2758 11.1881 15.1881 7.27575 19.9934 7.27575C24.7987 7.27575 28.711 11.1881 28.711 15.9934Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_65",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_65"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_65",
				result: "shape"
			})
		]
	}) })]
}), Lh = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 17",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_64)",
		children: /* @__PURE__ */ g("path", {
			d: "M29.5574 6H10.419C10.0363 6 9.86616 6.45544 10.1213 6.70386L16.9261 13.2456L19.2652 22.6856C19.3503 23.0582 19.8606 23.0996 20.0307 22.8098L29.9401 6.62105C30.1102 6.33123 29.8976 6 29.5574 6ZM12.503 7.2421H26.7504L17.9043 12.0035C17.7341 12.0863 17.5215 12.0449 17.3939 11.9207L12.503 7.2421ZM20.0307 20.4084L18.3295 13.5354C18.287 13.3698 18.3721 13.1628 18.5422 13.08L27.4309 8.27719L20.0307 20.4084Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_64",
		x: 0,
		y: 0,
		width: 40,
		height: 37,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_64"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_64",
				result: "shape"
			})
		]
	}) })]
}), Rh = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 4,
	viewBox: "0 0 16 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ g("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ g("circle", {
			cx: 8,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ g("circle", {
			cx: 14,
			cy: 2,
			r: 2,
			fill: "white"
		})
	]
}), zh = Y.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 4;

  svg {
    width: 20px;

    &.more {
      position: relative;
      ${({ $vertical: e }) => e && "top: -10px;"};
    }
  }

  ${({ $vertical: e }) => e ? "\n      flex-direction: column;\n      right: 14px;\n      bottom: 145px;\n      gap: 40px;\n      " : "\n      flex-direction: row;\n      gap: 14px;\n      left: 14px;\n      bottom: 80px;\n      "}
`, Bh = ({ vertical: e }) => /* @__PURE__ */ _(zh, {
	$vertical: e,
	children: [
		/* @__PURE__ */ g(Fh, {}),
		/* @__PURE__ */ g(Ih, {}),
		/* @__PURE__ */ g(Lh, {}),
		/* @__PURE__ */ g(Rh, { className: "more" })
	]
}), Vh = ({ post: e, className: t }) => {
	let n = e?.medias?.collection?.length > 1, r = e.comment?.trim(), [i, a] = m(!1), o = u(), { elementRef: s, isOverflowing: c } = yh({
		expanded: i,
		text: e.caption
	});
	return l(() => a(!1), [e.caption]), /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _(Hh, {
		className: t,
		children: [
			/* @__PURE__ */ _(Gh, { children: [
				/* @__PURE__ */ g(kh, { className: "arrow-back" }),
				/* @__PURE__ */ g(Oh, { children: "Reels" }),
				/* @__PURE__ */ g(Ah, { className: "camera" })
			] }),
			/* @__PURE__ */ g(Bh, { vertical: !0 }),
			/* @__PURE__ */ g("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[1]" }),
			/* @__PURE__ */ _(Uh, {
				$isMultipleMedia: n,
				$expanded: i,
				children: [
					/* @__PURE__ */ g(Ph, {
						profilePicture: e.profilePicture,
						username: e.username
					}),
					/* @__PURE__ */ g("div", {
						className: i ? "sp-max-h-[300px] sp-overflow-y-auto" : "sp-line-clamp-2 sp-overflow-hidden",
						style: i ? { scrollbarWidth: "none" } : void 0,
						id: o,
						ref: s,
						children: /* @__PURE__ */ g(Oh, { children: /* @__PURE__ */ g(em, {
							caption: e.caption,
							targetPlatform: "IG"
						}) })
					}),
					c && /* @__PURE__ */ g("button", {
						"aria-controls": o,
						"aria-expanded": i,
						"aria-label": i ? "Collapse caption" : "Show full caption",
						onClick: (e) => {
							e.stopPropagation(), a(!i);
						},
						className: "sp-text-white/70 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
						type: "button",
						children: i ? "less" : "more"
					}),
					/* @__PURE__ */ _(Kh, { children: [/* @__PURE__ */ g(jh, {}), /* @__PURE__ */ g("span", { children: "Audio will be auto-matched after publishing" })] })
				]
			}),
			/* @__PURE__ */ g(Dh, { medias: e.medias })
		]
	}), r && /* @__PURE__ */ _(Wh, {
		id: "post-preview-notes",
		children: [/* @__PURE__ */ _("strong", { children: [e.username, " "] }), /* @__PURE__ */ g(Gp, {
			caption: r,
			targetPlatform: "IG"
		})]
	})] });
}, Hh = Y.div`
  box-shadow: 0 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  background: #333;
  display: flex;
  overflow: hidden;
`, Uh = Y.div`
  position: absolute;
  bottom: ${(e) => e.$isMultipleMedia ? "85px" : "55px"};
  z-index: 4;
  padding: ${(e) => e.$expanded ? "12px" : "0 0 0 12px"};
  right: 60px;
  overflow-wrap: break-word;
  word-break: break-word;
  border-radius: ${(e) => e.$expanded ? "12px" : "0"};
  background: ${(e) => e.$expanded ? "rgba(0, 0, 0, 0.5)" : "transparent"};
  transition:
    background 0.2s ease,
    padding 0.2s ease;

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }
`, Wh = Y.div`
  margin: 14px 5px;
  font-size: 14px;
  line-height: 17px;
`, Gh = Y.div`
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 4;
  justify-content: space-between;
  width: 100%;

  p {
    font-weight: 700;
  }

  .arrow-back {
    width: 14px;
    margin-left: 12px;
  }

  .camera {
    width: 21px;
    margin-right: 12px;
  }
`, Kh = Y.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    width: 8px;
    flex-shrink: 0;
  }
`, qh = Y.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, Jh = Y.div`
  position: absolute;
  top: 20px;
  z-index: 2;
  width: 100%;

  .section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;

    p {
      width: 280px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 16px;
    }

    svg.close {
      width: 17px;
    }
  }
`, Yh = ({ post: e }) => /* @__PURE__ */ _(qh, { children: [
	/* @__PURE__ */ _(Jh, { children: [e.caption && /* @__PURE__ */ g("div", {
		className: "section",
		children: /* @__PURE__ */ g(Oh, { children: /* @__PURE__ */ g(em, {
			caption: e.caption,
			targetPlatform: "IG"
		}) })
	}), /* @__PURE__ */ g("div", {
		className: "section",
		children: /* @__PURE__ */ g(Ph, {
			profilePicture: e.profilePicture,
			username: e.username
		})
	})] }),
	/* @__PURE__ */ g(Bh, {}),
	/* @__PURE__ */ g(Dh, { medias: e.medias })
] }), Xh = ({ post: e, className: t, env: n }) => {
	let r = e.type;
	switch (r === "story" && e.storyType && e.storyType !== "story" && (e.storyType === "reel" ? (r = "reel", e.locationName = "Reel") : e.storyType === "igtv" && (r = "igtv", e.locationName = "IGTV")), r) {
		case "image":
		case "multiMedia": return /* @__PURE__ */ g(Bm, { post: e });
		case "video":
		case "reel": return /* @__PURE__ */ g(Vh, {
			post: e,
			className: t
		});
		case "igtv": return /* @__PURE__ */ g(Yh, { post: e });
		case "story": return /* @__PURE__ */ g(vh, {
			post: e,
			env: n
		});
		default: return /* @__PURE__ */ g(h, {});
	}
}, Zh = Y.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 16px;\n          letter-spacing: -0.02em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};

  .sked-mention.sked-mention-facebook {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, Qh = ({ username: e, profilePicture: t, small: n, scheduled: r }) => {
	let i = new b(r).format("MMM D [at] HH:mm");
	return i === "Invalid date" && (i = null), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-m-4",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ g(uo, {
				src: t,
				alt: e
			})
		}), /* @__PURE__ */ g("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ _("div", {
				className: "",
				children: [/* @__PURE__ */ g(Zh, {
					$variant: "heading",
					className: "sp-mb-1",
					children: e
				}), i && /* @__PURE__ */ g(Zh, {
					$variant: "subheading",
					children: i
				})]
			})
		})]
	});
}, $h = ({ children: e, href: t, target: n = "_blank", $isFlex: r = !1 }) => /* @__PURE__ */ g(im, {
	$isFlex: r,
	href: t,
	target: n,
	rel: "noreferrer",
	children: e
}), eg = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, tg = Y.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, ng = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g($h, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ g(tg, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ _("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ g("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ g($h, {
	href: e,
	children: /* @__PURE__ */ g(eg, { src: e })
}), rg = ({ url: e, isActiveSlide: t, isCarouselPost: n, controls: r = !0, backgroundColor: i, videoCoverObjectFit: a }) => {
	let { vid: o, videoCoverPreview: s, showVideoCover: c, resetVideo: l, handlePlay: u, handlePause: d, showResetButton: f } = lm({ usePostTypeCheck: !1 }), [p, h] = m(!1), v = !r, b = v && c && !p;
	return t ? /* @__PURE__ */ g("div", {
		className: To("sp-w-full sp-h-full", { "sp-relative": !n }, { "sp-absolute": n }),
		children: /* @__PURE__ */ _(fm, {
			$backgroundColor: i,
			$showVideoCover: c,
			$videoCoverObjectFit: a,
			children: [
				f && /* @__PURE__ */ g(hm, { onClick: () => {
					h(!1), l();
				} }),
				b && s && /* @__PURE__ */ g(pm, {
					$backgroundColor: i,
					$objectFit: a,
					src: s,
					alt: ""
				}),
				v && /* @__PURE__ */ g(bm, {
					playing: p,
					onToggle: () => h((e) => !e)
				}),
				/* @__PURE__ */ g(y, {
					src: e,
					controls: r,
					playing: v ? p : !!s,
					onPlay: u,
					onPause: d,
					light: !v && c ? s : void 0,
					className: "sp-overflow-hidden sp-my-auto",
					width: "100%",
					height: "100%"
				}, o)
			]
		})
	}) : null;
}, ig = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0, controls: c, backgroundColor: l, videoCoverObjectFit: u }) => t && i === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(rg, {
	url: e.url,
	isActiveSlide: s,
	isCarouselPost: n,
	controls: c,
	backgroundColor: l,
	videoCoverObjectFit: u
}) : /* @__PURE__ */ g(ng, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
}), ag = Y.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, og = ({ medias: e }) => {
	let [t, n] = m(!1);
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ g(ag, {
			className: "sp-relative",
			children: /* @__PURE__ */ g(ig, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				isActiveSlide: i === 0,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, sg = () => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-w-full sp-justify-center sp-py-2 sp-text-gray-700",
	children: [
		/* @__PURE__ */ g(cg, {
			icon: "icon-facebook-like",
			text: "Like"
		}),
		/* @__PURE__ */ g(cg, {
			icon: "icon-facebook-comment",
			text: "Comment"
		}),
		/* @__PURE__ */ g(cg, {
			icon: "icon-facebook-share",
			text: "Share"
		})
	]
}), cg = ({ icon: e, text: t }) => /* @__PURE__ */ _(Zh, {
	$variant: "icons",
	className: "sp-flex sp-items-center sp-justify-center sp-w-1/3 ",
	children: [/* @__PURE__ */ g("div", { className: `sp-mr-2 sp-text-xl ${e}` }), /* @__PURE__ */ g("div", {
		className: "sp-text-gray-700",
		children: t
	})]
}), lg = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _("div", { children: [n > 0 && /* @__PURE__ */ g(h, { children: n > 1 ? /* @__PURE__ */ g(og, { medias: t }) : /* @__PURE__ */ g(ig, {
		media: t[0],
		showOverlay: !1,
		showAll: !0,
		setShowAll: () => {},
		isActiveSlide: !0,
		mediaCount: n
	}) }), /* @__PURE__ */ g(sg, {})] });
}, ug = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", dg = ({ url: e }) => /* @__PURE__ */ g(x, {
	url: e,
	apiKey: ug,
	size: "large",
	className: "sp-shadow-lg"
}), fg = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ _("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ g(Qh, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName,
				scheduled: e.scheduledFor
			}),
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-flex-col sp-mx-4 sp-pb-4",
				style: e.type === "text" && e.redirectUrl === "" ? { borderBottom: "1px solid #BFBEBE" } : {},
				children: /* @__PURE__ */ _(Zh, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ g(em, {
						caption: t,
						targetPlatform: "FB"
					}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ _(h, { children: [" ", /* @__PURE__ */ g("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ g("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ g(dg, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ g(lg, { medias: e.medias }),
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
				children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ _(Zh, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ g("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ g(Gp, {
						caption: e.comment,
						targetPlatform: "FB"
					})]
				})
			})
		]
	});
}, pg = ({ post: e, media: t }) => {
	let [n, r] = m(!1), i = u(), { elementRef: a, isOverflowing: o } = yh({
		expanded: n,
		text: e.caption || ""
	});
	return l(() => r(!1), [e.caption]), /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-column sp-justify-center sp-h-full",
		children: /* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full",
			children: [
				/* @__PURE__ */ g("div", {
					className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black",
					children: /* @__PURE__ */ g(ig, {
						backgroundColor: "black",
						media: t,
						controls: !1,
						videoCoverObjectFit: "contain"
					})
				}),
				/* @__PURE__ */ g("div", {
					className: "sp-absolute sp-top-8 sp-flex sp-items-center sp-justify-between sp-w-full  sp-text-white sp-text-24px",
					children: /* @__PURE__ */ _("div", {
						className: "sp-mx-16px sp-w-full sp-flex sp-items-center sp-justify-between",
						children: [/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-xmark" })
						}), /* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-gap-16px",
							children: [/* @__PURE__ */ g("div", {
								className: "sp-flex sp-items-center sp-justify-center",
								children: /* @__PURE__ */ g("i", { className: "fa-regular fa-magnifying-glass" })
							}), /* @__PURE__ */ g("div", {
								className: "sp-flex sp-items-center sp-justify-center",
								children: /* @__PURE__ */ g("i", { className: "fa-regular fa-circle-user" })
							})]
						})]
					})
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-bottom-[50px] sp-right-[16px] sp-flex sp-flex-col sp-gap-[40px] sp-items-center sp-text-white sp-text-24px sp-z-10",
					children: [
						/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-thumbs-up" })
						}),
						/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-message" })
						}),
						/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-share" })
						}),
						/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-comment-lines" })
						}),
						/* @__PURE__ */ g("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ g("i", { className: "fa-regular fa-ellipsis" })
						})
					]
				}),
				/* @__PURE__ */ g("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[5]" }),
				/* @__PURE__ */ _("div", {
					className: `sp-absolute sp-bottom-[50px] sp-flex sp-flex-col sp-gap-3 sp-z-10 sp-transition-all sp-duration-200 ${n ? "sp-left-0 sp-right-0 sp-px-5 sp-bg-black/50 sp-p-3" : "sp-left-5 sp-max-w-[320px]"}`,
					children: [
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-gap-3",
							children: [/* @__PURE__ */ _("div", {
								className: "sp-flex sp-items-center sp-gap-[8px]",
								children: [
									/* @__PURE__ */ g("div", {
										className: "sp-w-[40px] sp-h-[40px] sp-rounded-full sp-overflow-hidden sp-bg-[#333] sp-flex sp-items-center sp-justify-center",
										children: /* @__PURE__ */ g("img", {
											src: e.profilePicture,
											className: "sp-w-full sp-h-full sp-object-cover"
										})
									}),
									/* @__PURE__ */ g("div", {
										className: "sp-flex sp-items-center sp-gap-1",
										children: /* @__PURE__ */ g("span", {
											className: "sp-text-white sp-font-semibold sp-text-[16px] sp-max-w-[180px] sp-overflow-hidden sp-whitespace-nowrap sp-text-ellipsis sp-inline-block",
											children: e.username
										})
									}),
									/* @__PURE__ */ g("div", {
										className: "sp-w-3 sp-h-3 sp-text-white sp-text-12px",
										children: /* @__PURE__ */ g("i", { className: "fa-regular fa-earth-americas" })
									})
								]
							}), /* @__PURE__ */ g("div", {
								className: "sp-flex-shrink-0 sp-ml-[12px]",
								children: /* @__PURE__ */ g("button", {
									className: "sp-bg-transparent  sp-border-[1px] sp-border-white/30 sp-border-solid sp-rounded-[9px] sp-text-white sp-text-[15px] sp-px-[12px] sp-py-[4px]",
									children: "Follow"
								})
							})]
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-text-white sp-text-[16px] sp-leading-6",
							children: [/* @__PURE__ */ g("div", {
								className: n ? "sp-max-h-[300px] sp-overflow-y-auto sp-break-words" : "sp-line-clamp-2 sp-overflow-hidden sp-break-words",
								style: n ? { scrollbarWidth: "none" } : void 0,
								id: i,
								ref: a,
								children: /* @__PURE__ */ g(em, {
									caption: e.caption || "",
									targetPlatform: "FB"
								})
							}), o && /* @__PURE__ */ g("button", {
								"aria-controls": i,
								"aria-expanded": n,
								"aria-label": n ? "Collapse caption" : "Show full caption",
								onClick: (e) => {
									e.stopPropagation(), r(!n);
								},
								className: "sp-text-gray-400 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
								type: "button",
								children: n ? "less" : "more"
							})]
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-gap-1.5 sp-text-white/70 sp-text-[11px] sp-mt-2",
							children: [/* @__PURE__ */ g("i", { className: "fa-solid fa-music sp-text-[10px]" }), /* @__PURE__ */ g("span", {
								className: "sp-truncate",
								children: "Audio will be auto-matched after publishing"
							})]
						})
					]
				})
			]
		})
	});
}, mg = ({ post: e }) => /* @__PURE__ */ _("div", {
	className: "sp-pb-8",
	children: [/* @__PURE__ */ g(pg, {
		post: e,
		media: e.medias.collection[0]
	}), /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-col sp-px-4 sp-py-8",
		children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ _(Zh, {
			$variant: "caption",
			className: "sp-whitespace-pre-line sp-break-words",
			children: [/* @__PURE__ */ g("span", {
				className: "sp-font-bold sp-mr-1",
				children: e.username
			}), /* @__PURE__ */ g(Gp, {
				caption: e.comment,
				targetPlatform: "FB"
			})]
		})
	})]
}), hg = ({ post: e }) => {
	let t = e.type, n = e.providedPost?.videoPostType;
	if (t === "video" && n === "reel") return /* @__PURE__ */ g(mg, { post: e });
	switch (t) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ g(fg, { post: e });
		case "story":
		case "fb-reel": return /* @__PURE__ */ g(mg, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, gg = Y.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: -0.025em;\n          white-space: pre-line;\n        ";
	}
}};
`, _g = ({ username: e, profilePicture: t, small: n }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center",
	children: [
		/* @__PURE__ */ g("div", {
			className: "sp-rounded-full sp-overflow-hidden sp-m-4",
			style: {
				width: "49px",
				height: "49px"
			},
			children: /* @__PURE__ */ g(uo, {
				src: t,
				alt: e
			})
		}),
		/* @__PURE__ */ g("div", {
			className: `sp-flex sp-flex-grow sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ _("div", {
				className: "sp-font-sans",
				children: [/* @__PURE__ */ g(gg, {
					$variant: "heading",
					className: "sp-mb-1",
					children: e
				}), /* @__PURE__ */ _(gg, {
					$variant: "subheading",
					className: "sp-text-gray-600",
					children: ["@", e]
				})]
			})
		}),
		/* @__PURE__ */ g("div", {
			className: "icon-twitter-down sp-mr-4 sp-text-2xl sp-text-gray-600",
			children: "\xA0"
		})
	]
}), vg = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, yg = Y.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, bg = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g($h, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ g(yg, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ _("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ g("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ g($h, {
	href: e,
	children: /* @__PURE__ */ g(vg, { src: e })
}), xg = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-bg-black sp-flex sp-items-center",
	children: /* @__PURE__ */ g(y, {
		src: e,
		controls: !0,
		playing: !1,
		className: "sp-relative",
		width: "100%",
		height: "auto"
	})
}) : null, Sg = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0 }) => t && i === !1 ? null : /* @__PURE__ */ _(h, { children: [(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(xg, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: s
}), !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(bg, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
})] }), Cg = () => /* @__PURE__ */ g("div", {
	className: "sp-py-4 sp-px-2 sp-w-full",
	children: /* @__PURE__ */ _("div", {
		className: "sp-flex sp-w-full sp-justify-center sp-text-gray-600 sp-py-2",
		style: {
			borderTop: "0.5px solid #ebebe4",
			borderBottom: "0.5px solid #ebebe4"
		},
		children: [
			/* @__PURE__ */ g(wg, { icon: "icon-twitter-reply" }),
			/* @__PURE__ */ g(wg, { icon: "icon-twitter-retweet" }),
			/* @__PURE__ */ g(wg, { icon: "icon-twitter-heart" }),
			/* @__PURE__ */ g(wg, { icon: "icon-twitter-share" })
		]
	})
}), wg = ({ icon: e }) => /* @__PURE__ */ g("div", {
	className: "sp-flex sp-items-center sp-justify-center sp-w-1/4 ",
	children: /* @__PURE__ */ g("div", { className: `sp-text-xl ${e}` })
}), Tg = Y.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Eg = ({ medias: e }) => {
	let [t, n] = m(!1);
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ g(Tg, {
			className: "sp-relative",
			children: /* @__PURE__ */ g(Sg, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, Dg = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _("div", {
		className: "sp-px-4",
		children: [n > 0 && /* @__PURE__ */ g(h, { children: n > 1 ? /* @__PURE__ */ g(Eg, {
			medias: t,
			count: n
		}) : /* @__PURE__ */ g(Sg, { media: t[0] }) }), /* @__PURE__ */ g("div", {
			className: "sp-flex sp-items-center sp-justify-between",
			children: /* @__PURE__ */ g(Cg, {})
		})]
	});
}, Og = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ _("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ g(_g, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-flex-col sp-m-4",
				children: /* @__PURE__ */ _(gg, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ g(em, {
						caption: t,
						targetPlatform: "TW"
					}), e.redirectUrl && /* @__PURE__ */ _(h, { children: [" ", /* @__PURE__ */ g("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ g("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ g(dg, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ g(Dg, { medias: e.medias })
		]
	});
}, kg = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ g(Og, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, Ag = Y.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 16px;\n          letter-spacing: 0.045em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 28px;\n          letter-spacing: 0.035em;\n        ";
	}
}};

  .sked-mention.sked-mention-linkedin {
    color: #0a66c2; // copied from LI home feed - in caption creator they're black but feed are #0a66c2
    cursor: pointer;
    font-weight: bold; // LI mentions are bold

    &:hover {
      text-decoration: underline;
    }
  }
`, jg = ({ username: e, profilePicture: t, locationName: n, small: r }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-rounded-full sp-overflow-hidden sp-m-4",
		style: {
			width: "48px",
			height: "48px"
		},
		children: /* @__PURE__ */ g(uo, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ _("div", {
		className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`,
		children: [/* @__PURE__ */ g(Ag, {
			$variant: "heading",
			children: e
		}), n && /* @__PURE__ */ g(Ag, {
			$variant: "subheading",
			className: "sp-text-gray-600",
			children: n
		})]
	})]
}), Mg = Y.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${(e) => e.backgroundColor || "var(--white)"};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -4px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -4px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -4px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -4px;
  }
`, Ng = Y.div`
  width: ${(e) => e.width || "auto"};
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(e) => e.backgroundColor || "var(--white)"};
  color: white;
  position: relative;
  z-index: 998;
  box-sizing: border-box;
  font-family: Helvetica;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`, Pg = ({ backgroundColor: e, arrowPosition: t, children: n, width: r, ...i }) => /* @__PURE__ */ g(Mg, {
	backgroundColor: e,
	className: `arrow-${t}`,
	children: /* @__PURE__ */ g(Ng, {
		backgroundColor: e,
		width: r,
		...i,
		children: n
	})
}), Fg = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		clipPath: "url(#clip0_4697_272)",
		children: /* @__PURE__ */ g("path", {
			d: "M7.99967 10.6666V7.99992M7.99967 5.33325H8.00634M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z",
			stroke: "white",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", {
		id: "clip0_4697_272",
		children: /* @__PURE__ */ g("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
}), Ig = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	(function(n, r) {
		/* istanbul ignore else */
		typeof j == "function" && typeof e == "object" && typeof t == "object" ? t.exports = r() : typeof define == "function" && define.amd ? define(function() {
			return r();
		}) : n.pluralize = r();
	})(e, function() {
		var e = [], t = [], n = {}, r = {}, i = {};
		function a(e) {
			return typeof e == "string" ? RegExp("^" + e + "$", "i") : e;
		}
		function o(e, t) {
			return e === t ? t : e === e.toLowerCase() ? t.toLowerCase() : e === e.toUpperCase() ? t.toUpperCase() : e[0] === e[0].toUpperCase() ? t.charAt(0).toUpperCase() + t.substr(1).toLowerCase() : t.toLowerCase();
		}
		function s(e, t) {
			return e.replace(/\$(\d{1,2})/g, function(e, n) {
				return t[n] || "";
			});
		}
		function c(e, t) {
			return e.replace(t[0], function(n, r) {
				var i = s(t[1], arguments);
				return o(n === "" ? e[r - 1] : n, i);
			});
		}
		function l(e, t, r) {
			if (!e.length || n.hasOwnProperty(e)) return t;
			for (var i = r.length; i--;) {
				var a = r[i];
				if (a[0].test(t)) return c(t, a);
			}
			return t;
		}
		function u(e, t, n) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? o(r, i) : e.hasOwnProperty(i) ? o(r, e[i]) : l(i, r, n);
			};
		}
		function d(e, t, n, r) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? !0 : !e.hasOwnProperty(i) && l(i, i, n) === i;
			};
		}
		function f(e, t, n) {
			var r = t === 1 ? f.singular(e) : f.plural(e);
			return (n ? t + " " : "") + r;
		}
		return f.plural = u(i, r, e), f.isPlural = d(i, r, e), f.singular = u(r, i, t), f.isSingular = d(r, i, t), f.addPluralRule = function(t, n) {
			e.push([a(t), n]);
		}, f.addSingularRule = function(e, n) {
			t.push([a(e), n]);
		}, f.addUncountableRule = function(e) {
			if (typeof e == "string") {
				n[e.toLowerCase()] = !0;
				return;
			}
			f.addPluralRule(e, "$0"), f.addSingularRule(e, "$0");
		}, f.addIrregularRule = function(e, t) {
			t = t.toLowerCase(), e = e.toLowerCase(), i[e] = t, r[t] = e;
		}, [
			["I", "we"],
			["me", "us"],
			["he", "they"],
			["she", "they"],
			["them", "them"],
			["myself", "ourselves"],
			["yourself", "yourselves"],
			["itself", "themselves"],
			["herself", "themselves"],
			["himself", "themselves"],
			["themself", "themselves"],
			["is", "are"],
			["was", "were"],
			["has", "have"],
			["this", "these"],
			["that", "those"],
			["echo", "echoes"],
			["dingo", "dingoes"],
			["volcano", "volcanoes"],
			["tornado", "tornadoes"],
			["torpedo", "torpedoes"],
			["genus", "genera"],
			["viscus", "viscera"],
			["stigma", "stigmata"],
			["stoma", "stomata"],
			["dogma", "dogmata"],
			["lemma", "lemmata"],
			["schema", "schemata"],
			["anathema", "anathemata"],
			["ox", "oxen"],
			["axe", "axes"],
			["die", "dice"],
			["yes", "yeses"],
			["foot", "feet"],
			["eave", "eaves"],
			["goose", "geese"],
			["tooth", "teeth"],
			["quiz", "quizzes"],
			["human", "humans"],
			["proof", "proofs"],
			["carve", "carves"],
			["valve", "valves"],
			["looey", "looies"],
			["thief", "thieves"],
			["groove", "grooves"],
			["pickaxe", "pickaxes"],
			["passerby", "passersby"]
		].forEach(function(e) {
			return f.addIrregularRule(e[0], e[1]);
		}), [
			[/s?$/i, "s"],
			[/[^\u0000-\u007F]$/i, "$0"],
			[/([^aeiou]ese)$/i, "$1"],
			[/(ax|test)is$/i, "$1es"],
			[/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
			[/(e[mn]u)s?$/i, "$1s"],
			[/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
			[/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
			[/(seraph|cherub)(?:im)?$/i, "$1im"],
			[/(her|at|gr)o$/i, "$1oes"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
			[/sis$/i, "ses"],
			[/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
			[/([^aeiouy]|qu)y$/i, "$1ies"],
			[/([^ch][ieo][ln])ey$/i, "$1ies"],
			[/(x|ch|ss|sh|zz)$/i, "$1es"],
			[/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
			[/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
			[/(pe)(?:rson|ople)$/i, "$1ople"],
			[/(child)(?:ren)?$/i, "$1ren"],
			[/eaux$/i, "$0"],
			[/m[ae]n$/i, "men"],
			["thou", "you"]
		].forEach(function(e) {
			return f.addPluralRule(e[0], e[1]);
		}), [
			[/s$/i, ""],
			[/(ss)$/i, "$1"],
			[/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
			[/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
			[/ies$/i, "y"],
			[/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
			[/\b(mon|smil)ies$/i, "$1ey"],
			[/\b((?:tit)?m|l)ice$/i, "$1ouse"],
			[/(seraph|cherub)im$/i, "$1"],
			[/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
			[/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
			[/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
			[/(test)(?:is|es)$/i, "$1is"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
			[/(alumn|alg|vertebr)ae$/i, "$1a"],
			[/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
			[/(matr|append)ices$/i, "$1ix"],
			[/(pe)(rson|ople)$/i, "$1rson"],
			[/(child)ren$/i, "$1"],
			[/(eau)x?$/i, "$1"],
			[/men$/i, "man"]
		].forEach(function(e) {
			return f.addSingularRule(e[0], e[1]);
		}), [
			"adulthood",
			"advice",
			"agenda",
			"aid",
			"aircraft",
			"alcohol",
			"ammo",
			"analytics",
			"anime",
			"athletics",
			"audio",
			"bison",
			"blood",
			"bream",
			"buffalo",
			"butter",
			"carp",
			"cash",
			"chassis",
			"chess",
			"clothing",
			"cod",
			"commerce",
			"cooperation",
			"corps",
			"debris",
			"diabetes",
			"digestion",
			"elk",
			"energy",
			"equipment",
			"excretion",
			"expertise",
			"firmware",
			"flounder",
			"fun",
			"gallows",
			"garbage",
			"graffiti",
			"hardware",
			"headquarters",
			"health",
			"herpes",
			"highjinks",
			"homework",
			"housework",
			"information",
			"jeans",
			"justice",
			"kudos",
			"labour",
			"literature",
			"machinery",
			"mackerel",
			"mail",
			"media",
			"mews",
			"moose",
			"music",
			"mud",
			"manga",
			"news",
			"only",
			"personnel",
			"pike",
			"plankton",
			"pliers",
			"police",
			"pollution",
			"premises",
			"rain",
			"research",
			"rice",
			"salmon",
			"scissors",
			"series",
			"sewage",
			"shambles",
			"shrimp",
			"software",
			"species",
			"staff",
			"swine",
			"tennis",
			"traffic",
			"transportation",
			"trout",
			"tuna",
			"wealth",
			"welfare",
			"whiting",
			"wildebeest",
			"wildlife",
			"you",
			/pok[eé]mon$/i,
			/[^aeiou]ese$/i,
			/deer$/i,
			/fish$/i,
			/measles$/i,
			/o[iu]s$/i,
			/pox$/i,
			/sheep$/i
		].forEach(f.addUncountableRule), f;
	});
})))(), 1), Lg = ({ preferVideoCoverPreviewOverride: e, thumbnailUrl: t, contextVideoCoverPreview: n }) => e && n ? n : t, Rg = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, zg = Y.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Bg = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a, url: o }) => t ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g($h, {
	href: o || e,
	$isFlex: !0,
	children: /* @__PURE__ */ g(zg, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ _("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ g("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ g($h, {
	href: o || e,
	children: /* @__PURE__ */ g(Rg, {
		src: e,
		title: "Click to see the full file in a new window."
	})
}), Vg = ({ url: e, thumbnailUrl: t, isActiveSlide: n, shouldUseVideoCoverPreviewOverride: r, width: i, height: a }) => {
	let [o, s] = m(!1), { videoCoverPreview: l, preferVideoCoverPreviewOverride: u } = c(am), { videoCoverPreview: d, showVideoCover: f } = lm({
		usePostTypeCheck: !1,
		videoCoverPreviewOverride: Lg({
			preferVideoCoverPreviewOverride: u && r,
			thumbnailUrl: t,
			contextVideoCoverPreview: l
		})
	}), p = i && a && i > 0 && a > 0 ? `${i} / ${a}` : null;
	if (!n) return null;
	let h = (e) => {
		console.error("Error loading video", e), s(!0);
	};
	return /* @__PURE__ */ _(Wg, {
		className: "sp-flex sp-items-center sp-h-full",
		style: p ? { aspectRatio: p } : void 0,
		children: [o && /* @__PURE__ */ g("div", {
			className: "sp-text-xl sp-text-red-500 sp-mx-auto",
			children: "Failed to load this video."
		}), !o && /* @__PURE__ */ g(y, {
			src: e,
			controls: !0,
			light: f ? d : void 0,
			playing: !!d,
			onError: (e) => h(e),
			className: "sp-relative react-player",
			width: "100%",
			height: "100%"
		})]
	});
}, Hg = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0, shouldUseVideoCoverPreviewOverride: c = !1 }) => t && i === !1 ? null : /* @__PURE__ */ _(h, { children: [
	(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(Vg, {
		url: e.url,
		thumbnailUrl: e.thumbnailUrl,
		isActiveSlide: s,
		shouldUseVideoCoverPreviewOverride: c,
		width: e.width,
		height: e.height
	}),
	!(e.isVideo || e.url.includes(".mp4") || e.url.includes(".pdf")) && /* @__PURE__ */ g(Bg, {
		src: e.url,
		forCarousel: n,
		showOverlay: r ?? !1,
		showAll: i ?? !1,
		setShowAll: a,
		mediaCount: o
	}),
	e.url.includes(".pdf") && /* @__PURE__ */ _("div", { children: [
		/* @__PURE__ */ _(Gg, { children: [
			/* @__PURE__ */ g("span", {
				className: "filename",
				title: e.fileName,
				children: e.fileName
			}),
			/* @__PURE__ */ g("span", {
				className: "dot",
				children: "●"
			}),
			/* @__PURE__ */ g("span", {
				className: "pages",
				children: (0, Ig.default)("page", e.pages, !0)
			}),
			/* @__PURE__ */ _(Kg, { children: [/* @__PURE__ */ g(Fg, {}), /* @__PURE__ */ g(qg, {
				id: "tooltip",
				children: /* @__PURE__ */ _(Pg, {
					arrowPosition: "bottom",
					backgroundColor: "#1A1A1A",
					width: "250px",
					children: [
						"Previewing Page 1 of ",
						e.pages,
						". The complete document will be posted to LinkedIn."
					]
				})
			})] })
		] }),
		e.thumbnailUrl !== void 0 && /* @__PURE__ */ g(Bg, {
			src: e.thumbnailUrl,
			url: e.url,
			forCarousel: !1,
			mediaCount: o,
			showAll: i ?? !1,
			setShowAll: a,
			showOverlay: r ?? !1
		}),
		/* @__PURE__ */ g(Ug, { children: /* @__PURE__ */ g("a", {
			href: e.url,
			target: "_blank",
			rel: "noreferrer",
			children: "Click to download and view the full document in a new tab."
		}) })
	] })
] }), Ug = Y.span`
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: flex;
`, Wg = Y.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #000;

  .react-player {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player > div {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player__preview {
    width: 100%;
    height: 100%;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
`, Gg = Y.div`
  background: rgba(0, 0, 0, 0.4);
  padding: 4px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  .filename {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }

  .dot {
    padding: 0 4px 0 6px;
    font-size: 6px;
    position: relative;
    top: 1px;
    line-height: 16px;
  }

  .pages {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }

  svg {
    position: relative;
    top: 2px;
    margin-left: 4px;
  }
`, Kg = Y.div`
  position: relative;
  display: inline-block;
  line-height: normal;

  svg {
    &:hover + #tooltip {
      display: block;
    }
  }
`, qg = Y.div`
  display: none;
  position: absolute;
  top: -60px;
  left: calc(-250px / 2 + 12px);
`, Jg = Y.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Yg = ({ medias: e }) => {
	let [t, n] = m(!1);
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ g(Jg, {
			className: "sp-relative",
			children: /* @__PURE__ */ g(Hg, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				shouldUseVideoCoverPreviewOverride: i === 0,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, Xg = () => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-w-full sp-items-center sp-justify-center sp-py-4 sp-text-gray-700 sp-font-bold",
	children: [
		/* @__PURE__ */ g(Zg, {
			icon: "icon-linkedin-like",
			text: "Like",
			className: "sp-justify-start sp-ml-2"
		}, "ico-like"),
		/* @__PURE__ */ g(Zg, {
			icon: "icon-linkedin-comment",
			text: "Comment",
			className: "sp-justify-center"
		}, "ico-comment"),
		/* @__PURE__ */ g(Zg, {
			icon: "icon-linkedin-share",
			text: "Share",
			className: "sp-justify-end sp-mr-2"
		}, "ico-share")
	]
}), Zg = ({ icon: e, text: t, className: n = "" }) => /* @__PURE__ */ _(Ag, {
	$variant: "icons",
	className: `sp-flex sp-items-center sp-w-1/3 ${n}`,
	children: [/* @__PURE__ */ g("div", { className: `sp-mr-1 sp-text-2xl ${e}` }), /* @__PURE__ */ g("div", {
		className: "sp-text-gray-700 sp-text-xl",
		children: t
	})]
}), Qg = ({ medias: e, postType: t }) => {
	let n = e?.collection || [];
	if (t === "document") {
		if (n.length === 0) n.push({});
		else {
			let t = e?.medias?.[0];
			t && (n[0].thumbnailUrl = t.thumbnailUrl, n[0].fileName = t.fileName, n[0].pages = t.meta?.pages, n[0].url = t.url);
		}
	}
	t === "multiMedia" && n.length > 0 && (n = n.filter((e) => !e.url.includes(".pdf")));
	let r = n.length;
	return /* @__PURE__ */ _("div", { children: [r > 0 && /* @__PURE__ */ g(h, { children: r > 1 ? /* @__PURE__ */ g(Yg, { medias: n }) : /* @__PURE__ */ g(Hg, {
		media: n[0],
		mediaCount: r,
		shouldUseVideoCoverPreviewOverride: !0,
		setShowAll: () => {},
		forCarousel: !1,
		showAll: !1,
		hidden: !1,
		isActiveSlide: !0,
		showOverlay: !1
	}) }), /* @__PURE__ */ g("div", {
		className: "sp-flex sp-items-center sp-justify-between",
		children: /* @__PURE__ */ g(Xg, {})
	})] });
}, $g = ({ post: e, trackEvent: t }) => /* @__PURE__ */ _("div", {
	className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
	children: [
		/* @__PURE__ */ g(jg, {
			username: e.username,
			profilePicture: e.profilePicture,
			locationName: e.locationName
		}),
		e.caption && /* @__PURE__ */ _(Ag, {
			$variant: "caption",
			className: "sp-whitespace-pre-line sp-break-words sp-flex sp-flex-col sp-m-8",
			children: [/* @__PURE__ */ g(em, {
				caption: e.caption,
				targetPlatform: "LI",
				trackEvent: t
			}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ _(h, { children: [" ", /* @__PURE__ */ g("a", {
				className: "sp-text-blue-400 sp-break-words",
				href: e.redirectUrl,
				target: "_blank",
				children: e.redirectUrl
			})] })]
		}),
		e.type === "text" && e.redirectUrl && /* @__PURE__ */ g("div", {
			className: "sp-p-4",
			children: /* @__PURE__ */ g(dg, { url: e.redirectUrl })
		}),
		/* @__PURE__ */ g(Qg, {
			medias: e.medias,
			postType: e.type
		}),
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
			children: e.comment && /* @__PURE__ */ _(Ag, {
				$variant: "caption",
				className: "sp-whitespace-pre-line sp-break-words",
				children: [/* @__PURE__ */ g("span", {
					className: "sp-font-bold sp-mr-1",
					children: e.username
				}), /* @__PURE__ */ g(Gp, {
					caption: e.comment,
					targetPlatform: "LI"
				})]
			})
		})
	]
}), e_ = ({ post: e, trackEvent: t }) => {
	switch (e.type) {
		case "image":
		case "text":
		case "video":
		case "multiMedia":
		case "document": return /* @__PURE__ */ g($g, {
			post: e,
			trackEvent: t
		});
		default: return /* @__PURE__ */ g(h, {});
	}
}, t_ = Y.span`
  font-family: Roboto, arial, sans-serif;

  ${({ $variant: e }) => {
	if (e === "buttonlabel") return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
}};
`, n_ = Y.div`
  font-family: Roboto, arial, sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          color: rgba(0,0,0,.54);\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 28px;\n          letter-spacing: 0.035em;\n        ";
		case "title": return "\n          font-style: normal;\n          font-weight: medium;\n          font-size: 20px;\n          line-height: 28px;\n        ";
		case "subtitle": return "\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 24px;\n        ";
	}
}};
`, r_ = Y(uo)`
  display: inherit;

  img {
    border-radius: 50%;
  }
`, i_ = ({ username: e, profilePicture: t }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-pb-4",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-mr-1",
		style: {
			width: "38x",
			height: "38px"
		},
		children: [/* @__PURE__ */ g(r_, {
			src: t,
			alt: e
		}), /* @__PURE__ */ g("div", {
			style: {
				position: "relative",
				top: "25px",
				right: "25%",
				marginLeft: "auto",
				fill: "#1a73e8",
				lineHeight: "18px",
				height: "18px"
			},
			children: /* @__PURE__ */ g("svg", {
				viewBox: "0 0 24 24",
				xmlns: "http://www.w3.org/2000/svg",
				style: { height: "18px" },
				children: /* @__PURE__ */ g("path", {
					stroke: "#fff",
					d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
				})
			})
		})]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-col sp-justify-center sp-leading-tight ",
		style: {
			width: "auto",
			height: "36px"
		},
		children: [/* @__PURE__ */ g(n_, {
			$variant: "heading",
			className: "",
			children: e
		}), /* @__PURE__ */ g(n_, {
			$variant: "subheading",
			className: "",
			children: "a minute ago"
		})]
	})]
}), a_ = Y.img`
  object-fit: contain;
  position: relative;
  width: 100%;
  max-height: 290px;
`, o_ = ({ src: e }) => /* @__PURE__ */ g($h, {
	href: e,
	children: /* @__PURE__ */ g(a_, { src: e })
}), s_ = ({ url: e }) => /* @__PURE__ */ g("div", {
	className: "sp-flex sp-items-center sp-h-full",
	children: /* @__PURE__ */ g(y, {
		src: e,
		playing: !1,
		loop: !0,
		controls: !0,
		className: "sp-w-full",
		width: "100%",
		height: "auto"
	})
}), c_ = ({ media: e }) => {
	let [t, n] = m(0), r = p(null), i = e.length, a = (e) => {
		let t = r.current;
		if (!t) return;
		let a = Math.max(0, Math.min(e, i - 1));
		t.scrollTo({
			left: a * (t.clientWidth / 1.1),
			behavior: "smooth"
		}), n(a);
	};
	return /* @__PURE__ */ _("div", {
		className: "sp-relative",
		children: [
			/* @__PURE__ */ g("div", {
				className: "sp-text-white sp-bg-black sp-rounded-lg sp-p-2 sp-text-xl sp-w-auto sp-text-center",
				style: {
					opacity: .7,
					position: "absolute",
					right: "25px",
					zIndex: 100,
					top: "10px"
				},
				children: /* @__PURE__ */ _(t_, { children: [
					t + 1,
					" / ",
					i
				] })
			}),
			/* @__PURE__ */ g(l_, {
				ref: r,
				onScroll: () => {
					let e = r.current;
					if (!e) return;
					let t = e.clientWidth / 1.1;
					n(Math.round(e.scrollLeft / t));
				},
				children: e.map((e, t) => e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(u_, {
					className: "sp-p-2",
					children: /* @__PURE__ */ g(s_, { url: e.url })
				}, `item-${t}`) : /* @__PURE__ */ g(u_, { children: /* @__PURE__ */ g(o_, { src: e.url }) }, `item-${t}`))
			}),
			t > 0 && /* @__PURE__ */ g(d_, {
				type: "button",
				$side: "left",
				"aria-label": "Previous media",
				onClick: () => a(t - 1)
			}),
			t < i - 1 && /* @__PURE__ */ g(d_, {
				type: "button",
				$side: "right",
				"aria-label": "Next media",
				onClick: () => a(t + 1)
			})
		]
	});
}, l_ = Y.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`, u_ = Y.div`
  box-sizing: border-box;
  flex: 0 0 calc(100% / 1.1);
  min-width: 0;
  scroll-snap-align: start;

  img {
    object-fit: cover;
    width: 100%;
  }
`, d_ = Y.button`
  background: rgb(255 255 255 / 80%);
  border: 0;
  border-radius: ${({ $side: e }) => e === "left" ? "0 10px 10px 0" : "10px 0 0 10px"};
  bottom: 0;
  cursor: pointer;
  height: 20%;
  margin: auto 0;
  min-height: 56px;
  position: absolute;
  ${({ $side: e }) => `${e}: 0;`}
  top: 0;
  width: 40px;
  z-index: 1;

  &::after {
    border-right: 3px solid #aaa;
    border-top: 3px solid #aaa;
    content: "";
    display: inline-block;
    height: 24px;
    transform: rotate(
      ${({ $side: e }) => e === "left" ? "-135deg" : "45deg"}
    );
    width: 24px;
  }
`, f_ = ({ media: e }) => e.length === 1 ? e[0].isVideo || e[0].url.includes(".mp4") ? /* @__PURE__ */ g(s_, { url: e[0].url }) : /* @__PURE__ */ g(o_, { src: e[0].url }) : /* @__PURE__ */ g(c_, { media: e }), p_ = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	if (t && t.length > 0) return /* @__PURE__ */ g("div", {
		className: "sp-h-full sp-py-4",
		children: n && /* @__PURE__ */ g(f_, { media: t })
	});
}, m_ = (e) => {
	switch (e) {
		case "BOOK": return "Book now";
		case "ORDER": return "Order online";
		case "SHOP": return "Buy";
		case "LEARN_MORE": return "Learn more";
		case "SIGN_UP": return "Sign up";
		case "CALL": return "Call now";
		default: return null;
	}
}, h_ = ({ post: e }) => {
	let t = null, n = null;
	e.event && e.event.startDate && (t = new b(e.event.startDate), n = new b(e.event.endDate));
	let r = e.caption, i = m_(e.callToAction.actionType);
	return /* @__PURE__ */ _("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pt-4 sp-pb-6 sp-px-6",
		children: [
			/* @__PURE__ */ g(i_, {
				username: e.username,
				profilePicture: e.profilePicture
			}),
			e.medias && e.medias.count > 0 && /* @__PURE__ */ g(p_, { medias: e.medias }),
			e.event && e.event.title && /* @__PURE__ */ _(n_, {
				$variant: "title",
				children: [
					e.event.title,
					" ",
					e.topicType === "OFFER" && /* @__PURE__ */ g("span", {
						style: {
							display: "inline-block",
							height: "20px",
							width: "20px"
						},
						children: /* @__PURE__ */ g("svg", {
							focusable: "false",
							xmlns: "http://www.w3.org/2000/svg",
							viewBox: "0 0 24 24",
							fill: "#f4b400",
							style: { height: "20px" },
							children: /* @__PURE__ */ g("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
						})
					})
				]
			}),
			t && e.topicType === "EVENT" && /* @__PURE__ */ g(n_, {
				$variant: "subtitle",
				className: "sp-text-googlegray-500 sp-font-light",
				children: `${b(t).format("MMM D, LT")} -  ${b(n).format("MMM D, LT")}`
			}),
			t && e.topicType === "OFFER" && /* @__PURE__ */ g(n_, {
				$variant: "subtitle",
				className: "",
				children: `Valid ${b(t).format("MMM D")} -  ${b(n).format("MMM D")}`
			}),
			r && /* @__PURE__ */ g(n_, {
				$variant: "caption",
				className: `sp-flex sp-flex-col sp-mt-6 sp-pb-6 ${t ? "sp-text-googlegray-500 sp-font-light" : null}`,
				style: { fontSize: t ? "13px" : "" },
				children: /* @__PURE__ */ g(em, { caption: r })
			}),
			e.topicType === "OFFER" && e.offer && /* @__PURE__ */ _(h, { children: [e.offer.couponCode && /* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-mb-6 sp-bg-googlegray-100 sp-border-dashed sp-border-googlegray-200 sp-p-6",
				children: [
					/* @__PURE__ */ g(t_, {
						className: "sp-text-googlegray-500 sp-text-xl sp-pb-2",
						children: "Show this code at the shop"
					}),
					/* @__PURE__ */ g(t_, {
						className: "sp-font-medium sp-text-5xl sp-pb-2",
						children: e.offer.couponCode
					}),
					/* @__PURE__ */ g(t_, {
						className: "sp-text-lg sp-font-bold",
						children: `Valid ${b(t).format("l, LT")} - ${b(n).format("l, LT")}`
					})
				]
			}), e.offer.redeemOnlineUrl && /* @__PURE__ */ g("a", {
				href: e.offer.redeemOnlineUrl,
				className: "sp-text-blue-700 sp-no-underline sp-text-2xl",
				target: "_blank",
				rel: "noreferrer",
				children: /* @__PURE__ */ g(t_, { children: "Redeem online" })
			})] }),
			e.callToAction && i && /* @__PURE__ */ g("div", {
				className: "sp-mb-2 sp-pt-4 sp-my-2",
				children: /* @__PURE__ */ g("a", {
					href: e.callToAction.url,
					target: "_blank",
					className: "sp-no-underline sp-inline",
					children: /* @__PURE__ */ g(t_, {
						$variant: "buttonlabel",
						style: { width: "auto" },
						className: " sp-text-white sp-bg-googleblue-500 sp-py-4 sp-px-6 sp-text-xl sp-no-underline hover:sp-bg-googleblue-600 sp-rounded hover:sp-shadow-lg",
						children: i
					})
				})
			}),
			e.topicType === "OFFER" && e.offer && e.offer.termsConditions && /* @__PURE__ */ g("div", {
				className: "sp-border-googlegray-300 sp-border-solid sp-mt-4 sp-pt-4",
				style: {
					borderWidth: 0,
					borderTopWidth: "1px"
				},
				children: /* @__PURE__ */ g(t_, {
					className: "sp-text-base sp-text-googlegray-400",
					children: e.offer.termsConditions
				})
			})
		]
	});
}, g_ = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "text":
		case "video":
		case "multiMedia":
		case "gmb": return /* @__PURE__ */ g(h_, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, __ = Y.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 16px;\n          letter-spacing: -0.02em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, v_ = ({ username: e, profilePicture: t, small: n, description: r }) => /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-rounded-full sp-overflow-hidden  sp-m-4",
		style: {
			width: "40px",
			height: "40px",
			minWidth: "40px",
			minHeight: "40px"
		},
		children: /* @__PURE__ */ g(uo, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ g("div", {
		className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
		children: /* @__PURE__ */ g("div", {
			className: "",
			children: /* @__PURE__ */ g(__, {
				$variant: "subheading",
				className: "sp-mb-1",
				children: e
			})
		})
	})]
}), /* @__PURE__ */ g("div", {
	className: "sp-ml-8 sp-mr-4",
	style: { paddingLeft: "40px" },
	children: /* @__PURE__ */ g(__, {
		$variant: "caption",
		className: "sp-mb-1",
		children: /* @__PURE__ */ g(em, { caption: r })
	})
})] }), y_ = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-bg-black sp-relative",
	style: {},
	children: /* @__PURE__ */ g(y, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, b_ = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : /* @__PURE__ */ g(h, { children: (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(y_, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) }), x_ = Y.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, S_ = ({ medias: e }) => {
	let [t, n] = m(!1);
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ g(x_, {
			className: "sp-relative",
			children: /* @__PURE__ */ g(b_, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, C_ = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ g("div", { children: n > 0 && /* @__PURE__ */ g(h, { children: n > 1 ? /* @__PURE__ */ g(S_, {
		medias: t,
		count: n
	}) : /* @__PURE__ */ g(b_, { media: t[0] }) }) });
}, w_ = ({ post: e }) => {
	let t = e.ytTitle;
	return /* @__PURE__ */ _("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pb-4",
		children: [
			/* @__PURE__ */ g(C_, { medias: e.medias }),
			/* @__PURE__ */ _("div", {
				className: "sp-mt-2 sp-mb-2 sp-flex sp-flex-col sp-border-0 sp-border-b sp-border-solid sp-border-gray-300",
				children: [/* @__PURE__ */ g("div", {
					className: "sp-mt-4 sp-mb-6 sp-m-2",
					children: /* @__PURE__ */ g(__, {
						$variant: "heading",
						className: "sp-whitespace-pre-line sp-break-words",
						children: t
					})
				}), /* @__PURE__ */ g("div", {})]
			}),
			/* @__PURE__ */ g(v_, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName,
				description: e.caption
			})
		]
	});
}, T_ = ({ post: e }) => {
	switch (e.type) {
		case "video": return /* @__PURE__ */ g(w_, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, E_ = Y.div`
  font-family: "Helvetica", sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          text-decoration: none !important;\n          color: inherit !important;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 10px;\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 10px;\n          line-height: 15px;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, D_ = Y.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n        ";
		case "bold": return "\n          font-style: normal;\n          font-weight: bold;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 13px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, O_ = ({ username: e, boardTitle: t, boardSectionTitle: n, profilePicture: r, small: i, description: a, url: o, title: s }) => {
	let c = null;
	if (o) try {
		let { hostname: e } = new URL(o);
		c = e;
	} catch {}
	return /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _("div", {
		className: "sp-p-2 sp-px-4",
		children: [
			o && c && /* @__PURE__ */ g("div", {
				className: "sp-pb-2",
				children: /* @__PURE__ */ _(E_, {
					$variant: "caption",
					children: [
						"Article from",
						" ",
						/* @__PURE__ */ g("a", {
							href: o,
							target: "_blank",
							style: {
								color: "inherit",
								textDecoration: "none"
							},
							rel: "noreferrer",
							children: /* @__PURE__ */ g(D_, {
								$variant: "bold",
								children: c
							})
						})
					]
				})
			}),
			s && /* @__PURE__ */ g("div", {
				className: "sp-pb-2",
				children: /* @__PURE__ */ g(k_, {
					url: o,
					children: /* @__PURE__ */ g(E_, {
						$variant: "heading",
						children: s
					})
				})
			}),
			a && /* @__PURE__ */ g(E_, {
				$variant: "caption",
				children: /* @__PURE__ */ g(em, {
					caption: a,
					targetPlatform: "PI"
				})
			})
		]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-px-4",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-mr-2",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ g(uo, {
				src: r,
				alt: e
			})
		}), /* @__PURE__ */ g("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${i ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ _("div", {
				className: "",
				children: [
					/* @__PURE__ */ _(D_, {
						$variant: "bold",
						className: "sp-mb-1",
						children: [e, " "]
					}),
					/* @__PURE__ */ g(D_, { children: "saved to " }),
					n && /* @__PURE__ */ _(h, { children: [
						/* @__PURE__ */ g(D_, {
							$variant: "bold",
							className: "sp-mb-1",
							children: n
						}),
						" ",
						"in "
					] }),
					/* @__PURE__ */ g(D_, {
						$variant: "bold",
						className: "sp-mb-1",
						children: t
					})
				]
			})
		})]
	})] });
}, k_ = ({ url: e, children: t }) => e ? /* @__PURE__ */ g("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ g("div", { children: t }), A_ = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
  border-radius: 20px;
`, j_ = ({ src: e }) => /* @__PURE__ */ g(A_, { src: e }), M_ = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-bg-black sp-relative",
	style: { borderRadius: "10px" },
	children: /* @__PURE__ */ g(y, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, N_ = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(M_, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) : /* @__PURE__ */ g(j_, { src: e.url }), P_ = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ g(F_, { children: n > 0 && /* @__PURE__ */ g(N_, { media: t[0] }) });
}, F_ = Y.div`
  border-radius: 20px;
  overflow: hidden;
`, I_ = ({ url: e, children: t }) => e ? /* @__PURE__ */ g("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ g("div", { children: t }), L_ = ({ post: e }) => /* @__PURE__ */ _(R_, {
	className: "sp-bg-white md:sp-shadow-around sp-pb-4",
	style: {
		borderTopLeftRadius: "20px",
		borderTopRightRadius: "20px"
	},
	children: [/* @__PURE__ */ g("div", {
		className: "sp-pb-2",
		children: /* @__PURE__ */ g(I_, {
			url: e.redirectUrl,
			children: /* @__PURE__ */ g(P_, { medias: e.medias })
		})
	}), /* @__PURE__ */ g(O_, {
		username: e.username,
		small: !1,
		profilePicture: e.profilePicture,
		description: e.caption,
		title: e.piTitle,
		boardTitle: e.boardTitle,
		boardSectionTitle: e.boardSectionTitle,
		url: e.redirectUrl
	})]
}), R_ = Y.div`
  padding: 35px 28px 28px;
`, z_ = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ g(L_, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, B_ = Y.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`, V_ = Y.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, H_ = ({ src: e }) => /* @__PURE__ */ g(V_, { src: e }), U_ = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-relative",
	children: /* @__PURE__ */ g(y, {
		controls: !0,
		src: e,
		playing: !1,
		width: "100%",
		height: "auto",
		style: {
			display: "grid",
			placeContent: "center",
			minHeight: "600px",
			background: "grey"
		}
	})
}) : null, W_ = ({ media: e, hidden: t = !1, showAll: n, isActiveSlide: r = !0 }) => t && n === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(U_, {
	url: e.url,
	isActiveSlide: r
}) : /* @__PURE__ */ g(B_, { children: /* @__PURE__ */ g(H_, { src: e.url }) }), G_ = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ g(K_, { children: n > 0 && /* @__PURE__ */ g(W_, { media: t[0] }) });
}, K_ = Y.div`
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: grey;
`, q_ = Y.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, J_ = (e) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "10 6 14 14",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_89)",
		children: /* @__PURE__ */ g("path", {
			d: "M23.6165 19.615C23.3689 19.8635 23.04 20 22.6891 20C22.3391 20 22.0093 19.8635 21.7617 19.615L19.4195 17.2735C18.4363 17.9069 17.2914 18.2435 16.1219 18.243C14.9112 18.2432 13.7277 17.8843 12.721 17.2118C11.7143 16.5392 10.9296 15.5832 10.4662 14.4647C10.0028 13.3462 9.88143 12.1153 10.1175 10.9278C10.3536 9.74027 10.9365 8.64946 11.7925 7.79325C12.6485 6.93706 13.7392 6.35396 14.9265 6.11769C16.1139 5.88142 17.3447 6.00259 18.4632 6.46589C19.5817 6.92919 20.5378 7.71379 21.2104 8.72049C21.883 9.72718 22.242 10.9107 22.242 12.1215C22.2426 13.2902 21.907 14.4344 21.2752 15.4176L23.6165 17.76C23.8621 18.0062 24 18.3398 24 18.6875C24 19.0352 23.8621 19.3688 23.6165 19.615ZM16.1219 8.625C15.6628 8.625 15.2081 8.71545 14.7839 8.89116C14.3598 9.06687 13.9743 9.32442 13.6497 9.6491C13.325 9.97378 13.0675 10.3592 12.8918 10.7834C12.7161 11.2077 12.6257 11.6623 12.6257 12.1215C12.6257 12.5807 12.7161 13.0353 12.8918 13.4595C13.0675 13.8838 13.325 14.2692 13.6497 14.5939C13.9743 14.9186 14.3598 15.1761 14.7839 15.3519C15.2081 15.5276 15.6628 15.618 16.1219 15.618C17.0493 15.618 17.9387 15.2496 18.5944 14.5938C19.2502 13.938 19.6186 13.0485 19.6186 12.1211C19.6186 11.1936 19.2502 10.3042 18.5944 9.64836C17.9387 8.99256 17.0493 8.62412 16.1219 8.62412V8.625Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_89",
		x: 0,
		y: 0,
		width: 34,
		height: 34,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_89"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_89",
				result: "shape"
			})
		]
	}) })]
}), Y_ = (e) => /* @__PURE__ */ g("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M14.0463 1.18364C13.2625 0.399877 12.2228 0 11.1831 0C10.1435 0 9.11978 0.399877 8.32003 1.18364L7.64823 1.85543L6.97644 1.18364C6.19268 0.399877 5.153 0 4.11332 0C2.46583 0 0.834332 0.991695 0.178533 2.95909C-0.253334 4.28668 0.114553 5.75823 1.10625 6.74992L7.15239 12.7961C7.4243 13.068 7.84018 13.068 8.11209 12.7961L14.0143 6.89388C15.6298 5.32636 15.6298 2.75115 14.0463 1.18364Z",
		fill: "white"
	})
}), X_ = (e) => /* @__PURE__ */ g("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		d: "M1.68328 11.6584C0.823728 12.0881 -0.0881374 11.1763 0.34164 10.3167L1.5049 7.99021C2.12365 6.7527 2.05895 5.2833 1.33382 4.10496L0.201123 2.26433C-0.314794 1.42596 0.56357 0.425049 1.46184 0.827721L11.0744 5.13679C11.8442 5.48188 11.8671 6.56645 11.1125 6.94373L1.68328 11.6584Z",
		fill: "white"
	})
}), Z_ = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 4,
	viewBox: "0 0 16 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ g("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ g("circle", {
			cx: 8,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ g("circle", {
			cx: 14,
			cy: 2,
			r: 2,
			fill: "white"
		})
	]
}), Q_ = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 14 8",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_103)",
		children: [/* @__PURE__ */ g("path", {
			d: "M21 7C20.7545 7 20.5556 7.19899 20.5556 7.44444V9.55555H18.4444C18.199 9.55555 18 9.75453 18 10C18 10.2455 18.199 10.4444 18.4444 10.4444H20.5556V12.5556C20.5556 12.801 20.7545 13 21 13C21.2455 13 21.4444 12.801 21.4444 12.5556V10.4444H23.5555C23.801 10.4444 24 10.2455 24 10C24 9.75453 23.801 9.55555 23.5555 9.55555H21.4444V7.44444C21.4444 7.19899 21.2455 7 21 7Z",
			fill: "white"
		}), /* @__PURE__ */ g("path", {
			d: "M10.8872 14C11.0037 14.0002 11.1191 13.9808 11.2267 13.9429C11.3343 13.9051 11.432 13.8495 11.5141 13.7794L13.5 12.0955L15.4782 13.7729C15.6019 13.8802 15.7606 13.9537 15.9339 13.984C16.1072 14.0143 16.2872 13.9999 16.4508 13.9427C16.6144 13.8856 16.7541 13.7883 16.852 13.6633C16.9498 13.5383 17.0014 13.3913 17 13.2413V7.16129C17 6.8533 16.8557 6.55792 16.5988 6.34013C16.342 6.12235 15.9936 6 15.6304 6H11.3696C11.0063 6 10.658 6.12235 10.4011 6.34013C10.1443 6.55792 10 6.8533 10 7.16129V13.2477C10.0004 13.4471 10.094 13.6383 10.2603 13.7793C10.4266 13.9203 10.652 13.9997 10.8872 14ZM10.913 7.16129C10.913 7.05863 10.9611 6.96017 11.0468 6.88757C11.1324 6.81498 11.2485 6.77419 11.3696 6.77419H15.6304C15.7515 6.77419 15.8676 6.81498 15.9532 6.88757C16.0388 6.96017 16.0869 7.05863 16.0869 7.16129V13.1948L13.5 11.0013L10.913 13.1948V7.16129Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_103",
		x: 0,
		y: 0,
		width: 34,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_103"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_103",
				result: "shape"
			})
		]
	}) })]
}), $_ = Y.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, ev = Y(q_)`
  position: absolute;
  top: 17px;
  z-index: 2;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
    font-size: 16px;
  }

  svg {
    position: relative;
    left: -50%;
    width: 14px;
  }
`, tv = Y.div`
  position: absolute;
  right: 7px;
  bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 15px;
  }
`, nv = Y.div`
  width: 32px;
  display: grid;
  place-content: center;
  height: 32px;
`, rv = Y.div`
  width: 32px;
  height: 32px;
  opacity: 0.2;
  border-radius: 50%;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: white;
  position: absolute;
`, iv = Y.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 22px;
  height: 22px;
  border-radius: 50%;
`, av = Y.div`
  position: absolute;
  z-index: 2;
  padding: 7px;
  display: flex;
  align-items: center;
  height: 22px;
  gap: 4px;
  bottom: 45px;

  p {
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  }

  .bookmarkIconWrap {
    position: relative;
    top: -2px;
    left: 4px;
    height: 8px;

    svg {
      height: 8px;
    }
  }
`, ov = ({ url: e, children: t }) => e ? /* @__PURE__ */ g("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ g("div", { children: t }), sv = ({ medias: e, profilePicture: t, username: n }) => /* @__PURE__ */ _("div", {
	className: "sp-relative",
	children: [
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-justify-center",
			children: /* @__PURE__ */ _(ev, { children: [/* @__PURE__ */ g(J_, {}), /* @__PURE__ */ g("span", { children: "Spotlight You" })] })
		}),
		/* @__PURE__ */ g(G_, { medias: e }),
		/* @__PURE__ */ _(tv, { children: [
			/* @__PURE__ */ _(nv, { children: [/* @__PURE__ */ g(rv, {}), /* @__PURE__ */ g(Y_, {})] }),
			/* @__PURE__ */ _(nv, { children: [/* @__PURE__ */ g(rv, {}), /* @__PURE__ */ g(X_, {})] }),
			/* @__PURE__ */ _(nv, { children: [/* @__PURE__ */ g(rv, {}), /* @__PURE__ */ g(Z_, {})] })
		] }),
		/* @__PURE__ */ _(av, { children: [
			/* @__PURE__ */ g(iv, { $profilePicture: t }),
			/* @__PURE__ */ _(q_, {
				className: "sp-font-bold sp-mb-2",
				children: ["@", n]
			}),
			/* @__PURE__ */ g("div", {
				className: "bookmarkIconWrap",
				children: /* @__PURE__ */ g(Q_, {})
			})
		] })
	]
}), cv = ({ post: e }) => /* @__PURE__ */ g($_, { children: /* @__PURE__ */ g(ov, {
	url: e.redirectUrl,
	children: /* @__PURE__ */ g(sv, {
		medias: e.medias,
		username: e.username,
		profilePicture: e.profilePicture
	})
}) }), lv = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ g(cv, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, uv = Y.img`
  display: block;
  object-fit: contain;
  position: relative;
  width: 100%;
`, dv = ({ url: e, isActiveSlide: t, videoCoverPreview: n }) => {
	let [r, i] = m(!1), [a, o] = m(!1), [s, c] = m(0);
	return l(() => {
		n && (i(!1), o(!1), c((e) => e + 1));
	}, [n]), t ? /* @__PURE__ */ _(fv, {
		className: "sp-relative",
		style: {
			minHeight: "500px",
			width: "100%"
		},
		children: [!r && a && /* @__PURE__ */ g(pv, { children: /* @__PURE__ */ g(um, { onClick: () => {
			i(!1), o(!1), c((e) => e + 1);
		} }) }), /* @__PURE__ */ g(y, {
			playing: !!n,
			onPlay: () => {
				i(!0), o(!0);
			},
			onPause: () => i(!1),
			controls: !0,
			light: n,
			src: e,
			width: "100%",
			height: "auto",
			style: {
				display: n ? "flex" : "grid",
				placeContent: "center",
				minHeight: "500px",
				background: "black"
			}
		}, s)]
	}) : null;
}, fv = Y.div`
  min-height: 500px;
  width: 100%;

  .react-player__preview {
    height: calc(-280px + 100vh) !important;
    background-color: black !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
  }
`, pv = Y.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, mv = ({ media: e, hidden: t = !1, showAll: n, isActiveSlide: r = !0, videoCoverPreview: i }) => t && n === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(dv, {
	url: e.url,
	isActiveSlide: r,
	videoCoverPreview: i
}) : /* @__PURE__ */ g(uv, { src: e.url }), hv = ({ current: e, ...t }) => /* @__PURE__ */ g("div", {
	style: { backgroundColor: `${e ? "#FFFFFF" : "#C4C4C4"}` },
	className: "\n    sp-rounded-full\n    sp-w-8px\n    sp-h-8px\n    sp-mx-1\n    sp-transition-all\n    sp-transition-duration-200\n    ease-in-out\n    sp-cursor-pointer\n    ",
	...t
}), gv = ({ count: e, current: t, titleCaptionHeight: n, onChange: r, isMultipleLinesDetected: i }) => /* @__PURE__ */ g("div", {
	className: "sp-absolute",
	style: {
		bottom: n - 3,
		left: 0,
		right: 0,
		backgroundColor: i ? "black" : void 0,
		height: 40
	},
	children: /* @__PURE__ */ g("div", {
		className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4 sp-absolute",
		style: {
			left: "50%",
			transform: "translateX(-50%)",
			bottom: 0
		},
		id: "dottt",
		children: [...Array(e)].map((e, n) => /* @__PURE__ */ g(hv, {
			current: n + 1 === t,
			onClick: () => {
				r(n + 1);
			}
		}, n))
	})
}), _v = ({ medias: e, count: t, titleCaptionHeight: n, isMultipleLinesDetected: r }) => {
	let [i, a] = m(1);
	return l(() => {
		i > e.length && a(e.length);
	}, [e.length]), /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g("div", {
		className: "sp-w-full sp-relative",
		style: { transform: r ? `translateY(-${(n + (t > 1 ? 35 : 10)) / 2}px)` : void 0 },
		children: /* @__PURE__ */ g(mv, { media: e[i - 1] })
	}), t > 1 && /* @__PURE__ */ g(gv, {
		count: t,
		current: i,
		titleCaptionHeight: n,
		onChange: (e) => a(e),
		isMultipleLinesDetected: r
	})] });
}, vv = ({ medias: e, videoCoverPreview: t, postType: n, titleCaptionHeight: r, isMultipleLinesDetected: i }) => {
	let a = e.collection, o = a.length;
	return n === "multiMedia" || n?.toLowerCase() === "image" ? /* @__PURE__ */ g(yv, { children: /* @__PURE__ */ g(_v, {
		medias: a,
		count: o,
		isMultipleLinesDetected: i,
		titleCaptionHeight: r
	}) }) : /* @__PURE__ */ g(yv, { children: o > 0 && /* @__PURE__ */ g(mv, {
		videoCoverPreview: t,
		media: a[0]
	}) });
}, yv = Y.div`
  overflow: hidden;
  border-radius: 15px;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: black;
  display: flex;
  overflow: hidden;
`, bv = Y.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, xv = (e) => /* @__PURE__ */ _("svg", {
	width: 52,
	height: 49,
	viewBox: "0 0 52 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		filter: "url(#filter0_d_0_24)",
		children: /* @__PURE__ */ g("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1429 6C23.7143 6 26 9.01299 26 9.01299C26 9.01299 28.2857 6 32.8571 6C38.1905 6 42 10.1428 42 15.4156C42 21.4416 37.0188 26.8133 32.4762 30.8571C29.6716 33.3537 27.5238 35 26 35C24.4762 35 22.2674 33.3412 19.5238 30.8571C15.0583 26.814 10 21.4416 10 15.4156C10 10.1428 13.8095 6 19.1429 6Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_24",
		x: 0,
		y: 0,
		width: 52,
		height: 49,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_24"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_24",
				result: "shape"
			})
		]
	}) })]
}), Sv = (e) => /* @__PURE__ */ _("svg", {
	width: 51,
	height: 50,
	viewBox: "0 0 51 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		opacity: .9,
		filter: "url(#filter0_d_0_25)",
		children: /* @__PURE__ */ g("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.1286 29.6848C39.2029 26.6131 41 23.4136 41 19.6882C41 12.1283 34.0609 6 25.5 6C16.9391 6 10 12.1283 10 19.6884C10 27.2485 17.1636 32.4385 25.7246 32.4385V34.9456C25.7246 35.74 26.5504 36.2512 27.2507 35.8726C29.4385 34.6901 33.4926 32.3184 36.1286 29.6848ZM17.9706 17.8423C19.1941 17.8423 20.1859 18.8244 20.1859 20.0341C20.1859 21.2463 19.1941 22.2284 17.9706 22.2284C16.7492 22.2284 15.7573 21.2463 15.7573 20.0341C15.7573 18.8244 16.7492 17.8423 17.9706 17.8423ZM27.7144 20.0341C27.7144 18.8244 26.7229 17.8423 25.5 17.8423C24.2772 17.8423 23.2858 18.8244 23.2858 20.0341C23.2858 21.2463 24.2773 22.2284 25.5 22.2284C26.7229 22.2284 27.7144 21.2463 27.7144 20.0341ZM33.0291 17.8423C34.2524 17.8423 35.2428 18.8244 35.2428 20.0341C35.2428 21.2463 34.2524 22.2284 33.0291 22.2284C31.8058 22.2284 30.814 21.2463 30.8142 20.0341C30.8142 18.8244 31.8058 17.8423 33.0291 17.8423Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_25",
		x: 0,
		y: 0,
		width: 51,
		height: 50,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_25"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_25",
				result: "shape"
			})
		]
	}) })]
}), Cv = (e) => /* @__PURE__ */ _("svg", {
	width: 51,
	height: 44,
	viewBox: "0 0 51 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		opacity: .9,
		filter: "url(#filter0_d_0_23)",
		children: /* @__PURE__ */ g("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.2228 7.13786C27.2228 6.13946 28.4318 5.62698 29.1629 6.31551L40.2873 16.7934C41.2662 17.7155 41.2321 19.2704 40.2135 20.1494L29.1259 29.7178C28.3833 30.3588 27.2228 29.8372 27.2228 28.8623V24.5263C27.2228 24.5263 15.318 22.4052 11.4993 29.3377C11.1432 29.984 9.75548 30.2101 10.0376 26.9853C11.2172 21.05 13.628 11.7838 27.2228 11.7838V7.13786Z",
			fill: "white"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ _("filter", {
		id: "filter0_d_0_23",
		x: 0,
		y: 0,
		width: 51,
		height: 44,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ g("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ g("feOffset", { dy: 4 }),
			/* @__PURE__ */ g("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ g("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ g("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_23"
			}),
			/* @__PURE__ */ g("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_23",
				result: "shape"
			})
		]
	}) })]
}), wv = (e) => /* @__PURE__ */ g("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1249 1.87579C12.1249 1.63512 11.9014 1.45676 11.6668 1.51012L5.6712 2.87348C5.5005 2.91229 5.37934 3.06409 5.37934 3.23914V12.0902H5.37897C5.3889 12.9029 4.5507 13.7484 3.35438 14.0689C2.01898 14.4267 0.743054 13.9951 0.504513 13.1048C0.265968 12.2146 1.15513 11.2028 2.49052 10.845C2.97713 10.7146 3.45585 10.6891 3.87934 10.7523V3.23914C3.87934 2.36382 4.48504 1.60493 5.33861 1.41083L11.3342 0.0474661C12.5075 -0.219354 13.6249 0.672475 13.6249 1.87579V10.2609C13.6564 11.0828 12.8123 11.9454 11.6011 12.2699C10.2657 12.6277 8.98976 12.1961 8.75123 11.3058C8.51269 10.4156 9.40185 9.4038 10.7372 9.04598C11.2234 8.91574 11.7017 8.89009 12.1249 8.95313V1.87579Z",
		fill: "white"
	})
}), Tv = (e) => /* @__PURE__ */ _("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ g("path", {
			d: "M27.4365 8.78874L27.2831 7.33075C27.1539 6.10359 26.1191 5.172 24.8852 5.172H5.11487C3.88093 5.172 2.84612 6.1036 2.71695 7.33075L2.56348 8.78874",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ g("path", {
			d: "M11.25 1L15.625 5.375",
			stroke: "white",
			strokeWidth: 1.875,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ g("path", {
			d: "M19.375 1L15 5.375",
			stroke: "white",
			strokeWidth: 1.875,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ g("path", {
			d: "M2.5 23.8585L2.71692 25.9193C2.8461 27.1465 3.88091 28.0781 5.11484 28.0781H24.8851C26.1191 28.0781 27.1539 27.1465 27.283 25.9193L27.5 23.8585",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ g("path", {
			d: "M1.28897 21.25V11.6692H3.3146V19.5799H7.42201V21.25H1.28897ZM10.7891 11.6692V21.25H8.76346V11.6692H10.7891ZM14.1866 11.6692L16.5023 18.9484H16.5912L18.9115 11.6692H21.157L17.8542 21.25H15.2438L11.9364 11.6692H14.1866ZM22.3102 21.25V11.6692H28.766V13.3393H24.3358V15.6222H28.4339V17.2923H24.3358V19.5799H28.7847V21.25H22.3102Z",
			fill: "white"
		})
	]
}), Ev = (e) => /* @__PURE__ */ _("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("circle", {
		cx: 9.04035,
		cy: 9.04035,
		r: 8.04035,
		stroke: "white",
		strokeWidth: 2
	}), /* @__PURE__ */ g("path", {
		d: "M21.2621 21.9124C21.6526 22.3029 22.2858 22.3029 22.6763 21.9124C23.0668 21.5219 23.0668 20.8887 22.6763 20.4982L21.2621 21.9124ZM14.1996 14.8499L21.2621 21.9124L22.6763 20.4982L15.6138 13.4357L14.1996 14.8499Z",
		fill: "white"
	})]
}), Dv = (e) => /* @__PURE__ */ _("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ g("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "#FF0505"
		}),
		/* @__PURE__ */ g("rect", {
			x: 9,
			y: 5,
			width: 2,
			height: 9,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ g("rect", {
			x: 5.5,
			y: 10.5,
			width: 2,
			height: 9,
			rx: 1,
			transform: "rotate(-90 5.5 10.5)",
			fill: "white"
		})
	]
}), Ov = Y.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  ${(e) => e.$env === "schedugram-client" && "\n    margin: 0 50px;\n    @media (max-width: 1279px) {\n      margin: 0;\n    }\n  "}
`, kv = Y.div`
  position: absolute;
  top: 42px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`, Av = Y.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 600;
    color: white;
    font-family: "Inter";
  }
`, jv = Y.p`
  opacity: 0.6;
  margin: 0;
`, Mv = Y.p`
  margin: 0 0 -2px 15px;
`, Nv = Y.span`
  display: block;
  height: 2px;
  width: 30px;
  background-color: white;
  margin: 0 auto;
`, Pv = Y.div`
  z-index: 10;
  position: absolute;
  right: 10px;
  bottom: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 45px;
    height: 45px;
  }
`, Fv = Y.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50%;
  position: relative;
  display: grid;
  place-items: center;
  margin-bottom: 20px;

  svg {
    position: absolute;
    bottom: -10px;
    height: auto;
  }
`, Iv = Y.div`
  position: absolute;
  bottom: 0px;
  z-index: 2;
  padding: 10px;
  left: 0px;
  right: 0px;
  padding-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  ${({ $isTakingUpSpace: e }) => e ? "background-color: black;" : ""}

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }

  .description {
    line-height: 20px;
    width: 210px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  svg.musicIcon {
    width: 14px;
    height: 15px;
    flex-shrink: 0;
  }
`, Lv = ({ url: e, ContentItem: t }) => e ? /* @__PURE__ */ g("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ g("div", { children: t }), Rv = ({ medias: e, profilePicture: t, username: n, description: r, videoCoverPreview: a, title: o, postType: s }) => {
	let [c, l] = i.useState(!1), [u, d] = i.useState(0);
	return /* @__PURE__ */ _("div", {
		className: "sp-relative",
		children: [
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-justify-center",
				children: /* @__PURE__ */ _(kv, { children: [
					/* @__PURE__ */ g(Tv, {}),
					/* @__PURE__ */ _(Av, { children: [/* @__PURE__ */ g(jv, { children: "Following" }), /* @__PURE__ */ _(Mv, { children: ["For You ", /* @__PURE__ */ g(Nv, {})] })] }),
					/* @__PURE__ */ g(Ev, {})
				] })
			}),
			/* @__PURE__ */ g(vv, {
				medias: e,
				videoCoverPreview: a,
				postType: s,
				isMultipleLinesDetected: c,
				titleCaptionHeight: u
			}),
			/* @__PURE__ */ g(Hv, { profilePicture: t }),
			/* @__PURE__ */ g(Vv, {
				username: n,
				title: o,
				description: r,
				onMultipleLinesDetected: l,
				onHeightDetected: d,
				isTakingUpSpace: c && zv(s)
			})
		]
	});
}, zv = (e) => e === "multiMedia" || e?.toLowerCase() === "image";
function Bv(e, t = 50) {
	return e && e.clientHeight > t;
}
var Vv = ({ username: e, title: t, description: n, onMultipleLinesDetected: r, onHeightDetected: a, isTakingUpSpace: o }) => {
	let s = i.useRef(null), [c, l] = i.useState(!1), u = i.useId(), { elementRef: f, isOverflowing: p } = yh({
		expanded: c,
		text: n
	});
	return i.useEffect(() => l(!1), [n]), r = r || (() => {}), a = a || (() => {}), d(() => {
		if (s.current) {
			if (a(s.current.clientHeight), Bv(s.current.querySelector(".title-caption"))) {
				r(!0);
				return;
			}
			r(!1);
		}
	}, [
		t,
		n,
		e
	]), /* @__PURE__ */ _(Iv, {
		ref: s,
		$isTakingUpSpace: o,
		children: [
			/* @__PURE__ */ _(bv, {
				className: "sp-font-bold sp-mb-2",
				children: ["@", e]
			}),
			/* @__PURE__ */ _("div", {
				className: "title-caption",
				children: [
					t && /* @__PURE__ */ g(bv, {
						className: "title sp-font-bold sp-mb-1 sp-mt-4 sp-text-2xl",
						children: t
					}),
					/* @__PURE__ */ g("div", {
						className: c ? "sp-max-h-[200px] sp-overflow-y-auto sp-leading-5" : "description",
						id: u,
						ref: f,
						children: /* @__PURE__ */ g(bv, { children: /* @__PURE__ */ g(em, {
							caption: n,
							targetPlatform: "TT"
						}) })
					}),
					p && /* @__PURE__ */ g("button", {
						"aria-controls": u,
						"aria-expanded": c,
						"aria-label": c ? "Collapse caption" : "Show full caption",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), l(!c);
						},
						className: "sp-text-white/60 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
						type: "button",
						children: c ? "less" : "more"
					})
				]
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-items-center sp-gap-1.5 sp-mt-3.5 sp-text-white/70 sp-text-[11px]",
				children: [/* @__PURE__ */ g(wv, { className: "musicIcon" }), /* @__PURE__ */ g("span", {
					className: "sp-truncate",
					children: "Audio will be auto-matched after publishing"
				})]
			})
		]
	});
}, Hv = ({ profilePicture: e }) => /* @__PURE__ */ _(Pv, { children: [
	/* @__PURE__ */ g(Fv, {
		$profilePicture: e,
		children: /* @__PURE__ */ g(Dv, { className: "sp-w-8" })
	}),
	/* @__PURE__ */ g(xv, {}),
	/* @__PURE__ */ g(Sv, {}),
	/* @__PURE__ */ g(Cv, {})
] }), Uv = ({ post: e, env: t, videoCoverPreview: n }) => /* @__PURE__ */ g(h, { children: /* @__PURE__ */ g(Ov, {
	$env: t,
	children: /* @__PURE__ */ g(Lv, {
		ContentItem: /* @__PURE__ */ g(Rv, {
			medias: e.medias,
			username: e.username,
			profilePicture: e.profilePicture,
			description: e.caption,
			videoCoverPreview: n,
			title: e.postOptions?.title,
			postType: e.type
		}),
		url: e.redirectUrl
	})
}) }), Wv = Uv, Gv = ({ post: e, env: t, videoCoverPreview: n }) => {
	switch (e.type) {
		case "image":
		case "multiMedia": return /* @__PURE__ */ g(Wv, {
			post: e,
			env: t,
			videoCoverPreview: n
		});
		case "video":
		case "text":
		case "story": return /* @__PURE__ */ g(Uv, {
			post: e,
			env: t,
			videoCoverPreview: n
		});
		default: return /* @__PURE__ */ g(h, {});
	}
}, Kv = Y.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: -0.025em;\n          white-space: pre-line;\n        ";
	}
}};
`, qv = ({ username: e, profilePicture: t, small: n }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-rounded-full sp-overflow-hidden sp-m-4",
		style: {
			width: "49px",
			height: "49px"
		},
		children: /* @__PURE__ */ g(uo, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ g("div", {
		className: `sp-flex sp-flex-grow sp-leading-tight ${n ? "sp-text-white" : ""}`,
		children: /* @__PURE__ */ g("div", {
			className: "sp-font-sans",
			children: /* @__PURE__ */ g(Kv, {
				$variant: "heading",
				className: "sp-mb-1",
				children: e
			})
		})
	})]
}), Jv = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Yv = Y.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Xv = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g($h, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ g(Yv, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ _("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ g("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ g($h, {
	href: e,
	children: /* @__PURE__ */ g(Jv, { src: e })
}), Zv = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-bg-black sp-flex sp-items-center",
	children: /* @__PURE__ */ g(y, {
		src: e,
		controls: !0,
		playing: !1,
		className: "sp-relative",
		width: "100%",
		height: "auto"
	})
}) : null, Qv = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0 }) => t && i === !1 ? null : /* @__PURE__ */ _(h, { children: [(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(Zv, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: s
}), !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ g(Xv, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
})] }), $v = () => /* @__PURE__ */ g("div", {
	className: "sp-py-2 sp-w-full",
	children: /* @__PURE__ */ _("div", {
		className: "sp-flex sp-w-full sp-justify-start sp-text-black sp-py-4 sp-pl-0",
		children: [
			/* @__PURE__ */ g(ey, { icon: "icon-instagram-heart" }),
			/* @__PURE__ */ g(ey, { icon: "icon-instagram-comment" }),
			/* @__PURE__ */ g(ey, { icon: "icon-twitter-retweet" }),
			/* @__PURE__ */ g(ey, { icon: "icon-instagram-share" })
		]
	})
}), ey = ({ icon: e }) => /* @__PURE__ */ g("div", {
	className: "sp-flex sp-items-center sp-justify-start sp-pr-4 ",
	children: /* @__PURE__ */ g("div", { className: `sp-text-xl ${e}` })
}), ty = Y.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, ny = ({ medias: e }) => {
	let [t, n] = m(!1);
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ g(ty, {
			className: "sp-relative",
			children: /* @__PURE__ */ g(Qv, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, ry = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _("div", {
		className: "sp-px-4",
		children: [n > 0 && /* @__PURE__ */ g(h, { children: n > 1 ? /* @__PURE__ */ g(ny, {
			medias: t,
			count: n
		}) : /* @__PURE__ */ g(Qv, { media: t[0] }) }), /* @__PURE__ */ g("div", {
			className: "sp-flex sp-items-center sp-justify-between",
			children: /* @__PURE__ */ g($v, {})
		})]
	});
}, iy = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ _("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ g(qv, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-flex-col sp-m-4",
				children: /* @__PURE__ */ _(Kv, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ g(em, {
						caption: t,
						targetPlatform: "TH"
					}), e.redirectUrl && /* @__PURE__ */ _(h, { children: [" ", /* @__PURE__ */ g("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ g("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ g(dg, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ g(ry, { medias: e.medias })
		]
	});
}, ay = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ g(iy, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, oy = Y.div`
  font-family: "Helvetica", sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 25px;\n          line-height: 30px;\n          text-decoration: none !important;\n          color: inherit !important;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 18px;\n          white-space: pre-line;\n        ";
		case "link": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 18px;\n          white-space: pre-line;\n          font-weight: bold;\n          color: black;\n          text-decoration: none;\n          &:hover {\n            text-decoration: underline;\n          }\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, sy = Y.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n        ";
		case "bold": return "\n          font-style: normal;\n          font-weight: bold;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, cy = ({ username: e, profilePicture: t, small: n, description: r, url: i }) => /* @__PURE__ */ g(h, { children: /* @__PURE__ */ _("div", {
	className: "sp-pt-4 sp-pb-2 sp-px-0 sp-flex sp-flex-row",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-flex sp-px-1",
		children: /* @__PURE__ */ g("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-mr-4",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ g(uo, {
				src: t,
				alt: e
			})
		})
	}), /* @__PURE__ */ _("div", { children: [
		/* @__PURE__ */ g("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ g("div", {
				className: "",
				children: /* @__PURE__ */ _(sy, {
					$variant: "bold",
					className: "sp-mb-1",
					children: [e, " "]
				})
			})
		}),
		r && /* @__PURE__ */ g(oy, {
			$variant: "caption",
			children: /* @__PURE__ */ g(em, { caption: r })
		}),
		i && /* @__PURE__ */ _("div", {
			className: "sp-py-2",
			children: [" ", /* @__PURE__ */ g("a", {
				href: i,
				target: "_blank",
				rel: "noreferrer",
				children: /* @__PURE__ */ g(oy, {
					$variant: "link",
					children: "URL for post"
				})
			})]
		})
	] })]
}) }), ly = Y.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, uy = ({ src: e }) => /* @__PURE__ */ g(ly, { src: e }), dy = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ g("div", {
	className: "sp-relative",
	style: {},
	children: /* @__PURE__ */ g(y, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, fy = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ g(dy, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) : /* @__PURE__ */ g(uy, { src: e.url }), py = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ g(my, { children: n > 0 && /* @__PURE__ */ g(fy, { media: t[0] }) });
}, my = Y.div`
  overflow: hidden;
`, hy = ({ url: e, children: t }) => e ? /* @__PURE__ */ g("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ g("div", { children: t }), gy = ({ post: e }) => /* @__PURE__ */ _(_y, {
	className: "sp-bg-white md:sp-shadow-around sp-pb-6",
	style: {
		borderTopLeftRadius: "20px",
		borderTopRightRadius: "20px"
	},
	children: [/* @__PURE__ */ g(cy, {
		username: e.username,
		profilePicture: e.profilePicture,
		description: e.caption,
		small: !1,
		url: e.redirectUrl
	}), /* @__PURE__ */ g("div", {
		className: "sp-pb-2",
		style: { paddingLeft: "47px" },
		children: /* @__PURE__ */ g(hy, {
			url: e.redirectUrl,
			children: /* @__PURE__ */ g(py, { medias: e.medias })
		})
	})]
}), _y = Y.div`
  padding: 1.1em;
`, vy = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ g(gy, { post: e });
		default: return /* @__PURE__ */ g(h, {});
	}
}, yy = class extends a {
	constructor(t) {
		super(t), e(this, "post", void 0), this.state = { hasError: !1 }, this.post = t.post;
	}
	static getDerivedStateFromError(e) {
		return { hasError: !0 };
	}
	componentDidCatch(e, t) {
		console.log(e);
	}
	render() {
		return this.state.hasError ? /* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-w-full sp-border-2 sp-border-solid sp-border-gray-300 sp-rounded-lg sp-p-8 sp-h-500px sp-shadow-lg",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-text-4xl sp-mb-8 sp-text-red-500 sp-font-bold",
				children: "Failed to load preview"
			}), /* @__PURE__ */ g("div", {
				className: "sp-text-3xl sp-text-red-500",
				children: "Please contact Sked support"
			})]
		}) : this.props.children;
	}
}, by = {
	FB: [
		"text",
		"image",
		"video",
		"multiMedia",
		"story",
		"fb-reel"
	],
	GMB: [
		"text",
		"image",
		"video",
		"multiMedia",
		"story",
		"fb-reel",
		"gmb"
	],
	IG: [
		"image",
		"video",
		"multiMedia",
		"story",
		"fb-reel"
	],
	LI: [
		"text",
		"image",
		"multiMedia",
		"video",
		"document",
		"fb-reel"
	],
	OT: [
		"image",
		"video",
		"multiMedia",
		"story",
		"text",
		"fb-reel"
	],
	PI: [
		"image",
		"video",
		"multiMedia",
		"fb-reel"
	],
	SC: [
		"image",
		"video",
		"multiMedia",
		"story",
		"text",
		"fb-reel"
	],
	TH: [
		"audio",
		"image",
		"video",
		"multiMedia",
		"text",
		"fb-reel"
	],
	TT: [
		"video",
		"image",
		"multiMedia",
		"fb-reel"
	],
	TW: [
		"text",
		"image",
		"video",
		"multiMedia",
		"fb-reel"
	],
	YT: ["video", "fb-reel"]
}, xy = {
	FB: "Facebook",
	GMB: "Google Business Profile",
	IG: "Instagram",
	LI: "LinkedIn",
	OT: "Other",
	PI: "Pinterest",
	SC: "Snapchat",
	TH: "Threads",
	TT: "TikTok",
	TW: "X",
	YT: "YouTube"
}, Sy = (e) => {
	let t = My(e), n = Ny(t), r = Ty(e), i = Py(r), a = by[t];
	return a ? a.includes(r) ? r === "multiMedia" && Ey(e) ? {
		platform: t,
		platformName: n,
		reason: "unsupported-document-media",
		supported: !1,
		type: "document",
		typeName: Py("document")
	} : t === "TT" && r === "multiMedia" && Oy(e) ? {
		platform: t,
		platformName: n,
		reason: "unsupported-media-combination",
		supported: !1,
		type: "mixedMedia",
		typeName: "Mixed media posts"
	} : {
		platform: t,
		platformName: n,
		reason: "supported",
		supported: !0,
		type: r,
		typeName: i
	} : {
		platform: t,
		platformName: n,
		reason: "unsupported-post-type",
		supported: !1,
		type: r,
		typeName: i
	} : {
		platform: t,
		platformName: n,
		reason: "unknown-platform",
		supported: !1,
		type: r,
		typeName: i
	};
}, Cy = (e) => Sy(e).supported, wy = (e) => {
	let t = Sy(e);
	if (t.supported) return null;
	let n = `${t.typeName} aren't available on ${t.platformName}.`;
	return t.reason === "unsupported-media-combination" && t.platform === "TT" && (n = "Mixed photo and video posts aren't available on TikTok."), t.reason === "unsupported-document-media" && t.platform === "LI" && (n = "Document posts on LinkedIn can't be combined with other media."), {
		title: "Post preview not available",
		message: n
	};
}, Ty = (e) => {
	let t = My(e), n = e?.type || e?.providedPost?.type || "text";
	return (e?.videoPostType || e?.providedPost?.videoPostType || null) === "reel" ? t === "FB" || t === "IG" ? "fb-reel" : "reel" : n === "reel" && t === "IG" ? "fb-reel" : n === "fb-reel" ? t !== "FB" && t !== "IG" ? "video" : "fb-reel" : n;
}, Ey = (e) => jy(e).some(Dy), Dy = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isDocument === !0 || t.includes("document") || t.includes("pdf") || n.endsWith(".pdf");
}, Oy = (e) => {
	let t = jy(e);
	return t.some(ky) && t.some(Ay);
}, ky = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isVideo === !0 || t.startsWith("video/") || /\.(m4v|mov|mp4|mpeg|mpg|webm)$/.test(n);
}, Ay = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isVideo === !1 || t.startsWith("image/") || /\.(avif|gif|heic|jpeg|jpg|png|webp)$/.test(n);
}, jy = (e) => e && (e.medias?.collection || e.mediaFiles || e.providedPost?.mediaFiles) || [], My = (e) => e?.platform || e?.platformType || "IG", Ny = (e) => xy[e] || e, Py = (e) => {
	switch (e) {
		case "fb-reel":
		case "reel": return "Reels";
		case "multiMedia": return "Carousel posts";
		case "story": return "Stories";
		case "text": return "Text posts";
		case "document": return "Document posts";
		case "video": return "Video posts";
		case "image":
		case "photo": return "Image posts";
		default: return `${Fy(e)} posts`;
	}
}, Fy = (e) => e.length > 0 ? `${e[0].toUpperCase()}${e.slice(1)}` : e, Iy = ({ className: e, copy: t, post: n }) => {
	let r = t || wy(n);
	return r ? /* @__PURE__ */ _("div", {
		className: ["sp-box-border sp-flex sp-w-full sp-items-start sp-gap-3 sp-rounded-lg sp-bg-[#fffbeb] sp-p-2 sp-font-sans sp-antialiased", e].filter(Boolean).join(" "),
		"data-testid": "unsupported-post-preview-placeholder",
		"data-preview-placeholder": "unsupported",
		children: [/* @__PURE__ */ g("div", { className: "sp-w-0.5 sp-self-stretch sp-rounded-[3px] sp-bg-[#d97706]" }), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-1 sp-py-1",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-flex sp-items-center sp-gap-2",
				children: [/* @__PURE__ */ g("svg", {
					"aria-hidden": "true",
					className: "sp-size-5 sp-shrink-0",
					fill: "none",
					viewBox: "0 0 20 20",
					children: /* @__PURE__ */ g("path", {
						d: "M9.999 7.5v3.333m0 2.5h.009M8.845 3.243 2.24 14.583A1.25 1.25 0 0 0 3.322 16.5h13.355a1.25 1.25 0 0 0 1.083-1.917L11.155 3.243a1.25 1.25 0 0 0-2.31 0Z",
						stroke: "#d97706",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: "1.5"
					})
				}), /* @__PURE__ */ g("div", {
					className: "sp-min-w-0 sp-flex-1 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#333333]",
					children: r.title
				})]
			}), /* @__PURE__ */ g("div", {
				className: "sp-text-sm sp-font-normal sp-leading-5 sp-text-[#808080]",
				children: r.message
			})]
		})]
	}) : null;
}, Ly = (e) => {
	if (e === null) return null;
	if (e.type !== "fb-reel") return e;
	switch (e.platform) {
		case "FB": return e;
		case "IG": return {
			...e,
			type: "reel"
		};
		default: return {
			...e,
			type: "video"
		};
	}
}, Ry = "x".repeat(9), zy = ({ buttonClassName: e, caption: t, charsPerLine: n, className: r, collapsedCaption: i, collapsedLines: a, contentClassName: o, expandedContentClassName: s, expanded: c, expandable: l, leadingText: d, measurementText: f, onExpandedChange: p, prefix: m, renderCaption: v, scrollOnExpandMaxHeight: y, suffix: b, targetPlatform: x, trackEvent: S, wideCharacterWeight: C }) => {
	let w = u(), T = l ?? (Hy({
		charsPerLine: n,
		leadingText: d,
		text: f ?? t,
		wideCharacterWeight: C
	}) > a || i !== void 0 && i !== t.trim()), E = c ? "less" : "more", D = !c && T ? i ?? By({
		caption: t,
		charsPerLine: n,
		collapsedLines: a,
		leadingText: d,
		wideCharacterWeight: C
	}) : t, O = c && y ? { maxHeight: y } : void 0;
	return /* @__PURE__ */ _("div", {
		className: [
			"sp-break-words",
			c && y ? "sp-overflow-y-auto" : void 0,
			r,
			o,
			c ? s : void 0
		].filter(Boolean).join(" "),
		id: w,
		style: O,
		children: [
			m,
			/* @__PURE__ */ g(Xp, {
				caption: t,
				children: /* @__PURE__ */ g("span", { children: v ? v({ caption: D }) : /* @__PURE__ */ g(Gp, {
					caption: D,
					targetPlatform: x,
					trackEvent: S
				}) })
			}),
			!T || c ? b : null,
			T ? /* @__PURE__ */ _(h, { children: [c ? null : /* @__PURE__ */ g("span", {
				"aria-hidden": "true",
				className: "sp-ml-0.5",
				children: "…"
			}), /* @__PURE__ */ g("button", {
				"aria-controls": w,
				"aria-expanded": c,
				"aria-label": c ? "Collapse caption" : "Show full caption",
				"data-uplift-caption-affordance": "true",
				className: [
					"sp-ml-1 sp-inline sp-cursor-pointer sp-border-0 sp-bg-transparent sp-p-0 sp-text-left",
					c ? "sp-underline sp-underline-offset-2" : void 0,
					e
				].filter(Boolean).join(" "),
				onClick: (e) => {
					e.stopPropagation(), p(!c);
				},
				type: "button",
				children: E
			})] }) : null
		]
	});
}, By = ({ caption: e, charsPerLine: t, collapsedLines: n, leadingText: r, wideCharacterWeight: i }) => {
	let a = Array.from(e.trim()), o = 0, s = a.length, c = "";
	for (; o <= s;) {
		let e = Math.floor((o + s) / 2), l = a.slice(0, e).join("").trimEnd();
		Hy({
			charsPerLine: t,
			leadingText: r,
			text: `${l}${Ry}`,
			wideCharacterWeight: i
		}) <= n ? (c = l, o = e + 1) : s = e - 1;
	}
	return c;
}, Vy = ({ charsPerLine: e, collapsedLines: t, expanded: n, leadingText: r, lineHeight: i, text: a, wideCharacterWeight: o }) => {
	let s = Hy({
		charsPerLine: e,
		leadingText: r,
		text: a,
		wideCharacterWeight: o
	});
	return Math.min(n ? s : t, s) * i;
}, Hy = ({ charsPerLine: e, leadingText: t, text: n, wideCharacterWeight: r }) => {
	let i = n.trim();
	return i ? i.split(/\r\n?|\n/).reduce((n, i, a) => {
		let o = a === 0 && t ? `${t} ${i}` : i;
		return n + Math.max(1, Math.ceil(Wy(o, r) / e));
	}, 0) : 0;
}, Uy = /[\u1100-\u11ff\u2e80-\u9fff\uf900-\ufaff\uac00-\ud7af]/, Wy = (e, t = 1) => t <= 1 ? e.length : Array.from(e).reduce((e, n) => e + Gy(n, t), 0), Gy = (e, t = 1) => t > 1 && Uy.test(e) ? t : 1, Ky = (...e) => e.filter(Boolean).join(" "), qy = ({ children: e, className: t, platform: n, style: r }) => /* @__PURE__ */ g("div", {
	className: Ky("sp-box-border sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-text-[16px] sp-leading-5 sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t),
	"data-preview-variant": "uplift",
	"data-preview-platform": n,
	style: {
		fontFamily: "Inter, Helvetica, Arial, sans-serif",
		...r
	},
	children: e
}), Jy = (e, t) => !!(e && RegExp(`(^|\\s)-?sp-${t}-`).test(e)), Yy = ({ alt: e = "", className: t, onError: n, src: r, ...i }) => {
	let [a, o] = m(!1), s = Ky(!Jy(t, "h") && "sp-h-10", !Jy(t, "w") && "sp-w-10", "sp-shrink-0 sp-rounded-full sp-bg-[#eef0f2] sp-object-cover", t);
	return !r || a ? /* @__PURE__ */ g("span", {
		"aria-label": e,
		className: Ky(s, "sp-flex sp-items-center sp-justify-center sp-overflow-hidden sp-text-sm sp-font-semibold sp-leading-none sp-text-[#4b5563]"),
		role: "img",
		children: Xy(e)
	}) : /* @__PURE__ */ g("img", {
		alt: e,
		className: Ky("sp-block", s),
		onError: (e) => {
			o(!0), n?.(e);
		},
		src: r,
		...i
	});
}, Xy = (e) => e.trim().charAt(0).toUpperCase() || "?", Zy = ({ className: e, ...t }) => /* @__PURE__ */ g("div", {
	className: Ky("sp-overflow-hidden sp-truncate sp-text-base sp-font-semibold sp-leading-none sp-text-black", e),
	...t
}), Qy = ({ className: e, ...t }) => /* @__PURE__ */ g("div", {
	className: Ky("sp-box-border sp-min-h-0 sp-min-w-0 sp-overflow-hidden sp-bg-[#e4e6eb]", e),
	...t
}), $y = ({ ariaLabel: e = "Media carousel", className: t, countClassName: n = "sp-right-2.5 sp-top-2.5", dotClassName: r = "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2", medias: i, onIndexChange: a, arrowClassName: o, renderSlide: s, showArrows: c = !0, showCount: l = !0, showDots: u = !0, slideClassName: d }) => {
	let [f, p] = m(0), h = Math.min(f, Math.max(0, i.length - 1)), v = h > 0, y = h < i.length - 1, b = eb(i.length, h);
	return i.length === 0 ? null : /* @__PURE__ */ _("div", {
		"aria-label": e,
		className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", t].filter(Boolean).join(" "),
		"data-uplift-carousel-count": i.length,
		"data-uplift-carousel-index": h + 1,
		children: [
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-h-full sp-transition-transform sp-duration-200",
				style: { transform: `translateX(-${h * 100}%)` },
				children: i.map((e, t) => /* @__PURE__ */ g("div", {
					className: ["sp-relative sp-h-full sp-w-full sp-shrink-0", d].filter(Boolean).join(" "),
					"data-uplift-carousel-slide": t + 1,
					children: s(e, {
						index: t,
						isActive: t === h
					})
				}, t))
			}),
			c && v ? /* @__PURE__ */ g(tb, {
				ariaLabel: "Previous media",
				className: ["sp-left-2", o].filter(Boolean).join(" "),
				direction: "previous",
				onClick: () => {
					if (v) {
						let e = h - 1;
						p(e), a?.(e);
					}
				}
			}) : null,
			c && y ? /* @__PURE__ */ g(tb, {
				ariaLabel: "Next media",
				className: ["sp-right-2", o].filter(Boolean).join(" "),
				direction: "next",
				onClick: () => {
					if (y) {
						let e = h + 1;
						p(e), a?.(e);
					}
				}
			}) : null,
			l ? /* @__PURE__ */ _("div", {
				className: ["sp-absolute sp-rounded-full sp-bg-black/40 sp-px-2 sp-py-1 sp-text-sm sp-leading-none sp-text-white", n].join(" "),
				children: [
					h + 1,
					"/",
					i.length
				]
			}) : null,
			u ? /* @__PURE__ */ g("div", {
				className: ["sp-absolute sp-flex sp-items-center sp-gap-1", r].join(" "),
				children: b.map((e) => /* @__PURE__ */ g("span", {
					className: ["sp-block sp-h-1.5 sp-w-1.5 sp-rounded-full", e === h ? "sp-bg-[#0095f6]" : "sp-bg-[#c7c7c7]"].join(" "),
					"data-uplift-carousel-dot": e + 1
				}, e))
			}) : null
		]
	});
}, eb = (e, t) => {
	let n = Math.min(e, 5), r = Math.max(0, e - n), i = Math.min(Math.max(0, t - 2), r);
	return Array.from({ length: n }, (e, t) => i + t);
}, tb = ({ ariaLabel: e, className: t, direction: n, onClick: r }) => /* @__PURE__ */ g("button", {
	"aria-label": e,
	className: ["sp-absolute sp-top-1/2 sp-flex sp-h-8 sp-w-8 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-white/90 sp-p-0 sp-text-black sp-shadow-[0_2px_8px_rgba(0,0,0,0.18)]", t].join(" "),
	onClick: r,
	type: "button",
	children: /* @__PURE__ */ g("svg", {
		"aria-hidden": "true",
		fill: "none",
		height: "20",
		viewBox: "0 0 24 24",
		width: "20",
		children: n === "next" ? /* @__PURE__ */ g("path", {
			d: "m9 18 6-6-6-6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		}) : /* @__PURE__ */ g("path", {
			d: "m15 18-6-6 6-6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		})
	})
}), nb = 0, rb = 1, ib = .05, ab = "sp-right-4 sp-top-[112px]", ob = ({ audioControlsClassName: e, autoPlay: t = !1, autoplayMode: n = "none", backgroundColor: r, className: i, controls: a = !1, customControls: o = !1, fit: s, gateCover: c, intrinsicRatio: l, isActive: u = !0, loop: d = !1, measureWhenInactive: f = !1, muted: h = !1, onError: v, onIntrinsicDimensions: y, poster: b, publishedRatio: x, scrubber: S = !1, scrubberClassName: C, source: w, videoClassName: T }) => {
	let E = p(null), D = `${w}:${b ?? ""}`, [O, k] = m({
		hasEnded: !1,
		hasPlayed: !1,
		identity: D,
		isPlaying: !1,
		resetKey: 0
	}), [A, j] = m({
		identity: D,
		isMuted: h,
		policyMuted: h,
		volume: rb
	}), [M, N] = m(!1), [P, ee] = m(), [F, te] = m({
		currentTime: 0,
		duration: 0,
		identity: D
	}), ne = O.identity === D ? O : {
		hasEnded: !1,
		hasPlayed: !1,
		identity: D,
		isPlaying: !1,
		resetKey: 0
	}, { hasEnded: I, hasPlayed: L, isPlaying: R, resetKey: z } = ne, B = A.identity === D && A.policyMuted === h ? A : {
		identity: D,
		isMuted: h,
		policyMuted: h,
		volume: A.identity === D ? A.volume : rb
	}, { isMuted: V, volume: H } = B, re = c ?? (o && !!(b && b !== w)), ie = !re && t, ae = o && (!ie || L) && !I && (!a || !L), oe = o && L && I, U = o && !a, W = S && o && !a, se = F.identity === D ? F : {
		currentTime: 0,
		duration: 0,
		identity: D
	}, ce = se.duration > 0 ? Math.min(1, se.currentTime / se.duration) : 0;
	if (!u) return f ? /* @__PURE__ */ g("video", {
		"aria-hidden": "true",
		className: "sp-hidden",
		onLoadedMetadata: (e) => {
			y?.(e.currentTarget.videoWidth, e.currentTarget.videoHeight);
		},
		preload: "metadata",
		src: w
	}) : null;
	let le = () => {
		let e = E.current;
		e && (e.paused ? e.play() : e.pause());
	}, ue = () => {
		let e = E.current;
		if (!e) return;
		let t = !V;
		if (e.muted = t, !t && e.muted) {
			console.warn("[UpliftVideoPlayer] Browser prevented unmuting the video.");
			return;
		}
		if (!t && e.volume === 0) {
			e.volume = rb, j({
				...B,
				isMuted: t,
				volume: rb
			});
			return;
		}
		j({
			...B,
			isMuted: t
		});
	}, de = (e) => {
		let t = E.current;
		if (!t) return;
		let n = Math.min(rb, Math.max(nb, Number(e.target.value)));
		t.volume = n, n === 0 ? t.muted = !0 : t.muted && (t.muted = !1), j({
			...B,
			isMuted: t.muted,
			volume: n
		});
	}, fe = () => {
		let e = E.current;
		e && j({
			...B,
			isMuted: e.muted,
			volume: e.volume
		});
	}, G = (e) => {
		te({
			currentTime: e.currentTime,
			duration: Number.isFinite(e.duration) ? e.duration : 0,
			identity: D
		});
	};
	return /* @__PURE__ */ _("div", {
		className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", i].filter(Boolean).join(" "),
		"data-uplift-video-player": "true",
		"data-uplift-fit": s,
		"data-uplift-intrinsic-ratio": l,
		"data-uplift-video-autoplay": ie ? "true" : "false",
		"data-uplift-video-autoplay-mode": n,
		"data-uplift-video-cover-gated": re ? "true" : "false",
		"data-uplift-media-kind": "video",
		"data-uplift-poster": b,
		"data-uplift-published-ratio": x,
		"data-uplift-video-playing": R ? "true" : "false",
		style: r ? { backgroundColor: r } : void 0,
		children: [
			/* @__PURE__ */ g("video", {
				className: [
					"sp-block sp-h-full sp-w-full",
					r ? "" : "sp-bg-[#111]",
					T || "sp-object-cover"
				].filter(Boolean).join(" "),
				controls: a,
				autoPlay: ie,
				loop: d,
				muted: V,
				onEnded: () => {
					k((e) => ({
						...ne,
						resetKey: e.identity === D ? e.resetKey : ne.resetKey,
						hasEnded: !0,
						isPlaying: !1
					}));
				},
				onError: v,
				onDurationChange: W ? (e) => G(e.currentTarget) : void 0,
				onLoadedMetadata: (e) => {
					y?.(e.currentTarget.videoWidth, e.currentTarget.videoHeight), W && G(e.currentTarget);
				},
				onPause: () => k((e) => ({
					...ne,
					resetKey: e.identity === D ? e.resetKey : ne.resetKey,
					isPlaying: !1
				})),
				onPlay: () => {
					fe(), k((e) => ({
						...ne,
						resetKey: e.identity === D ? e.resetKey : ne.resetKey,
						hasEnded: !1,
						hasPlayed: !0,
						isPlaying: !0
					}));
				},
				onTimeUpdate: W ? (e) => G(e.currentTarget) : void 0,
				onVolumeChange: fe,
				playsInline: !0,
				poster: b,
				preload: "metadata",
				ref: E,
				src: w,
				style: r ? { backgroundColor: r } : void 0
			}, `${D}:${z}`),
			re && !L && b && b !== P ? /* @__PURE__ */ g("img", {
				alt: "",
				onError: () => ee(b),
				className: ["sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full", T || "sp-object-cover"].filter(Boolean).join(" "),
				src: b
			}) : null,
			ae ? /* @__PURE__ */ g("button", {
				"aria-label": R ? "Pause video" : "Play video",
				"data-uplift-video-playback-button": "true",
				className: ["sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-border-0 sp-bg-transparent sp-p-0 sp-text-white", "sp-cursor-pointer"].join(" "),
				onClick: le,
				type: "button",
				children: /* @__PURE__ */ g("span", {
					className: ["sp-flex sp-h-[52px] sp-w-[52px] sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-transition-opacity", R || I ? "sp-opacity-0" : "sp-opacity-100"].join(" "),
					children: g(R ? cb : sb, {})
				})
			}) : null,
			oe ? /* @__PURE__ */ g("button", {
				"aria-label": "Replay video",
				className: "sp-absolute sp-left-1/2 sp-top-1/2 sp-flex sp-h-14 sp-w-14 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/30 sp-p-0 sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]",
				onClick: () => {
					ie && j({
						...B,
						isMuted: h
					}), k((e) => ({
						hasEnded: !1,
						hasPlayed: !1,
						identity: D,
						isPlaying: !1,
						resetKey: e.identity === D ? e.resetKey + 1 : 1
					}));
				},
				style: { transform: "translate(-50%, -50%)" },
				type: "button",
				children: /* @__PURE__ */ g(lb, {})
			}) : null,
			W ? /* @__PURE__ */ _("div", {
				className: ["sp-absolute sp-inset-x-0 sp-z-20 sp-h-4", C || "sp-bottom-0"].join(" "),
				"data-uplift-video-scrubber": "true",
				onClick: (e) => e.stopPropagation(),
				onPointerDown: (e) => e.stopPropagation(),
				children: [/* @__PURE__ */ g("div", {
					"aria-hidden": "true",
					className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-0",
					"data-uplift-video-scrubber-track": "true",
					children: /* @__PURE__ */ g("div", {
						className: "sp-h-full",
						"data-uplift-video-scrubber-fill": "true",
						style: { width: `${ce * 100}%` }
					})
				}), /* @__PURE__ */ g("input", {
					"aria-label": "Seek",
					"aria-valuetext": `${fb(se.currentTime)} of ${fb(se.duration)}`,
					className: "sp-absolute sp-inset-0 sp-m-0 sp-h-full sp-w-full sp-cursor-pointer sp-opacity-0",
					disabled: se.duration === 0,
					max: String(se.duration),
					min: "0",
					onChange: (e) => {
						let t = E.current;
						if (!t) return;
						let n = Math.min(se.duration, Math.max(0, Number(e.target.value)));
						t.currentTime = n, te({
							...se,
							currentTime: n
						});
					},
					step: "any",
					type: "range",
					value: se.currentTime
				})]
			}) : null,
			U ? /* @__PURE__ */ _("div", {
				className: ["sp-absolute sp-z-10 sp-flex sp-flex-row-reverse sp-items-center sp-gap-2", e || ab].join(" "),
				onBlur: (e) => {
					e.currentTarget.contains(e.relatedTarget) || N(!1);
				},
				onFocus: () => N(!0),
				onMouseEnter: () => N(!0),
				onMouseLeave: () => N(!1),
				children: [/* @__PURE__ */ g("button", {
					"aria-label": V || H === 0 ? "Unmute video" : "Mute video",
					className: "sp-flex sp-h-8 sp-w-8 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-black/40 sp-p-0 sp-text-white",
					onClick: ue,
					type: "button",
					children: g(V || H === 0 ? ub : db, {})
				}), M ? /* @__PURE__ */ g("input", {
					"aria-label": "Volume",
					"aria-valuetext": `${Math.round(H * 100)}%`,
					className: "sp-h-1 sp-w-16 sp-cursor-pointer",
					max: String(rb),
					min: String(nb),
					onChange: de,
					step: String(ib),
					type: "range",
					value: H
				}) : null]
			}) : null
		]
	});
}, sb = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "26",
	viewBox: "0 0 24 28",
	width: "24",
	children: /* @__PURE__ */ g("path", {
		d: "M22 14L2 26V2L22 14Z",
		fill: "currentColor"
	})
}), cb = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "24",
	viewBox: "0 0 20 24",
	width: "20",
	children: [/* @__PURE__ */ g("rect", {
		fill: "currentColor",
		height: "22",
		rx: "1",
		width: "6",
		x: "1",
		y: "1"
	}), /* @__PURE__ */ g("rect", {
		fill: "currentColor",
		height: "22",
		rx: "1",
		width: "6",
		x: "13",
		y: "1"
	})]
}), lb = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: "sp-block sp-translate-x-[1px]",
	fill: "none",
	height: "28",
	viewBox: "0 0 36 34",
	width: "28",
	children: /* @__PURE__ */ g("path", {
		d: "M2.333 13.667s3.342-4.553 6.056-7.27C11.104 3.68 14.856 2 19 2c8.284 0 15 6.716 15 15s-6.716 15-15 15c-6.839 0-12.608-4.576-14.414-10.833M2.333 13.667v-10m0 10h10",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2.9"
	})
}), ub = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: [
		/* @__PURE__ */ g("path", {
			d: "M11 5L6 9H2v6h4l5 4V5z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ g("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2",
			x1: "23",
			x2: "17",
			y1: "9",
			y2: "15"
		}),
		/* @__PURE__ */ g("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2",
			x1: "17",
			x2: "23",
			y1: "9",
			y2: "15"
		})
	]
}), db = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: [
		/* @__PURE__ */ g("path", {
			d: "M11 5L6 9H2v6h4l5 4V5z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ g("path", {
			d: "M15.54 8.46a5 5 0 0 1 0 7.07",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ g("path", {
			d: "M19.07 4.93a10 10 0 0 1 0 14.14",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2"
		})
	]
}), fb = (e) => {
	let t = Math.max(0, Math.floor(e));
	return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
}, pb = [
	"TT",
	"IG",
	"FB",
	"LI"
], mb = [
	"IG",
	"FB",
	"LI"
], hb = (e) => e ? typeof e == "string" ? e : e.platformType || e.TYPE || "" : "", gb = (e) => pb.includes(hb(e)), _b = (e) => mb.includes(hb(e)), vb = (e = []) => e.filter((e) => gb(e)), yb = ({ platforms: e = [], selectedPlatform: t }) => t === "LINKED" ? e.some((e) => gb(e)) : gb(t), bb = ({ platforms: e = [], selectedPlatform: t }) => {
	let n = (t === "LINKED" ? e : [t || ""]).filter((e) => gb(e));
	return n.length > 0 && n.every((e) => _b(e));
}, xb = ({ isStory: e, isVideoPost: t, mediaUrlCount: n, storyType: r }) => n > 1 || n > 0 && !t || e && r !== "reel" ? !1 : t, Sb = ({ hasCoverPoster: e, platform: t, surface: n }) => e ? t !== "IG" || n !== "reel" && n !== "story" : !1, Cb = [
	".mp4",
	".mov",
	".webm",
	".m4v"
], wb = (e) => e?.url || e?.thumbnailUrl || "", Tb = (e) => {
	if (!e) return !1;
	if (e.isVideo || e.type?.toLowerCase().startsWith("video/")) return !0;
	let t = wb(e).toLowerCase().split(/[?#]/)[0];
	return Cb.some((e) => t.endsWith(e));
}, Eb = (e, t) => Tb(e[t]) ? e.slice(0, t).filter(Tb).length : t, Db = ({ coverScope: e = "singlePostOnly", media: t, mediaCount: n = 1, mediaIndex: r = 0, preferVideoCoverPreviewOverride: i = !1, videoCoverPreview: a }) => {
	let o = wb(t), s = a || void 0, c = t?.thumbnailUrl || void 0;
	return (e === "allVideos" || e === "firstVideoOnly" && r === 0 || e === "singlePostOnly" && n === 1 || i && r === 0) && s ? s : c || o || void 0;
}, Ob = ({ fit: e, media: t, platform: n, surface: r }) => ({
	fit: e || Mb({
		media: t,
		platform: n,
		surface: r
	}),
	intrinsicRatio: jb(t),
	publishedRatio: Nb({
		media: t,
		platform: n,
		surface: r
	})
}), kb = ({ fit: e, media: t, platform: n, surface: r, width: i }) => {
	let a = Ob({
		fit: e,
		media: t,
		platform: n,
		surface: r
	}), o = Lb(a.publishedRatio);
	return {
		...a,
		height: Rb(i / o),
		width: i
	};
}, Ab = (e) => ({
	autoPlay: !1,
	autoplayMode: "none",
	loop: !1,
	muted: !1
}), jb = (e) => {
	let t = e?.width, n = e?.height;
	if (!(!t || !n || t <= 0 || n <= 0)) return `${t} / ${n}`;
}, Mb = ({ media: e, platform: t, surface: n }) => (t === "IG" || t === "FB") && n === "reel" || (t === "LI" || t === "YT" || t === "OT" || t === "TT") && n === "video" || t === "PI" && n === "pin" && Tb(e) ? "contain" : "cover", Nb = ({ media: e, platform: t, surface: n }) => t === "IG" && (n === "feed" || n === "carousel") ? Ib({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 4 / 5,
	minRatioLabel: "4 / 5"
}) : t === "OT" ? n === "video" ? Fb({
	fallbackRatio: "16 / 9",
	media: e
}) : "1 / 1" : n === "story" || n === "reel" || t === "SC" || t === "TT" ? "9 / 16" : t === "PI" && n === "pin" ? Tb(e) ? Ib({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 1 / 2,
	minRatioLabel: "1 / 2"
}) : Pb(e) : t === "TW" && n === "video" ? Ib({
	fallbackRatio: "16 / 9",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TW" && n === "grid" ? Ib({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TH" && n === "video" ? Ib({
	fallbackRatio: "4 / 5",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TH" && n === "grid" || t === "FB" && n === "grid" ? Ib({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 4 / 5,
	minRatioLabel: "4 / 5"
}) : t === "LI" && (n === "grid" || n === "video") ? Ib({
	fallbackRatio: n === "video" ? "16 / 9" : "1 / 1",
	maxRatio: n === "video" ? 16 / 9 : 1.91,
	maxRatioLabel: n === "video" ? "16 / 9" : "1.91 / 1",
	media: e,
	minRatio: n === "video" ? 9 / 16 : 1 / 1.91,
	minRatioLabel: n === "video" ? "9 / 16" : "1 / 1.91"
}) : t === "GMB" ? n === "carousel" ? "1 / 1" : "400 / 264" : t === "YT" && n === "video" ? Fb({
	fallbackRatio: "16 / 9",
	media: e
}) : "1 / 1", Pb = (e) => {
	let t = e?.width, n = e?.height;
	return !t || !n || t <= 0 || n <= 0 ? "400 / 264" : t / n <= 2 / 3 ? "2 / 3" : `${t} / ${n}`;
}, Fb = ({ fallbackRatio: e, media: t }) => {
	let n = t?.width, r = t?.height;
	return !n || !r || n <= 0 || r <= 0 ? e : `${n} / ${r}`;
}, Ib = ({ fallbackRatio: e, maxRatio: t, maxRatioLabel: n, media: r, minRatio: i, minRatioLabel: a }) => {
	let o = r?.width, s = r?.height;
	if (!o || !s || o <= 0 || s <= 0) return e;
	let c = o / s;
	return c < i ? a : c > t ? n : `${o} / ${s}`;
}, Lb = (e) => {
	let [t, n] = e.split("/").map((e) => Number(e.trim()));
	return !t || !n || t <= 0 || n <= 0 ? 1 : t / n;
}, Rb = (e) => Math.round(e * 1e3) / 1e3, zb = ({ audioControlsClassName: e, backgroundColor: t, className: n, controls: r, coverScope: i, customVideoControls: a, fit: o, imageClassName: s, isActive: c = !0, media: l, mediaCount: u = 1, mediaIndex: d = 0, measureWhenInactive: f = !1, onIntrinsicDimensions: p, platform: h, preferVideoCoverPreviewOverride: _, surface: v, videoClassName: y, videoCoverPreview: b, videoScrubberClassName: x }) => {
	let [S, C] = m(), w = wb(l), T = Tb(l), E = Ob({
		fit: o,
		media: l,
		platform: h,
		surface: v
	}), D = E.fit === "contain" ? "sp-object-contain" : "sp-object-cover", O = /* @__PURE__ */ g("div", {
		className: ["sp-h-full sp-w-full sp-bg-[#e6e6e6]", n].filter(Boolean).join(" "),
		"data-uplift-fit": E.fit,
		"data-uplift-media-kind": "empty",
		"data-uplift-published-ratio": E.publishedRatio
	});
	if (!w) return O;
	if (T) {
		let o = Db({
			coverScope: i,
			media: l,
			mediaCount: u,
			mediaIndex: d,
			preferVideoCoverPreviewOverride: _,
			videoCoverPreview: b
		}), s = Ab({
			isActive: c,
			platform: h,
			surface: v
		}), m = !!(o && o !== w);
		if (S === w) {
			let e = m ? o : l?.thumbnailUrl;
			return !e || e === w ? O : /* @__PURE__ */ g(Bb, {
				fallbackSource: l?.thumbnailUrl,
				source: e,
				terminalFallback: O,
				alt: l?.altText ?? "",
				className: [
					"sp-block sp-h-full sp-w-full",
					D,
					n,
					y
				].filter(Boolean).join(" "),
				"data-uplift-fit": E.fit,
				"data-uplift-media-kind": "video-still",
				"data-uplift-published-ratio": E.publishedRatio
			}, `${w}\u0000still`);
		}
		let T = Sb({
			hasCoverPoster: m,
			platform: h,
			surface: v
		}), k = v === "reel" || v === "story", A = a ?? (k || T), j = r ?? (!A || T && !k);
		return /* @__PURE__ */ g(ob, {
			audioControlsClassName: e,
			autoPlay: s.autoPlay,
			autoplayMode: s.autoplayMode,
			backgroundColor: t,
			className: n,
			controls: j,
			customControls: A,
			fit: E.fit,
			gateCover: T,
			intrinsicRatio: E.intrinsicRatio,
			isActive: c,
			loop: s.loop,
			measureWhenInactive: f,
			muted: s.muted,
			onError: () => C(w),
			onIntrinsicDimensions: (e, t) => p?.(w, e, t),
			poster: o,
			publishedRatio: E.publishedRatio,
			scrubber: x !== void 0,
			scrubberClassName: x,
			source: w,
			videoClassName: [D, y].filter(Boolean).join(" ")
		}, w);
	}
	return /* @__PURE__ */ g(Bb, {
		fallbackSource: l?.thumbnailUrl,
		source: w,
		terminalFallback: O,
		alt: l?.altText ?? "",
		className: [
			"sp-block sp-h-full sp-w-full",
			D,
			n,
			s
		].filter(Boolean).join(" "),
		"data-uplift-fit": E.fit,
		"data-uplift-intrinsic-ratio": E.intrinsicRatio,
		"data-uplift-media-kind": "image",
		"data-uplift-published-ratio": E.publishedRatio,
		onLoad: (e) => {
			p?.(w, e.currentTarget.naturalWidth, e.currentTarget.naturalHeight);
		}
	}, `${w}\u0000${l?.thumbnailUrl ?? ""}`);
}, Bb = ({ fallbackSource: e, onError: t, source: n, terminalFallback: r, ...i }) => {
	let [a, o] = m([]), s = [n, ...e && e !== n ? [e] : []].find((e) => !a.includes(e));
	return s ? /* @__PURE__ */ g("img", {
		...i,
		onError: (e) => {
			o((e) => e.includes(s) ? e : [...e, s]), t?.(e);
		},
		src: s
	}, s) : r;
}, Vb = (e) => {
	let [t, n] = m(() => /* @__PURE__ */ new Map()), r = JSON.stringify(e.map(wb).filter(Boolean)), i = f(() => new Set(JSON.parse(r)), [r]), a = s((e, t, r) => {
		!e || !i.has(e) || !Number.isFinite(t) || !Number.isFinite(r) || t <= 0 || r <= 0 || n((n) => {
			let i = n.get(e);
			if (i?.width === t && i.height === r) return n;
			let a = new Map(n);
			return a.set(e, {
				height: r,
				width: t
			}), a;
		});
	}, [i]);
	return {
		medias: f(() => e.map((e) => {
			let n = t.get(wb(e));
			return n ? {
				...e,
				height: n.height,
				width: n.width
			} : e;
		}), [t, e]),
		reportIntrinsicDimensions: a
	};
}, Hb = (e) => typeof e == "object" && !!e && !Array.isArray(e), Ub = (e) => {
	if (typeof e == "string") return e.trim() || void 0;
}, Wb = (e) => typeof e == "number" && Number.isFinite(e) ? e : void 0, Gb = (e) => {
	if (!Hb(e)) return;
	let t = Ub(e.audioId);
	if (!t) return;
	let n = Wb(e.audioVolume), r = Wb(e.videoVolume);
	return {
		audioId: t,
		...n === void 0 ? {} : { audioVolume: n },
		...r === void 0 ? {} : { videoVolume: r }
	};
}, Kb = (e) => {
	if (!Hb(e)) return;
	let t = {}, n = Ub(e.title), r = Ub(e.artist), i = Ub(e.artworkUrl);
	return n && (t.title = n), r && (t.artist = r), i && (t.artworkUrl = i), Object.keys(t).length ? t : void 0;
}, qb = (e) => {
	if (!Hb(e)) return;
	let t = Ub(e.graduationStrategy);
	return t ? { graduationStrategy: t } : void 0;
}, Jb = (e) => {
	if (!Hb(e)) return {};
	let t = Gb(e.audioConfiguration), n = Kb(e.audioMeta), r = Ub(e.audioName), i = qb(e.trialReel), a = Wb(e.thumbOffsetMs);
	return {
		...t ? { audioConfiguration: t } : {},
		...n ? { audioMeta: n } : {},
		...r ? { audioName: r } : {},
		...typeof e.isAiGenerated == "boolean" ? { isAiGenerated: e.isAiGenerated } : {},
		...typeof e.shareToFeed == "boolean" ? { shareToFeed: e.shareToFeed } : {},
		...a === void 0 ? {} : { thumbOffsetMs: a },
		...i ? { trialReel: i } : {}
	};
}, Yb = ({ type: e, videoPostType: t }) => t === "reel" || e === "reel", Xb = ({ instagram: e, type: t, videoPostType: n }) => Yb({
	type: t,
	videoPostType: n
}) ? typeof e?.shareToFeed == "boolean" && e.shareToFeed : null, Zb = ({ instagram: e, username: t }) => {
	let n = t?.trim() || "Original audio";
	if (!e?.audioConfiguration?.audioId) return {
		hasTrack: !1,
		text: `${n} · Original audio`
	};
	let r = e?.audioMeta?.artworkUrl;
	if (e?.audioName) return {
		artworkUrl: r,
		hasTrack: !0,
		text: e.audioName
	};
	let { artist: i, title: a } = e?.audioMeta ?? {};
	return a ? {
		artworkUrl: r,
		hasTrack: !0,
		text: i ? `${a} · ${i}` : a
	} : {
		artworkUrl: r,
		hasTrack: !0,
		text: "Audio"
	};
}, Qb = {
	collection: [],
	count: 0
}, $b = (e) => !!e?.trim(), ex = (e) => {
	let t = e.medias?.collection ?? [], n = e;
	return {
		id: e.id,
		caption: e.caption || "",
		comment: e.comment || "",
		platform: e.platform,
		type: e.type,
		storyType: e.storyType || null,
		medias: e.medias ? {
			collection: t,
			count: e.medias.count ?? t.length
		} : Qb,
		username: e.username || "",
		profilePicture: e.profilePicture || "",
		followerCount: n.followedBy ?? n.followed_by ?? n.providedPost?.followed_by ?? null,
		imageUrl: e.image_url || "",
		locationName: e.locationName || null,
		redirectUrl: e.redirectUrl || "",
		storyUrl: e.storyUrl || "",
		storyLabel: e.storyLabel || "",
		storyStickerHeight: e.storyStickerHeight || null,
		tags: Array.isArray(e.providedPost?.tags) ? e.providedPost.tags : [],
		productTags: Array.isArray(e.providedPost?.productTags) ? e.providedPost.productTags : [],
		callToAction: e.callToAction || "",
		event: e.event || "",
		topicType: e.topicType || null,
		ytTitle: e.ytTitle || null,
		piTitle: e.piTitle || null,
		boardTitle: e.boardTitle || null,
		collaboratingIgUsers: n.collaboratingIgUsers ?? n.providedPost?.collaboratingIgUsers,
		instagram: Jb(n.providedPost?.instagram),
		providedPost: e.providedPost,
		sourcePost: e
	};
}, tx = /* @__PURE__ */ new Set([
	"fb-reel",
	"image",
	"multiMedia",
	"story",
	"text",
	"video"
]), nx = 5, rx = 3, ix = 68, ax = 20, ox = 30, sx = 55, cx = 49, lx = 48, ux = 20, dx = 16, fx = 1, px = 54, mx = 622, hx = (e) => e.platform === "FB" && (tx.has(e.type) || cS(e)), gx = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.type === "fb-reel" || cS(e), a = e.type === "story";
	return g(i ? Jx : a ? Xx : _x, {
		post: e,
		className: t,
		trackEvent: n,
		videoCoverPreview: r
	});
}, _x = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Vb(e.medias.collection), [o, c] = m(!1), l = Gx(e, i), u = Px({
		caption: e.caption,
		charsPerLine: l.charsPerLine,
		collapsedLines: l.collapsedLines,
		expanded: o,
		lineHeight: l.lineHeight
	}), f = [e.caption, o ? "expanded" : "collapsed"].join("|"), [h, v] = m(null), y = [e.username, e.comment].join("|"), [b, x] = m(null), S = p(null), C = p(null), w = h?.key === f ? h.height : void 0, T = b?.key === y ? b.height : void 0, E = s((e) => {
		v((t) => t?.key === f && t.height === e ? t : {
			height: e,
			key: f
		});
	}, [f]), D = Ex(e, i, o, w, T), O = $b(e.caption);
	return d(() => {
		if (!o) return;
		let e = S.current;
		if (!e) return;
		let t = Math.ceil(e.scrollHeight);
		t > 0 && Math.abs(t - u) > 1 && v({
			height: t,
			key: f
		});
	}, [
		o,
		f,
		u
	]), d(() => {
		if (!e.comment.trim()) {
			x(null);
			return;
		}
		let t = C.current;
		if (!t) return;
		let n = Math.ceil(t.scrollHeight);
		n > 0 && n !== T && x({
			height: n,
			key: y
		});
	}, [
		y,
		T,
		e.comment
	]), /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-[#141414]", t].filter(Boolean).join(" "),
		platform: "FB",
		children: /* @__PURE__ */ _("article", {
			className: "sp-relative sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": D.dataLayout,
			children: [/* @__PURE__ */ g(yx, { post: e }), /* @__PURE__ */ g("div", {
				style: { height: D.height - ix },
				children: /* @__PURE__ */ _("div", {
					className: "sp-relative",
					style: { top: -68 },
					children: [
						O && /* @__PURE__ */ g("div", {
							ref: S,
							className: ["sp-absolute sp-left-4 sp-top-[68px] sp-w-[368px] sp-overflow-hidden sp-break-words sp-whitespace-pre-line sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline", D.captionClassName].join(" "),
							style: { height: D.captionHeight },
							children: /* @__PURE__ */ g(bx, {
								caption: e.caption,
								charsPerLine: 44,
								collapsedLines: l.collapsedLines,
								expanded: o,
								lineHeight: l.lineHeight,
								onCollapsedHeightChange: E,
								onExpandedChange: c,
								trackEvent: n
							})
						}),
						D.kind === "link" && /* @__PURE__ */ g(Cx, {
							layout: D,
							post: e,
							videoCoverPreview: r
						}),
						D.kind === "video" && /* @__PURE__ */ g(Sx, {
							layout: D,
							media: i[0],
							onIntrinsicDimensions: a,
							post: e,
							videoCoverPreview: r
						}),
						D.kind === "single-media" && /* @__PURE__ */ g(xx, {
							media: i[0],
							mediaCount: i.length,
							mediaIndex: 0,
							onIntrinsicDimensions: a,
							rect: D.mediaRects[0],
							videoCoverPreview: r
						}),
						D.kind === "media-link" && D.mediaRects.map((t, n) => /* @__PURE__ */ g(xx, {
							href: Tb(i[n]) ? void 0 : e.redirectUrl,
							media: i[n],
							mediaCount: i.length,
							mediaIndex: Eb(i, n),
							onIntrinsicDimensions: a,
							rect: t,
							videoCoverPreview: r,
							children: t.overlayCount ? /* @__PURE__ */ _("div", {
								className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white",
								children: ["+", t.overlayCount]
							}) : null
						}, vx(i[n], t))),
						D.kind === "media-link" && D.linkCardTop !== void 0 && /* @__PURE__ */ g(qx, {
							post: e,
							top: D.linkCardTop
						}),
						D.kind === "collage" && D.mediaRects.map((e, t) => /* @__PURE__ */ g(xx, {
							media: i[t],
							mediaCount: i.length,
							mediaIndex: Eb(i, t),
							onIntrinsicDimensions: a,
							rect: e,
							videoCoverPreview: r,
							children: e.overlayCount ? /* @__PURE__ */ _("div", {
								className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white",
								children: ["+", e.overlayCount]
							}) : null
						}, vx(i[t], e))),
						/* @__PURE__ */ g(wx, { top: D.actionsTop }),
						D.firstCommentTop !== void 0 && /* @__PURE__ */ g(Tx, {
							commentRef: C,
							post: e,
							top: D.firstCommentTop,
							trackEvent: n
						})
					]
				})
			})]
		})
	});
}, vx = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), yx = ({ post: e }) => /* @__PURE__ */ _("header", {
	className: "sp-grid sp-grid-cols-[40px_minmax(0,1fr)_32px] sp-items-center sp-gap-2 sp-px-4 sp-pt-4 sp-pb-3",
	children: [
		/* @__PURE__ */ g(Yy, {
			className: "sp-h-10 sp-w-10",
			src: e.profilePicture,
			alt: e.username
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-min-w-0 sp-flex sp-flex-col sp-items-start sp-gap-1",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-w-full sp-text-base sp-font-semibold sp-leading-4 sp-break-words",
				children: e.username
			}), /* @__PURE__ */ _("div", {
				className: "sp-flex sp-items-center sp-gap-1 sp-text-sm sp-leading-none sp-text-[#808080]",
				children: [
					/* @__PURE__ */ g("span", { children: "Just now" }),
					/* @__PURE__ */ g("span", {
						"aria-hidden": "true",
						children: "."
					}),
					/* @__PURE__ */ g($x, {})
				]
			})]
		}),
		/* @__PURE__ */ g(iS, {
			className: "sp-text-[#808080]",
			size: 32
		})
	]
}), bx = ({ caption: e, charsPerLine: t, collapsedLines: n, expanded: r, lineHeight: i, onCollapsedHeightChange: a, onExpandedChange: o, trackEvent: s }) => {
	let c = Vx({
		caption: e,
		charsPerLine: t,
		collapsedLines: n
	}), l = [
		e,
		t,
		n,
		i
	].join("|"), u = c !== e.trim(), [f, v] = m({
		expandable: u,
		key: l,
		value: c
	}), y = p(null), b = p(null), x = p(null), S = f.key === l ? f.value : c, C = f.key === l ? f.expandable : u;
	return d(() => {
		let t = y.current, o = b.current, s = x.current, c = t?.parentElement;
		if (!t || !o || !s || !c) return;
		let u = !1, d = () => {
			let d = c.getBoundingClientRect(), f = n * i;
			if (d.width === 0) return;
			o.textContent = e.trim().replace(/\r\n?/g, "\n"), s.style.display = "none";
			let p = t.scrollHeight, m = p > f + .5, h = e.trim();
			m && (s.style.display = "inline", h = Ix({
				caption: e,
				containerHeight: f,
				measurement: t,
				measurementText: o
			})), u || (r || a(m ? f : Math.ceil(p)), v((e) => e.key === l && e.expandable === m && e.value === h ? e : {
				expandable: m,
				key: l,
				value: h
			}));
		};
		d();
		let f, p = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(() => {
			f !== void 0 && window.cancelAnimationFrame(f), f = window.requestAnimationFrame(() => {
				f = void 0, d();
			});
		});
		return p?.observe(c), document.fonts?.ready.then(() => {
			u || d();
		}), () => {
			u = !0, f !== void 0 && window.cancelAnimationFrame(f), p?.disconnect();
		};
	}, [
		e,
		n,
		r,
		i,
		l,
		a
	]), /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(zy, {
		buttonClassName: "sp-text-[#808080]",
		caption: e,
		charsPerLine: t,
		collapsedCaption: S,
		collapsedLines: n,
		contentClassName: "sp-whitespace-pre-line",
		expanded: r,
		expandable: C,
		onExpandedChange: o,
		targetPlatform: "FB",
		trackEvent: s
	}), /* @__PURE__ */ _("div", {
		"aria-hidden": "true",
		className: "sp-pointer-events-none sp-fixed sp-left-[-10000px] sp-top-0 sp-w-[368px] sp-break-words sp-whitespace-pre-line sp-invisible",
		ref: y,
		style: { lineHeight: `${i}px` },
		children: [/* @__PURE__ */ g("span", { ref: b }), /* @__PURE__ */ _("span", {
			ref: x,
			children: [/* @__PURE__ */ g("span", {
				className: "sp-ml-0.5",
				children: "…"
			}), /* @__PURE__ */ g("span", {
				className: "sp-ml-1 sp-inline",
				"data-uplift-caption-affordance": "true",
				children: "more"
			})]
		})]
	})] });
}, xx = ({ children: e, href: t, media: n, mediaCount: r, mediaIndex: i, onIntrinsicDimensions: a, rect: o, videoCoverPreview: s }) => {
	let c = "sp-absolute sp-overflow-hidden sp-bg-[#e4e6eb]", l = {
		height: o.height,
		left: o.left,
		top: o.top,
		width: o.width
	}, u = /* @__PURE__ */ _(h, { children: [n && /* @__PURE__ */ g(zb, {
		coverScope: "firstVideoOnly",
		media: n,
		mediaCount: r,
		mediaIndex: i,
		onIntrinsicDimensions: a,
		platform: "FB",
		surface: "grid",
		videoCoverPreview: s
	}), e] });
	return t ? /* @__PURE__ */ g("a", {
		"aria-label": `Open ${sS(t)} in a new tab`,
		className: `${c} sp-block sp-text-inherit sp-no-underline`,
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		href: t,
		rel: "noreferrer",
		style: l,
		target: "_blank",
		children: u
	}) : /* @__PURE__ */ g("div", {
		className: c,
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		style: l,
		children: u
	});
}, Sx = ({ layout: e, media: t, onIntrinsicDimensions: n, post: r, videoCoverPreview: i }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-black",
	"data-uplift-media-frame-ratio": e.mediaRects[0] ? `${e.mediaRects[0].width} / ${e.mediaRects[0].height}` : void 0,
	style: {
		height: e.contentHeight,
		top: e.contentTop
	},
	children: [/* @__PURE__ */ g(zb, {
		coverScope: "singlePostOnly",
		media: t ?? {
			isVideo: !0,
			thumbnailUrl: r.imageUrl,
			url: r.imageUrl
		},
		platform: "FB",
		onIntrinsicDimensions: n,
		surface: "grid",
		videoCoverPreview: i
	}), /* @__PURE__ */ g("div", {
		className: "sp-absolute sp-bottom-4 sp-right-4 sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/50 sp-text-white",
		children: /* @__PURE__ */ g(oS, { size: 20 })
	})]
}), Cx = ({ layout: e, post: t, videoCoverPreview: n }) => {
	let r = t.medias.collection[0] ?? {
		thumbnailUrl: t.imageUrl || n,
		url: t.imageUrl || n
	};
	return /* @__PURE__ */ g("a", {
		className: "sp-absolute sp-left-0 sp-block sp-w-full sp-overflow-hidden sp-text-inherit sp-no-underline",
		href: t.redirectUrl,
		rel: "noreferrer",
		style: {
			height: e.contentHeight,
			top: e.contentTop
		},
		target: "_blank",
		children: e.linkHasBody ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g("div", {
			className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]",
			children: /* @__PURE__ */ g(zb, {
				media: r,
				platform: "FB",
				surface: "grid"
			})
		}), /* @__PURE__ */ _("div", {
			className: "sp-box-border sp-h-[55px] sp-w-full sp-bg-[#f2f2f2] sp-px-4 sp-py-2",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]",
				children: sS(t.redirectUrl)
			}), /* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]",
				children: t.redirectUrl
			})]
		})] }) : /* @__PURE__ */ g("div", {
			className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]",
			children: /* @__PURE__ */ g(zb, {
				media: r,
				platform: "FB",
				surface: "grid"
			})
		})
	});
}, wx = ({ top: e }) => /* @__PURE__ */ _("footer", {
	className: "sp-absolute sp-left-0 sp-flex sp-h-10 sp-w-full sp-items-start sp-gap-8 sp-px-4 sp-text-sm sp-font-medium sp-leading-none sp-text-[#808080]",
	style: { top: e },
	children: [
		/* @__PURE__ */ g(Zx, {
			icon: /* @__PURE__ */ g(eS, {}),
			count: 1
		}),
		/* @__PURE__ */ g(Zx, {
			icon: /* @__PURE__ */ g(tS, {}),
			count: 1
		}),
		/* @__PURE__ */ g(Zx, {
			className: "sp-gap-1",
			icon: /* @__PURE__ */ g(nS, {}),
			count: 1
		})
	]
}), Tx = ({ commentRef: e, post: t, top: n, trackEvent: r }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-4 sp-w-[368px] sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline",
	"data-uplift-first-comment": "facebook",
	ref: e,
	style: { top: n },
	children: [/* @__PURE__ */ g("span", {
		className: "sp-mr-1 sp-font-semibold",
		children: t.username
	}), /* @__PURE__ */ g(Gp, {
		caption: t.comment.trim(),
		targetPlatform: "FB",
		trackEvent: r
	})]
}), Ex = (e, t, n, r, i) => {
	let a = Gx(e, t), o = r ?? Px({
		caption: e.caption,
		charsPerLine: a.charsPerLine,
		collapsedLines: a.collapsedLines,
		expanded: n,
		lineHeight: a.lineHeight
	}), s = a.className, c = o > 0, l = t.length, u = i ?? Fx(e);
	if (e.redirectUrl && l > 0) {
		let e = Ox(t, o), n = Math.max(...e.mediaRects.map((e) => e.top + e.height)), r = n, i = r + sx + 12;
		return Dx({
			actionsTop: i,
			captionHeight: o,
			captionClassName: s,
			contentHeight: n - e.contentTop,
			contentTop: e.contentTop,
			dataLayout: "facebook-media-link",
			height: i + cx,
			kind: "media-link",
			linkCardTop: r,
			mediaRects: e.mediaRects
		}, u);
	}
	if (l <= 1 && (e.type === "video" || Tb(t[0]))) {
		let e = Nx(t[0], Mx(140, o)), n = e.top + e.height + 12;
		return Dx({
			actionsTop: n,
			captionHeight: o,
			captionClassName: s,
			contentHeight: e.height,
			contentTop: e.top,
			dataLayout: "facebook-video",
			height: n + cx,
			kind: "video",
			mediaRects: [e]
		}, u);
	}
	if (e.redirectUrl) {
		let e = c && o >= 180, t = Mx(e ? 264 : 140, o), n = e ? 273 : 328, r = t + n + (e ? 16 : -1);
		return Dx({
			actionsTop: r,
			captionHeight: o,
			captionClassName: s,
			contentHeight: n,
			contentTop: t,
			dataLayout: e ? "facebook-hashtag" : "facebook-link",
			height: r + cx,
			kind: "link",
			linkHasBody: !e,
			mediaRects: []
		}, u);
	}
	if (l === 0) {
		let e = Mx(138, o), t = o === 0 ? kx : Math.max(e, o >= 180 ? 260 : o >= 100 ? 180 : 138);
		return Dx({
			actionsTop: t,
			captionHeight: o,
			captionClassName: s,
			contentHeight: 0,
			contentTop: 0,
			dataLayout: "facebook-text",
			height: t + cx,
			kind: "text",
			mediaRects: []
		}, u);
	}
	return Dx({
		...Ox(t, o),
		captionHeight: o,
		captionClassName: s
	}, u);
}, Dx = (e, t) => {
	if (t <= 0) return e;
	let n = e.actionsTop + cx;
	return {
		...e,
		firstCommentTop: n,
		height: n + t + dx
	};
}, Ox = (e, t) => {
	let n = e.length;
	if (n === 1) {
		if (t >= 700) {
			let n = Nx(e[0], Mx(780, t)), r = n.top + n.height + 12;
			return {
				actionsTop: r,
				contentHeight: n.height,
				contentTop: n.top,
				dataLayout: "facebook-image-long",
				height: r + cx,
				kind: "single-media",
				mediaRects: [n]
			};
		}
		if (t >= 180) {
			let n = Nx(e[0], Mx(264, t)), r = n.top + n.height + 12;
			return {
				actionsTop: r,
				contentHeight: n.height,
				contentTop: n.top,
				dataLayout: "facebook-image-hashtag",
				height: r + cx,
				kind: "single-media",
				mediaRects: [n]
			};
		}
		let n = Nx(e[0], Mx(137, t)), r = n.top + n.height + 12;
		return {
			actionsTop: r,
			contentHeight: n.height,
			contentTop: n.top,
			dataLayout: "facebook-image",
			height: r + cx,
			kind: "single-media",
			mediaRects: [n]
		};
	}
	if (n === 2) {
		let e = Mx(137, t), n = e + 196 + 10;
		return {
			actionsTop: n,
			contentHeight: 196,
			contentTop: e,
			dataLayout: "facebook-collage-2",
			height: n + cx,
			kind: "collage",
			mediaRects: [{
				height: 196,
				left: 0,
				top: e,
				width: 196
			}, {
				height: 196,
				left: 204,
				top: e,
				width: 196
			}]
		};
	}
	if (n === 3) {
		let n = Mx(144, t);
		if (Kx(e)) {
			let e = n + 400 + 16;
			return {
				actionsTop: e,
				contentHeight: 400,
				contentTop: n,
				dataLayout: "facebook-collage-3-portrait",
				height: e + cx,
				kind: "collage",
				mediaRects: [
					{
						height: 400,
						left: 0,
						top: n,
						width: 196
					},
					{
						height: 196,
						left: 204,
						top: n,
						width: 196
					},
					{
						height: 196,
						left: 204,
						top: n + 204,
						width: 196
					}
				]
			};
		}
		let r = n + 204, i = n + 400 + 16;
		return {
			actionsTop: i,
			contentHeight: 400,
			contentTop: n,
			dataLayout: "facebook-collage-3",
			height: i + cx,
			kind: "collage",
			mediaRects: [
				{
					height: 196,
					left: 0,
					top: n,
					width: 400
				},
				{
					height: 196,
					left: 0,
					top: r,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: r,
					width: 196
				}
			]
		};
	}
	if (n === 4) {
		let e = Mx(144, t), n = e + 204, r = e + 400 + 16;
		return {
			actionsTop: r,
			contentHeight: 400,
			contentTop: e,
			dataLayout: "facebook-collage-4",
			height: r + cx,
			kind: "collage",
			mediaRects: [
				{
					height: 196,
					left: 0,
					top: e,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: e,
					width: 196
				},
				{
					height: 196,
					left: 0,
					top: n,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: n,
					width: 196
				}
			]
		};
	}
	let r = Mx(144, t), i = r + 204, a = r + 332 + 16;
	return {
		actionsTop: a,
		contentHeight: 332,
		contentTop: r,
		dataLayout: n > 5 ? "facebook-collage-5-plus" : "facebook-collage-5",
		height: a + cx,
		kind: "collage",
		mediaRects: [
			{
				height: 196,
				left: 0,
				top: r,
				width: 196
			},
			{
				height: 196,
				left: 204,
				top: r,
				width: 196
			},
			{
				height: 128,
				left: 0,
				top: i,
				width: 128
			},
			{
				height: 128,
				left: 136,
				top: i,
				width: 128
			},
			{
				height: 128,
				left: 272,
				overlayCount: n > 5 ? n - 4 : void 0,
				top: i,
				width: 128
			}
		]
	};
}, kx = 68, Ax = 68, jx = 9, Mx = (e, t) => t > 0 ? Math.max(e, Ax + t + jx) : kx, Nx = (e, t) => {
	let n = kb({
		media: e,
		platform: "FB",
		surface: "grid",
		width: 400
	});
	return {
		height: n.height,
		left: 0,
		top: t,
		width: n.width
	};
}, Px = ({ caption: e, charsPerLine: t, collapsedLines: n, expanded: r, lineHeight: i }) => e.trim().length === 0 ? 0 : Vy({
	charsPerLine: t,
	collapsedLines: n,
	expanded: r,
	lineHeight: i,
	text: e
}), Fx = (e) => {
	let t = e.comment.trim();
	return t ? Hy({
		charsPerLine: lx,
		leadingText: e.username,
		text: t
	}) * ux : 0;
}, Ix = ({ caption: e, containerHeight: t, measurement: n, measurementText: r }) => {
	let i = Lx(e.trim()), a = 0, o = i.length, s = "";
	for (; a <= o;) {
		let e = Math.floor((a + o) / 2), c = i.slice(0, e).join("").trimEnd();
		r.textContent = c.replace(/\r\n?/g, "\n"), n.scrollHeight <= t + .5 ? (s = c, a = e + 1) : o = e - 1;
	}
	return s;
}, Lx = (e) => {
	let t = Intl.Segmenter;
	return t ? Array.from(new t(void 0, { granularity: "grapheme" }).segment(e), ({ segment: e }) => e) : Rx(e);
}, Rx = (e) => {
	let t = Array.from(e), n = [], r = 0;
	for (; r < t.length;) {
		let e = t[r++];
		for (zx(e) && r < t.length && zx(t[r]) && (e += t[r++]); r < t.length && Bx(t[r]);) e += t[r++];
		for (; r + 1 < t.length && t[r] === "‍";) for (e += t[r++], e += t[r++]; r < t.length && Bx(t[r]);) e += t[r++];
		n.push(e);
	}
	return n;
}, zx = (e) => {
	let t = e.codePointAt(0) ?? 0;
	return t >= 127462 && t <= 127487;
}, Bx = (e) => {
	let t = e.codePointAt(0) ?? 0;
	return /^\p{Mark}$/u.test(e) || t >= 65024 && t <= 65039 || t >= 917760 && t <= 917999 || t >= 127995 && t <= 127999 || t === 8419;
}, Vx = ({ caption: e, charsPerLine: t, collapsedLines: n }) => {
	let r = e.trim();
	if (Hy({
		charsPerLine: t,
		text: r
	}) <= n) return r;
	let i = Lx(r), a = i.length, o = r;
	for (; o.length > 0 && Hx({
		charsPerLine: t,
		text: `${o}${Ry}`
	}) > n;) {
		let e = i[--a];
		for (o = o.slice(0, -e.length); a > 0 && /^\s+$/u.test(i[a - 1]);) {
			let e = i[--a];
			o = o.slice(0, -e.length);
		}
	}
	return o;
}, Hx = ({ charsPerLine: e, text: t }) => Ux(t, e).length, Ux = (e, t) => e.trim().split(/\r\n?|\n/).flatMap((e) => Wx(e, t)), Wx = (e, t) => {
	if (!e) return [""];
	let n = [], r = "";
	for (let i of e.match(/\S+\s*/g) ?? []) {
		let e = `${r}${i}`;
		for (r && e.trimEnd().length > t ? (n.push(r.trimEnd()), r = i.trimStart()) : r = e; r.length > t;) n.push(r.slice(0, t)), r = r.slice(t);
	}
	return r && n.push(r.trimEnd()), n;
}, Gx = (e, t) => t.length > 0 || e.redirectUrl ? {
	charsPerLine: 44,
	className: "sp-text-base",
	collapsedLines: rx,
	lineHeight: ax
} : Hy({
	charsPerLine: 32,
	text: e.caption
}) <= 2 ? {
	charsPerLine: 32,
	className: "sp-text-2xl sp-leading-[30px]",
	collapsedLines: nx,
	lineHeight: ox
} : {
	charsPerLine: 44,
	className: "sp-text-base",
	collapsedLines: nx,
	lineHeight: ax
}, Kx = (e) => e.length > 0 && e.every((e) => typeof e.width == "number" && typeof e.height == "number" && e.height > e.width), qx = ({ post: e, top: t }) => /* @__PURE__ */ _("a", {
	className: "sp-absolute sp-left-0 sp-box-border sp-block sp-h-[55px] sp-w-full sp-border-0 sp-border-b sp-border-solid sp-border-[#c4c4c4] sp-bg-[#f2f2f2] sp-px-4 sp-py-2 sp-text-inherit sp-no-underline",
	href: e.redirectUrl,
	rel: "noreferrer",
	style: { top: t },
	target: "_blank",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]",
		children: sS(e.redirectUrl)
	}), /* @__PURE__ */ g("div", {
		className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]",
		children: e.redirectUrl
	})]
}), Jx = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.medias.collection[0], [a, o] = m(!1), s = r || i?.thumbnailUrl || e.imageUrl, c = i?.url || e.imageUrl, u = $b(e.caption), d = u && Hy({
		charsPerLine: 36,
		text: e.caption
	}) > fx, f = a && d, p = {
		...i || {},
		thumbnailUrl: s,
		url: c || s
	};
	return l(() => {
		d || o(!1);
	}, [d]), /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-h-[800px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "FB",
		children: /* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": "facebook-reel",
			children: [
				/* @__PURE__ */ g("div", {
					className: "sp-absolute sp-inset-0",
					"data-uplift-media-frame-ratio": "9 / 16",
					children: /* @__PURE__ */ g(zb, {
						backgroundColor: "#000",
						className: "sp-h-full sp-w-full",
						coverScope: "singlePostOnly",
						customVideoControls: !0,
						media: {
							...p,
							isVideo: Tb(p)
						},
						platform: "FB",
						surface: "reel",
						videoCoverPreview: r,
						videoScrubberClassName: "sp-bottom-0"
					})
				}),
				/* @__PURE__ */ g("div", { className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-top-[546px] sp-h-[254px] sp-bg-gradient-to-t sp-from-[rgba(0,0,0,0.6)] sp-to-transparent" }),
				f && /* @__PURE__ */ g("div", {
					className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-bg-black/40",
					"data-uplift-caption-backdrop": "true"
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-4 sp-top-8 sp-flex sp-h-6 sp-w-[368px] sp-items-center sp-justify-between",
					children: [/* @__PURE__ */ g(aS, {}), /* @__PURE__ */ _("div", {
						className: "sp-flex sp-items-center sp-gap-4",
						children: [/* @__PURE__ */ g(rS, {}), /* @__PURE__ */ g(Yy, {
							className: "sp-h-6 sp-w-6",
							src: e.profilePicture,
							alt: e.username
						})]
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[352px] sp-top-[424px] sp-flex sp-w-8 sp-flex-col sp-gap-10 sp-text-white",
					children: [
						/* @__PURE__ */ g(eS, { size: 32 }),
						/* @__PURE__ */ g(tS, { size: 32 }),
						/* @__PURE__ */ g(nS, { size: 32 }),
						/* @__PURE__ */ g(tS, { size: 32 }),
						/* @__PURE__ */ g(iS, { size: 32 })
					]
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-5 sp-flex sp-w-[298px] sp-flex-col sp-gap-3",
					style: { bottom: px },
					children: [/* @__PURE__ */ _("div", {
						className: "sp-flex sp-items-center sp-gap-3",
						children: [
							/* @__PURE__ */ g(Yy, {
								className: "sp-h-10 sp-w-10",
								src: e.profilePicture,
								alt: e.username
							}),
							/* @__PURE__ */ g(Zy, {
								className: "sp-text-white",
								children: e.username
							}),
							/* @__PURE__ */ g("button", {
								className: "sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white",
								type: "button",
								children: "Follow"
							})
						]
					}), u && /* @__PURE__ */ g(Yx, {
						caption: e.caption,
						expanded: f,
						onExpandedChange: o,
						trackEvent: n
					})]
				})
			]
		})
	});
}, Yx = ({ caption: e, expanded: t, onExpandedChange: n, trackEvent: r }) => {
	if (!(Hy({
		charsPerLine: 36,
		text: e
	}) > fx)) return /* @__PURE__ */ g("div", {
		className: "sp-text-base sp-leading-5 sp-text-white",
		children: /* @__PURE__ */ g(em, {
			caption: e,
			targetPlatform: "FB",
			trackEvent: r
		})
	});
	let i = Vx({
		caption: e,
		charsPerLine: 36,
		collapsedLines: fx
	});
	return /* @__PURE__ */ g(zy, {
		buttonClassName: "sp-text-sm sp-text-gray-400",
		caption: e,
		charsPerLine: 36,
		collapsedCaption: i,
		collapsedLines: fx,
		contentClassName: "sp-whitespace-pre-line sp-text-base sp-leading-5 sp-text-white [&_*]:sp-inline",
		expanded: t,
		onExpandedChange: n,
		scrollOnExpandMaxHeight: mx,
		targetPlatform: "FB",
		trackEvent: r
	});
}, Xx = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.medias.collection, a = i[0], o = a?.url || e.imageUrl || a?.thumbnailUrl || "", s = r || a?.thumbnailUrl || e.imageUrl, c = {
		...a || {},
		isVideo: Tb(a) || Tb({
			thumbnailUrl: s,
			url: o || s
		}),
		thumbnailUrl: s,
		url: o || s
	}, l = i.length > 1 ? i : [c], [u, d] = m(0), f = Math.min(u, l.length - 1);
	return /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "FB",
		children: /* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": "facebook-story",
			children: [
				l.length > 1 ? /* @__PURE__ */ g($y, {
					ariaLabel: "Facebook story carousel",
					className: "sp-absolute sp-inset-0",
					medias: l,
					onIndexChange: d,
					renderSlide: (e, { index: t, isActive: n }) => /* @__PURE__ */ g("div", {
						className: "sp-absolute sp-inset-0",
						"data-uplift-media-frame-ratio": "9 / 16",
						children: /* @__PURE__ */ g(zb, {
							className: "sp-h-full sp-w-full",
							coverScope: "firstVideoOnly",
							customVideoControls: !0,
							isActive: n,
							media: e,
							mediaCount: l.length,
							mediaIndex: Eb(l, t),
							platform: "FB",
							surface: "story",
							videoCoverPreview: r,
							videoScrubberClassName: "sp-bottom-0"
						})
					}),
					showCount: !1,
					showDots: !1
				}) : o ? /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-inset-0",
					"data-uplift-media-frame-ratio": "9 / 16",
					children: /* @__PURE__ */ g(zb, {
						className: "sp-h-full sp-w-full",
						coverScope: "singlePostOnly",
						customVideoControls: !0,
						media: c,
						platform: "FB",
						surface: "story",
						videoCoverPreview: r,
						videoScrubberClassName: "sp-bottom-0"
					})
				}) : /* @__PURE__ */ g("div", { className: "sp-absolute sp-inset-0 sp-bg-[#1b4f9c]" }),
				/* @__PURE__ */ g("div", {
					"aria-hidden": "true",
					className: "sp-absolute sp-left-[11px] sp-top-2.5 sp-flex sp-w-[380px] sp-gap-1",
					"data-uplift-facebook-story-progress": l.length,
					children: l.map((e, t) => /* @__PURE__ */ g("span", {
						className: ["sp-block sp-h-1 sp-flex-1 sp-rounded-full", t <= f ? "sp-bg-white" : "sp-bg-white/30"].join(" "),
						"data-uplift-facebook-story-segment": t === f ? "active" : "inactive"
					}, `story-segment-${t}`))
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-2.5 sp-top-6 sp-flex sp-h-[36.487px] sp-w-[280px] sp-items-center sp-gap-2.5",
					children: [/* @__PURE__ */ g(Yy, {
						className: "sp-h-[36.487px] sp-w-[36.487px]",
						src: e.profilePicture,
						alt: e.username
					}), /* @__PURE__ */ g(Zy, {
						className: "sp-text-sm sp-leading-[14px] sp-text-white",
						children: e.username
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[317px] sp-top-[33.5px] sp-flex sp-h-[18px] sp-w-[74px] sp-items-center sp-justify-between sp-text-white",
					children: [
						/* @__PURE__ */ g(rS, { size: 18 }),
						/* @__PURE__ */ g(iS, { size: 18 }),
						/* @__PURE__ */ g(aS, { size: 18 })
					]
				}),
				!o && $b(e.caption) && /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-left-[104px] sp-top-[341px] sp-w-[191px] sp-text-center sp-text-[22px] sp-font-semibold sp-leading-[27px] sp-text-white",
					children: /* @__PURE__ */ g(em, {
						caption: e.caption,
						targetPlatform: "FB",
						trackEvent: n
					})
				})
			]
		})
	});
}, Zx = ({ className: e, count: t, icon: n }) => /* @__PURE__ */ _("span", {
	className: ["sp-flex sp-items-center sp-gap-2", e].filter(Boolean).join(" "),
	children: [n, /* @__PURE__ */ g("span", { children: t })]
}), Qx = ({ children: e, size: t = 24, className: n = "sp-text-[#808080]", viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: n,
	fill: "none",
	height: t,
	viewBox: r,
	width: t,
	children: e
}), $x = () => /* @__PURE__ */ g(Qx, {
	size: 12,
	viewBox: "0 0 12 12",
	children: /* @__PURE__ */ g("path", {
		d: "M6 0C2.685 0 0 2.685 0 6C0 9.315 2.685 12 6 12C9.315 12 12 9.315 12 6C12 2.685 9.315 0 6 0ZM6 1.5C6.495 1.5 6.96 1.635 7.41 1.785C7.095 2.085 6.735 2.355 6.795 2.625C6.855 2.895 7.83 2.82 7.83 3.375C7.83 3.78 7.2 3.9 7.635 4.365C8.16 4.89 6.675 5.835 6.645 6.525C6.6 7.77 7.905 7.98 8.94 7.98C9.57 7.98 9.735 8.28 9.69 8.64C8.88 9.795 7.5 10.515 5.985 10.515C5.415 10.515 4.89 10.38 4.395 10.185C4.725 9.525 3.975 8.22 3.27 7.8C2.925 7.455 2.19 7.59 1.77 7.425C1.635 7.02 1.5 6.615 1.485 6.165C1.53 6.09 1.605 6.03 1.725 6.03C2.01 6.03 2.4 6.6 2.61 6.54C2.88 6.48 1.5 4.575 2.145 4.2C2.445 4.02 3.045 4.785 2.85 3.96C2.67 3.195 3.39 3.54 3.84 3.345C4.23 3.18 4.515 2.73 4.035 2.46C3.945 2.415 3.84 2.31 3.705 2.175C4.38 1.77 5.16 1.515 6 1.515V1.5ZM9.465 3.135C9.735 3.465 9.945 3.825 10.125 4.215V4.26C10.065 4.365 9.96 4.425 9.795 4.59C9.375 5.01 9.315 4.275 9.135 4.125C8.94 3.945 8.235 4.155 8.145 3.93C8.04 3.66 8.895 3.3 9.465 3.135Z",
		fill: "currentColor"
	})
}), eS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), tS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), nS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59167 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40808 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.163C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), rS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-white",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), iS = ({ className: e = "sp-text-white", size: t = 24 }) => /* @__PURE__ */ _(Qx, {
	className: e,
	size: t,
	viewBox: "0 0 32 32",
	children: [
		/* @__PURE__ */ g("path", {
			d: "M16 17.3333C16.7364 17.3333 17.3333 16.7364 17.3333 16C17.3333 15.2636 16.7364 14.6667 16 14.6667C15.2636 14.6667 14.6667 15.2636 14.6667 16C14.6667 16.7364 15.2636 17.3333 16 17.3333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ g("path", {
			d: "M25.3333 17.3333C26.0697 17.3333 26.6667 16.7364 26.6667 16C26.6667 15.2636 26.0697 14.6667 25.3333 14.6667C24.597 14.6667 24 15.2636 24 16C24 16.7364 24.597 17.3333 25.3333 17.3333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ g("path", {
			d: "M6.66667 17.3333C7.40305 17.3333 8 16.7364 8 16C8 15.2636 7.40305 14.6667 6.66667 14.6667C5.93029 14.6667 5.33333 15.2636 5.33333 16C5.33333 16.7364 5.93029 17.3333 6.66667 17.3333Z",
			fill: "currentColor"
		})
	]
}), aS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-white",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "m6 6 12 12M18 6 6 18",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	})
}), oS = ({ size: e = 24 }) => /* @__PURE__ */ g(Qx, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ g("path", {
		d: "M4 9v6h4l5 4V5L8 9H4Zm13 1 4 4m0-4-4 4",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), sS = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, cS = (e) => e.type === "video" && e.providedPost?.videoPostType === "reel", lS = (e) => typeof e == "object" && !!e, uS = (e) => {
	if (typeof e != "number" && (typeof e != "string" || !/^-?(?:\d+\.?\d*|\.\d+)$/.test(e.trim()))) return null;
	let t = typeof e == "number" ? e : Number(e.trim());
	return Number.isFinite(t) && t >= 0 && t <= 100 ? t : null;
}, dS = (e) => {
	let t = e.coordinates;
	if (lS(t) && typeof t.x == "number" && typeof t.y == "number" && Number.isFinite(t.x) && Number.isFinite(t.y) && t.x >= 0 && t.x <= 100 && t.y >= 0 && t.y <= 100) return {
		x: t.x,
		y: t.y
	};
	let n = uS(e.left), r = uS(e.top);
	return n === null || r === null ? null : {
		x: n,
		y: r
	};
}, fS = (e) => Array.isArray(e) ? e.flatMap((e) => {
	if (!lS(e) || typeof e.value != "string") return [];
	let t = e.value.trim().replace(/^@+/, ""), n = dS(e);
	return t && n ? [{
		value: t,
		...n
	}] : [];
}) : [], pS = (e) => /^\d+$/.test(e), mS = (e) => Array.isArray(e) ? e.flatMap((e) => {
	if (!lS(e) || typeof e.value != "string") return [];
	let t = e.value.trim();
	return t ? [{
		label: (typeof e.productName == "string" ? e.productName.trim() : "") || (pS(t) ? "Product" : t),
		...dS(e) ?? {}
	}] : [];
}) : [], hS = ({ children: e, className: t = "sp-text-black", size: n = 24, viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: r,
	width: n,
	children: e
}), gS = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ g(hS, {
	className: e,
	children: /* @__PURE__ */ g("path", {
		d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), _S = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: "sp-text-white",
	fill: "none",
	height: "22",
	viewBox: "0 0 24 24",
	width: "25.356",
	children: /* @__PURE__ */ g("path", {
		d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), vS = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ g(hS, {
	className: e,
	children: /* @__PURE__ */ g("path", {
		d: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), yS = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ g(hS, {
	className: e,
	children: /* @__PURE__ */ g("path", {
		d: "m22 2-7 20-4-9-9-4 20-7Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), bS = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: "sp-text-white",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "22.24",
	children: /* @__PURE__ */ g("path", {
		d: "m22 2-7 20-4-9-9-4 20-7Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), xS = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: "sp-text-black",
	fill: "none",
	height: "24",
	viewBox: "5 0 14 24",
	width: "14",
	children: /* @__PURE__ */ g("path", {
		d: "M6 3h12v18l-6-4-6 4V3Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), SS = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ g(hS, {
	className: e,
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ g("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), CS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	children: /* @__PURE__ */ g("path", {
		d: "m18 6-12 12M6 6l12 12",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	})
}), wS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-[#436ce1]",
	size: 28,
	children: /* @__PURE__ */ g("path", {
		d: "M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20.1l1.1-1.1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), TS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	size: 16,
	viewBox: "0 0 16 16",
	children: /* @__PURE__ */ g("path", {
		d: "M5.25 6.25V5a2.75 2.75 0 1 1 5.5 0v1.25h1.03c.63 0 1.15.48 1.22 1.1l.58 5.25A1.25 1.25 0 0 1 12.34 14H3.66a1.25 1.25 0 0 1-1.24-1.4L3 7.35c.07-.62.59-1.1 1.22-1.1h1.03Zm1.5 0h2.5V5a1.25 1.25 0 1 0-2.5 0v1.25Zm-.75 2a.75.75 0 0 0 .75-.75H5.25c0 .41.34.75.75.75Zm4 0a.75.75 0 0 0 .75-.75h-1.5c0 .41.34.75.75.75Z",
		fill: "currentColor"
	})
}), ES = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	size: 16,
	viewBox: "0 0 16 16",
	children: /* @__PURE__ */ g("path", {
		d: "M8 8.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm-5.6 4.93c.62-2.33 2.74-4.05 5.6-4.05s4.98 1.72 5.6 4.05c.17.64-.35 1.07-.94 1.07H3.34c-.59 0-1.11-.43-.94-1.07Z",
		fill: "currentColor"
	})
}), DS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	children: /* @__PURE__ */ g("path", {
		d: "m15 18-6-6 6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), OS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	children: /* @__PURE__ */ g("path", {
		d: "M4 8a2 2 0 0 1 2-2h2l2-2h4l2 2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Zm8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), kS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ g("path", {
		d: "m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), AS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ g("path", {
		d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), jS = () => /* @__PURE__ */ _(hS, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ g("path", {
		d: "M12 7v10M7 12h10",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	}), /* @__PURE__ */ g("rect", {
		height: "18",
		rx: "5",
		stroke: "currentColor",
		strokeWidth: "1.8",
		width: "18",
		x: "3",
		y: "3"
	})]
}), MS = () => /* @__PURE__ */ g(hS, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ g("path", {
		d: "M4 7h16v13H4V7Zm2-4 2.5 4M12 3l2.5 4M18 3l2 4",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), NS = ({ className: e = "sp-text-black", size: t = 12 }) => /* @__PURE__ */ _(hS, {
	className: e,
	size: t,
	children: [
		/* @__PURE__ */ g("path", {
			d: "M9 18V5l12-2v13",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "6",
			cy: "18",
			fill: "currentColor",
			r: "3"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "18",
			cy: "16",
			fill: "currentColor",
			r: "3"
		})
	]
}), PS = ({ className: e = "sp-text-[#737373]", size: t = 12 }) => /* @__PURE__ */ _(hS, {
	className: e,
	size: t,
	children: [
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "12",
			r: "9",
			stroke: "currentColor",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ g("path", {
			d: "M12 10.5v6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "7.75",
			fill: "currentColor",
			r: "1.15"
		})
	]
}), FS = (e) => Math.max(34, 14 * (1 + Math.max(0, e))), IS = (e) => 11 + FS(e) + 12, LS = 12.391, RS = 85.609, zS = 42.609, BS = ({ actionsTop: e, caption: t, captionExpanded: n, captionTop: r, firstComment: i, firstCommentExpanded: a, hasCaption: o, username: s }) => {
	let c = o ? Vy({
		charsPerLine: 52,
		collapsedLines: 4,
		expanded: n,
		leadingText: s,
		lineHeight: 16,
		text: t
	}) : 0, l = i ? Vy({
		charsPerLine: 52,
		collapsedLines: 1,
		expanded: a,
		leadingText: s,
		lineHeight: 16,
		text: i
	}) : 0;
	if (!c && !l) return e + 27 + 16;
	let u = c && l ? 11 : 0;
	return r + c + l + u + 33;
}, VS = ({ caption: e, charsPerLine: t, collapsedLines: n, leadingText: r }) => {
	let i = e.trim();
	if (!i) return "";
	let a = r ? Array.from(r).length + 1 : 0, o = i.split(/\r\n?|\n/).map((e, n) => {
		let r = Array.from(e);
		return {
			characters: r,
			lines: Math.max(1, Math.ceil(((n === 0 ? a : 0) + r.length) / t))
		};
	});
	if (o.reduce((e, { lines: t }) => e + t, 0) <= n) return i;
	let s = [], c = 0;
	for (let [e, { characters: r, lines: i }] of o.entries()) {
		let o = n - c;
		if (i < o) {
			s.push(r.join("")), c += i;
			continue;
		}
		let l = o * t - (e === 0 ? a : 0) - 9;
		s.push(r.slice(0, Math.max(0, l)).join("").trimEnd());
		break;
	}
	return s.join("\n").trimEnd();
}, HS = (e, t) => {
	let n = Math.min(e, 5), r = Math.max(0, e - n), i = Math.min(Math.max(0, t - 2), r);
	return Array.from({ length: n }, (e, t) => i + t);
}, US = ({ accessibilityLabel: e, caption: t, charsPerLine: n, collapsedLines: r, dataSlot: i, expanded: a, onExpandedChange: o, targetPlatform: s, textClassName: c, trackEvent: l, username: d, copyable: f = !0 }) => {
	let p = u(), m = VS({
		caption: t,
		charsPerLine: n,
		collapsedLines: r,
		leadingText: d
	}), h = m !== t.trim(), v = t.replace(/\r\n?/g, "\n");
	return h ? /* @__PURE__ */ _("div", {
		className: [
			c,
			"sp-break-words",
			a ? void 0 : "sp-overflow-hidden"
		].filter(Boolean).join(" "),
		"data-uplift-instagram-text": i,
		id: p,
		children: [
			d ? /* @__PURE__ */ g("span", {
				className: "sp-mr-1 sp-font-semibold",
				children: d
			}) : null,
			f ? /* @__PURE__ */ g(em, {
				caption: t,
				displayedCaption: a ? v : m,
				targetPlatform: s,
				trackEvent: l
			}) : /* @__PURE__ */ g(Gp, {
				caption: a ? v : m,
				targetPlatform: s,
				trackEvent: l
			}),
			a ? null : /* @__PURE__ */ g("span", {
				"aria-hidden": "true",
				className: "sp-ml-0.5",
				children: "…"
			}),
			/* @__PURE__ */ g("button", {
				"aria-controls": p,
				"data-uplift-caption-affordance": "true",
				"aria-expanded": a,
				"aria-label": a ? `Collapse ${e ?? "caption"}` : `Show full ${e ?? "caption"}`,
				className: ["sp-ml-1 sp-inline sp-cursor-pointer sp-border-0 sp-bg-transparent sp-p-0 sp-font-semibold sp-text-inherit", a ? "sp-underline sp-underline-offset-2" : void 0].filter(Boolean).join(" "),
				onClick: (e) => {
					e.stopPropagation(), o(!a);
				},
				type: "button",
				children: a ? "less" : "more"
			})
		]
	}) : /* @__PURE__ */ _("div", {
		className: c,
		"data-uplift-instagram-text": i,
		children: [d ? /* @__PURE__ */ g("span", {
			className: "sp-mr-1 sp-font-semibold",
			children: d
		}) : null, f ? /* @__PURE__ */ g(em, {
			caption: t,
			displayedCaption: v,
			targetPlatform: s,
			trackEvent: l
		}) : /* @__PURE__ */ g(Gp, {
			caption: v,
			targetPlatform: s,
			trackEvent: l
		})]
	});
}, WS = ({ media: e, backgroundColor: t, className: n, coverScope: r = "singlePostOnly", customVideoControls: i, isActive: a, mediaCount: o, mediaIndex: s, measureWhenInactive: c, onIntrinsicDimensions: l, surface: u = "feed", videoCoverPreview: d, videoScrubberClassName: f }) => /* @__PURE__ */ g(zb, {
	backgroundColor: t,
	className: n,
	coverScope: r,
	customVideoControls: i,
	isActive: a,
	media: e,
	mediaCount: o,
	mediaIndex: s,
	measureWhenInactive: c,
	onIntrinsicDimensions: l,
	platform: "IG",
	surface: u,
	videoCoverPreview: d,
	videoScrubberClassName: f
}), GS = ({ children: e, expanded: t, kind: n = "user", onClick: r, style: i }) => /* @__PURE__ */ g("button", {
	"aria-expanded": t,
	"aria-label": `${t ? "Hide" : "Show"} ${n === "product" ? "product" : "user"} tags`,
	"data-uplift-instagram-tag-button": n,
	"data-uplift-instagram-user-tag-button": "true",
	className: "sp-absolute sp-left-[10px] sp-z-20 sp-flex sp-h-7 sp-w-7 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-[rgba(38,38,38,0.64)] sp-p-0 sp-text-white sp-shadow-[0_1px_2px_rgba(0,0,0,0.16)] sp-transition-[background-color,transform] sp-duration-150 hover:sp-bg-[rgba(38,38,38,0.76)] active:sp-scale-95 focus-visible:sp-outline focus-visible:sp-outline-2 focus-visible:sp-outline-offset-2 focus-visible:sp-outline-white",
	onClick: r,
	style: i,
	type: "button",
	children: e
}), KS = ({ tags: e }) => /* @__PURE__ */ g("div", {
	className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-0 sp-z-10 sp-flex sp-flex-wrap sp-gap-1.5 sp-p-3",
	"data-uplift-instagram-user-tags": !0,
	"data-uplift-instagram-tags-unpositioned": "true",
	children: e.map((e) => /* @__PURE__ */ g("a", {
		"aria-label": `View ${e.value} on Instagram`,
		className: "sp-pointer-events-auto sp-block sp-max-w-[220px] sp-truncate sp-whitespace-nowrap sp-rounded-lg sp-bg-[rgba(38,38,38,0.72)] sp-px-3 sp-py-[9px] sp-text-sm sp-font-semibold sp-leading-4 sp-text-white sp-no-underline sp-shadow-[0_1px_2px_rgba(0,0,0,0.14)] hover:sp-bg-[rgba(38,38,38,0.82)]",
		"data-uplift-instagram-user-tag": e.value,
		href: `https://instagram.com/${encodeURIComponent(e.value)}`,
		onClick: (e) => e.stopPropagation(),
		rel: "noreferrer",
		target: "_blank",
		children: e.value
	}, e.value))
}), qS = ({ tags: e }) => /* @__PURE__ */ g("div", {
	className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-z-10 sp-overflow-hidden",
	"data-uplift-instagram-user-tags": !0,
	children: e.map((e) => /* @__PURE__ */ _("div", {
		className: "sp-pointer-events-auto sp-absolute sp-flex -sp-translate-x-1/2 -sp-translate-y-full sp-flex-col sp-items-center sp-pb-[6px]",
		"data-uplift-instagram-user-tag": e.value,
		onClick: (e) => e.stopPropagation(),
		style: {
			left: `${e.x}%`,
			top: `${e.y}%`
		},
		children: [/* @__PURE__ */ g("a", {
			"aria-label": `View ${e.value} on Instagram`,
			className: "sp-block sp-max-w-[220px] sp-truncate sp-whitespace-nowrap sp-rounded-lg sp-bg-[rgba(38,38,38,0.72)] sp-px-3 sp-py-[9px] sp-text-sm sp-font-semibold sp-leading-4 sp-text-white sp-no-underline sp-shadow-[0_1px_2px_rgba(0,0,0,0.14)] hover:sp-bg-[rgba(38,38,38,0.82)]",
			href: `https://instagram.com/${encodeURIComponent(e.value)}`,
			rel: "noreferrer",
			target: "_blank",
			children: e.value
		}), /* @__PURE__ */ g("span", {
			"aria-hidden": "true",
			className: "sp-absolute sp-bottom-0 sp-left-1/2 sp-h-0 sp-w-0 -sp-translate-x-1/2 sp-border-x-[6px] sp-border-b-0 sp-border-t-[6px] sp-border-solid sp-border-x-transparent sp-border-t-[rgba(38,38,38,0.72)]",
			"data-uplift-instagram-user-tag-pointer": !0
		})]
	}, `${e.value}-${e.x}-${e.y}`))
}), JS = ({ positioned: e, tags: t }) => e ? /* @__PURE__ */ g("div", {
	className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-z-10 sp-overflow-hidden",
	"data-uplift-instagram-product-tags": !0,
	children: t.map((e) => /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-flex -sp-translate-x-1/2 -sp-translate-y-full sp-flex-col sp-items-center sp-pb-[6px]",
		"data-uplift-instagram-product-tag": e.label,
		style: {
			left: `${e.x}%`,
			top: `${e.y}%`
		},
		children: [/* @__PURE__ */ g("span", {
			className: "sp-block sp-max-w-[220px] sp-truncate sp-whitespace-nowrap sp-rounded-lg sp-bg-[rgba(38,38,38,0.72)] sp-px-3 sp-py-[9px] sp-text-sm sp-font-semibold sp-leading-4 sp-text-white sp-shadow-[0_1px_2px_rgba(0,0,0,0.14)]",
			children: e.label
		}), /* @__PURE__ */ g("span", {
			"aria-hidden": "true",
			className: "sp-absolute sp-bottom-0 sp-left-1/2 sp-h-0 sp-w-0 -sp-translate-x-1/2 sp-border-x-[6px] sp-border-b-0 sp-border-t-[6px] sp-border-solid sp-border-x-transparent sp-border-t-[rgba(38,38,38,0.72)]"
		})]
	}, `${e.label}-${e.x}-${e.y}`))
}) : /* @__PURE__ */ g("div", {
	className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-0 sp-z-10 sp-flex sp-flex-wrap sp-gap-1.5 sp-p-3",
	"data-uplift-instagram-product-tags": !0,
	"data-uplift-instagram-tags-unpositioned": "true",
	children: t.map((e) => /* @__PURE__ */ g("span", {
		className: "sp-block sp-max-w-[220px] sp-truncate sp-whitespace-nowrap sp-rounded-lg sp-bg-[rgba(38,38,38,0.72)] sp-px-3 sp-py-[9px] sp-text-sm sp-font-semibold sp-leading-4 sp-text-white sp-shadow-[0_1px_2px_rgba(0,0,0,0.14)]",
		"data-uplift-instagram-product-tag": e.label,
		children: e.label
	}, e.label))
}), YS = (e) => e === "story", XS = (e, t) => !t || YS(e), ZS = (e, t) => !YS(e) && !t, QS = /* @__PURE__ */ new Set(["image", "multiMedia"]), $S = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"reel",
	"story",
	"video"
]), eC = (e) => typeof e == "object" && !!e, tC = (e) => Array.isArray(e) && e.some((e) => eC(e) && typeof e.value == "string" && e.value.trim().length > 0), nC = (e) => fS(e.tags).length > 0 || tC(e.productTags), rC = (e, t) => t.some(nC) ? t.map((e) => ({
	productTags: e.productTags,
	tags: e.tags
})) : t.map((t, n) => n === 0 ? {
	productTags: e.productTags,
	tags: e.tags
} : {
	productTags: [],
	tags: []
}), iC = (e) => e.medias.collection.length > 0 ? e.medias.collection : [{
	isVideo: !1,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}], aC = (e) => e.type === "video" || e.type === "reel" || e.type === "story" && e.storyType === "reel", oC = (e) => e.type === "story" && e.storyType === "igtv", sC = ({ instagramPublishingChrome: e = !0, post: t, className: n, trackEvent: r, videoCoverPreview: i }) => {
	let a = rC(t, iC(t)), o = a.map((e) => mS(e.productTags)), s = a.map((e) => fS(e.tags)), c = s.some((e) => e.length > 0);
	return /* @__PURE__ */ g(cC, {
		className: n,
		instagramPublishingChrome: e,
		post: t,
		slideProductTags: o,
		slideUserTags: s,
		trackEvent: r,
		videoCoverPreview: i
	}, `${t.id}:${c}`);
}, cC = ({ instagramPublishingChrome: e = !0, post: t, className: n, slideProductTags: r, slideUserTags: i, trackEvent: a, videoCoverPreview: o }) => {
	let { medias: s, reportIntrinsicDimensions: c } = Vb(iC(t)), l = s.length > 1, u = $b(t.caption), f = t.comment.trim(), v = e && t.instagram?.isAiGenerated === !0, [y, b] = m(0), [x, S] = m(!1), [C, w] = m(!1), [T, E] = m(!1), [D, O] = m(!1), k = p(null), A = p(null), j = Math.min(y, Math.max(0, s.length - 1)), M = kb({
		media: s[0],
		platform: "IG",
		surface: l ? "carousel" : "feed",
		width: 400
	}), N = lC(t, e), P = FS(N), ee = IS(N), F = ee + M.height, te = F + LS, ne = te + 11, I = te + 40, L = BS({
		actionsTop: te,
		caption: t.caption,
		captionExpanded: x,
		captionTop: I,
		firstComment: f,
		firstCommentExpanded: C,
		hasCaption: u,
		username: t.username
	}), R = F - RS, z = F - zS, B = HS(s.length, j), V = i[j] ?? [], H = V.length > 0, re = XS(l ? "carousel" : "feed", s[j]?.isVideo === !0), ie = r[j] ?? [], ae = ie.length > 0, oe = ZS(l ? "carousel" : "feed", s[j]?.isVideo === !0) && ie.every((e) => typeof e.x == "number" && typeof e.y == "number");
	return d(() => {
		let e = k.current, t = A.current;
		if (!e || !t) return;
		let n = () => {
			let n = t.getBoundingClientRect().height || t.scrollHeight;
			n <= 0 || (e.style.height = `${I + n + 33}px`);
		};
		if (n(), typeof ResizeObserver > "u") return;
		let r = new ResizeObserver(n);
		return r.observe(t), () => r.disconnect();
	}, [
		x,
		I,
		f,
		C,
		t.caption,
		t.username,
		v
	]), /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-text-sm sp-leading-4 sp-shadow-none", n].filter(Boolean).join(" "),
		platform: "IG",
		children: /* @__PURE__ */ _("article", {
			ref: k,
			className: "sp-relative sp-w-full",
			"data-uplift-renderer": "instagram",
			"data-uplift-layout": "instagram-feed",
			style: { height: L },
			children: [
				/* @__PURE__ */ _("header", {
					className: "sp-absolute sp-left-[10px] sp-top-[11px] sp-flex sp-w-[380px] sp-items-center sp-justify-between",
					style: { height: P },
					children: [/* @__PURE__ */ g(fC, {
						post: t,
						showAudio: e
					}), /* @__PURE__ */ g(SS, { className: "sp-text-black" })]
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-[#f2f2f2]",
					"data-uplift-media-frame-ratio": M.publishedRatio,
					onClick: () => {
						E(!1), O(!1);
					},
					style: {
						height: M.height,
						top: ee
					},
					children: [
						l ? /* @__PURE__ */ g($y, {
							ariaLabel: "Instagram feed carousel",
							arrowClassName: "sp-z-20",
							countClassName: "sp-right-[10px] sp-top-[9px]",
							medias: s,
							onIndexChange: (e) => {
								b(e), E(!1), O(!1);
							},
							renderSlide: (e, { index: t, isActive: n }) => /* @__PURE__ */ g(WS, {
								className: "sp-h-full",
								coverScope: "none",
								isActive: n,
								media: e,
								mediaCount: s.length,
								mediaIndex: t,
								measureWhenInactive: t === 0,
								onIntrinsicDimensions: c,
								surface: "carousel"
							}),
							showDots: !1,
							showCount: !1
						}) : s[0] && /* @__PURE__ */ g(WS, {
							media: s[0],
							videoCoverPreview: o,
							className: "sp-h-full",
							onIntrinsicDimensions: c
						}),
						H && T && g(re ? qS : KS, { tags: V }),
						ae && D && /* @__PURE__ */ g(JS, {
							positioned: oe,
							tags: ie
						})
					]
				}),
				ae && /* @__PURE__ */ g(GS, {
					expanded: D,
					kind: "product",
					onClick: () => O((e) => !e),
					style: { top: H ? R : z },
					children: /* @__PURE__ */ g(TS, {})
				}),
				H && /* @__PURE__ */ g(GS, {
					expanded: T,
					onClick: () => E((e) => !e),
					style: { top: z },
					children: /* @__PURE__ */ g(ES, {})
				}),
				l && /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[354px] sp-top-[66px] sp-flex sp-h-[27px] sp-w-9 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-text-sm sp-leading-none sp-text-white",
					children: [
						j + 1,
						"/",
						s.length
					]
				}), /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-inset-x-0 sp-flex sp-h-[7px] sp-items-center sp-justify-center sp-gap-1",
					"data-uplift-instagram-dots": "true",
					style: { top: ne },
					children: B.map((e) => /* @__PURE__ */ g("span", { className: ["sp-block sp-rounded-full", e === j ? "sp-h-[6px] sp-w-[6px] sp-bg-[#0095f6]" : "sp-h-[5px] sp-w-[5px] sp-bg-[#d9d9d9]"].join(" ") }, e))
				})] }),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[10px] sp-flex sp-h-[27px] sp-w-[380px] sp-items-center sp-justify-between",
					"data-uplift-instagram-actions": "true",
					style: { top: te },
					children: [/* @__PURE__ */ _("div", {
						className: "sp-flex sp-items-center sp-gap-3",
						children: [
							/* @__PURE__ */ g(gS, {}),
							/* @__PURE__ */ g(vS, {}),
							/* @__PURE__ */ g(yS, {})
						]
					}), /* @__PURE__ */ g(xS, {})]
				}),
				(u || f || v) && /* @__PURE__ */ _("div", {
					ref: A,
					className: "sp-absolute sp-left-[10px] sp-flex sp-w-[380px] sp-flex-col sp-gap-[11px]",
					"data-uplift-caption-stack": "instagram-feed",
					style: { top: I },
					children: [
						v && /* @__PURE__ */ g(dC, {}),
						u && /* @__PURE__ */ g(US, {
							caption: t.caption,
							charsPerLine: 52,
							collapsedLines: 4,
							dataSlot: "feed-caption",
							expanded: x,
							onExpandedChange: S,
							textClassName: "sp-text-sm sp-leading-4",
							targetPlatform: "IG",
							trackEvent: a,
							username: t.username
						}),
						f && /* @__PURE__ */ g(US, {
							accessibilityLabel: "first comment",
							caption: f,
							charsPerLine: 52,
							collapsedLines: 1,
							dataSlot: "feed-first-comment",
							expanded: C,
							copyable: !1,
							onExpandedChange: w,
							targetPlatform: "IG",
							textClassName: "sp-text-sm sp-leading-4",
							trackEvent: a,
							username: t.username
						})
					]
				})
			]
		})
	});
}, lC = (e, t) => +!!e.locationName?.trim() + (t && iC(e).some((e) => e.isVideo) ? 1 : 0), uC = ({ post: e, showAudio: t = !0 }) => {
	let n = e.locationName?.trim(), r = t && iC(e).some((e) => e.isVideo) ? Zb({
		instagram: e.instagram,
		username: e.username
	}) : null;
	return !n && !r ? null : /* @__PURE__ */ _(h, { children: [n && /* @__PURE__ */ g("div", {
		className: "sp-truncate sp-text-[13px] sp-font-normal sp-leading-[14px] sp-text-[#262626]",
		"data-uplift-instagram-location": "true",
		title: n,
		children: n
	}), r && /* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1 sp-text-[13px] sp-font-normal sp-leading-[14px] sp-text-[#262626]",
		"data-uplift-instagram-audio": r.hasTrack ? "track" : "original",
		title: r.text,
		children: [/* @__PURE__ */ g(NS, {
			className: "sp-shrink-0 sp-text-[#262626]",
			size: 11
		}), /* @__PURE__ */ g("span", {
			className: "sp-truncate",
			children: r.text
		})]
	})] });
}, dC = () => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-gap-1 sp-text-[12px] sp-leading-[14px] sp-text-[#737373]",
	"data-uplift-instagram-ai-label": "true",
	children: [/* @__PURE__ */ g(PS, {
		className: "sp-shrink-0 sp-text-[#737373]",
		size: 12
	}), /* @__PURE__ */ g("span", { children: "Made with AI" })]
}), fC = ({ post: e, showAudio: t = !0 }) => {
	let n = (e.collaboratingIgUsers ?? []).filter((t) => t.username !== e.username);
	if (n.length === 0) return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ g(Yy, {
			className: "sp-h-[34px] sp-w-[34px]",
			src: e.profilePicture,
			alt: e.username
		}), /* @__PURE__ */ _("div", {
			className: "sp-min-w-0 sp-max-w-[320px]",
			children: [/* @__PURE__ */ g(Zy, {
				className: "sp-text-sm sp-leading-[14px]",
				children: e.username
			}), /* @__PURE__ */ g(uC, {
				post: e,
				showAudio: t
			})]
		})]
	});
	let r = n.length === 1 ? n[0]?.username : `${n.length} others`;
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-[34px] sp-w-[34px] sp-shrink-0",
			children: [/* @__PURE__ */ g(Yy, {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-z-10 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white",
				src: e.profilePicture,
				alt: e.username
			}), /* @__PURE__ */ g(Yy, {
				className: "sp-absolute sp-right-0 sp-top-0 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white",
				src: n[0]?.profilePictureUrl,
				alt: n[0]?.username ?? ""
			})]
		}), /* @__PURE__ */ _("div", {
			className: "sp-min-w-0 sp-max-w-[320px] sp-text-black",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-whitespace-nowrap sp-text-sm sp-leading-4",
				children: [/* @__PURE__ */ g("span", {
					className: "sp-font-semibold",
					children: e.username
				}), r ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g("span", { children: " and " }), /* @__PURE__ */ g("span", {
					className: "sp-font-semibold",
					children: r
				})] }) : null]
			}), /* @__PURE__ */ g(uC, {
				post: e,
				showAudio: t
			})]
		})]
	});
}, pC = ({ artworkUrl: e, avatarUrl: t }) => {
	let n = [e, t].filter(Boolean), r = n.join("|"), [i, a] = m({
		signature: r,
		count: 0
	}), o = i.signature === r ? i.count : 0;
	i.signature !== r && a({
		signature: r,
		count: 0
	});
	let s = n[o];
	return /* @__PURE__ */ g("div", {
		className: "sp-flex sp-h-[29px] sp-w-[29px] sp-items-center sp-justify-center sp-overflow-hidden sp-rounded-[6px] sp-border sp-border-solid sp-border-white/40 sp-bg-neutral-800",
		"data-uplift-instagram-audio-disc": s ? "artwork" : "glyph",
		children: s ? /* @__PURE__ */ g("img", {
			alt: "",
			className: "sp-h-full sp-w-full sp-animate-[spin_6s_linear_infinite] sp-object-cover motion-reduce:sp-animate-none",
			onError: () => a((e) => ({
				signature: r,
				count: e.count + 1
			})),
			src: s
		}) : /* @__PURE__ */ g(NS, {
			className: "sp-text-white",
			size: 14
		})
	});
}, mC = ({ instagram: e, username: t }) => {
	let n = Zb({
		instagram: e,
		username: t
	});
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-shrink-0 sp-flex-col sp-gap-0.5",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2 sp-text-[13px] sp-leading-[16px] sp-text-white",
			"data-uplift-instagram-audio": n.hasTrack ? "track" : "original",
			title: n.text,
			children: [/* @__PURE__ */ g(NS, {
				className: "sp-shrink-0 sp-text-white",
				size: 12
			}), /* @__PURE__ */ g("span", {
				className: "sp-truncate",
				children: n.text
			})]
		}), /* @__PURE__ */ g("span", {
			className: "sp-text-[11px] sp-leading-[14px] sp-text-white/70",
			children: "Audio will be auto-matched after publishing"
		})]
	});
}, hC = ({ instagramPublishingChrome: e = !0, post: t, className: n, dataLayout: r = "instagram-reel", showFirstComment: i = !1, trackEvent: a, title: o = "Reels", videoCoverPreview: s }) => {
	let c = iC(t)[0], u = $b(t.caption), f = t.locationName?.trim(), h = e && t.instagram?.isAiGenerated === !0, v = i ? t.comment.trim() : "", [y, b] = m(!1), x = u && VS({
		caption: t.caption,
		charsPerLine: 42,
		collapsedLines: 1
	}) !== t.caption.trim(), S = y && x, C = p(null), [w, T] = m(!1), E = () => {
		let e = C.current;
		T(!!(e && e.scrollHeight - e.scrollTop - e.clientHeight > 1));
	};
	d(E, [S, t.caption]);
	let D = e ? t.instagram?.trialReel : void 0, O = e ? Xb({
		instagram: t.instagram,
		type: t.type,
		videoPostType: t.providedPost?.videoPostType
	}) : null, k = (t.collaboratingIgUsers ?? []).filter((e) => e.username !== t.username);
	return l(() => {
		x || b(!1);
	}, [x]), /* @__PURE__ */ _(qy, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-shadow-none", n].filter(Boolean).join(" "),
		platform: "IG",
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-relative sp-h-[710px] sp-w-full sp-bg-black sp-text-white",
				"data-uplift-renderer": "instagram",
				"data-uplift-reel-caption-expanded": S ? "true" : "false",
				"data-uplift-layout": r,
				"data-uplift-media-frame-ratio": "9 / 16",
				children: [
					c && /* @__PURE__ */ g(WS, {
						backgroundColor: "#000",
						media: c,
						videoCoverPreview: s,
						className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[710px]",
						customVideoControls: !0,
						surface: "reel",
						videoScrubberClassName: "sp-bottom-[52px]"
					}),
					/* @__PURE__ */ g("div", { className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[254px] sp-bg-gradient-to-b sp-from-black/40 sp-to-transparent" }),
					/* @__PURE__ */ g("div", { className: "sp-absolute sp-inset-x-0 sp-top-[404px] sp-h-[254px] sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent" }),
					S && /* @__PURE__ */ g("div", {
						className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-bg-black/70",
						"data-uplift-caption-backdrop": "true"
					}),
					/* @__PURE__ */ _("header", {
						className: "sp-absolute sp-left-5 sp-right-5 sp-top-9 sp-flex sp-items-center sp-justify-between",
						children: [
							/* @__PURE__ */ g(DS, {}),
							/* @__PURE__ */ _("div", {
								className: "sp-flex sp-flex-col sp-items-center sp-gap-1",
								children: [/* @__PURE__ */ g("div", {
									className: "sp-text-lg sp-font-bold sp-leading-none sp-tracking-normal",
									children: o
								}), D && /* @__PURE__ */ g("div", {
									className: "sp-rounded-full sp-bg-white/20 sp-px-2 sp-py-[2px] sp-text-[11px] sp-font-medium sp-leading-[14px] sp-text-white",
									"data-uplift-instagram-trial-reel": D.graduationStrategy,
									children: "Trial reel"
								})]
							}),
							/* @__PURE__ */ g(OS, {})
						]
					}),
					/* @__PURE__ */ _("div", {
						className: "sp-absolute sp-right-5 sp-top-[344px] sp-flex sp-flex-col sp-gap-7",
						children: [
							/* @__PURE__ */ g(gS, { className: "sp-text-white" }),
							/* @__PURE__ */ g(vS, { className: "sp-text-white" }),
							/* @__PURE__ */ g(yS, { className: "sp-text-white" }),
							/* @__PURE__ */ g(SS, { className: "sp-text-white" }),
							e && /* @__PURE__ */ g(pC, {
								artworkUrl: t.instagram?.audioMeta?.artworkUrl,
								avatarUrl: t.profilePicture
							})
						]
					}),
					/* @__PURE__ */ _("div", {
						className: "sp-absolute sp-bottom-[72px] sp-left-[19px] sp-right-16 sp-flex sp-max-h-[566px] sp-flex-col sp-gap-3 sp-overflow-hidden",
						"data-uplift-reel-info": "true",
						children: [
							/* @__PURE__ */ _("div", {
								className: "sp-flex sp-shrink-0 sp-items-center sp-gap-3",
								children: [
									/* @__PURE__ */ g(Yy, {
										className: "sp-h-[34px] sp-w-[34px]",
										src: t.profilePicture,
										alt: t.username
									}),
									/* @__PURE__ */ g("span", {
										className: "sp-min-w-0 sp-truncate sp-text-[15px] sp-font-semibold sp-leading-none",
										children: k.length === 0 ? t.username : k.length === 1 ? `${t.username} and ${k[0].username}` : `${t.username} and ${k.length} others`
									}),
									/* @__PURE__ */ g("span", {
										className: "sp-cursor-default sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white",
										"data-uplift-instagram-follow": "true",
										children: "Follow"
									})
								]
							}),
							f && /* @__PURE__ */ g("div", {
								className: "sp-shrink-0 sp-truncate sp-text-[13px] sp-font-normal sp-leading-[14px] sp-text-white/90",
								"data-uplift-instagram-location": "true",
								title: f,
								children: f
							}),
							h && /* @__PURE__ */ _("div", {
								className: "sp-flex sp-shrink-0 sp-items-center sp-gap-1 sp-text-[12px] sp-leading-[14px] sp-text-white/80",
								"data-uplift-instagram-ai-label": "true",
								children: [/* @__PURE__ */ g(PS, {
									className: "sp-shrink-0 sp-text-white/80",
									size: 12
								}), /* @__PURE__ */ g("span", { children: "Made with AI" })]
							}),
							u && /* @__PURE__ */ g("div", {
								className: "sp-min-h-0 sp-overflow-y-auto",
								"data-uplift-reel-caption-more-below": w ? "true" : "false",
								"data-uplift-reel-caption-scroll": "true",
								onScroll: E,
								ref: C,
								children: /* @__PURE__ */ g(US, {
									caption: t.caption,
									charsPerLine: 42,
									collapsedLines: 1,
									dataSlot: "reel-caption",
									expanded: S,
									onExpandedChange: b,
									textClassName: "sp-whitespace-pre-line sp-text-[15px] sp-leading-[18px] sp-text-white [&_*]:sp-inline",
									targetPlatform: "IG",
									trackEvent: a
								})
							}),
							e && /* @__PURE__ */ g(mC, {
								instagram: t.instagram,
								username: t.username
							})
						]
					}),
					/* @__PURE__ */ _("footer", {
						className: "sp-absolute sp-inset-x-0 sp-bottom-0 sp-flex sp-h-[52px] sp-items-center sp-justify-around sp-bg-black sp-px-6",
						children: [
							/* @__PURE__ */ g(kS, {}),
							/* @__PURE__ */ g(AS, {}),
							/* @__PURE__ */ g(jS, {}),
							/* @__PURE__ */ g(MS, {}),
							/* @__PURE__ */ g(Yy, {
								className: "sp-h-[22px] sp-w-[22px]",
								src: t.profilePicture,
								alt: t.username
							})
						]
					})
				]
			}),
			O === !1 && /* @__PURE__ */ g("div", {
				className: "sp-box-border sp-w-full sp-bg-white sp-px-[10px] sp-pt-[14px] sp-text-[13px] sp-leading-[16px] sp-text-[#737373]",
				"data-uplift-instagram-placement": "reels-only",
				children: "Reels tab only, not in the grid"
			}),
			v && /* @__PURE__ */ _("div", {
				className: "sp-box-border sp-w-full sp-break-words sp-bg-white sp-px-[10px] sp-py-[14px] sp-text-sm sp-leading-[17px] sp-text-black",
				"data-uplift-first-comment": "instagram-reel",
				children: [/* @__PURE__ */ g("span", {
					className: "sp-mr-1 sp-font-semibold",
					children: t.username
				}), /* @__PURE__ */ g(Gp, {
					caption: v,
					targetPlatform: "IG",
					trackEvent: a
				})]
			})
		]
	});
}, gC = "sp-bottom-[64px]", _C = ({ instagramPublishingChrome: e = !0, post: t, className: n, videoCoverPreview: r }) => {
	let i = iC(t), a = i[0], o = Gm(t.storyStickerHeight), [s, c] = m(0), l = Math.min(s, Math.max(0, i.length - 1)), u = e ? fS(rC(t, i)[l]?.tags) : [], d = e && t.instagram?.isAiGenerated === !0, f = e ? i : i.slice(0, 1);
	return /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", n].filter(Boolean).join(" "),
		platform: "IG",
		children: /* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-ig-story-frame": !0,
			"data-uplift-renderer": "instagram",
			"data-uplift-layout": "instagram-story",
			"data-uplift-media-frame-ratio": "9 / 16",
			children: [
				i.length > 1 ? /* @__PURE__ */ g($y, {
					ariaLabel: "Instagram story carousel",
					className: "sp-absolute sp-inset-0",
					countClassName: "sp-right-5 sp-top-[76px]",
					dotClassName: "sp-left-1/2 sp-top-3 -sp-translate-x-1/2",
					medias: i,
					onIndexChange: c,
					renderSlide: (e, { index: t, isActive: n }) => /* @__PURE__ */ g(WS, {
						className: "sp-absolute sp-inset-0 sp-h-full",
						coverScope: "firstVideoOnly",
						isActive: n,
						media: e,
						mediaCount: i.length,
						mediaIndex: Eb(i, t),
						surface: "story",
						videoCoverPreview: r,
						videoScrubberClassName: gC
					}),
					showDots: !1
				}) : a && /* @__PURE__ */ g(WS, {
					media: a,
					videoCoverPreview: r,
					className: "sp-absolute sp-inset-0 sp-h-full",
					surface: "story",
					videoScrubberClassName: gC
				}),
				/* @__PURE__ */ g("div", { className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-0 sp-h-[160px] sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent" }),
				/* @__PURE__ */ g("div", {
					className: "sp-absolute sp-left-[11px] sp-top-[9px] sp-flex sp-w-[378px] sp-gap-1",
					"data-uplift-instagram-story-progress": f.length,
					children: f.map((e, t) => /* @__PURE__ */ g("span", {
						className: ["sp-block sp-h-0.5 sp-flex-1 sp-rounded-full", t <= l ? "sp-bg-white" : "sp-bg-white/30"].join(" "),
						"data-uplift-instagram-story-segment": t === l ? "active" : "inactive"
					}, `story-segment-${t}`))
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-6 sp-right-[11px] sp-top-7 sp-flex sp-items-center sp-justify-between",
					children: [/* @__PURE__ */ _("div", {
						className: "sp-flex sp-items-center sp-gap-3.5",
						children: [/* @__PURE__ */ g(Yy, {
							className: "sp-h-[34px] sp-w-[34px]",
							src: t.profilePicture,
							alt: t.username
						}), /* @__PURE__ */ g("span", {
							className: "sp-text-[15px] sp-font-semibold sp-leading-none",
							children: t.username
						})]
					}), /* @__PURE__ */ _("div", {
						className: "sp-flex sp-items-center sp-gap-5",
						children: [/* @__PURE__ */ g(SS, { className: "sp-text-white" }), /* @__PURE__ */ g(CS, {})]
					})]
				}),
				t.storyUrl && /* @__PURE__ */ _("a", {
					className: "sp-absolute sp-left-1/2 sp-box-border sp-flex sp-h-11 sp-w-fit sp-min-w-0 -sp-translate-x-1/2 sp-items-center sp-justify-center sp-gap-2.5 sp-rounded-[5.666px] sp-bg-white sp-px-[13px] sp-text-center sp-text-[26.761px] sp-font-bold sp-uppercase sp-leading-[1.2] sp-text-[#436ce1] sp-no-underline sp-shadow-[2px_3px_9px_rgba(0,0,0,0.2)]",
					"data-ig-story-link-sticker": !0,
					"data-story-sticker-label-length": (t.storyLabel || "View products").length,
					"data-story-sticker-height": t.storyStickerHeight ?? .8,
					href: t.storyUrl,
					rel: "noreferrer",
					style: {
						maxWidth: "calc(100% - 32px)",
						top: o
					},
					target: "_blank",
					children: [/* @__PURE__ */ g("span", {
						className: "sp-flex sp-shrink-0",
						children: /* @__PURE__ */ g(wS, {})
					}), /* @__PURE__ */ g("span", {
						className: "sp-min-w-0 sp-truncate",
						children: t.storyLabel || "View products"
					})]
				}),
				u.length > 0 && /* @__PURE__ */ g("div", {
					className: "sp-pointer-events-none sp-absolute sp-inset-0",
					"data-uplift-instagram-story-tags": u.length,
					children: u.map((e) => /* @__PURE__ */ _("span", {
						className: "sp-absolute -sp-translate-x-1/2 -sp-translate-y-1/2 sp-rounded-[4px] sp-bg-black/60 sp-px-2 sp-py-1 sp-text-[13px] sp-font-semibold sp-leading-none sp-text-white",
						"data-uplift-instagram-story-tag": e.value,
						style: {
							left: `${e.x}%`,
							top: `${e.y}%`
						},
						children: ["@", e.value]
					}, e.value))
				}),
				d && /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-left-6 sp-top-[70px]",
					children: /* @__PURE__ */ g(dC, {})
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[17px] sp-top-[656px] sp-flex sp-items-center sp-gap-5 sp-opacity-80",
					children: [
						/* @__PURE__ */ g("div", {
							className: "sp-box-border sp-flex sp-h-[47px] sp-w-[276px] sp-items-center sp-rounded-full sp-border-[1.5px] sp-border-solid sp-border-white sp-pl-[22px] sp-pr-5 sp-text-lg sp-leading-none",
							children: "Send Message"
						}),
						/* @__PURE__ */ g(_S, {}),
						/* @__PURE__ */ g(bS, {})
					]
				})
			]
		})
	});
}, vC = (e) => e.platform === "IG" && $S.has(e.type), yC = ({ instagramPublishingChrome: e = !0, post: t, className: n, trackEvent: r, videoCoverPreview: i }) => aC(t) ? /* @__PURE__ */ g(hC, {
	instagramPublishingChrome: e,
	post: t,
	className: n,
	showFirstComment: !0,
	trackEvent: r,
	videoCoverPreview: i
}) : oC(t) ? /* @__PURE__ */ g(hC, {
	instagramPublishingChrome: e,
	dataLayout: "instagram-igtv",
	post: t,
	className: n,
	trackEvent: r,
	title: "Video",
	videoCoverPreview: i
}) : t.type === "story" ? /* @__PURE__ */ g(_C, {
	instagramPublishingChrome: e,
	post: t,
	className: n,
	videoCoverPreview: i
}) : QS.has(t.type) ? /* @__PURE__ */ g(sC, {
	instagramPublishingChrome: e,
	post: t,
	className: n,
	trackEvent: r,
	videoCoverPreview: i
}) : null;
//#endregion
//#region lib/components/markup/PdfMarkupMedia.tsx
function bC({ document: e, pageNumber: t, onRendered: n }) {
	let r = p(null), i = p(n);
	i.current = n;
	let [a, o] = m(!1), [s, c] = m();
	return l(() => {
		let n = !1, a;
		return o(!1), e.getPage(t).then(async (e) => {
			let o = r.current;
			if (n || !o) return;
			let s = o.ownerDocument.createElement("canvas"), l = e.getViewport({ scale: 1 }), u = e.getViewport({ scale: Math.min(2, 2e3 / Math.max(l.width, l.height)) });
			s.width = Math.ceil(u.width), s.height = Math.ceil(u.height), a = e.render({
				canvas: s,
				canvasContext: s.getContext("2d"),
				viewport: u
			});
			try {
				if (await a.promise, n) return;
				o.width = s.width, o.height = s.height, o.getContext("2d").drawImage(s, 0, 0), c(t), i.current(s.width, s.height);
			} finally {
				e.cleanup();
			}
		}).catch(() => {
			n || o(!0);
		}), () => {
			n = !0, a?.cancel();
		};
	}, [e, t]), /* @__PURE__ */ _("div", {
		className: "relative size-full",
		"aria-busy": !a && s !== t,
		children: [/* @__PURE__ */ g("canvas", {
			ref: r,
			role: "img",
			"aria-label": `PDF page ${s ?? t}`,
			className: "block size-full object-contain"
		}), a && /* @__PURE__ */ _("div", {
			role: "alert",
			className: "absolute inset-0 grid place-items-center bg-neutral-800/90 p-4 text-center text-sm text-white",
			children: [
				"Unable to render page ",
				t,
				". Try another page or download the PDF."
			]
		})]
	});
}
//#endregion
//#region lib/components/markup/usePdfDocument.ts
function xC(e) {
	let [t, n] = m();
	return l(() => {
		if (n(void 0), !e) return;
		let t = !1, r;
		return import("./pdf-document-DMYk2Ygu.js").then(async ({ loadPdfDocument: i }) => {
			if (t) return;
			if (r = await i(e), t) {
				r.destroy();
				return;
			}
			let a = await r.promise;
			t || n({
				url: e,
				document: a
			});
		}).catch(() => {
			t || n({
				url: e,
				error: "Unable to open this PDF. Download the document to review it, or try again."
			});
		}), () => {
			t = !0, r?.destroy();
		};
	}, [e]), t?.url === e ? t : void 0;
}
//#endregion
//#region lib/components/markup/pdfMedia.ts
function SC(e) {
	let t = [
		e.sourceUrl,
		e.originalUrl,
		e.url
	], n = t.find((e) => /\.pdf(?:[?#]|$)/i.test(e || "")) || (e.type === "application/pdf" || e.mime === "application/pdf" || e.meta?.mime === "application/pdf" || e.isDocument || e.meta?.isDocument ? t.find(Boolean) : void 0);
	if (!n) return;
	let r = e.pages ?? e.meta?.pages;
	return {
		url: n,
		...Number.isSafeInteger(r) && r > 0 ? { pageCount: r } : {}
	};
}
//#endregion
//#region lib/components/previews/uplift/LinkedinUpliftPreview.tsx
var CC = /* @__PURE__ */ new Set([
	"document",
	"image",
	"multiMedia",
	"text",
	"video"
]), wC = 3, TC = 20, EC = 104, DC = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", OC = 12, kC = 16, AC = 20, jC = 36, MC = 620, NC = 12, PC = 20, FC = (e) => e.platform === "LI" && CC.has(e.type) && (e.type === "document" || !bw(e)), IC = ({ post: e, className: t, videoCoverPreview: n, preferVideoCoverPreviewOverride: r, trackEvent: i }) => {
	let { medias: a, reportIntrinsicDimensions: o } = Vb(pw(e)), [s, c] = m(!1), l = ZC(e, s), u = [
		e.caption,
		e.redirectUrl ?? "",
		s ? "expanded" : "collapsed"
	].join("|"), [f, h] = m(null), v = p(null), y = f?.key === u ? f.height : void 0, b = aw(e), x = uw(e, a, s, y);
	return d(() => {
		if (!s) {
			h(null);
			return;
		}
		let e = v.current;
		if (!e) return;
		let t = Math.ceil(e.scrollHeight);
		t > 0 && Math.abs(t - l) > 1 && h({
			height: t,
			key: u
		});
	}, [
		s,
		u,
		l
	]), /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-white sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "),
		platform: "LI",
		children: /* @__PURE__ */ _("article", {
			className: "sp-relative sp-w-full sp-bg-white",
			"data-uplift-layout": x.dataLayout,
			"data-uplift-renderer": "linkedin",
			style: { height: x.height },
			children: [
				/* @__PURE__ */ g(LC, { post: e }),
				x.captionHeight > 0 && /* @__PURE__ */ g(RC, {
					captionRef: v,
					expanded: s,
					height: x.captionHeight,
					onExpandedChange: c,
					post: e,
					top: x.captionTop,
					trackEvent: i
				}),
				b && x.linkRect.height > 0 && /* @__PURE__ */ g(BC, {
					rect: x.linkRect,
					url: b
				}),
				x.kind === "document" && /* @__PURE__ */ g(VC, {
					media: x.documentMedia,
					rect: x.documentRect
				}, gw(x.documentMedia)),
				x.kind === "single-media" && /* @__PURE__ */ g(zC, {
					media: a[0],
					mediaCount: a.length,
					mediaIndex: 0,
					onIntrinsicDimensions: o,
					preferVideoCoverPreviewOverride: r,
					rect: x.mediaRects[0],
					videoCoverPreview: n
				}),
				x.kind === "collage" && /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-overflow-hidden sp-bg-white",
					"data-linkedin-media-count": Math.min(a.length, 5),
					style: {
						height: 400,
						left: 0,
						top: x.collageTop,
						width: 400
					},
					children: x.mediaRects.map((e, t) => /* @__PURE__ */ g(zC, {
						media: a[t],
						mediaCount: a.length,
						mediaIndex: Eb(a, t),
						onIntrinsicDimensions: o,
						preferVideoCoverPreviewOverride: r,
						rect: e,
						videoCoverPreview: n,
						children: a.length > 5 && t === 4 ? /* @__PURE__ */ _("div", {
							className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/40 sp-text-2xl sp-font-semibold sp-leading-none sp-text-white",
							children: ["+", a.length - 5]
						}) : null
					}, _w(a[t], e)))
				}),
				x.dividerTop ? /* @__PURE__ */ g("span", {
					"aria-hidden": "true",
					className: "sp-absolute sp-left-4 sp-h-px sp-w-[368px] sp-bg-[#e6e6e6]",
					style: { top: x.dividerTop }
				}) : null,
				/* @__PURE__ */ g(HC, { top: x.actionsTop }),
				x.firstCommentHeight > 0 && /* @__PURE__ */ g(WC, {
					height: x.firstCommentHeight,
					post: e,
					top: x.firstCommentTop,
					trackEvent: i
				})
			]
		})
	});
}, LC = ({ post: e }) => /* @__PURE__ */ _("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-h-[51px] sp-w-[368px] sp-items-center sp-gap-2",
	children: [/* @__PURE__ */ g(Yy, {
		alt: e.username,
		className: "sp-h-12 sp-w-12 sp-rounded-full",
		src: e.profilePicture
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-h-[51px] sp-min-w-0 sp-flex-1 sp-items-start sp-justify-between",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-min-w-0",
			children: [
				/* @__PURE__ */ g(Zy, {
					className: "sp-text-base sp-font-semibold sp-leading-[19px]",
					children: e.username
				}),
				/* @__PURE__ */ g("div", {
					"aria-hidden": "true",
					className: "sp-h-4 sp-text-xs sp-leading-4",
					children: "\xA0"
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-flex sp-items-center sp-gap-1 sp-text-xs sp-leading-4 sp-text-[#333]",
					children: [
						/* @__PURE__ */ g("span", { children: "Just now" }),
						/* @__PURE__ */ g("span", {
							className: "sp-text-sm sp-font-semibold sp-leading-4 sp-text-black",
							children: "·"
						}),
						/* @__PURE__ */ g(Rw, {})
					]
				})
			]
		}), /* @__PURE__ */ g(Lw, {})]
	})]
}), RC = ({ captionRef: e, expanded: t, height: n, onExpandedChange: r, post: i, top: a, trackEvent: o }) => {
	let s = rw(i), c = nw(i, t);
	return /* @__PURE__ */ g("div", {
		ref: e,
		className: "sp-absolute sp-left-4 sp-w-[368px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-font-semibold [&_a]:sp-text-[#4f31ff] [&_a]:sp-no-underline",
		style: {
			height: n,
			top: a
		},
		children: /* @__PURE__ */ g(zy, {
			caption: i.caption,
			charsPerLine: 40,
			collapsedLines: wC,
			contentClassName: "sp-whitespace-pre-line",
			expanded: t,
			measurementText: tw(i),
			onExpandedChange: r,
			targetPlatform: "LI",
			trackEvent: o,
			buttonClassName: "sp-text-base sp-font-medium sp-leading-5 sp-text-[#808080]",
			suffix: c ? /* @__PURE__ */ _(h, { children: [" ", /* @__PURE__ */ g("a", {
				className: "sp-break-words sp-font-semibold sp-text-[#4f31ff] sp-no-underline",
				href: s,
				rel: "noreferrer",
				target: "_blank",
				children: s
			})] }) : null
		})
	});
}, zC = ({ children: e, media: t, mediaCount: n, mediaIndex: r, onIntrinsicDimensions: i, preferVideoCoverPreviewOverride: a, rect: o, videoCoverPreview: s }) => {
	let c = vw(t);
	return /* @__PURE__ */ _(Qy, {
		className: "sp-absolute sp-bg-[#f2f2f2]",
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		style: {
			height: o.height,
			left: o.left,
			top: o.top,
			width: o.width
		},
		children: [
			/* @__PURE__ */ g(zb, {
				coverScope: c ? "none" : void 0,
				media: t,
				mediaCount: n,
				mediaIndex: r,
				onIntrinsicDimensions: i,
				platform: "LI",
				preferVideoCoverPreviewOverride: a,
				surface: c ? "video" : "grid",
				videoCoverPreview: c ? s : void 0
			}),
			c && /* @__PURE__ */ g("div", {
				className: "sp-absolute sp-right-4 sp-top-4 sp-rounded sp-bg-[#454545] sp-px-2 sp-py-1 sp-text-xs sp-font-semibold sp-leading-[15px] sp-text-white",
				children: "02:30"
			}),
			e
		]
	});
}, BC = ({ rect: e, url: t }) => {
	let [n, r] = m(() => Ow.get(Nw(t)) ?? null);
	l(() => {
		let e = !0;
		if (!kw(t)) {
			r(null);
			return;
		}
		let n = Ow.get(Nw(t));
		if (n) {
			r(n);
			return;
		}
		r(null);
		let i = setTimeout(() => {
			Aw(t).then((t) => {
				e && r(t);
			});
		}, Ew);
		return () => {
			e = !1, clearTimeout(i);
		};
	}, [t]);
	let i = n?.imageUrl || "", a = n?.title || Fw(t), o = n?.description || "";
	return /* @__PURE__ */ _("a", {
		className: "sp-absolute sp-box-border sp-flex sp-items-center sp-gap-3 sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-p-3 sp-text-inherit sp-no-underline",
		href: Nw(t),
		rel: "noreferrer",
		target: "_blank",
		style: {
			height: e.height,
			left: e.left,
			top: e.top,
			width: e.width
		},
		children: [/* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-20 sp-w-[120px] sp-shrink-0 sp-items-center sp-justify-center sp-overflow-hidden sp-rounded-lg sp-bg-[#f4f4f6] sp-text-[#676767]",
			children: i ? /* @__PURE__ */ g("img", {
				alt: "",
				className: "sp-h-full sp-w-full sp-object-cover",
				src: i
			}) : /* @__PURE__ */ g(Bw, {})
		}), /* @__PURE__ */ _("div", {
			"data-linkedin-link-card": "compact",
			className: "sp-flex sp-h-20 sp-min-w-0 sp-flex-1 sp-flex-col sp-justify-center sp-gap-1",
			children: [
				/* @__PURE__ */ g("div", {
					className: "sp-line-clamp-1 sp-text-sm sp-font-semibold sp-leading-5 sp-text-[#333]",
					children: a
				}),
				o ? /* @__PURE__ */ g("div", {
					className: "sp-line-clamp-2 sp-text-xs sp-leading-4 sp-text-[#333]",
					children: o
				}) : null,
				/* @__PURE__ */ g("div", {
					className: "sp-truncate sp-text-xs sp-leading-4 sp-text-[#666]",
					children: Pw(t)
				})
			]
		})]
	});
}, VC = ({ media: e, rect: t }) => {
	let n = Sw(e), r = xC(e && SC(e)?.url), i = r?.document?.numPages ?? Cw(e), a = e?.thumbnailUrl || e?.url || "", o = !(!a || xw(a)), s = Math.max(1, i - 1), [c, l] = m(1), u = Math.min(c, s), d = [{
		slot: "leading",
		pageNumber: u
	}, {
		slot: "trailing",
		pageNumber: u + 1
	}].filter(({ pageNumber: e }) => e <= i), f = u < s, p = u > 1, h = () => {
		e?.url && window.open(e.url, "_blank", "noreferrer");
	};
	return /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-box-border sp-flex sp-flex-col sp-gap-2 sp-overflow-hidden sp-bg-[#f4f4f6] sp-p-2 sp-text-inherit sp-no-underline",
		"data-linkedin-document-card": "true",
		onClick: (e) => {
			e.target instanceof Element && e.target.closest("button") || h();
		},
		onKeyDown: (e) => {
			e.target instanceof Element && e.target.closest("button") || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), h());
		},
		role: "link",
		style: {
			height: t.height,
			left: t.left,
			top: t.top,
			width: t.width
		},
		tabIndex: 0,
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2 sp-text-xs sp-leading-4 sp-text-[#676767]",
				children: [/* @__PURE__ */ g("span", {
					className: "sp-min-w-0 sp-flex-1 sp-truncate sp-font-semibold",
					title: n,
					children: n
				}), /* @__PURE__ */ _("span", {
					className: "sp-shrink-0",
					children: [
						i,
						" ",
						i === 1 ? "page" : "pages"
					]
				})]
			}),
			/* @__PURE__ */ g("div", {
				className: "sp-relative sp-grid sp-min-h-0 sp-w-full sp-flex-1 sp-gap-2",
				style: { gridTemplateColumns: `repeat(${d.length}, minmax(0, 1fr))` },
				children: d.map(({ pageNumber: e, slot: t }) => /* @__PURE__ */ _("div", {
					className: "sp-relative sp-min-h-0 sp-min-w-0 sp-overflow-hidden sp-rounded sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white",
					children: [e === 1 && o ? /* @__PURE__ */ g("img", {
						alt: "",
						className: "sp-absolute sp-inset-0 sp-h-full sp-w-full sp-object-contain",
						src: a
					}) : /* @__PURE__ */ _("div", {
						"aria-hidden": !!r?.document,
						className: "sp-absolute sp-inset-0 sp-flex sp-flex-col sp-items-center sp-justify-center sp-gap-2 sp-text-[#676767]",
						children: [/* @__PURE__ */ g(zw, {}), /* @__PURE__ */ _("span", {
							className: "sp-text-xs sp-font-semibold sp-leading-4",
							children: ["Page ", e]
						})]
					}), r?.document && /* @__PURE__ */ g("div", {
						className: "sp-absolute sp-inset-0 sp-h-full sp-w-full sp-bg-white",
						children: /* @__PURE__ */ g(bC, {
							document: r.document,
							pageNumber: e,
							onRendered: () => {}
						})
					})]
				}, t))
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-items-center sp-justify-between sp-gap-2",
				children: [/* @__PURE__ */ _("div", {
					className: "sp-flex sp-items-center sp-gap-2",
					children: [
						/* @__PURE__ */ g("button", {
							"aria-label": "Previous document pages",
							disabled: !p,
							className: "sp-flex sp-h-6 sp-w-6 sp-min-w-0 sp-items-center sp-justify-center sp-rounded sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-p-0 sp-text-[#454545] disabled:sp-opacity-30",
							onClick: (e) => {
								e.stopPropagation(), l((e) => Math.max(1, e - 1));
							},
							type: "button",
							children: /* @__PURE__ */ g(Kw, {})
						}),
						/* @__PURE__ */ _("span", {
							className: "sp-text-xs sp-leading-4 sp-text-[#676767]",
							"aria-live": "polite",
							children: [
								u,
								d.length > 1 ? `–${u + 1}` : "",
								" /",
								" ",
								i
							]
						}),
						/* @__PURE__ */ g("button", {
							"aria-label": "Next document pages",
							disabled: !f,
							className: "sp-flex sp-h-6 sp-w-6 sp-min-w-0 sp-items-center sp-justify-center sp-rounded sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-p-0 sp-text-[#454545] disabled:sp-opacity-30",
							onClick: (e) => {
								e.stopPropagation(), l((e) => Math.min(s, e + 1));
							},
							type: "button",
							children: /* @__PURE__ */ g(Gw, {})
						})
					]
				}), /* @__PURE__ */ g("button", {
					"aria-label": "Open document",
					className: "sp-flex sp-h-6 sp-w-6 sp-min-w-0 sp-items-center sp-justify-center sp-rounded sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-p-0 sp-text-[#454545]",
					onClick: (e) => {
						e.stopPropagation(), h();
					},
					type: "button",
					children: /* @__PURE__ */ g(qw, {})
				})]
			})
		]
	});
}, HC = ({ top: e }) => /* @__PURE__ */ _("footer", {
	className: "sp-absolute sp-left-4 sp-flex sp-h-5 sp-w-[368px] sp-items-center sp-gap-6 sp-text-sm sp-font-semibold sp-leading-none sp-text-[#676767]",
	style: { top: e },
	children: [
		/* @__PURE__ */ g(UC, {
			icon: /* @__PURE__ */ g(Vw, {}),
			count: 1
		}),
		/* @__PURE__ */ g(UC, {
			icon: /* @__PURE__ */ g(Hw, {}),
			count: 1
		}),
		/* @__PURE__ */ g(UC, {
			icon: /* @__PURE__ */ g(Uw, {}),
			count: 1
		}),
		/* @__PURE__ */ g(UC, {
			icon: /* @__PURE__ */ g(Ww, {}),
			count: 1
		})
	]
}), UC = ({ icon: e, count: t }) => /* @__PURE__ */ _("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [/* @__PURE__ */ g("span", {
		className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-leading-none",
		children: e
	}), /* @__PURE__ */ g("span", {
		className: "sp-leading-[17px]",
		children: t
	})]
}), WC = ({ height: e, post: t, top: n, trackEvent: r }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-4 sp-w-[368px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-sm sp-leading-5 sp-text-black [&_a]:sp-font-semibold [&_a]:sp-text-[#4f31ff] [&_a]:sp-no-underline",
	style: {
		height: e,
		top: n
	},
	children: [/* @__PURE__ */ g("span", {
		className: "sp-mr-1 sp-font-semibold",
		children: t.username
	}), /* @__PURE__ */ g(Gp, {
		caption: t.comment.trim(),
		targetPlatform: "LI",
		trackEvent: r
	})]
}), GC = {
	height: 0,
	left: 0,
	top: 0,
	width: 0
}, KC = 79, qC = 72, JC = 151, YC = 159, XC = 12, ZC = (e, t) => $b(e.caption) ? Vy({
	charsPerLine: 40,
	collapsedLines: wC,
	expanded: t,
	lineHeight: TC,
	text: tw(e)
}) : 0, QC = (e) => e.comment.trim() ? Hy({
	charsPerLine: 40,
	leadingText: e.username,
	text: e.comment
}) * PC : 0, $C = (e, t) => t ? ew(e) + t + kC : e + jC, ew = (e) => e + AC + NC, tw = (e) => rw(e) ? `${e.caption} ${rw(e)}` : e.caption, nw = (e, t) => !!(rw(e) && (t || Hy({
	charsPerLine: 40,
	text: tw(e)
}) <= wC)), rw = (e) => e.redirectUrl && !iw(e) && !e.caption.includes(e.redirectUrl) ? e.redirectUrl : "", iw = (e) => !(!aw(e) || e.type !== "text" && e.type !== "image" && e.type !== "multiMedia" && e.type !== "video"), aw = (e) => e.redirectUrl || ow(e.caption), ow = (e) => {
	let t = e.match(/\b((?:https?:\/\/|www\.)[^\s<]+)/i)?.[1]?.replace(/[),.;!?]+$/, "");
	return t ? t.startsWith("www.") ? `https://${t}` : t : "";
}, sw = ({ captionExpanded: e, captionHeight: t, hasLinkCard: n }) => {
	let r = cw(t, e), i = n ? r : 0;
	return {
		firstContentTop: r,
		linkTop: i,
		mediaTop: n ? i + EC + OC : r
	};
}, cw = (e, t) => e > 0 ? t ? KC + e + XC : Math.max(JC, KC + e + XC) : qC, lw = (e, t) => e > 0 ? t ? KC + e + XC : Math.max(YC, KC + e + XC) : qC, uw = (e, t, n, r) => {
	let i = e.type === "text" && !!aw(e), a = iw(e), o = r ?? ZC(e, n), { firstContentTop: s, linkTop: c, mediaTop: l } = sw({
		captionExpanded: n,
		captionHeight: o,
		hasLinkCard: a
	}), u = $b(e.caption) && /(^|\s)#\w+/.test(e.caption), d = QC(e);
	if (i) {
		let e = s + EC + OC;
		return {
			actionsTop: e,
			captionHeight: o,
			captionTop: KC,
			dataLayout: "linkedin-link",
			firstCommentHeight: d,
			firstCommentTop: ew(e),
			height: $C(e, d),
			kind: "link",
			documentRect: GC,
			linkRect: {
				height: EC,
				left: 16,
				top: s,
				width: 368
			},
			mediaRects: []
		};
	}
	if (e.type === "text" || t.length === 0) {
		let e = u ? 78 : KC, t = o === 0 ? qC : Math.max(u ? 240 : 159, e + o + 20);
		return {
			actionsTop: t,
			captionHeight: o,
			captionTop: e,
			dataLayout: u ? "linkedin-text-hashtag" : "linkedin-text",
			dividerTop: o === 0 ? void 0 : t - 11,
			firstCommentHeight: d,
			firstCommentTop: ew(t),
			height: $C(t, d),
			kind: "text",
			documentRect: GC,
			linkRect: GC,
			mediaRects: []
		};
	}
	if (e.type === "document") {
		let t = cw(o, n), r = t + 299 + OC;
		return {
			actionsTop: r,
			captionHeight: o,
			captionTop: KC,
			dataLayout: "linkedin-document",
			documentMedia: mw(e),
			documentRect: {
				height: 299,
				left: 0,
				top: t,
				width: 400
			},
			firstCommentHeight: d,
			firstCommentTop: ew(r),
			height: $C(r, d),
			kind: "document",
			linkRect: GC,
			mediaRects: []
		};
	}
	if (t.length === 1 && (vw(t[0]) || e.type === "video")) {
		let e = dw(t[0], "video", l), n = e.top + e.height + OC;
		return {
			actionsTop: n,
			captionHeight: o,
			captionTop: KC,
			dataLayout: a ? "linkedin-video-link" : "linkedin-video",
			firstCommentHeight: d,
			firstCommentTop: ew(n),
			height: $C(n, d),
			kind: "single-media",
			documentRect: GC,
			linkRect: a ? {
				height: EC,
				left: 16,
				top: c,
				width: 368
			} : GC,
			mediaRects: [e]
		};
	}
	if (t.length === 1) {
		let e = dw(t[0], "grid", l), n = e.top + e.height + OC, r = $C(n, d);
		return {
			actionsTop: n,
			captionHeight: o,
			captionTop: KC,
			dataLayout: a ? "linkedin-image-link" : "linkedin-image",
			firstCommentHeight: d,
			firstCommentTop: ew(n),
			height: !a && o > 0 ? Math.max(r, MC) : r,
			kind: "single-media",
			documentRect: GC,
			linkRect: a ? {
				height: EC,
				left: 16,
				top: c,
				width: 368
			} : GC,
			mediaRects: [e]
		};
	}
	let f = a ? l : lw(o, n), p = f + 400 + 16;
	return {
		actionsTop: p,
		captionHeight: o,
		captionTop: 83,
		collageTop: f,
		dataLayout: `linkedin-collage-${Math.min(t.length, 5)}${t.length > 5 ? "-plus" : ""}${a ? "-link" : ""}`,
		firstCommentHeight: d,
		firstCommentTop: ew(p),
		height: $C(p, d),
		kind: "collage",
		documentRect: GC,
		linkRect: a ? {
			height: EC,
			left: 16,
			top: c,
			width: 368
		} : GC,
		mediaRects: fw(t.length)
	};
}, dw = (e, t, n) => {
	let r = kb({
		media: e,
		platform: "LI",
		surface: t,
		width: 400
	});
	return {
		height: r.height,
		left: 0,
		top: n,
		width: r.width
	};
}, fw = (e) => e === 2 ? [{
	height: 400,
	left: 0,
	top: 0,
	width: 199
}, {
	height: 400,
	left: 201,
	top: 0,
	width: 199
}] : e === 3 ? [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 400
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 199
	},
	{
		height: 158,
		left: 201,
		top: 242,
		width: 199
	}
] : e === 4 ? [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 400
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 134,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 268,
		top: 242,
		width: 132
	}
] : [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 199
	},
	{
		height: 240,
		left: 201,
		top: 0,
		width: 199
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 134,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 268,
		top: 242,
		width: 132
	}
], pw = (e) => {
	if (e.type === "text") return [];
	let t = e.medias.collection.filter((e) => !e.url?.includes(".pdf"));
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, mw = (e) => e.medias.collection.find(yw) ?? hw(e)[0] ?? (e.imageUrl ? {
	fileName: Sw({ url: e.imageUrl }),
	isVideo: !1,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
} : void 0), hw = (e) => e.sourcePost.medias?.medias?.filter(yw) ?? [], gw = (e) => [
	e?.url ?? "",
	e?.thumbnailUrl ?? "",
	e?.pages ?? ""
].join("|"), _w = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), vw = (e) => Tb(e), yw = (e) => !!(e && (e.type === "application/pdf" || xw(e.url) || xw(e.thumbnailUrl) || xw(e.fileName))), bw = (e) => xw(e.imageUrl) || e.medias.collection.some(yw), xw = (e) => !!e?.toLowerCase().includes(".pdf"), Sw = (e) => e?.fileName || ww(e?.url) || ww(e?.thumbnailUrl) || "Document.pdf", Cw = (e) => {
	let t = e;
	return e?.pages || t?.meta?.pages || 1;
}, ww = (e) => {
	if (!e) return "";
	try {
		let t = new URL(e).pathname.split("/").filter(Boolean).pop();
		return t ? decodeURIComponent(t) : "";
	} catch {
		let t = e.split("/").filter(Boolean).pop();
		return t ? decodeURIComponent(t) : "";
	}
}, Tw = (e) => `https://api.microlink.io/?${new URLSearchParams({
	apiKey: DC,
	url: Nw(e)
}).toString()}`, Ew = 800, Dw = /* @__PURE__ */ new Map(), Ow = /* @__PURE__ */ new Map(), kw = (e) => {
	try {
		let { hostname: t } = new URL(Nw(e));
		return /\.[^.\s]{2,}$/.test(t);
	} catch {
		return !1;
	}
}, Aw = (e) => {
	let t = Nw(e), n = Dw.get(t);
	if (n) return n;
	let r = fetch(Tw(e)).then((e) => {
		if (!e.ok) throw Error(`microlink request failed: ${e.status}`);
		return e.json();
	}).then((e) => {
		if (e?.status !== "success" || !e.data) return null;
		let n = jw(e.data);
		return Ow.set(t, n), n;
	}).catch(() => (Dw.delete(t), null));
	return Dw.set(t, r), r;
}, jw = (e) => ({
	description: e.description || "",
	imageUrl: Mw(e.image) || Mw(e.logo),
	title: e.title || ""
}), Mw = (e) => e ? typeof e == "string" ? e : e.url || "" : "", Nw = (e) => /^https?:\/\//i.test(e) ? e : `https://${e}`, Pw = (e) => {
	let t = Nw(e);
	try {
		return new URL(t).hostname.replace(/^www\./i, "") || e;
	} catch {
		return e.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
	}
}, Fw = (e) => {
	let t = Pw(e);
	try {
		return new URL(Nw(e)).pathname.split("/").filter(Boolean).pop()?.replace(/[-_]+/g, " ").trim() || t || e;
	} catch {
		return t || e;
	}
}, Iw = ({ children: e, className: t = "sp-text-current", size: n = 20, viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: r,
	width: n,
	children: e
}), Lw = () => /* @__PURE__ */ g(Iw, {
	className: "sp-text-[#333]",
	size: 32,
	children: /* @__PURE__ */ g("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), Rw = () => /* @__PURE__ */ _(Iw, {
	className: "sp-text-[#333]",
	size: 12,
	children: [/* @__PURE__ */ g("path", {
		d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ g("path", {
		d: "M3.6 9h16.8M3.6 15h16.8M12 3a13.8 13.8 0 0 1 0 18M12 3a13.8 13.8 0 0 0 0 18",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})]
}), zw = () => /* @__PURE__ */ _(Iw, {
	className: "sp-text-[#676767]",
	size: 54,
	children: [/* @__PURE__ */ g("path", {
		d: "M7 3h7l5 5v13H7V3Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.6"
	}), /* @__PURE__ */ g("path", {
		d: "M14 3v5h5M10 13h6M10 17h6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.6"
	})]
}), Bw = () => /* @__PURE__ */ _(Iw, {
	size: 32,
	children: [/* @__PURE__ */ g("path", {
		d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ g("path", {
		d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})]
}), Vw = () => /* @__PURE__ */ g(Iw, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ g("path", {
		d: "M5.83333 18.3333V9.16667M1.66667 10.8333V16.6667C1.66667 17.5871 2.41286 18.3333 3.33333 18.3333H14.5219C15.7558 18.3333 16.8052 17.4331 16.9928 16.2135L17.8902 10.3801C18.1232 8.86575 16.9515 7.5 15.4193 7.5H12.5C12.0398 7.5 11.6667 7.1269 11.6667 6.66667V3.72153C11.6667 2.58666 10.7467 1.66667 9.6118 1.66667C9.34111 1.66667 9.09582 1.82608 8.98588 2.07344L6.05328 8.67178C5.91953 8.97272 5.6211 9.16667 5.29177 9.16667H3.33333C2.41286 9.16667 1.66667 9.91286 1.66667 10.8333Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Hw = () => /* @__PURE__ */ g(Iw, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ g("path", {
		d: "M5.83301 7.49999H14.1663V8.33333H5.83301V7.49999ZM5.83301 10.8333H11.6663V9.99999H5.83301V10.8333ZM19.1663 9.16666C19.1787 10.0791 18.9699 10.981 18.5577 11.7951C18.1456 12.6093 17.5424 13.3115 16.7997 13.8417L9.99967 18.3333V15H6.66634C5.11924 15 3.63551 14.3854 2.54155 13.2915C1.44759 12.1975 0.833008 10.7138 0.833008 9.16666C0.833008 7.61957 1.44759 6.13583 2.54155 5.04187C3.63551 3.94791 5.11924 3.33333 6.66634 3.33333H13.333C14.8801 3.33333 16.3638 3.94791 17.4578 5.04187C18.5518 6.13583 19.1663 7.61957 19.1663 9.16666ZM17.4997 9.16666C17.4997 8.06159 17.0607 7.00178 16.2793 6.22038C15.4979 5.43898 14.4381 4.99999 13.333 4.99999H6.66634C5.56127 4.99999 4.50146 5.43898 3.72006 6.22038C2.93866 7.00178 2.49967 8.06159 2.49967 9.16666C2.49967 10.2717 2.93866 11.3315 3.72006 12.1129C4.50146 12.8943 5.56127 13.3333 6.66634 13.3333H11.6663V15.2333L15.833 12.5C16.361 12.1219 16.7888 11.6206 17.0792 11.0398C17.3697 10.4589 17.514 9.81594 17.4997 9.16666Z",
		fill: "currentColor"
	})
}), Uw = () => /* @__PURE__ */ g(Iw, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ g("path", {
		d: "M14.1667 8.33333L17.5 5L14.1667 1.66667M17.5 5H6.5C5.09987 5 4.3998 5 3.86502 5.27248C3.39462 5.51217 3.01217 5.89462 2.77248 6.36502C2.5 6.8998 2.5 7.59987 2.5 9V9.16667M2.5 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V10.8333M5.83333 11.6667L2.5 15L5.83333 18.3333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Ww = () => /* @__PURE__ */ g(Iw, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ g("path", {
		d: "M17.5 2.5L0 8.33333L6.38333 11.8833L13.3333 6.66667L8.11667 13.6167L11.6667 20L17.5 2.5Z",
		fill: "currentColor"
	})
}), Gw = () => /* @__PURE__ */ g(Iw, {
	size: 18,
	children: /* @__PURE__ */ g("path", {
		d: "m9 18 6-6-6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Kw = () => /* @__PURE__ */ g(Iw, {
	size: 18,
	children: /* @__PURE__ */ g("path", {
		d: "m15 18-6-6 6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), qw = () => /* @__PURE__ */ g(Iw, {
	size: 16,
	children: /* @__PURE__ */ g("path", {
		d: "M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5M3 3l6 6M21 3l-6 6M3 21l6-6M21 21l-6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Jw = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"text",
	"video"
]), Yw = 48, Xw = 320, Zw = 24, Qw = 20, $w = 6, eT = 8, tT = 8, nT = 20, rT = 2, iT = (e) => e.platform === "TW" && Jw.has(e.type), aT = ({ post: e, className: t, videoCoverPreview: n, trackEvent: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Vb(bT(e)), [o, s] = m(!1), c = fT(e, i, o), l = yT(e) ? e.redirectUrl : "";
	return /* @__PURE__ */ g(qy, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-base sp-leading-5", t].filter(Boolean).join(" "),
		platform: "TW",
		children: /* @__PURE__ */ _("article", {
			className: "sp-relative sp-m-4 sp-w-[368px] sp-bg-white",
			"data-uplift-layout": c.dataLayout,
			"data-uplift-renderer": "twitter",
			style: { height: c.height },
			children: [
				/* @__PURE__ */ g(Yy, {
					alt: e.username,
					className: "sp-absolute sp-left-0 sp-top-0 sp-h-10 sp-w-10",
					src: e.profilePicture
				}),
				/* @__PURE__ */ g(oT, { username: e.username }),
				c.captionHeight > 0 && /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-left-12 sp-w-[320px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline",
					"data-uplift-caption": "twitter",
					style: {
						height: c.captionHeight,
						top: Zw
					},
					children: /* @__PURE__ */ g(sT, {
						caption: e.caption,
						expanded: o,
						onExpandedChange: s,
						suffixUrl: l,
						trackEvent: r
					})
				}),
				c.kind === "link" && /* @__PURE__ */ g(lT, {
					media: i[0],
					post: e,
					rect: c.linkRect
				}),
				c.kind === "single-media" && /* @__PURE__ */ g(cT, {
					media: i[0],
					mediaCount: i.length,
					mediaIndex: 0,
					onIntrinsicDimensions: a,
					rect: c.mediaRects[0],
					videoCoverPreview: n
				}),
				c.kind === "collage" && /* @__PURE__ */ g("div", {
					className: "sp-absolute sp-overflow-hidden sp-rounded-lg sp-bg-white",
					"data-twitter-media-count": Math.min(i.length, 4),
					style: {
						height: 180,
						left: Yw,
						top: c.mediaTop,
						width: Xw
					},
					children: c.mediaRects.map((e, t) => /* @__PURE__ */ g(cT, {
						media: i[t],
						mediaCount: i.length,
						mediaIndex: Eb(i, t),
						onIntrinsicDimensions: a,
						rect: {
							...e,
							left: e.left - Yw,
							top: e.top - c.mediaTop
						},
						videoCoverPreview: ST(i[t]) ? n : void 0
					}, xT(i[t], e)))
				}),
				/* @__PURE__ */ g(uT, { top: c.actionsTop })
			]
		})
	});
}, oT = ({ username: e }) => /* @__PURE__ */ _("header", {
	className: "sp-absolute sp-left-12 sp-top-0 sp-flex sp-h-6 sp-w-[320px] sp-items-center sp-justify-between sp-gap-2",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1",
		children: [
			/* @__PURE__ */ g("span", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-[19px] sp-text-black",
				children: e
			}),
			/* @__PURE__ */ _("span", {
				className: "sp-truncate sp-text-sm sp-leading-[17px] sp-text-[#666]",
				children: ["@", CT(e)]
			}),
			/* @__PURE__ */ g("span", {
				className: "sp-text-sm sp-font-semibold sp-leading-[17px] sp-text-[#666]",
				children: "."
			}),
			/* @__PURE__ */ g("span", {
				className: "sp-whitespace-nowrap sp-text-sm sp-leading-[17px] sp-text-[#666]",
				children: "Just now"
			})
		]
	}), /* @__PURE__ */ g(DT, {})]
}), sT = ({ caption: e, expanded: t, onExpandedChange: n, suffixUrl: r, trackEvent: i }) => /* @__PURE__ */ g(zy, {
	buttonClassName: "sp-text-[#526572]",
	caption: e,
	charsPerLine: 36,
	collapsedLines: $w,
	contentClassName: "sp-whitespace-pre-line",
	expanded: t,
	measurementText: [e.trim(), r].filter(Boolean).join(" "),
	onExpandedChange: n,
	suffix: r ? /* @__PURE__ */ _(h, { children: [e.trim() ? " " : "", /* @__PURE__ */ g("a", {
		className: "sp-break-words sp-text-[#1694e0] sp-no-underline",
		href: r,
		rel: "noreferrer",
		target: "_blank",
		children: r
	})] }) : null,
	targetPlatform: "TW",
	trackEvent: i
}), cT = ({ media: e, mediaCount: t, mediaIndex: n, onIntrinsicDimensions: r, rect: i, videoCoverPreview: a }) => {
	let o = ST(e);
	return /* @__PURE__ */ g(Qy, {
		className: "sp-absolute sp-rounded-lg",
		"data-uplift-media-frame-ratio": `${i.width} / ${i.height}`,
		style: {
			height: i.height,
			left: i.left,
			top: i.top,
			width: i.width
		},
		children: /* @__PURE__ */ g(zb, {
			coverScope: "firstVideoOnly",
			media: e,
			mediaCount: t,
			mediaIndex: n,
			onIntrinsicDimensions: r,
			platform: "TW",
			surface: o ? "video" : "grid",
			videoCoverPreview: o ? a : void 0
		})
	});
}, lT = ({ media: e, post: t, rect: n }) => /* @__PURE__ */ _("a", {
	className: "sp-absolute sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline",
	href: t.redirectUrl,
	rel: "noreferrer",
	style: {
		height: n.height,
		left: n.left,
		top: n.top,
		width: n.width
	},
	target: "_blank",
	children: [/* @__PURE__ */ g("div", {
		className: "sp-h-[203px] sp-w-full sp-overflow-hidden sp-bg-[#d8d8d8]",
		children: /* @__PURE__ */ g(zb, {
			media: e,
			platform: "TW",
			surface: "grid"
		})
	}), /* @__PURE__ */ _("div", {
		className: "sp-box-border sp-h-[55px] sp-w-full sp-px-4 sp-py-2",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]",
			children: wT(t.redirectUrl)
		}), /* @__PURE__ */ g("div", {
			className: "sp-truncate sp-text-base sp-leading-[19px] sp-text-black",
			children: TT(t.redirectUrl)
		})]
	})]
}), uT = ({ top: e }) => /* @__PURE__ */ _("footer", {
	className: "sp-absolute sp-left-12 sp-flex sp-h-5 sp-w-[320px] sp-items-center sp-justify-between sp-text-sm sp-leading-[17px] sp-text-[#526572]",
	style: { top: e },
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-start sp-gap-8",
		children: [
			/* @__PURE__ */ g(dT, { icon: /* @__PURE__ */ g(OT, {}) }),
			/* @__PURE__ */ g(dT, { icon: /* @__PURE__ */ g(kT, {}) }),
			/* @__PURE__ */ g(dT, { icon: /* @__PURE__ */ g(AT, {}) }),
			/* @__PURE__ */ g(dT, { icon: /* @__PURE__ */ g(jT, {}) })
		]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ g(MT, {}), /* @__PURE__ */ g(NT, {})]
	})]
}), dT = ({ icon: e }) => /* @__PURE__ */ _("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [e, /* @__PURE__ */ g("span", { children: "1" })]
}), fT = (e, t, n) => {
	let r = e.type === "text" && !!e.redirectUrl, i = t[0], a = vT(e, n), o = gT(a);
	if (r) {
		let e = {
			height: 258,
			left: Yw,
			top: o,
			width: 320
		}, t = e.top + e.height + tT;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-link",
			height: _T(t),
			kind: "link",
			linkRect: e,
			mediaTop: o,
			mediaRects: []
		};
	}
	if (e.type === "text" && t.length === 0) {
		let e = gT(a);
		return {
			actionsTop: e,
			captionHeight: a,
			dataLayout: "twitter-text",
			height: _T(e),
			kind: "text",
			linkRect: mT,
			mediaTop: o,
			mediaRects: []
		};
	}
	if (e.type === "video" || ST(i)) {
		let e = pT(i, "video", o), t = e.top + e.height + tT;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-video",
			height: _T(t),
			kind: "single-media",
			linkRect: mT,
			mediaTop: o,
			mediaRects: [e]
		};
	}
	if (t.length <= 1) {
		let e = pT(i, "grid", o), t = e.top + e.height + tT;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-image",
			height: _T(t),
			kind: "single-media",
			linkRect: mT,
			mediaTop: o,
			mediaRects: [e]
		};
	}
	let s = o + 180 + tT;
	return {
		actionsTop: s,
		captionHeight: a,
		dataLayout: `twitter-collage-${Math.min(t.length, 4)}${t.length > 4 ? "-plus" : ""}`,
		height: _T(s),
		kind: "collage",
		linkRect: mT,
		mediaTop: o,
		mediaRects: hT(t.length, o)
	};
}, pT = (e, t, n) => {
	let r = kb({
		media: e,
		platform: "TW",
		surface: t,
		width: Xw
	});
	return {
		height: r.height,
		left: Yw,
		top: n,
		width: r.width
	};
}, mT = {
	height: 0,
	left: 0,
	top: 0,
	width: 0
}, hT = (e, t) => e === 2 ? [{
	height: 180,
	left: Yw,
	top: t,
	width: 158
}, {
	height: 180,
	left: 210,
	top: t,
	width: 158
}] : e === 3 ? [
	{
		height: 180,
		left: Yw,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t + 92,
		width: 158
	}
] : [
	{
		height: 88,
		left: Yw,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: Yw,
		top: t + 92,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t + 92,
		width: 158
	}
], gT = (e) => e > 0 ? Zw + e + eT : 28, _T = (e) => e + nT - rT, vT = (e, t) => {
	let n = [e.caption.trim(), yT(e) ? e.redirectUrl : ""].filter(Boolean).join(" ");
	if (!n) return 0;
	let r = n.split(/\r\n?|\n/).reduce((e, t) => e + Math.max(1, Math.ceil(t.length / 36)), 0), i = Math.min(t ? r : $w, r), a = t && r > $w ? Qw : 0;
	return i * Qw + a;
}, yT = (e) => !!e.redirectUrl && e.type !== "text", bT = (e) => {
	if (e.type === "text" && !e.redirectUrl) return [];
	if (e.type === "text" && e.redirectUrl) return e.imageUrl ? [{
		isVideo: !1,
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}] : [];
	let t = e.medias.collection;
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, xT = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), ST = (e) => Tb(e), CT = (e) => e.toLowerCase().replace(/[^a-z0-9_]+/g, ""), wT = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, TT = (e) => {
	let t = wT(e);
	return t === e ? e : t;
}, ET = ({ children: e, className: t = "sp-text-current", size: n = 20 }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: "0 0 24 24",
	width: n,
	children: e
}), DT = () => /* @__PURE__ */ g(ET, {
	className: "sp-text-[#c4c4c4]",
	size: 24,
	children: /* @__PURE__ */ g("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), OT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), kT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), AT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), jT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "M4 20V10M10.7 20V4M17.3 20v-7",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "2"
}) }), MT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "M6 4.5A1.5 1.5 0 0 1 7.5 3h9A1.5 1.5 0 0 1 18 4.5V21l-6-3.5L6 21V4.5Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), NT = () => /* @__PURE__ */ g(ET, { children: /* @__PURE__ */ g("path", {
	d: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 16V4m0 0 4 4m-4-4-4 4",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), PT = /* @__PURE__ */ new Set([
	"audio",
	"image",
	"multiMedia",
	"text",
	"video"
]), FT = (e) => e.platform === "TH" && PT.has(e.type), IT = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Vb(WT(e)), o = e.type === "text" && !!e.redirectUrl, s = e.type === "audio", c = $b(e.caption), l = c || !!(e.redirectUrl && e.type !== "text");
	return /* @__PURE__ */ g(qy, {
		className: ["sp-rounded-lg sp-border-[#e6e6e6] sp-p-4 sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "),
		platform: "TH",
		children: /* @__PURE__ */ _("article", {
			className: "sp-flex sp-items-start sp-gap-2",
			"data-uplift-renderer": "threads",
			"data-uplift-layout": GT(e, i),
			children: [/* @__PURE__ */ g(Yy, {
				alt: e.username,
				className: "sp-h-10 sp-w-10 sp-shrink-0",
				src: e.profilePicture
			}), /* @__PURE__ */ _("div", {
				className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-2",
				children: [
					/* @__PURE__ */ g(LT, { username: e.username }),
					l && /* @__PURE__ */ _("div", {
						className: "sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline",
						children: [c && /* @__PURE__ */ g(em, {
							caption: e.caption,
							targetPlatform: "TH",
							trackEvent: n
						}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ _(h, { children: [c && " ", /* @__PURE__ */ g("a", {
							className: "sp-break-words sp-text-[#1694e0] sp-no-underline",
							href: e.redirectUrl,
							rel: "noreferrer",
							target: "_blank",
							children: e.redirectUrl
						})] })]
					}),
					o && /* @__PURE__ */ g(BT, { url: e.redirectUrl }),
					s && /* @__PURE__ */ g(VT, {}),
					i.length > 0 && /* @__PURE__ */ g(RT, {
						medias: i,
						onIntrinsicDimensions: a,
						videoCoverPreview: r
					}),
					/* @__PURE__ */ g(HT, {})
				]
			})]
		})
	});
}, LT = ({ username: e }) => /* @__PURE__ */ _("header", {
	className: "sp-flex sp-min-w-0 sp-items-center sp-justify-between sp-gap-2",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1",
		children: [/* @__PURE__ */ g("span", {
			className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5 sp-text-black",
			children: e
		}), /* @__PURE__ */ g("span", {
			className: "sp-whitespace-nowrap sp-text-sm sp-leading-5 sp-text-[#666]",
			children: "Just now"
		})]
	}), /* @__PURE__ */ g(ZT, {})]
}), RT = ({ medias: e, onIntrinsicDimensions: t, videoCoverPreview: n }) => {
	let [r, i] = m(0), a = e.length > 0 ? r % e.length : 0;
	if (e.length === 1) {
		let r = e[0], i = KT(r), a = Ob({
			media: r,
			platform: "TH",
			surface: i ? "video" : "grid"
		});
		return /* @__PURE__ */ g("div", {
			className: ["sp-relative sp-overflow-hidden sp-rounded-lg sp-bg-[#f2f2f2]", i ? "sp-w-[265px]" : "sp-w-full"].filter(Boolean).join(" "),
			"data-uplift-media-frame-ratio": a.publishedRatio,
			style: { aspectRatio: a.publishedRatio },
			children: /* @__PURE__ */ g(zT, {
				className: "sp-h-full sp-w-full",
				media: r,
				mediaCount: e.length,
				mediaIndex: 0,
				onIntrinsicDimensions: t,
				videoCoverPreview: i ? n : void 0
			})
		});
	}
	let o = qT(e, a);
	return /* @__PURE__ */ _("div", {
		className: "sp-relative",
		"data-threads-carousel-controls": "true",
		children: [
			/* @__PURE__ */ g("div", {
				className: "sp-flex sp-h-[169px] sp-w-full sp-gap-2 sp-overflow-hidden",
				"data-threads-carousel-start-index": a,
				"data-threads-media-count": o.length,
				children: o.map(({ media: r, originalIndex: i }, a) => /* @__PURE__ */ g(zT, {
					className: [a === 0 ? "sp-w-[236px]" : "sp-w-[123px]", "sp-shrink-0 sp-rounded-lg"].filter(Boolean).join(" "),
					media: r,
					mediaCount: e.length,
					mediaIndex: Eb(e, i),
					onIntrinsicDimensions: t,
					videoCoverPreview: KT(r) ? n : void 0
				}, `${r.url}-${i}`))
			}),
			/* @__PURE__ */ g(rE, {
				ariaLabel: "Previous media",
				direction: "previous",
				onClick: () => {
					i((t) => (t + e.length - 1) % e.length);
				}
			}),
			/* @__PURE__ */ g(rE, {
				ariaLabel: "Next media",
				direction: "next",
				onClick: () => {
					i((t) => (t + 1) % e.length);
				}
			})
		]
	});
}, zT = ({ media: e, className: t, children: n, mediaCount: r = 1, mediaIndex: i = 0, onIntrinsicDimensions: a, videoCoverPreview: o }) => KT(e) ? /* @__PURE__ */ _(Qy, {
	className: ["sp-relative", t].filter(Boolean).join(" "),
	children: [/* @__PURE__ */ g(zb, {
		coverScope: "firstVideoOnly",
		media: e,
		mediaCount: r,
		mediaIndex: i,
		onIntrinsicDimensions: a,
		platform: "TH",
		surface: "video",
		videoCoverPreview: o
	}), n]
}) : /* @__PURE__ */ _(Qy, {
	className: ["sp-relative", t].filter(Boolean).join(" "),
	children: [/* @__PURE__ */ g(zb, {
		media: e,
		onIntrinsicDimensions: a,
		platform: "TH",
		surface: "grid"
	}), n]
}), BT = ({ url: e }) => /* @__PURE__ */ _("a", {
	className: "sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline",
	href: e,
	rel: "noreferrer",
	target: "_blank",
	children: [/* @__PURE__ */ g("div", { className: "sp-h-[203px] sp-bg-[#d8d8d8]" }), /* @__PURE__ */ _("div", {
		className: "sp-px-4 sp-py-2",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]",
			children: JT(e)
		}), /* @__PURE__ */ g("div", {
			className: "sp-truncate sp-text-base sp-leading-5 sp-text-black",
			children: "Why does my dog have a pink nose?"
		})]
	})]
}), VT = () => /* @__PURE__ */ _("div", {
	className: "sp-box-border sp-flex sp-w-[225px] sp-items-center sp-gap-2 sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-px-4 sp-py-2",
	"data-threads-audio-card": "true",
	children: [/* @__PURE__ */ g(nE, {}), /* @__PURE__ */ g("div", {
		className: "sp-flex sp-h-6 sp-w-[153px] sp-items-center sp-gap-0.5",
		children: YT.map((e, t) => /* @__PURE__ */ g("span", { className: ["sp-w-0.5 sp-rounded-full sp-bg-[#111]", e].filter(Boolean).join(" ") }, `${e}-${t}`))
	})]
}), HT = () => /* @__PURE__ */ _("footer", {
	className: "sp-flex sp-items-start sp-gap-6 sp-text-sm sp-leading-5 sp-text-[#526572]",
	children: [
		/* @__PURE__ */ g(UT, { icon: /* @__PURE__ */ g(QT, {}) }),
		/* @__PURE__ */ g(UT, { icon: /* @__PURE__ */ g($T, {}) }),
		/* @__PURE__ */ g(UT, { icon: /* @__PURE__ */ g(eE, {}) }),
		/* @__PURE__ */ g(tE, {})
	]
}), UT = ({ icon: e }) => /* @__PURE__ */ _("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [e, /* @__PURE__ */ g("span", { children: "1" })]
}), WT = (e) => {
	if (e.type === "text" || e.type === "audio") return [];
	let t = e.medias.collection;
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, GT = (e, t) => e.type === "audio" ? "threads-audio" : e.type === "text" && e.redirectUrl ? "threads-link" : e.type === "text" ? "threads-text" : t.length > 1 ? t.some(KT) ? "threads-carousel-video" : "threads-carousel-image" : t[0] && KT(t[0]) ? "threads-single-video" : "threads-single-image", KT = (e) => Tb(e), qT = (e, t) => Array.from({ length: Math.min(e.length, 4) }, (n, r) => {
	let i = (t + r) % e.length;
	return {
		media: e[i],
		originalIndex: i
	};
}), JT = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, YT = [
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]",
	"sp-h-[11px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]",
	"sp-h-[11px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]"
], XT = ({ children: e, className: t = "sp-text-current", size: n = 20 }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: "0 0 24 24",
	width: n,
	children: e
}), ZT = () => /* @__PURE__ */ g(XT, {
	size: 24,
	children: /* @__PURE__ */ g("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), QT = () => /* @__PURE__ */ g(XT, { children: /* @__PURE__ */ g("path", {
	d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), $T = () => /* @__PURE__ */ g(XT, { children: /* @__PURE__ */ g("path", {
	d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), eE = () => /* @__PURE__ */ g(XT, { children: /* @__PURE__ */ g("path", {
	d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), tE = () => /* @__PURE__ */ g(XT, { children: /* @__PURE__ */ g("path", {
	d: "m22 2-7 20-4-9-9-4 20-7Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), nE = () => /* @__PURE__ */ g(XT, {
	size: 24,
	children: /* @__PURE__ */ g("path", {
		d: "M8 5v14l11-7L8 5Z",
		fill: "currentColor"
	})
}), rE = ({ ariaLabel: e, direction: t, onClick: n }) => /* @__PURE__ */ g("button", {
	"aria-label": e,
	className: ["sp-absolute sp-top-1/2 sp-z-10 sp-flex sp-h-8 sp-w-8 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border sp-border-solid sp-border-[#d8d8d8] sp-bg-white sp-p-0 sp-text-[#526572] sp-shadow-[0_2px_6px_rgba(16,24,40,0.18)]", t === "previous" ? "sp-left-2" : "sp-right-2"].join(" "),
	onClick: n,
	style: { transform: "translateY(-50%)" },
	type: "button",
	children: /* @__PURE__ */ g(iE, { direction: t })
}), iE = ({ direction: e }) => /* @__PURE__ */ g(XT, {
	size: 18,
	children: /* @__PURE__ */ g("path", {
		d: e === "previous" ? "m15 18-6-6 6-6" : "m9 6 6 6-6 6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), aE = (e) => /* @__PURE__ */ g("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ g("g", {
		id: "annotation-heart",
		children: /* @__PURE__ */ _("g", {
			id: "Icon",
			children: [/* @__PURE__ */ g("path", {
				d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
				stroke: "black",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ g("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9973 8.33059C11.1975 7.4216 9.8639 7.17708 8.86188 8.00945C7.85986 8.84182 7.71879 10.2335 8.50568 11.2179C8.97361 11.8033 10.1197 12.8531 10.9719 13.6079C11.3237 13.9195 11.4996 14.0753 11.7114 14.1385C11.8925 14.1926 12.102 14.1926 12.2832 14.1385C12.4949 14.0753 12.6708 13.9195 13.0226 13.6079C13.8748 12.8531 15.0209 11.8033 15.4888 11.2179C16.2757 10.2335 16.1519 8.83306 15.1326 8.00945C14.1134 7.18584 12.797 7.4216 11.9973 8.33059Z",
				stroke: "black",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		})
	})
}), oE = (e) => /* @__PURE__ */ _("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ g("g", {
		id: "Share - Pinterest 1",
		clipPath: "url(#clip0_0_27)",
		children: /* @__PURE__ */ g("path", {
			id: "Vector",
			d: "M17.4997 11.6667C18.4163 11.6667 19.1663 12.4167 19.1663 13.3333V18.3333C19.1663 19.25 18.4163 20 17.4997 20H2.49967C1.58301 20 0.833008 19.25 0.833008 18.3333V13.3333C0.833008 12.4167 1.58301 11.6667 2.49967 11.6667C3.41634 11.6667 4.16634 12.4167 4.16634 13.3333V16.6667H15.833V13.3333C15.833 12.4167 16.583 11.6667 17.4997 11.6667ZM7.34967 7.36667C6.69967 8.01667 5.64134 8.025 4.99134 7.36667C4.34134 6.71667 4.33301 5.66667 4.98301 5.01667L9.99134 0L15.008 5.00833C15.658 5.65833 15.6663 6.71667 15.0163 7.36667C14.3663 8.01667 13.308 8.025 12.658 7.36667L11.658 6.375V11.525C11.658 11.967 11.4824 12.391 11.1699 12.7035C10.8573 13.0161 10.4334 13.1917 9.99134 13.1917C9.54931 13.1917 9.12539 13.0161 8.81283 12.7035C8.50027 12.391 8.32467 11.967 8.32467 11.525V6.38333L7.34967 7.36667Z",
			fill: "black"
		})
	}), /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", {
		id: "clip0_0_27",
		children: /* @__PURE__ */ g("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
}), sE = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"video"
]), cE = 2, lE = 2, uE = 20, dE = 40, fE = 30, pE = 48, mE = 16, hE = 52, gE = 16, _E = 5, vE = (e) => e.platform === "PI" && sE.has(e.type), yE = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let [i, a] = m(!1), o = p(null), s = OE(e, i), c = BE(e), l = zE(e), { medias: u, reportIntrinsicDimensions: f } = Vb(c.length > 0 ? c : [l]), h = c.length > 0 ? u : c, _ = u[0] || l, v = [
		e.piTitle ?? "",
		e.caption,
		h.length,
		i ? "expanded" : "collapsed"
	].join("|"), [y, b] = m(null), x = y?.key === v ? y.height : s;
	if (d(() => {
		if (!i) {
			b(null);
			return;
		}
		let e = o.current;
		if (!e) return;
		let t = () => {
			let t = Math.ceil(Math.max(e.scrollHeight, e.offsetHeight));
			t > 0 && Math.abs(t - s) > 1 && b((e) => e?.key === v && e.height === t ? e : {
				height: t,
				key: v
			});
		};
		t();
		let n = typeof requestAnimationFrame == "function" ? requestAnimationFrame(t) : void 0, r = typeof ResizeObserver == "function" ? new ResizeObserver(t) : void 0;
		return r?.observe(e), () => {
			n !== void 0 && cancelAnimationFrame(n), r?.disconnect();
		};
	}, [
		v,
		i,
		s
	]), e.type === "text") return null;
	let S = !!(_ && HE(_)), C = LE(_), w = !S && C.name !== "pinterest-image-portrait" ? FE(C, x) : void 0, T = w === void 0 ? void 0 : { "--pinterest-shell-height": `${w}px` };
	return /* @__PURE__ */ g("div", {
		className: [
			"sp-box-border sp-mx-auto sp-overflow-hidden sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased",
			S ? "sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-[32px]" : IE(C, x, w),
			t
		].filter(Boolean).join(" "),
		"data-preview-platform": "PI",
		"data-preview-variant": "uplift",
		style: T,
		children: S ? /* @__PURE__ */ g(bE, {
			bodyHeight: x,
			bodyRef: o,
			captionExpanded: i,
			media: _,
			onCaptionExpandedChange: a,
			onIntrinsicDimensions: f,
			post: e,
			trackEvent: n,
			videoCoverPreview: r
		}) : /* @__PURE__ */ g(xE, {
			layout: C,
			bodyHeight: x,
			bodyRef: o,
			captionExpanded: i,
			carouselMedias: h,
			media: _,
			onCaptionExpandedChange: a,
			onIntrinsicDimensions: f,
			post: e,
			trackEvent: n
		})
	});
}, bE = ({ bodyHeight: e, bodyRef: t, captionExpanded: n, media: r, onCaptionExpandedChange: i, onIntrinsicDimensions: a, post: o, trackEvent: s, videoCoverPreview: c }) => /* @__PURE__ */ _("article", {
	className: "sp-flex sp-h-full sp-flex-col",
	"data-uplift-layout": "pinterest-video",
	"data-uplift-renderer": "pinterest",
	children: [/* @__PURE__ */ g(CE, {
		media: r,
		onIntrinsicDimensions: a,
		videoCoverPreview: c
	}), /* @__PURE__ */ _("div", {
		className: "sp-box-border sp-flex sp-flex-1 sp-flex-col sp-gap-3 sp-p-4",
		"data-pinterest-video-content": "true",
		children: [
			/* @__PURE__ */ g(wE, { post: o }),
			/* @__PURE__ */ g(TE, {
				bodyHeight: e,
				bodyRef: t,
				captionExpanded: n,
				onCaptionExpandedChange: i,
				post: o,
				trackEvent: s
			}),
			/* @__PURE__ */ g(EE, {
				showVisit: !1,
				width: "narrow"
			})
		]
	})]
}), xE = ({ layout: e, bodyHeight: t, bodyRef: n, captionExpanded: r, carouselMedias: i, media: a, onCaptionExpandedChange: o, onIntrinsicDimensions: s, post: c, trackEvent: l }) => e.name === "pinterest-image-portrait" ? /* @__PURE__ */ _("article", {
	className: "sp-box-border sp-flex sp-w-full sp-flex-col",
	"data-uplift-layout": e.name,
	"data-uplift-renderer": "pinterest",
	children: [
		/* @__PURE__ */ g(SE, {
			carouselMedias: i,
			layout: e,
			media: a,
			onIntrinsicDimensions: s
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-box-border sp-w-full sp-px-4 sp-pt-4",
			children: [/* @__PURE__ */ g(wE, { post: c }), t > 0 ? /* @__PURE__ */ g(TE, {
				bodyHeight: t,
				bodyRef: n,
				captionExpanded: r,
				onCaptionExpandedChange: o,
				post: c,
				trackEvent: l
			}) : null]
		}),
		/* @__PURE__ */ g(EE, {
			className: "sp-mx-4 sp-mb-4 sp-mt-4",
			showVisit: !!c.redirectUrl,
			width: "narrow"
		})
	]
}) : /* @__PURE__ */ _("article", {
	className: "sp-relative sp-h-full sp-w-full",
	"data-uplift-layout": e.name,
	"data-uplift-renderer": "pinterest",
	children: [
		/* @__PURE__ */ g(SE, {
			carouselMedias: i,
			layout: e,
			media: a,
			onIntrinsicDimensions: s
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-absolute sp-left-4 sp-w-[368px]",
			style: {
				height: PE(t),
				top: e.contentTop
			},
			children: [/* @__PURE__ */ g(wE, { post: c }), t > 0 ? /* @__PURE__ */ g(TE, {
				bodyHeight: t,
				bodyRef: n,
				captionExpanded: r,
				onCaptionExpandedChange: o,
				post: c,
				trackEvent: l
			}) : null]
		}),
		/* @__PURE__ */ g(EE, {
			showVisit: !!c.redirectUrl,
			top: e.contentTop + PE(t) + mE
		})
	]
}), SE = ({ carouselMedias: e, layout: t, media: n, onIntrinsicDimensions: r }) => /* @__PURE__ */ g(Qy, {
	className: [
		"sp-overflow-hidden sp-bg-[#f2f2f2]",
		t.name !== "pinterest-image-portrait" && "sp-absolute",
		t.mediaClassName
	].filter(Boolean).join(" "),
	"data-uplift-media-frame-ratio": `${t.mediaWidth} / ${t.mediaHeight}`,
	style: {
		height: t.mediaHeight,
		left: t.name === "pinterest-image-portrait" ? void 0 : t.mediaLeft,
		top: t.name === "pinterest-image-portrait" ? void 0 : t.mediaTop,
		width: t.mediaWidth
	},
	children: e.length > 1 ? /* @__PURE__ */ g($y, {
		ariaLabel: "Pinterest media carousel",
		medias: e,
		renderSlide: (n, { index: i, isActive: a }) => /* @__PURE__ */ g(zb, {
			imageClassName: t.imageClassName,
			isActive: a,
			media: n,
			mediaCount: e.length,
			mediaIndex: i,
			onIntrinsicDimensions: r,
			platform: "PI",
			surface: "pin"
		})
	}) : /* @__PURE__ */ g(zb, {
		imageClassName: t.imageClassName,
		media: n,
		onIntrinsicDimensions: r,
		platform: "PI",
		surface: "pin"
	})
}), CE = ({ media: e, onIntrinsicDimensions: t, videoCoverPreview: n }) => {
	let r = Ob({
		media: e,
		platform: "PI",
		surface: "pin"
	});
	return HE(e) ? /* @__PURE__ */ g("div", {
		className: "sp-relative sp-w-full sp-overflow-hidden sp-rounded-t-[32px] sp-bg-[#f2f2f2]",
		"data-uplift-media-frame-ratio": r.publishedRatio,
		style: { aspectRatio: r.publishedRatio },
		children: /* @__PURE__ */ g(zb, {
			className: "sp-h-full sp-w-full",
			coverScope: "singlePostOnly",
			customVideoControls: !0,
			media: e,
			onIntrinsicDimensions: t,
			platform: "PI",
			surface: "pin",
			videoCoverPreview: n,
			videoScrubberClassName: "sp-bottom-0"
		})
	}) : null;
}, wE = ({ post: e }) => {
	let t = VE(e.followerCount);
	return /* @__PURE__ */ _("header", {
		className: "sp-flex sp-h-12 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ g(Yy, {
			alt: e.username,
			className: "sp-h-12 sp-w-12",
			src: e.profilePicture
		}), /* @__PURE__ */ _("div", {
			className: "sp-min-w-0",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), t ? /* @__PURE__ */ g("div", {
				className: "sp-text-xs sp-leading-4 sp-text-[#1a1a1a]",
				children: t
			}) : null]
		})]
	});
}, TE = ({ bodyHeight: e, bodyRef: t, captionExpanded: n, onCaptionExpandedChange: r, post: i, trackEvent: a }) => {
	let o = $b(i.piTitle), s = $b(i.caption);
	return !o && !s ? null : /* @__PURE__ */ _("div", {
		ref: t,
		className: "sp-mt-3 sp-flex sp-flex-col sp-break-words",
		"data-pinterest-body": "true",
		style: {
			height: n ? void 0 : e,
			minHeight: n ? void 0 : e
		},
		children: [o ? /* @__PURE__ */ g("div", {
			className: "sp-line-clamp-1 sp-h-[30px] sp-text-xl sp-font-semibold sp-leading-[30px]",
			children: i.piTitle
		}) : null, s ? /* @__PURE__ */ g(zy, {
			buttonClassName: "sp-text-base sp-font-semibold sp-leading-5 sp-text-black",
			caption: i.caption,
			charsPerLine: 42,
			className: "sp-text-base sp-leading-5",
			collapsedLines: lE,
			contentClassName: "sp-whitespace-pre-line sp-text-base sp-leading-5",
			expanded: n,
			onExpandedChange: r,
			targetPlatform: "PI",
			trackEvent: a,
			wideCharacterWeight: cE
		}) : null]
	});
}, EE = ({ className: e, showVisit: t, top: n, width: r = "narrow" }) => /* @__PURE__ */ _("footer", {
	className: [
		"sp-grid sp-h-[52px] sp-grid-cols-[24px_1fr_24px] sp-items-center",
		r === "wide" ? "sp-w-[400px]" : "sp-w-[368px]",
		n !== void 0 && "sp-absolute sp-left-4",
		e
	].filter(Boolean).join(" "),
	"data-pinterest-actions-width": r,
	style: n === void 0 ? void 0 : { top: n },
	children: [
		/* @__PURE__ */ g("span", {
			className: "sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-justify-self-start",
			children: /* @__PURE__ */ g(aE, { "aria-hidden": "true" })
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-[52px] sp-items-center sp-justify-center sp-gap-2 sp-justify-self-center",
			children: [t && /* @__PURE__ */ g("span", {
				className: "sp-flex sp-h-[52px] sp-w-20 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#efefef] sp-text-lg sp-font-semibold sp-leading-7 sp-text-[#333]",
				children: "Visit"
			}), /* @__PURE__ */ g("span", {
				className: "sp-flex sp-h-[52px] sp-w-[94px] sp-items-center sp-justify-center sp-rounded-full sp-bg-[#e60022] sp-text-lg sp-font-semibold sp-leading-7 sp-text-white",
				children: "Save"
			})]
		}),
		/* @__PURE__ */ g("span", {
			className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-justify-self-end",
			children: /* @__PURE__ */ g(oE, { "aria-hidden": "true" })
		})
	]
}), DE = 16, OE = (e, t = !1) => {
	let n = $b(e.piTitle), r = $b(e.caption);
	return (n ? fE : 0) + (r ? Math.max(dE, kE(e.caption, t)) : 0);
}, kE = (e, t) => {
	let n = AE(e);
	return Math.min(t ? n : lE, n) * uE;
}, AE = (e) => {
	let t = e.trim();
	return t ? t.split(/\r\n?|\n/).reduce((e, t) => e + jE(t, 42), 0) : 0;
}, jE = (e, t) => {
	let n = e.trim().split(/\s+/).filter(Boolean);
	if (n.length === 0) return 1;
	let r = 1, i = 0;
	return n.forEach((e) => {
		let n = NE(e);
		if (i === 0) {
			i = n, r += Math.max(0, Math.ceil(n / t) - 1), i = n % t || t;
			return;
		}
		let a = i + 1 + n;
		if (a <= t) {
			i = a;
			return;
		}
		r += 1, i = n, n > t && (r += Math.ceil(n / t) - 1, i = n % t || t);
	}), r;
}, ME = (e) => (e.codePointAt(0) ?? 0) > 255, NE = (e) => Array.from(e).reduce((e, t) => e + (ME(t) ? cE : 1), 0), PE = (e) => e > 0 ? 60 + e : pE, FE = (e, t) => e.contentTop + PE(t) + mE + hE + gE, IE = (e, t, n) => e.name === "pinterest-image-portrait" || n === void 0 ? "sp-w-[400px] sp-rounded-[32px]" : "sp-h-[var(--pinterest-shell-height)] sp-w-[400px] sp-rounded-[32px]", LE = (e) => {
	let t = RE(e) ?? 400 / 264, n = kb({
		media: e,
		platform: "PI",
		surface: "pin",
		width: 400
	}), r = n.height;
	return {
		contentTop: r + DE,
		imageClassName: "sp-object-center",
		mediaClassName: "sp-rounded-t-[32px]",
		mediaHeight: r,
		mediaLeft: 0,
		mediaTop: 0,
		mediaWidth: n.width,
		name: t < 1 ? "pinterest-image-portrait" : "pinterest-image-horizontal"
	};
}, RE = (e) => {
	if (!(!e?.width || !e.height || e.width <= 0 || e.height <= 0)) return e.width / e.height;
}, zE = (e) => e.medias.collection[0] || {
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}, BE = (e) => {
	if (e.type !== "image" && e.type !== "multiMedia" || e.medias.collection.length < 2 || e.medias.collection.length > _E) return [];
	let t = e.medias.collection.filter((e) => !HE(e));
	return t.length === e.medias.collection.length ? t : [];
}, VE = (e) => typeof e != "number" || !Number.isFinite(e) ? null : `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Math.max(0, e))} ${e === 1 ? "follower" : "followers"}`, HE = (e) => Tb(e), UE = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"video"
]), WE = 2, GE = (e) => {
	if (e.platform !== "TT" || !UE.has(e.type)) return !1;
	let t = rD(e);
	return e.type === "video" || t.every((e) => !iD(e));
}, KE = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = rD(e), a = e.type === "video" || iD(i[0]), o = a ? "tiktok-video" : "tiktok-carousel-photo", s = i[0], [c, u] = m(!1), d = $b(e.caption) && Hy({
		charsPerLine: 36,
		text: e.caption
	}) > WE, f = c && d;
	return l(() => {
		d || u(!1);
	}, [d]), /* @__PURE__ */ _("div", {
		className: ["sp-relative sp-mx-auto sp-h-[856px] sp-w-[400px] sp-overflow-hidden sp-rounded-none sp-bg-black sp-font-sans sp-text-white sp-shadow-none sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "TT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": o,
		"data-uplift-renderer": "tiktok",
		children: [
			a ? /* @__PURE__ */ g(qE, {
				isVideoPost: a,
				media: s,
				videoCoverPreview: r
			}) : /* @__PURE__ */ g(JE, { medias: i }),
			a ? /* @__PURE__ */ g(YE, {}) : null,
			f && /* @__PURE__ */ g("div", {
				className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-[70px] sp-top-0 sp-bg-black/40",
				"data-uplift-caption-backdrop": "true"
			}),
			/* @__PURE__ */ g(XE, {}),
			/* @__PURE__ */ g(QE, { post: e }),
			/* @__PURE__ */ g($E, {
				captionExpanded: f,
				onCaptionExpandedChange: u,
				post: e,
				trackEvent: n
			}),
			/* @__PURE__ */ g(eD, {})
		]
	});
}, qE = ({ media: e, isVideoPost: t, videoCoverPreview: n }) => {
	let r = e?.url || e?.thumbnailUrl || "";
	return t ? /* @__PURE__ */ g("div", {
		className: "sp-absolute sp-left-0 sp-top-0 sp-h-[856px] sp-w-full sp-bg-black",
		"data-uplift-media-frame-ratio": "9 / 16",
		children: /* @__PURE__ */ g(zb, {
			backgroundColor: "#000",
			className: "sp-h-full sp-w-full",
			controls: !1,
			coverScope: "singlePostOnly",
			customVideoControls: !0,
			media: e,
			platform: "TT",
			surface: "video",
			videoCoverPreview: n,
			videoScrubberClassName: "sp-bottom-[70px]"
		})
	}) : /* @__PURE__ */ g("div", {
		className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]",
		children: r && /* @__PURE__ */ g(zb, {
			media: e,
			platform: "TT",
			surface: "carousel"
		})
	});
}, JE = ({ medias: e }) => /* @__PURE__ */ g("div", {
	className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]",
	children: /* @__PURE__ */ g($y, {
		ariaLabel: "TikTok photo carousel",
		arrowClassName: "sp-z-20",
		dotClassName: "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2",
		medias: e,
		renderSlide: (t, { index: n, isActive: r }) => /* @__PURE__ */ g(zb, {
			isActive: r,
			media: t,
			mediaCount: e.length,
			mediaIndex: n,
			platform: "TT",
			surface: "carousel"
		}),
		showCount: !1
	})
}), YE = () => /* @__PURE__ */ g("div", { className: "sp-pointer-events-none sp-absolute sp-left-0 sp-top-[532px] sp-h-[254px] sp-w-full sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent sp-opacity-50" }), XE = () => /* @__PURE__ */ _("header", {
	className: "sp-absolute sp-left-4 sp-right-4 sp-top-[50px] sp-flex sp-items-start sp-justify-between",
	children: [
		/* @__PURE__ */ g(ZE, {}),
		/* @__PURE__ */ _("div", {
			className: "sp-absolute sp-left-[107px] sp-top-[5px] sp-flex sp-items-start sp-gap-[19px] sp-text-base sp-font-semibold sp-leading-[1.21] sp-tracking-[0.24px] sp-drop-shadow-[0_5px_12px_rgba(0,0,0,0.15)]",
			children: [/* @__PURE__ */ g("span", {
				className: "sp-opacity-60",
				children: "Following"
			}), /* @__PURE__ */ _("span", {
				className: "sp-relative",
				children: ["For you", /* @__PURE__ */ g("span", { className: "sp-absolute sp-left-1/2 sp-top-[27px] sp-h-[2px] sp-w-[26px] -sp-translate-x-1/2 sp-bg-white" })]
			})]
		}),
		/* @__PURE__ */ g(oD, { className: "sp-absolute sp-left-[346px] sp-top-[5px] sp-text-white" })
	]
}), ZE = () => /* @__PURE__ */ _(aD, {
	className: "sp-text-white",
	size: 30,
	viewBox: "0 0 30 28",
	children: [/* @__PURE__ */ g("path", {
		d: "M6.5 5.5h17c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2h-17c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2ZM10.5 5.5 7.5 2M18.5 5.5 22 2M8 26h14",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ g("text", {
		fill: "currentColor",
		fontFamily: "Inter, sans-serif",
		fontSize: "8.8",
		fontWeight: "700",
		textAnchor: "middle",
		x: "15",
		y: "17.2",
		children: "LIVE"
	})]
}), QE = ({ post: e }) => /* @__PURE__ */ _("aside", {
	className: "sp-absolute sp-left-[332px] sp-top-[412px] sp-flex sp-w-[45px] sp-flex-col sp-items-center sp-gap-9",
	children: [
		/* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-[58.273px] sp-w-[45px]",
			children: [/* @__PURE__ */ g(Yy, {
				alt: e.username,
				className: "sp-box-border sp-h-[45px] sp-w-[45px] sp-border-2 sp-border-white",
				src: e.profilePicture
			}), /* @__PURE__ */ g("span", {
				className: "sp-absolute sp-bottom-[-10px] sp-left-1/2 sp-flex sp-h-[20px] sp-w-[20px] -sp-translate-x-1/2 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#fe2c55] sp-text-lg sp-font-semibold sp-leading-none",
				children: "+"
			})]
		}),
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-[31px] sp-w-[34.207px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ g(sD, {})
		}),
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-[33.246px] sp-w-[34.354px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ g(cD, {})
		}),
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-[27.491px] sp-w-[35.51px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ g(lD, {})
		})
	]
}), $E = ({ captionExpanded: e, onCaptionExpandedChange: t, post: n, trackEvent: r }) => {
	let i = $b(n.caption);
	return /* @__PURE__ */ _("div", {
		className: ["sp-absolute sp-left-4 sp-w-[315px] sp-text-sm sp-leading-[1.1]", i ? "sp-bottom-[84px] sp-min-h-[64px]" : "sp-top-[708px]"].join(" "),
		"data-uplift-tiktok-caption": "true",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-font-bold sp-leading-normal",
			children: n.username
		}), i ? /* @__PURE__ */ g(zy, {
			buttonClassName: "sp-font-medium sp-leading-[1.33] sp-text-white sp-opacity-80",
			caption: n.caption,
			charsPerLine: 36,
			className: "sp-mt-1",
			collapsedLines: WE,
			contentClassName: "sp-pr-2",
			expanded: e,
			onExpandedChange: t,
			scrollOnExpandMaxHeight: 200,
			targetPlatform: "TT",
			trackEvent: r
		}) : null]
	});
}, eD = () => /* @__PURE__ */ _("nav", {
	className: "sp-absolute sp-left-0 sp-top-[786px] sp-h-[70px] sp-w-full sp-bg-[#070707]",
	children: [
		/* @__PURE__ */ g(tD, {
			className: "sp-left-[26px] sp-top-1.5 sp-w-[26px]",
			icon: /* @__PURE__ */ g(uD, {}),
			label: "Home"
		}),
		/* @__PURE__ */ g(tD, {
			className: "sp-left-[104px] sp-top-2 sp-w-[33px]",
			icon: /* @__PURE__ */ g(dD, {}),
			label: "Friends"
		}),
		/* @__PURE__ */ g(nD, {}),
		/* @__PURE__ */ g(tD, {
			className: "sp-left-[268px] sp-top-2 sp-w-6",
			icon: /* @__PURE__ */ g(fD, {}),
			label: "Inbox"
		}),
		/* @__PURE__ */ g(tD, {
			className: "sp-left-[346px] sp-top-2 sp-w-7",
			icon: /* @__PURE__ */ g(pD, {}),
			label: "Profile"
		})
	]
}), tD = ({ className: e, icon: t, label: n }) => /* @__PURE__ */ _("div", {
	className: ["sp-absolute sp-flex sp-flex-col sp-items-center sp-gap-0.5 sp-text-[9px] sp-font-medium sp-leading-[1.33]", e].join(" "),
	children: [t, /* @__PURE__ */ g("span", { children: n })]
}), nD = () => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-[178.49px] sp-top-2 sp-h-[29.318px] sp-w-[44.821px]",
	children: [
		/* @__PURE__ */ g("span", { className: "sp-absolute sp-left-[7.91px] sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#fe2c55]" }),
		/* @__PURE__ */ g("span", { className: "sp-absolute sp-left-0 sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#20d5ec]" }),
		/* @__PURE__ */ g("span", {
			className: "sp-absolute sp-left-[3.955px] sp-top-0 sp-flex sp-h-[29.002px] sp-w-[36.912px] sp-items-center sp-justify-center sp-rounded-[6.435px] sp-bg-white sp-text-[23px] sp-leading-none sp-text-[#333]",
			children: "+"
		})
	]
}), rD = (e) => (e.medias.collection.length ? e.medias.collection : [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}]).filter(Boolean), iD = (e) => Tb(e), aD = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), oD = ({ className: e }) => /* @__PURE__ */ g(aD, {
	className: e ?? "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ g("path", {
		d: "m20 20-4.3-4.3m2.3-5.2a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2.2"
	})
}), sD = () => /* @__PURE__ */ g(aD, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: /* @__PURE__ */ g("path", { d: "M12 21.4 10.6 20C5.6 15.5 2.3 12.5 2.3 8.8 2.3 5.8 4.7 3.5 7.6 3.5c1.7 0 3.3.8 4.4 2 1-1.2 2.7-2 4.4-2 3 0 5.3 2.3 5.3 5.3 0 3.7-3.3 6.7-8.3 11.2L12 21.4Z" })
}), cD = () => /* @__PURE__ */ _(aD, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: [
		/* @__PURE__ */ g("path", { d: "M4 11.5C4 7.4 7.6 4 12 4s8 3.4 8 7.5S16.4 19 12 19c-.8 0-1.7-.1-2.4-.4L5.7 21l1-3.9A7.2 7.2 0 0 1 4 11.5Z" }),
		/* @__PURE__ */ g("circle", {
			cx: "8.8",
			cy: "11.5",
			fill: "black",
			r: "1"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "11.5",
			fill: "black",
			r: "1"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "15.2",
			cy: "11.5",
			fill: "black",
			r: "1"
		})
	]
}), lD = () => /* @__PURE__ */ g(aD, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: /* @__PURE__ */ g("path", { d: "M20 3v7.2C12.6 10.7 8.2 14.1 6.4 21 5.8 14 9.2 8.1 20 7.3V3Z" })
}), uD = () => /* @__PURE__ */ g(aD, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 22,
	children: /* @__PURE__ */ g("path", { d: "M3 10.5 11 3l8 7.5V20h-5v-6H8v6H3v-9.5Z" })
}), dD = () => /* @__PURE__ */ g(aD, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ g("path", {
		d: "M8.5 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3 19c.5-3.4 2.4-5.2 5.5-5.2S13.5 15.6 14 19H3Zm10.5-3.8c.7-.7 1.6-1 2.8-1 2.3 0 3.7 1.3 4.1 3.8h-4.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), fD = () => /* @__PURE__ */ _(aD, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ g("path", {
		d: "M4 5h16v12H8l-4 3V5Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ g("path", {
		d: "M8 9h8M8 13h5",
		stroke: "currentColor",
		strokeWidth: "1.8"
	})]
}), pD = () => /* @__PURE__ */ _(aD, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ g("circle", {
		cx: "12",
		cy: "7",
		r: "3.2",
		stroke: "currentColor",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ g("path", {
		d: "M5 20c.8-4.1 3.1-6.1 7-6.1s6.2 2 7 6.1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "1.8"
	})]
}), mD = /* @__PURE__ */ new Set([
	"gmb",
	"image",
	"multiMedia",
	"text",
	"video"
]), hD = 20, gD = 2, _D = 5, vD = 8, yD = 4, bD = 435, xD = 559, SD = 44, CD = 17, wD = 360, TD = 484, ED = 24, DD = 16, OD = 40, kD = (e) => e.platform === "GMB" && mD.has(e.type) && !!GD(e), AD = ({ post: e, className: t, videoCoverPreview: n }) => {
	let r = GD(e), i = KD(e), a = qD(e.callToAction), o = JD(e.event), [s, c] = m(!1), l = !!(o && YD(o)) && (e.topicType === "EVENT" || e.topicType === "OFFER" || r === "gmb-single-image-buy" || r === "gmb-single-image-sign-up"), u = $b(e.caption);
	if (!r) return null;
	let d = eO({
		action: a,
		caption: e.caption,
		expanded: s,
		hasCaption: u,
		layout: r
	});
	return /* @__PURE__ */ _("article", {
		className: sO("sp-relative sp-mx-auto sp-w-[400px] sp-overflow-hidden sp-rounded-lg sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", !d && $D(r, u), t),
		"data-preview-platform": "GMB",
		"data-preview-variant": "uplift",
		"data-uplift-layout": r,
		"data-uplift-renderer": "google-my-business",
		style: d,
		children: [
			/* @__PURE__ */ g(jD, { post: e }),
			r === "gmb-text" ? /* @__PURE__ */ g(MD, {
				action: a,
				caption: e.caption,
				captionExpanded: s,
				collapsedLines: _D,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-link" ? /* @__PURE__ */ g(MD, {
				action: a,
				caption: e.caption,
				captionExpanded: s,
				collapsedLines: vD,
				onCaptionExpandedChange: c
			}) : null,
			r.startsWith("gmb-single-image") ? /* @__PURE__ */ g(ND, {
				action: a,
				event: o,
				media: i[0],
				post: e,
				showEvent: l,
				hasCaption: u,
				captionExpanded: s,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-carousel" || r === "gmb-carousel-book" ? /* @__PURE__ */ g(PD, {
				action: a,
				hasCaption: u,
				medias: i,
				post: e,
				captionExpanded: s,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-video" || r === "gmb-video-learn-more" ? /* @__PURE__ */ g(FD, {
				action: a,
				hasCaption: u,
				media: i[0],
				post: e,
				captionExpanded: s,
				onCaptionExpandedChange: c,
				videoCoverPreview: n
			}) : null
		]
	});
}, jD = ({ post: e }) => /* @__PURE__ */ _("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-gap-2",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-relative sp-h-12 sp-w-12 sp-shrink-0",
		children: [/* @__PURE__ */ g(Yy, {
			alt: e.username,
			className: "sp-h-12 sp-w-12",
			src: e.profilePicture
		}), /* @__PURE__ */ g(pO, {})]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-flex-1 sp-items-center sp-justify-between",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-min-w-0 sp-flex-col sp-justify-center sp-gap-1",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-base sp-font-normal sp-leading-none sp-text-black",
				children: e.username
			}), /* @__PURE__ */ g("div", {
				className: "sp-text-sm sp-font-normal sp-leading-none sp-text-[#4d4d4d]",
				children: "Just now"
			})]
		}), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-shrink-0 sp-items-start sp-gap-2 sp-text-black",
			children: [/* @__PURE__ */ g(mO, {}), /* @__PURE__ */ g(hO, {})]
		})]
	})]
}), MD = ({ action: e, caption: t, captionExpanded: n, collapsedLines: r, onCaptionExpandedChange: i }) => /* @__PURE__ */ _("div", {
	className: "sp-ml-[15px] sp-mr-[17px] sp-pt-[75px] sp-pb-[17px]",
	children: [/* @__PURE__ */ g(LD, {
		caption: t,
		collapsedLines: r,
		expanded: n,
		onExpandedChange: i
	}), /* @__PURE__ */ g(WD, {
		action: e,
		className: "sp-static sp-mt-6"
	})]
}), ND = ({ action: e, event: t, media: n, post: r, hasCaption: i, captionExpanded: a, onCaptionExpandedChange: o, showEvent: s }) => /* @__PURE__ */ _("div", {
	className: "sp-pt-[79px]",
	children: [/* @__PURE__ */ g(HD, { media: n }), /* @__PURE__ */ _("div", {
		className: "sp-ml-[15px] sp-mr-[17px] sp-mt-4 sp-pb-[17px]",
		children: [
			s ? /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(BD, { event: t }), /* @__PURE__ */ g(VD, { event: t })] }) : null,
			i ? /* @__PURE__ */ g(LD, {
				caption: r.caption,
				className: s ? "sp-mt-4" : void 0,
				collapsedLines: _D,
				expanded: a,
				onExpandedChange: o
			}) : null,
			/* @__PURE__ */ g(WD, {
				action: e,
				className: "sp-static sp-mt-6"
			})
		]
	})]
}), PD = ({ action: e, captionExpanded: t, hasCaption: n, medias: r, onCaptionExpandedChange: i, post: a }) => {
	let [o, s] = m(0), c = Math.min(o, Math.max(0, r.length - 1)), l = nO({
		caption: a.caption,
		collapsedLines: yD,
		defaultTop: xD,
		expanded: t,
		gap: SD,
		hasCaption: n,
		top: bD
	});
	return /* @__PURE__ */ _(h, { children: [
		/* @__PURE__ */ g("div", {
			className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[340px] sp-w-[400px] sp-overflow-hidden",
			children: /* @__PURE__ */ g($y, {
				ariaLabel: "Google Business media carousel",
				arrowClassName: "sp-z-20",
				medias: r,
				onIndexChange: s,
				renderSlide: (e, { index: t }) => /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(UD, {
					className: "sp-left-0 sp-top-0 sp-h-[340px] sp-w-[340px]",
					media: e,
					surface: "carousel"
				}), r[t + 1] ? /* @__PURE__ */ g(UD, {
					className: "sp-left-[348px] sp-top-0 sp-h-[340px] sp-w-[340px]",
					media: r[t + 1],
					surface: "carousel"
				}) : null] }),
				showCount: !1,
				showDots: !1
			})
		}),
		/* @__PURE__ */ _("span", {
			className: "sp-absolute sp-left-[347px] sp-top-[95px] sp-rounded-[24px] sp-bg-black/40 sp-px-2 sp-py-0.5 sp-text-xs sp-font-medium sp-leading-5 sp-text-white",
			"data-uplift-carousel-counter": "true",
			children: [
				c + 1,
				"/",
				Math.max(1, r.length)
			]
		}),
		n ? /* @__PURE__ */ g(ID, {
			caption: a.caption,
			className: "sp-left-4 sp-top-[435px]",
			collapsedLines: yD,
			expanded: t,
			onExpandedChange: i
		}) : null,
		/* @__PURE__ */ g(WD, {
			action: e,
			style: { top: n ? l : 435 }
		})
	] });
}, FD = ({ action: e, captionExpanded: t, hasCaption: n, media: r, onCaptionExpandedChange: i, post: a, videoCoverPreview: o }) => {
	let s = r?.url || a.imageUrl || r?.thumbnailUrl || "", c = o || r?.thumbnailUrl || a.imageUrl || s, l = nO({
		caption: a.caption,
		collapsedLines: _D,
		defaultTop: TD,
		expanded: t,
		gap: ED,
		hasCaption: n,
		top: wD
	});
	return /* @__PURE__ */ _(h, { children: [
		/* @__PURE__ */ g("div", {
			className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]",
			"data-uplift-media-frame-ratio": "400 / 264",
			children: /* @__PURE__ */ g(zb, {
				className: "sp-h-full sp-w-full",
				coverScope: "singlePostOnly",
				customVideoControls: !0,
				media: {
					...r || {},
					isVideo: !0,
					thumbnailUrl: c,
					url: s
				},
				platform: "GMB",
				surface: "video",
				videoCoverPreview: o,
				videoScrubberClassName: "sp-bottom-0"
			})
		}),
		n ? /* @__PURE__ */ g(ID, {
			caption: a.caption,
			className: "sp-left-4 sp-top-[360px]",
			collapsedLines: _D,
			expanded: t,
			onExpandedChange: i
		}) : null,
		/* @__PURE__ */ g(WD, {
			action: e,
			style: { top: n ? l : 360 }
		})
	] });
}, ID = ({ caption: e = "", className: t, collapsedLines: n, expanded: r, onExpandedChange: i }) => $b(e) ? /* @__PURE__ */ g("div", {
	className: sO("sp-absolute sp-w-[368px] sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", t),
	children: /* @__PURE__ */ g(RD, {
		caption: e,
		collapsedLines: n,
		expanded: r,
		onExpandedChange: i
	})
}) : null, LD = ({ caption: e = "", className: t, collapsedLines: n, expanded: r, onExpandedChange: i }) => $b(e) ? /* @__PURE__ */ g("div", {
	className: sO("sp-w-full sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", t),
	children: /* @__PURE__ */ g(RD, {
		caption: e,
		collapsedLines: n,
		expanded: r,
		onExpandedChange: i
	})
}) : null, RD = ({ caption: e, collapsedLines: t, expanded: n, onExpandedChange: r }) => /* @__PURE__ */ g(zy, {
	buttonClassName: "sp-text-[#4d4d4d]",
	caption: e,
	charsPerLine: 55,
	collapsedLines: t,
	contentClassName: "sp-whitespace-pre-line",
	expanded: n,
	onExpandedChange: r,
	renderCaption: ({ caption: e }) => /* @__PURE__ */ g(zD, { caption: e }),
	wideCharacterWeight: gD
}), zD = ({ caption: e }) => {
	if (!e) return null;
	let t = e.replace(/\r\n?/g, "\n").split(cO);
	return /* @__PURE__ */ g(h, { children: t.map((e, t) => e ? lO.test(e) ? /* @__PURE__ */ g("a", {
		href: e,
		rel: "noreferrer",
		target: "_blank",
		children: e
	}, `${e}-${t}`) : e : null) });
}, BD = ({ event: e }) => /* @__PURE__ */ g("p", {
	className: "sp-m-0 sp-w-full sp-truncate sp-text-xl sp-font-medium sp-leading-7 sp-text-[#202125]",
	children: e?.title || "PINK NOSE DOG"
}), VD = ({ event: e }) => {
	let t = XD(e);
	return /* @__PURE__ */ g("p", {
		className: "sp-m-0 sp-mt-[10px] sp-w-full sp-truncate sp-text-sm sp-font-medium sp-leading-5 sp-text-[#70747a]",
		children: t
	});
}, HD = ({ media: e }) => {
	let t = e?.url || e?.thumbnailUrl || "";
	return /* @__PURE__ */ g("div", {
		className: "sp-ml-[-1px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]",
		"data-uplift-media-frame-ratio": "400 / 264",
		children: t ? /* @__PURE__ */ g(zb, {
			media: e,
			platform: "GMB",
			surface: "feed"
		}) : null
	});
}, UD = ({ className: e, media: t, surface: n = "feed" }) => {
	let r = t?.url || t?.thumbnailUrl || "";
	return /* @__PURE__ */ g("div", {
		className: sO("sp-absolute sp-overflow-hidden sp-bg-[#e6e6e6]", e || "sp-left-0 sp-top-[80px] sp-h-[264px] sp-w-[400px]"),
		"data-uplift-media-frame-ratio": n === "carousel" ? "1 / 1" : "400 / 264",
		children: r ? /* @__PURE__ */ g(zb, {
			media: t,
			platform: "GMB",
			surface: n
		}) : null
	});
}, WD = ({ action: e, className: t, style: n }) => {
	if (!e) return null;
	let r = t?.includes("sp-static"), i = /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(fO, { icon: e.icon }), /* @__PURE__ */ g("span", {
		className: "sp-text-sm sp-font-medium sp-leading-5 sp-text-[#3771e0]",
		children: e.label
	})] }), a = sO(r ? null : "sp-absolute sp-left-4", "sp-box-border sp-flex sp-h-10 sp-w-fit sp-items-center sp-gap-1 sp-rounded-[20px] sp-border sp-border-solid sp-border-[#c4c4c4] sp-px-4 sp-py-2 sp-text-[#3771e0] sp-no-underline", t);
	return e.url ? /* @__PURE__ */ g("a", {
		className: a,
		href: e.url,
		rel: "noreferrer",
		style: n,
		target: "_blank",
		children: i
	}) : /* @__PURE__ */ g("div", {
		className: a,
		style: n,
		children: i
	});
}, GD = (e) => {
	let t = KD(e), n = qD(e.callToAction), r = t.length > 0, i = t.some(oO);
	if (!r && (e.type === "text" || e.type === "gmb")) return e.redirectUrl ? "gmb-link" : "gmb-text";
	if (i) return n ? n.actionType === "LEARN_MORE" ? "gmb-video-learn-more" : null : "gmb-video";
	if (t.length > 1) return n ? n.actionType === "BOOK" ? "gmb-carousel-book" : null : "gmb-carousel";
	if (!r) return null;
	if (!n) return "gmb-single-image";
	switch (n.actionType) {
		case "BOOK": return "gmb-single-image-book";
		case "LEARN_MORE": return "gmb-single-image-learn-more";
		case "SHOP": return "gmb-single-image-buy";
		case "SIGN_UP": return "gmb-single-image-sign-up";
		default: return "gmb-single-image";
	}
}, KD = (e) => (e.medias.collection.length ? e.medias.collection : e.imageUrl ? [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}] : []).filter(Boolean), qD = (e) => {
	if (!e || typeof e == "string") return null;
	switch (e.actionType) {
		case "BOOK": return {
			actionType: "BOOK",
			icon: "book",
			label: "Book",
			url: e.url
		};
		case "CALL": return {
			actionType: "CALL",
			icon: "info",
			label: "Call now",
			url: e.url
		};
		case "LEARN_MORE": return {
			actionType: "LEARN_MORE",
			icon: "info",
			label: "Learn more",
			url: e.url
		};
		case "ORDER": return {
			actionType: "ORDER",
			icon: "shopping-cart",
			label: "Order online",
			url: e.url
		};
		case "SHOP": return {
			actionType: "SHOP",
			icon: "shopping-cart",
			label: "Buy",
			url: e.url
		};
		case "SIGN_UP": return {
			actionType: "SIGN_UP",
			icon: "book",
			label: "Sign up",
			url: e.url
		};
		default: return null;
	}
}, JD = (e) => e && typeof e == "object" ? e : null, YD = (e) => !!(e && typeof e == "object" && e.title && e.startDate && e.endDate), XD = (e) => {
	if (!e?.startDate || !e?.endDate) return "";
	let t = new Date(e.startDate), n = new Date(e.endDate);
	return Number.isNaN(t.getTime()) || Number.isNaN(n.getTime()) ? "" : `${ZD(t)}, ${QD(t)} - ${QD(n)}`;
}, ZD = (e) => new Intl.DateTimeFormat("en-GB", {
	day: "2-digit",
	month: "short",
	timeZone: "UTC"
}).format(e), QD = (e) => new Intl.DateTimeFormat("en-US", {
	hour: "numeric",
	hour12: !0,
	minute: "2-digit",
	timeZone: "UTC"
}).format(e).toLowerCase(), $D = (e, t) => {
	if (!t) switch (e) {
		case "gmb-carousel":
		case "gmb-carousel-book": return "sp-h-[492px]";
		case "gmb-single-image":
		case "gmb-single-image-book":
		case "gmb-single-image-buy":
		case "gmb-single-image-learn-more":
		case "gmb-single-image-sign-up": return "sp-min-h-[416px]";
		case "gmb-link":
		case "gmb-text": return "sp-min-h-[88px]";
		default: return "sp-h-[416px]";
	}
	switch (e) {
		case "gmb-carousel":
		case "gmb-carousel-book": return "sp-h-[616px]";
		case "gmb-single-image":
		case "gmb-single-image-book":
		case "gmb-single-image-buy":
		case "gmb-single-image-learn-more":
		case "gmb-single-image-sign-up": return "sp-min-h-[416px]";
		case "gmb-link": return "sp-min-h-[252px]";
		case "gmb-text": return "sp-min-h-[192px]";
		default: return "sp-h-[540px]";
	}
}, eO = ({ action: e, caption: t, expanded: n, hasCaption: r, layout: i }) => {
	if (r) {
		if (i === "gmb-carousel" || i === "gmb-carousel-book") return { height: tO({
			action: e,
			bottomPadding: CD,
			caption: t,
			collapsedLines: yD,
			defaultHeight: 616,
			expanded: n,
			gap: SD,
			top: bD
		}) };
		if (i === "gmb-video" || i === "gmb-video-learn-more") return { height: tO({
			action: e,
			bottomPadding: DD,
			caption: t,
			collapsedLines: _D,
			defaultHeight: 540,
			expanded: n,
			gap: ED,
			top: wD
		}) };
	}
}, tO = ({ action: e, bottomPadding: t, caption: n, collapsedLines: r, defaultHeight: i, expanded: a, gap: o, top: s }) => {
	let c = s + rO({
		caption: n,
		collapsedLines: r,
		expanded: a
	}) + o + (e ? OD : 0) + t;
	return Math.max(i, c);
}, nO = ({ caption: e, collapsedLines: t, defaultTop: n, expanded: r, gap: i, hasCaption: a, top: o }) => {
	if (!a) return n;
	let s = rO({
		caption: e,
		collapsedLines: t,
		expanded: r
	});
	return Math.max(n, o + s + i);
}, rO = ({ caption: e = "", collapsedLines: t, expanded: n }) => {
	let r = iO(e);
	return Math.min(n ? r : t, r) * hD;
}, iO = (e) => {
	let t = e.trim();
	return t ? t.split(/\r\n?|\n/).reduce((e, t) => {
		let n = Array.from(t).reduce((e, t) => e + aO(t), 0);
		return e + Math.max(1, Math.ceil(n / 55));
	}, 0) : 0;
}, aO = (e) => uO.test(e) ? gD : 1, oO = (e) => Tb(e), sO = (...e) => e.filter(Boolean).join(" "), cO = /(https?:\/\/[^\s]+)/g, lO = /^https?:\/\/[^\s]+$/, uO = /[\u1100-\u11ff\u2e80-\u9fff\uf900-\ufaff\uac00-\ud7af]/u, dO = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), fO = ({ icon: e }) => {
	switch (e) {
		case "book": return /* @__PURE__ */ g(gO, {});
		case "shopping-cart": return /* @__PURE__ */ g(vO, {});
		default: return /* @__PURE__ */ g(_O, {});
	}
}, pO = () => /* @__PURE__ */ _(dO, {
	className: "sp-absolute -sp-bottom-1 -sp-right-1",
	fill: "none",
	size: 24,
	viewBox: "0 0 24 24",
	children: [/* @__PURE__ */ g("path", {
		d: "M12 2.5 5 5.6v5.7c0 4.4 2.8 8.4 7 9.9 4.2-1.5 7-5.5 7-9.9V5.6l-7-3.1Z",
		fill: "#3771e0"
	}), /* @__PURE__ */ g("path", {
		d: "m8.1 11.8 2.5 2.5 5.4-5.7",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})]
}), mO = () => /* @__PURE__ */ g(dO, { children: /* @__PURE__ */ g("path", {
	d: "M12 4v10m0-10 3.5 3.5M12 4 8.5 7.5M5 11v8h14v-8",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), hO = () => /* @__PURE__ */ _(dO, {
	fill: "currentColor",
	children: [
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "5",
			r: "1.8"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "12",
			r: "1.8"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "19",
			r: "1.8"
		})
	]
}), gO = () => /* @__PURE__ */ g(dO, { children: /* @__PURE__ */ g("path", {
	d: "M7 4h10v16l-5-3-5 3V4Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), _O = () => /* @__PURE__ */ _(dO, { children: [/* @__PURE__ */ g("circle", {
	cx: "12",
	cy: "12",
	r: "9",
	stroke: "currentColor",
	strokeWidth: "2"
}), /* @__PURE__ */ g("path", {
	d: "M12 10v6m0-9h.01",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "2"
})] }), vO = () => /* @__PURE__ */ g(dO, { children: /* @__PURE__ */ g("path", {
	d: "M4 5h2l2 10h9.5l2-7H7m2 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), yO = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"story",
	"video"
]), bO = (e) => e.platform === "SC" && yO.has(e.type) && !!EO(e), xO = ({ post: e, className: t, videoCoverPreview: n }) => {
	let r = EO(e);
	return r ? /* @__PURE__ */ _("div", {
		className: ["sp-relative sp-mx-auto sp-h-[823px] sp-w-[400px] sp-overflow-hidden sp-rounded-t-[16px] sp-bg-[#1e1e1e] sp-font-sans sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "SC",
		"data-preview-variant": "uplift",
		"data-snapchat-media-count": e.medias.count,
		"data-uplift-layout": "snapchat-default",
		"data-uplift-renderer": "snapchat",
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-absolute sp-left-0 sp-top-0 sp-h-[704px] sp-w-full sp-overflow-hidden sp-bg-white",
				"data-uplift-media-frame-ratio": "400 / 704",
				children: [/* @__PURE__ */ g(SO, {
					media: r,
					videoCoverPreview: n
				}), /* @__PURE__ */ g(CO, { post: e })]
			}),
			/* @__PURE__ */ g("div", { className: "sp-absolute sp-left-[180.5px] sp-top-[712px] sp-h-[6px] sp-w-[39px] sp-rounded-lg sp-bg-[#717171]" }),
			/* @__PURE__ */ g(wO, {})
		]
	}) : null;
}, SO = ({ media: e, videoCoverPreview: t }) => /* @__PURE__ */ g(zb, {
	className: "sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full sp-bg-[#f2f2f2] sp-object-cover",
	coverScope: "singlePostOnly",
	customVideoControls: DO(e),
	media: e,
	platform: "SC",
	surface: "story",
	videoCoverPreview: t,
	videoScrubberClassName: "sp-bottom-0"
}), CO = ({ post: e }) => /* @__PURE__ */ _("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-justify-between sp-text-white",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ g(Yy, {
			alt: e.username,
			className: "sp-h-10 sp-w-10 sp-shrink-0",
			src: e.profilePicture
		}), /* @__PURE__ */ _("div", {
			className: "sp-min-w-0",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), /* @__PURE__ */ g("div", {
				className: "sp-text-xs sp-font-medium sp-leading-4 sp-text-white/80",
				children: "Just now"
			})]
		})]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-shrink-0 sp-items-center sp-gap-4",
		children: [/* @__PURE__ */ g(kO, {}), /* @__PURE__ */ g(AO, {})]
	})]
}), wO = () => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-0 sp-top-[726px] sp-box-border sp-flex sp-h-[50px] sp-w-full sp-items-start sp-gap-4 sp-px-2",
	children: [
		/* @__PURE__ */ g(TO, {
			className: "sp-w-16",
			children: /* @__PURE__ */ g(jO, {})
		}),
		/* @__PURE__ */ g("div", {
			className: "sp-flex sp-h-[50px] sp-min-w-0 sp-flex-1 sp-items-center sp-rounded-[40px] sp-bg-[#404040] sp-px-4 sp-text-base sp-font-semibold sp-leading-5",
			children: "Send a Chat"
		}),
		/* @__PURE__ */ g(TO, {
			className: "sp-w-16",
			children: /* @__PURE__ */ g(MO, {})
		})
	]
}), TO = ({ children: e, className: t }) => /* @__PURE__ */ g("div", {
	className: ["sp-flex sp-h-[50px] sp-shrink-0 sp-items-center sp-justify-center sp-rounded-[40px] sp-bg-[#404040] sp-text-white", t].filter(Boolean).join(" "),
	children: e
}), EO = (e) => {
	let t = e.medias.collection[0];
	return t?.url || t?.thumbnailUrl ? t : e.imageUrl ? {
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	} : null;
}, DO = (e) => Tb(e), OO = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), kO = () => /* @__PURE__ */ _(OO, {
	size: 24,
	children: [/* @__PURE__ */ g("path", {
		d: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	}), /* @__PURE__ */ g("path", {
		d: "M13.7 21a2 2 0 0 1-3.4 0",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})]
}), AO = () => /* @__PURE__ */ _(OO, {
	fill: "currentColor",
	size: 24,
	children: [
		/* @__PURE__ */ g("circle", {
			cx: "5",
			cy: "12",
			r: "2"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "12",
			r: "2"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "19",
			cy: "12",
			r: "2"
		})
	]
}), jO = () => /* @__PURE__ */ _(OO, {
	size: 32,
	viewBox: "0 0 32 32",
	children: [/* @__PURE__ */ g("path", {
		d: "M9.5 10 11 7h10l1.5 3H26a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.5Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "2.4"
	}), /* @__PURE__ */ g("circle", {
		cx: "16",
		cy: "17",
		r: "5",
		stroke: "currentColor",
		strokeWidth: "2.4"
	})]
}), MO = () => /* @__PURE__ */ g(OO, {
	fill: "currentColor",
	size: 32,
	viewBox: "0 0 32 32",
	children: /* @__PURE__ */ g("path", { d: "M27.6 4.8 4.5 15.1c-1.8.8-1.6 3.5.3 4l8.1 2.1 2.1 8.1c.5 1.9 3.2 2.1 4 .3L29.2 6.4c.5-1.1-.5-2.1-1.6-1.6Zm-5.5 7.1-5.8 13.2-1.2-4.8 7-8.4Zm-8.4 7-4.8-1.2 13.2-5.8-8.4 7Z" })
}), NO = 3, PO = (e) => e.platform === "YT" && e.type === "video", FO = ({ post: e, className: t, videoCoverPreview: n }) => {
	let { medias: r, reportIntrinsicDimensions: i } = Vb([zO(e)]), a = r[0], o = $b(e.caption), [s, c] = m(!1), l = Ob({
		media: a,
		platform: "YT",
		surface: "video"
	});
	return /* @__PURE__ */ _("article", {
		className: ["sp-mx-auto sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "YT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": "youtube-video",
		"data-uplift-renderer": "youtube",
		children: [/* @__PURE__ */ g("div", {
			className: "sp-relative sp-w-full sp-overflow-hidden sp-bg-black",
			"data-uplift-media-frame-ratio": l.publishedRatio,
			style: { aspectRatio: l.publishedRatio },
			children: /* @__PURE__ */ g(zb, {
				className: "sp-h-full sp-w-full",
				coverScope: "singlePostOnly",
				media: a,
				onIntrinsicDimensions: i,
				platform: "YT",
				surface: "video",
				videoCoverPreview: n
			})
		}), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-col sp-gap-3 sp-p-4",
			children: [
				/* @__PURE__ */ g("div", {
					className: "sp-line-clamp-2 sp-text-lg sp-font-semibold sp-leading-6",
					children: e.ytTitle || "Untitled video"
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-flex sp-items-center sp-gap-3",
					children: [/* @__PURE__ */ g(Yy, {
						alt: e.username,
						className: "sp-h-10 sp-w-10",
						src: e.profilePicture
					}), /* @__PURE__ */ _("div", {
						className: "sp-min-w-0",
						children: [/* @__PURE__ */ g("div", {
							className: "sp-truncate sp-text-sm sp-font-semibold sp-leading-5",
							children: e.username
						}), /* @__PURE__ */ g("div", {
							className: "sp-text-xs sp-leading-4 sp-text-[#606060]",
							children: "Just now"
						})]
					})]
				}),
				o ? /* @__PURE__ */ g(IO, {
					caption: e.caption,
					expanded: s,
					onExpandedChange: c
				}) : null,
				/* @__PURE__ */ g(LO, {})
			]
		})]
	});
}, IO = ({ caption: e, expanded: t, onExpandedChange: n }) => /* @__PURE__ */ g("div", {
	className: "sp-whitespace-pre-line sp-break-words sp-text-sm sp-leading-5 sp-text-[#333] [&_a]:sp-text-[#065fd4] [&_a]:sp-no-underline",
	children: /* @__PURE__ */ g(zy, {
		buttonClassName: "sp-text-[#606060]",
		caption: e,
		charsPerLine: 48,
		collapsedLines: NO,
		contentClassName: "sp-whitespace-pre-line",
		expanded: t,
		onExpandedChange: n
	})
}), LO = () => /* @__PURE__ */ _("footer", {
	className: "sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-pt-3 sp-text-xs sp-font-medium sp-leading-none sp-text-[#606060]",
	children: [
		/* @__PURE__ */ g(RO, {
			icon: /* @__PURE__ */ g(VO, {}),
			label: "Like"
		}),
		/* @__PURE__ */ g(RO, {
			icon: /* @__PURE__ */ g(HO, {}),
			label: "Comment"
		}),
		/* @__PURE__ */ g(RO, {
			icon: /* @__PURE__ */ g(UO, {}),
			label: "Share"
		})
	]
}), RO = ({ icon: e, label: t }) => /* @__PURE__ */ _("span", {
	className: "sp-flex sp-items-center sp-gap-1.5",
	children: [e, t]
}), zO = (e) => e.medias.collection[0] || {
	isVideo: !0,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}, BO = ({ children: e }) => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: e
}), VO = () => /* @__PURE__ */ g(BO, { children: /* @__PURE__ */ g("path", {
	d: "M7 10v10H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3Zm0 0 4.6-6.2c.6-.8 1.9-.4 1.9.6V9h4.3a2 2 0 0 1 2 2.3l-1 6.5a2 2 0 0 1-2 1.7H7V10Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), HO = () => /* @__PURE__ */ g(BO, { children: /* @__PURE__ */ g("path", {
	d: "M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), UO = () => /* @__PURE__ */ _(BO, { children: [/* @__PURE__ */ g("path", {
	d: "M18 8 8 13l10 5V8Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}), /* @__PURE__ */ g("path", {
	d: "M8 13H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "1.8"
})] }), WO = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"story",
	"text",
	"video"
]), GO = 4, KO = (e) => e.platform === "OT" && WO.has(e.type), qO = ({ post: e, className: t, videoCoverPreview: n }) => {
	let { medias: r, reportIntrinsicDimensions: i } = Vb($O(e)), a = r[0], o = ek(e, a), s = $b(e.caption), [c, l] = m(!1);
	return /* @__PURE__ */ _("article", {
		className: ["sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "OT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": o,
		"data-uplift-renderer": "other-notification",
		children: [
			/* @__PURE__ */ g(JO, { post: e }),
			s ? /* @__PURE__ */ g(YO, {
				caption: e.caption,
				expanded: c,
				onExpandedChange: l
			}) : null,
			a ? /* @__PURE__ */ g(XO, {
				medias: r,
				onIntrinsicDimensions: i,
				post: e,
				videoCoverPreview: n
			}) : null,
			e.redirectUrl && !a ? /* @__PURE__ */ g(ZO, { url: e.redirectUrl }) : null,
			/* @__PURE__ */ g(QO, { hasRedirect: !!e.redirectUrl })
		]
	});
}, JO = ({ post: e }) => /* @__PURE__ */ _("header", {
	className: "sp-flex sp-items-center sp-gap-3 sp-p-4 sp-pb-0",
	children: [
		/* @__PURE__ */ g(Yy, {
			alt: e.username,
			className: "sp-h-10 sp-w-10 sp-shrink-0",
			src: e.profilePicture
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-min-w-0 sp-flex-1",
			children: [/* @__PURE__ */ g("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), /* @__PURE__ */ g("div", {
				className: "sp-text-sm sp-leading-5 sp-text-[#737373]",
				children: "Notification preview"
			})]
		}),
		/* @__PURE__ */ g(nk, {})
	]
}), YO = ({ caption: e, expanded: t, onExpandedChange: n }) => /* @__PURE__ */ g("div", {
	className: "sp-whitespace-pre-line sp-break-words sp-px-4 sp-pt-3 sp-text-base sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline",
	children: /* @__PURE__ */ g(zy, {
		buttonClassName: "sp-text-[#737373]",
		caption: e,
		charsPerLine: 44,
		collapsedLines: GO,
		contentClassName: "sp-whitespace-pre-line",
		expanded: t,
		onExpandedChange: n,
		renderCaption: ({ caption: e }) => /* @__PURE__ */ g(Gp, { caption: e })
	})
}), XO = ({ medias: e, onIntrinsicDimensions: t, post: n, videoCoverPreview: r }) => {
	let i = e[0], a = e.length > 1, o = a ? "carousel" : n.type === "story" ? "story" : "feed", s = Ob({
		media: i,
		platform: "OT",
		surface: Tb(i) ? "video" : o
	}), c = (i, s, c) => {
		let l = Tb(i), u = /* @__PURE__ */ g(zb, {
			className: "sp-h-full sp-w-full",
			coverScope: a ? "firstVideoOnly" : "singlePostOnly",
			isActive: c,
			media: i,
			mediaCount: e.length,
			mediaIndex: Eb(e, s),
			measureWhenInactive: s === 0,
			onIntrinsicDimensions: t,
			platform: "OT",
			surface: l ? "video" : o,
			videoCoverPreview: l ? r : void 0
		});
		return n.redirectUrl ? /* @__PURE__ */ g("a", {
			className: "sp-block sp-h-full sp-w-full sp-text-inherit sp-no-underline",
			"data-other-notification-redirect": "true",
			href: n.redirectUrl,
			rel: "noreferrer",
			target: "_blank",
			children: u
		}) : u;
	};
	return /* @__PURE__ */ g("div", {
		className: "sp-mx-4 sp-mt-3",
		children: /* @__PURE__ */ g(Qy, {
			className: "sp-relative sp-w-full sp-rounded-lg",
			"data-uplift-media-frame-ratio": s.publishedRatio,
			style: { aspectRatio: s.publishedRatio },
			children: a ? /* @__PURE__ */ g($y, {
				ariaLabel: "Notification media carousel",
				arrowClassName: "sp-z-20",
				medias: e,
				renderSlide: (e, { index: t, isActive: n }) => c(e, t, n),
				showDots: !1
			}) : c(i, 0, !0)
		})
	});
}, ZO = ({ url: e }) => /* @__PURE__ */ _("a", {
	className: "sp-mx-4 sp-mt-3 sp-flex sp-items-center sp-justify-between sp-rounded-lg sp-border sp-border-solid sp-border-[#d6d6d6] sp-px-3 sp-py-2 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#1877f2] sp-no-underline",
	"data-other-notification-redirect": "true",
	href: e,
	rel: "noreferrer",
	target: "_blank",
	children: [/* @__PURE__ */ g("span", {
		className: "sp-truncate",
		children: tk(e)
	}), /* @__PURE__ */ g(rk, {})]
}), QO = ({ hasRedirect: e }) => /* @__PURE__ */ _("footer", {
	className: "sp-mt-4 sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-px-4 sp-py-3 sp-text-sm sp-font-medium sp-leading-none sp-text-[#737373]",
	children: [/* @__PURE__ */ g("span", { children: "Preview" }), e ? /* @__PURE__ */ g("span", { children: "Open link" }) : /* @__PURE__ */ g("span", { children: "Draft" })]
}), $O = (e) => e.type === "text" ? [] : e.medias.collection.length > 0 ? e.medias.collection : e.type === "image" || e.type === "video" ? [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}] : [], ek = (e, t) => t ? e.type === "story" ? "other-notification-story-first-media" : e.type === "multiMedia" ? "other-notification-multimedia-first-media" : Tb(t) ? "other-notification-video" : "other-notification-image" : "other-notification-text", tk = (e) => {
	try {
		return new URL(e).hostname.replace(/^www\./, "");
	} catch {
		return e;
	}
}, nk = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-h-6 sp-w-6 sp-text-[#737373]",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	children: [
		/* @__PURE__ */ g("circle", {
			cx: "6",
			cy: "12",
			r: "1.5"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "12",
			cy: "12",
			r: "1.5"
		}),
		/* @__PURE__ */ g("circle", {
			cx: "18",
			cy: "12",
			r: "1.5"
		})
	]
}), rk = () => /* @__PURE__ */ g("svg", {
	"aria-hidden": "true",
	className: "sp-h-4 sp-w-4 sp-shrink-0",
	fill: "none",
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ g("path", {
		d: "M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4m-7-9h7m0 0v7m0-7-9 9",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), ik = (e) => {
	let t = Ly(e);
	return t ? ak(ex(t)) !== null : !1;
}, ak = (e) => hx(e) ? "facebook" : vC(e) ? "instagram" : FC(e) ? "linkedin" : iT(e) ? "twitter" : FT(e) ? "threads" : vE(e) ? "pinterest" : GE(e) ? "tiktok" : kD(e) ? "google-my-business" : bO(e) ? "snapchat" : PO(e) ? "youtube" : KO(e) ? "other-notification" : null, ok = ({ post: e, trackEvent: t, className: n, videoCoverPreview: r, preferVideoCoverPreviewOverride: i, instagramPublishingChrome: a }) => {
	let o = ex(e), s = ak(o);
	return s === "facebook" ? /* @__PURE__ */ g(gx, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "instagram" ? /* @__PURE__ */ g(yC, {
		instagramPublishingChrome: a,
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "linkedin" ? /* @__PURE__ */ g(IC, {
		post: o,
		className: n,
		videoCoverPreview: r,
		preferVideoCoverPreviewOverride: i,
		trackEvent: t
	}) : s === "twitter" ? /* @__PURE__ */ g(aT, {
		post: o,
		className: n,
		videoCoverPreview: r,
		trackEvent: t
	}) : s === "threads" ? /* @__PURE__ */ g(IT, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "pinterest" ? /* @__PURE__ */ g(yE, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "tiktok" ? /* @__PURE__ */ g(KE, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "google-my-business" ? /* @__PURE__ */ g(AD, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "snapchat" ? /* @__PURE__ */ g(xO, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "youtube" ? /* @__PURE__ */ g(FO, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : s === "other-notification" ? /* @__PURE__ */ g(qO, {
		post: o,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : null;
}, sk = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i, preferVideoCoverPreviewOverride: a, previewVariant: o = "legacy", captionCopyEnabled: s, onCaptionCopyError: c, onCaptionCopySuccess: l, instagramPublishingChrome: u }) => {
	let d = Ly(e);
	return /* @__PURE__ */ g(Vf, {
		value: {
			captionCopyEnabled: s,
			onCaptionCopyError: c,
			onCaptionCopySuccess: l
		},
		children: /* @__PURE__ */ g(yy, {
			post: e || {},
			children: /* @__PURE__ */ g(ck, {
				post: d,
				trackEvent: t,
				className: n,
				videoCoverPreview: i,
				env: r,
				preferVideoCoverPreviewOverride: a,
				previewVariant: o,
				legacyContextPost: e,
				instagramPublishingChrome: u
			}, e?.id)
		})
	});
}, ck = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i, preferVideoCoverPreviewOverride: a, previewVariant: o = "legacy", legacyContextPost: s, instagramPublishingChrome: c }) => {
	if (e === null) throw Error("PreviewBuilder: null post, unknown platform");
	return Cy(e) ? o === "uplift" ? ok({
		instagramPublishingChrome: c,
		post: e,
		trackEvent: t,
		className: n,
		env: r,
		videoCoverPreview: i,
		preferVideoCoverPreviewOverride: a
	}) || /* @__PURE__ */ g(uk, { children: /* @__PURE__ */ g(Iy, {
		className: n,
		copy: {
			title: "Post preview not available",
			message: "This post type is not available in the new preview yet."
		},
		post: e
	}) }) : /* @__PURE__ */ g(uk, { children: /* @__PURE__ */ g(am.Provider, {
		value: {
			post: s,
			className: n,
			env: r,
			videoCoverPreview: i,
			preferVideoCoverPreviewOverride: a,
			previewVariant: o
		},
		children: /* @__PURE__ */ g(lk, {
			post: e,
			trackEvent: t,
			className: n,
			env: r,
			videoCoverPreview: i
		})
	}) }) : /* @__PURE__ */ g(uk, { children: /* @__PURE__ */ g(Iy, {
		className: n,
		post: e
	}) });
}, lk = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i }) => {
	if (e === null) throw Error("PreviewBuilder: null post, unknown platform");
	let a = e.platform;
	switch (a) {
		case "IG": return /* @__PURE__ */ g(Xh, {
			post: e,
			className: n,
			env: r
		});
		case "FB": return /* @__PURE__ */ g(hg, { post: e });
		case "TW": return /* @__PURE__ */ g(kg, { post: e });
		case "LI": return /* @__PURE__ */ g(e_, {
			post: e,
			trackEvent: t
		});
		case "GMB": return /* @__PURE__ */ g(g_, { post: e });
		case "YT": return /* @__PURE__ */ g(T_, { post: e });
		case "PI": return /* @__PURE__ */ g(z_, { post: e });
		case "SC": return /* @__PURE__ */ g(lv, { post: e });
		case "TT": return /* @__PURE__ */ g(Gv, {
			post: e,
			env: r,
			videoCoverPreview: i
		});
		case "TH": return /* @__PURE__ */ g(ay, { post: e });
		case "OT": return /* @__PURE__ */ g(vy, { post: e });
		default: throw Error(`PreviewBuilder: unknown platform ${a}`);
	}
}, uk = Y.div`
  font-family:
    "Gotham SSm A", "Gotham SSm B", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`, dk = /^https?:\/\/sked-customer-uploads\.s3(\.[a-z0-9-]+)?\.amazonaws\.com\/(.+)$/, fk = "https://s3.amazonaws.com/sked-customer-uploads", pk = "https://customer-uploads.skedsocial.com";
function mk(e) {
	return !e || typeof e != "string" ? e : dk.test(e) ? e.replace(dk, pk + "/$2") : e.startsWith(fk) ? e.replace(fk, pk) : e;
}
//#endregion
//#region lib/models/MediasModel.js
var hk = class {
	constructor(e) {
		this.medias = [e], e.mediaFiles && e.mediaFiles.length > 0 && (this.medias = e.mediaFiles.map((t, n) => n !== 0 || !e.thumbnailUrl || !_k(t) || !vk(e) ? t : {
			...t,
			thumbnailUrl: e.thumbnailUrl
		})), this.collection = this.buildCollection(this.medias), this.count = this.collection.length;
	}
	buildCollection(e) {
		return e.flatMap((e) => {
			let t = gk(e);
			if (!t) return [];
			let n = (t.toLowerCase().endsWith(".heic") || t.toLowerCase().endsWith(".heif")) && e.thumbnailUrl ? e.thumbnailUrl : t;
			return [{
				id: e.asset_id || e.hash || e.media_id || e.urn || void 0,
				thumbnailUrl: mk(e.thumbnailUrl),
				fileName: e.fileName,
				pages: e.meta?.pages ?? e.pages,
				width: e.meta?.width ?? e.width,
				height: e.meta?.height ?? e.height,
				url: mk(n),
				sourceUrl: mk(t),
				type: e.type,
				isVideo: e.isVideo,
				tags: e.tags,
				productTags: e.productTags,
				altText: e.altText
			}];
		});
	}
};
function gk(e) {
	return e ? _k(e) ? e.url || e.originalUrl || "" : e.url || e.originalUrl || e.thumbnailUrl || "" : "";
}
function _k(e) {
	return e?.isVideo === !0;
}
function vk(e) {
	return e?.platform === "LI" || e?.platformType === "LI" || e?.platforms?.[0]?.platformType === "LI";
}
//#endregion
//#region lib/models/PostModel.js
var yk = class {
	constructor(e, t, n, r) {
		this.providedPost = e, this.id = e.post_id, this.stage = e.post_stage, this.caption = e.caption, this.currentStatusKey = e.post_status_key, this.rejectionReason = "", this.scheduledFor = e.when, this.image_url = mk(e.url), this.comment = e.firstcomment || e.first_comment, this.locationName = e.location && e.location.name, this.redirectUrl = e.redirectUrl ? e.redirectUrl : "", this.storyUrl = e.storyUrl ? e.storyUrl : "", this.storyLabel = e.storyLabel ? e.storyLabel : "", this.storyStickerHeight = e.storyStickerHeight ? e.storyStickerHeight : null, this.medias = new hk(e), this.callToAction = e.gmbCallToAction ? e.gmbCallToAction : "", this.event = e.gmbEvent ? e.gmbEvent : "", this.topicType = e.gmbTopicType ? e.gmbTopicType : null, this.offer = e.gmbOffer ? {
			...e.gmbOffer,
			redeemOnlineUrl: e.gmbOffer.redeemOnlineUrl || e.redirectUrl
		} : null, this.platform = e.platform, this.type = e.type, this.storyType = e.storyType || null, this.ytTitle = e.ytTitle || null, this.ytCategoryId = e.ytCategoryId || null, this.ytTags = e.ytTags || "", t && t.username ? (this.username = t.username, this.profilePicture = t.profile_picture_url, this.followedBy = t.followed_by) : e.username || e.profilePicture ? (this.username = e.username, this.profilePicture = e.profilePicture, this.followedBy = e.followed_by) : (this.username = "Failed to find account", this.profilePicture = "https://picsum.photos/id/1/200/200", this.followedBy = null), this.approvedKey = n, this.rejectedKey = r;
		let i = null, a = null;
		if (e.piBoards && e.piBoards.length > 0 && t.boards && t.boards.length > 0) {
			let n = t.boards.find((t) => t.id === e.piBoards[0]);
			if (n && (i = n.name, n.sections && n.sections.length > 0 && e.piSectionId)) {
				let t = n.sections.find((t) => t.id === e.piSectionId);
				t && (a = t.title);
			}
		}
		this.boardTitle = i || null, this.boardSectionTitle = a || null, this.piTitle = e.piTitle || null, this.postOptions = e.postOptions || null;
	}
	get status() {
		switch (this.currentStatusKey) {
			case this.approvedKey: return "approved";
			case this.rejectedKey: return "rejected";
			default: return "initial";
		}
	}
	approve() {
		this.currentStatusKey = this.approvedKey;
	}
	reject(e) {
		this.currentStatusKey = this.rejectedKey, this.rejectionReason = e;
	}
}, bk = class {
	constructor(e, t) {
		let n = e.schedule ? e.schedule : e;
		this.providedPost = n, this.id = n._id, this.stage = "draft", n.scheduledFor ? this.stage = "scheduled" : n.queued && (this.stage = "queued"), this.caption = n.caption || "", this.currentStatusKey = n.normalizedPost_status_key, this.rejectionReason = "", this.scheduledFor = n.when, this.image_url = mk(n.url), this.comment = n.firstcomment || n.first_comment || "", this.locationName = n.location && n.location.name, this.redirectUrl = n.redirectUrl ? n.redirectUrl : "", this.storyUrl = n.storyUrl ? n.storyUrl : "", this.storyLabel = n.storyLabel ? n.storyLabel : "", this.storyStickerHeight = n.storyStickerHeight ? n.storyStickerHeight : null, this.callToAction = n.gmbCallToAction ? n.gmbCallToAction : "", this.event = n.gmbEvent ? n.gmbEvent : "", this.topicType = n.gmbTopicType ? n.gmbTopicType : null, this.offer = n.gmbOffer ? {
			...n.gmbOffer,
			redeemOnlineUrl: n.gmbOffer.redeemOnlineUrl || n.redirectUrl
		} : null, this.medias = new hk(n), this.platform = n.platformType || "IG", n.platforms && n.platforms.length > 0 && (this.platform = n.platforms[0].platformType), this.type = n.type, this.storyType = n.storyType || null, this.username = t.login, this.profilePicture = t.profilePictureUrl || "", this.followedBy = t.followed_by, this.ytTitle = n.ytTitle || null, this.ytCategoryId = n.ytCategoryId || null, this.ytTags = n.ytTags || "";
		let r = "", i = null;
		if (n.piBoards && n.piBoards.length > 0 && t.boards && t.boards.length > 0) {
			let e = t.boards.find((e) => e.id === n.piBoards[0]);
			if (e && (r = e.name, e.sections && e.sections.length > 0 && n.piSectionId)) {
				let t = e.sections.find((e) => e.id === n.piSectionId);
				t && (i = t.title);
			}
		}
		this.boardTitle = r || null, this.boardSectionTitle = i || null, this.piTitle = n.piTitle || null, this.postOptions = n.postOptions || null;
	}
}, xk = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Sk = To, Ck = (e, t) => (n) => {
	if (t?.variants == null) return Sk(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = xk(t) || xk(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return Sk(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
};
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-compose-refs@1.1.2_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function wk(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
function Tk(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = wk(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : wk(e[t], null);
			}
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.2.4_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.mjs
var Ek = Symbol.for("react.lazy"), Dk = r.use;
function Ok(e) {
	return typeof e == "object" && !!e && "then" in e;
}
function kk(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Ek && "_payload" in e && Ok(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Ak(e) {
	let t = /* @__PURE__ */ Mk(e), n = r.forwardRef((e, n) => {
		let { children: i, ...a } = e;
		kk(i) && typeof Dk == "function" && (i = Dk(i._payload));
		let o = r.Children.toArray(i), s = o.find(Pk);
		if (s) {
			let e = s.props.children, i = o.map((t) => t === s ? r.Children.count(e) > 1 ? r.Children.only(null) : r.isValidElement(e) ? e.props.children : null : t);
			return /* @__PURE__ */ g(t, {
				...a,
				ref: n,
				children: r.isValidElement(e) ? r.cloneElement(e, void 0, i) : null
			});
		}
		return /* @__PURE__ */ g(t, {
			...a,
			ref: n,
			children: i
		});
	});
	return n.displayName = `${e}.Slot`, n;
}
var jk = /* @__PURE__ */ Ak("Slot");
// @__NO_SIDE_EFFECTS__
function Mk(e) {
	let t = r.forwardRef((e, t) => {
		let { children: n, ...i } = e;
		if (kk(n) && typeof Dk == "function" && (n = Dk(n._payload)), r.isValidElement(n)) {
			let e = Ik(n), a = Fk(i, n.props);
			return n.type !== r.Fragment && (a.ref = t ? Tk(t, e) : e), r.cloneElement(n, a);
		}
		return r.Children.count(n) > 1 ? r.Children.only(null) : null;
	});
	return t.displayName = `${e}.SlotClone`, t;
}
var Nk = Symbol("radix.slottable");
function Pk(e) {
	return r.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Nk;
}
function Fk(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
function Ik(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
//#endregion
//#region ../ui/dist/components/primitives/button.js
var Lk = [
	"className",
	"variant",
	"size",
	"asChild"
], Rk = "!border !border-blue-500 !bg-blue-500 !text-white !shadow-xs hover:!bg-blue-600 hover:!border-blue-600 active:!bg-blue-700 active:!border-blue-700 disabled:!bg-neutral-200 disabled:!border-neutral-200 disabled:!text-white", zk = Ck("!cursor-pointer !inline-flex !items-center !justify-center ![gap:8px] !whitespace-nowrap ![border-radius:8px] !text-sm !font-semibold !transition-all disabled:!pointer-events-none disabled:!opacity-50 [&_svg]:!pointer-events-none [&_svg:not([class*='size-'])]:!size-4 !shrink-0 [&_svg]:!shrink-0 [&>i]:!shrink-0 !outline-none focus-visible:!border-ring focus-visible:!ring-ring/50 focus-visible:!ring-[3px] aria-invalid:!ring-destructive/20 dark:aria-invalid:!ring-destructive/40 aria-invalid:!border-destructive ![font-family:var(--font-inter)]", {
	variants: {
		variant: {
			default: Rk,
			"blue-primary": Rk,
			"blue-secondary": "!border !border-blue-500 !text-blue-500 !bg-white !shadow-xs hover:!bg-blue-25 active:!bg-blue-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white",
			"blue-tertiary": "!border !border-blue-500 !text-blue-500 !bg-white hover:!bg-blue-25 active:!bg-blue-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white",
			"green-primary": "!border !border-green-500 !bg-green-500 !text-white !shadow-xs hover:!bg-green-600 hover:!border-green-600 active:!bg-green-700 active:!border-green-700 disabled:!bg-neutral-200 disabled:!border-neutral-200 disabled:!text-white",
			"green-secondary": "!border !border-green-500 !text-green-500 !bg-white !shadow-xs hover:!bg-green-25 active:!bg-green-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white",
			"green-tertiary": "!border !border-green-500 !text-green-500 !bg-white hover:!bg-green-25 active:!bg-green-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white",
			"red-primary": "!border !border-red-500 !bg-red-500 !text-white !shadow-xs hover:!bg-red-600 hover:!border-red-600 active:!bg-red-700 active:!border-red-700 disabled:!bg-neutral-200 disabled:!border-neutral-200 disabled:!text-white focus-visible:!ring-red-500/20 dark:focus-visible:!ring-red-500/40",
			"red-secondary": "!border !border-red-500 !text-red-500 !bg-white !shadow-xs hover:!bg-red-25 active:!bg-red-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white focus-visible:!ring-red-500/20 dark:focus-visible:!ring-red-500/40",
			"red-tertiary": "!border !border-red-500 !text-red-500 !bg-white hover:!bg-red-25 active:!bg-red-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white focus-visible:!ring-red-500/20 dark:focus-visible:!ring-red-500/40",
			"orange-primary": "!border !border-[var(--color-warning-500)] !bg-[var(--color-warning-500)] !text-white !shadow-xs hover:!bg-[var(--color-warning-600)] hover:!border-[var(--color-warning-600)] active:!bg-[var(--color-warning-700)] active:!border-[var(--color-warning-700)] disabled:!bg-neutral-200 disabled:!border-neutral-200 disabled:!text-white",
			"black-secondary": "!border !border-neutral-800 !text-neutral-800 !bg-white !shadow-xs hover:!bg-blue-25 active:!bg-blue-50 disabled:!border-neutral-200 disabled:!text-neutral-200 disabled:!bg-white",
			link: "!text-blue-500 !underline-offset-4 hover:!underline disabled:!text-blue-300"
		},
		size: {
			xxs: "!h-[24px] ![padding:4px_8px] ![font-size:12px] [&>i]:![font-size:14px]",
			xs: "!h-[32px] ![padding:8px_26px] ![font-size:12px] [&>i]:![font-size:14px]",
			sm: "!h-[36px] ![padding:8px_28px] ![font-size:14px] [&>i]:![font-size:16px]",
			md: "!h-[40px] ![padding:10px_30px] ![font-size:14px] [&>i]:![font-size:16px]",
			lg: "!h-[44px] ![padding:10px_32px] ![font-size:16px] [&>i]:![font-size:18px]",
			xl: "!h-[48px] ![padding:12px_34px] ![font-size:16px] [&>i]:![font-size:18px]",
			"2xl": "!h-[60px] ![padding:16px_46px] ![font-size:18px] [&>i]:![font-size:20px]",
			icon: "!size-[36px] [&>i]:![font-size:16px]",
			responsive: "!h-[36px] ![padding:8px_28px] ![font-size:14px] [&>i]:![font-size:16px] sm:!h-[40px] sm:![padding:10px_30px] lg:!h-[44px] lg:![padding:10px_32px] lg:![font-size:16px] lg:[&>i]:![font-size:18px]"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md"
	}
}), Bk = r.forwardRef((e, t) => {
	let { className: n, variant: r, size: i, asChild: a = !1 } = e, o = Qs(e, Lk);
	return /* @__PURE__ */ g(a ? jk : "button", ic({
		ref: t,
		"data-slot": "button",
		className: $(zk({
			variant: r,
			size: i,
			className: n
		}))
	}, o));
});
Bk.displayName = "Button";
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-scope@1.1.16_@types+react-dom@18.3.7_@types+react@18.3.31__@types_161760c0d51338f080e5b66a9ea35f08/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var Vk = Object.defineProperty, Hk = (e, t) => Vk(e, "name", {
	value: t,
	configurable: !0
}), Uk = "focusScope.autoFocusOnMount", Wk = "focusScope.autoFocusOnUnmount", Gk = {
	bubbles: !1,
	cancelable: !0
}, Kk = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Hk(function(e, t) {
	let { loop: n = !1, trapped: i = !1, onMountAutoFocus: a, onUnmountAutoFocus: o, ...s } = e, [c, l] = r.useState(null), u = ba(a), d = ba(o), f = r.useRef(null), p = Ea(t, l), m = r.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	r.useEffect(() => {
		if (i) {
			let e = function(e) {
				if (m.paused || !c) return;
				let t = e.target;
				c.contains(t) ? f.current = t : $k(f.current, { select: !0 });
			}, t = function(e) {
				if (m.paused || !c) return;
				let t = e.relatedTarget;
				t !== null && (c.contains(t) || $k(f.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && $k(c);
			};
			Hk(e, "handleFocusIn"), Hk(t, "handleFocusOut"), Hk(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return c && r.observe(c, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		i,
		c,
		m.paused
	]), r.useEffect(() => {
		if (c) {
			eA.add(m);
			let e = document.activeElement;
			if (!c.contains(e)) {
				let t = new CustomEvent(Uk, Gk);
				c.addEventListener(Uk, u), c.dispatchEvent(t), t.defaultPrevented || (qk(rA(Yk(c)), { select: !0 }), document.activeElement === e && $k(c));
			}
			return () => {
				c.removeEventListener(Uk, u), setTimeout(() => {
					let t = new CustomEvent(Wk, Gk);
					c.addEventListener(Wk, d), c.dispatchEvent(t), t.defaultPrevented || $k(e ?? document.body, { select: !0 }), c.removeEventListener(Wk, d), eA.remove(m);
				}, 0);
			};
		}
	}, [
		c,
		u,
		d,
		m
	]);
	let h = r.useCallback((e) => {
		if (!n && !i || m.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, r = document.activeElement;
		if (t && r) {
			let t = e.currentTarget, [i, a] = Jk(t);
			i && a ? !e.shiftKey && r === a ? (e.preventDefault(), n && $k(i, { select: !0 })) : e.shiftKey && r === i && (e.preventDefault(), n && $k(a, { select: !0 })) : r === t && e.preventDefault();
		}
	}, [
		n,
		i,
		m.paused
	]);
	return /* @__PURE__ */ g(Wa.div, {
		tabIndex: -1,
		...s,
		ref: p,
		onKeyDown: h
	});
}, "FocusScope"));
function qk(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if ($k(r, { select: t }), document.activeElement !== n) return;
}
Hk(qk, "focusFirst");
function Jk(e) {
	let t = Yk(e);
	return [Xk(t, e), Xk(t.reverse(), e)];
}
Hk(Jk, "getTabbableEdges");
function Yk(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ Hk((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
Hk(Yk, "getTabbableCandidates");
function Xk(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : Zk(r, { upTo: t }))) return r;
}
Hk(Xk, "findVisible");
function Zk(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
Hk(Zk, "isHidden");
function Qk(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
Hk(Qk, "isSelectableInput");
function $k(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && Qk(e) && t && e.select();
	}
}
Hk($k, "focus");
var eA = tA();
function tA() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = nA(e, t), e.unshift(t);
		},
		remove(t) {
			e = nA(e, t), e[0]?.resume();
		}
	};
}
Hk(tA, "createFocusScopesStack");
function nA(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
Hk(nA, "arrayRemove");
function rA(e) {
	return e.filter((e) => e.tagName !== "A");
}
Hk(rA, "removeLinks");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-guards@1.1.6_@types+react@18.3.31_react@18.3.1/node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var iA = Object.defineProperty, aA = (e, t) => iA(e, "name", {
	value: t,
	configurable: !0
}), oA = 0, sA = null;
function cA(e) {
	return lA(), e.children;
}
aA(cA, "FocusGuards");
function lA() {
	r.useEffect(() => {
		sA || (sA = {
			start: uA(),
			end: uA()
		});
		let { start: e, end: t } = sA;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), oA++, () => {
			oA === 1 && (sA?.start.remove(), sA?.end.remove(), sA = null), oA = Math.max(0, oA - 1);
		};
	}, []);
}
aA(lA, "useFocusGuards");
function uA() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
aA(uA, "createFocusGuard");
//#endregion
//#region ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var dA = function() {
	return dA = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, dA.apply(this, arguments);
};
function fA(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function pA(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@18.3.31_react@18.3.1/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var mA = "right-scroll-bar-position", hA = "width-before-scroll-bar", gA = "with-scroll-bars-hidden", _A = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@18.3.31_react@18.3.1/node_modules/use-callback-ref/dist/es2015/assignRef.js
function vA(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@18.3.31_react@18.3.1/node_modules/use-callback-ref/dist/es2015/useRef.js
function yA(e, t) {
	var n = m(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@18.3.31_react@18.3.1/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var bA = typeof window < "u" ? r.useLayoutEffect : r.useEffect, xA = /* @__PURE__ */ new WeakMap();
function SA(e, t) {
	var n = yA(t || null, function(t) {
		return e.forEach(function(e) {
			return vA(e, t);
		});
	});
	return bA(function() {
		var t = xA.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || vA(e, null);
			}), i.forEach(function(e) {
				r.has(e) || vA(e, a);
			});
		}
		xA.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@18.3.31_react@18.3.1/node_modules/use-sidecar/dist/es2015/medium.js
function CA(e) {
	return e;
}
function wA(e, t) {
	t === void 0 && (t = CA);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function TA(e) {
	e === void 0 && (e = {});
	var t = wA(null);
	return t.options = dA({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@18.3.31_react@18.3.1/node_modules/use-sidecar/dist/es2015/exports.js
var EA = function(e) {
	var t = e.sideCar, n = fA(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = t.read();
	if (!i) throw Error("Sidecar medium not found");
	return r.createElement(i, dA({}, n));
};
EA.isSideCarExport = !0;
function DA(e, t) {
	return e.useMedium(t), EA;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@18.3.31_react@18.3.1/node_modules/react-remove-scroll/dist/es2015/medium.js
var OA = TA(), kA = function() {}, AA = r.forwardRef(function(e, t) {
	var n = r.useRef(null), i = r.useState({
		onScrollCapture: kA,
		onWheelCapture: kA,
		onTouchMoveCapture: kA
	}), a = i[0], o = i[1], s = e.forwardProps, c = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noRelative, h = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = e.gapMode, x = fA(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = SA([n, t]), w = dA(dA({}, x), a);
	return r.createElement(r.Fragment, null, d && r.createElement(S, {
		sideCar: OA,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: n,
		gapMode: b
	}), s ? r.cloneElement(r.Children.only(c), dA(dA({}, w), { ref: C })) : r.createElement(y, dA({}, w, {
		className: l,
		ref: C
	}), c));
});
AA.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, AA.classNames = {
	fullWidth: hA,
	zeroRight: mA
};
//#endregion
//#region ../../node_modules/.pnpm/get-nonce@1.0.1/node_modules/get-nonce/dist/es2015/index.js
var jA = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@18.3.31_react@18.3.1/node_modules/react-style-singleton/dist/es2015/singleton.js
function MA() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = jA();
	return t && e.setAttribute("nonce", t), e;
}
function NA(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function PA(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var FA = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = MA()) && (NA(t, n), PA(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, IA = function() {
	var e = FA();
	return function(t, n) {
		r.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, LA = function() {
	var e = IA();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, RA = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, zA = function(e) {
	return parseInt(e || "", 10) || 0;
}, BA = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		zA(n),
		zA(r),
		zA(i)
	];
}, VA = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return RA;
	var t = BA(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, HA = LA(), UA = "data-scroll-locked", WA = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${gA} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${UA}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${mA} {
    right: ${s}px ${r};
  }
  
  .${hA} {
    margin-right: ${s}px ${r};
  }
  
  .${mA} .${mA} {
    right: 0 ${r};
  }
  
  .${hA} .${hA} {
    margin-right: 0 ${r};
  }
  
  body[${UA}] {
    ${_A}: ${s}px;
  }
`;
}, GA = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, KA = function() {
	r.useEffect(function() {
		return document.body.setAttribute(UA, (GA() + 1).toString()), function() {
			var e = GA() - 1;
			e <= 0 ? document.body.removeAttribute(UA) : document.body.setAttribute(UA, e.toString());
		};
	}, []);
}, qA = function(e) {
	var t = e.noRelative, n = e.noImportant, i = e.gapMode, a = i === void 0 ? "margin" : i;
	KA();
	var o = r.useMemo(function() {
		return VA(a);
	}, [a]);
	return r.createElement(HA, { styles: WA(o, !t, a, n ? "" : "!important") });
}, JA = !1;
if (typeof window < "u") try {
	var YA = Object.defineProperty({}, "passive", { get: function() {
		return JA = !0, !0;
	} });
	window.addEventListener("test", YA, YA), window.removeEventListener("test", YA, YA);
} catch {
	JA = !1;
}
var XA = JA ? { passive: !1 } : !1, ZA = function(e) {
	return e.tagName === "TEXTAREA";
}, QA = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !ZA(e) && n[t] === "visible");
}, $A = function(e) {
	return QA(e, "overflowY");
}, ej = function(e) {
	return QA(e, "overflowX");
}, tj = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), ij(e, r)) {
			var i = aj(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, nj = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, rj = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, ij = function(e, t) {
	return e === "v" ? $A(t) : ej(t);
}, aj = function(e, t) {
	return e === "v" ? nj(t) : rj(t);
}, oj = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, sj = function(e, t, n, r, i) {
	var a = oj(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = aj(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && ij(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, cj = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, lj = function(e) {
	return [e.deltaX, e.deltaY];
}, uj = function(e) {
	return e && "current" in e ? e.current : e;
}, dj = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, fj = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, pj = 0, mj = [];
function hj(e) {
	var t = r.useRef([]), n = r.useRef([0, 0]), i = r.useRef(), a = r.useState(pj++)[0], o = r.useState(LA)[0], s = r.useRef(e);
	r.useEffect(function() {
		s.current = e;
	}, [e]), r.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var t = pA([e.lockRef.current], (e.shards || []).map(uj), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var c = r.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var r = cj(e), a = n.current, o = "deltaX" in e ? e.deltaX : a[0] - r[0], c = "deltaY" in e ? e.deltaY : a[1] - r[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = tj(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = tj(d, u)), !m) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var h = i.current || l;
		return sj(h, t, e, h === "h" ? o : c, !0);
	}, []), l = r.useCallback(function(e) {
		var n = e;
		if (mj.length && mj[mj.length - 1] === o) {
			var r = "deltaY" in n ? lj(n) : cj(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && dj(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(uj).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(a.length > 0 ? c(n, a[0]) : !s.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), u = r.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: gj(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = r.useCallback(function(e) {
		n.current = cj(e), i.current = void 0;
	}, []), f = r.useCallback(function(t) {
		u(t.type, lj(t), t.target, c(t, e.lockRef.current));
	}, []), p = r.useCallback(function(t) {
		u(t.type, cj(t), t.target, c(t, e.lockRef.current));
	}, []);
	r.useEffect(function() {
		return mj.push(o), e.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, XA), document.addEventListener("touchmove", l, XA), document.addEventListener("touchstart", d, XA), function() {
			mj = mj.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, XA), document.removeEventListener("touchmove", l, XA), document.removeEventListener("touchstart", d, XA);
		};
	}, []);
	var m = e.removeScrollBar, h = e.inert;
	return r.createElement(r.Fragment, null, h ? r.createElement(o, { styles: fj(a) }) : null, m ? r.createElement(qA, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function gj(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@18.3.31_react@18.3.1/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var _j = DA(OA, hj), vj = r.forwardRef(function(e, t) {
	return r.createElement(AA, dA({}, e, {
		ref: t,
		sideCar: _j
	}));
});
vj.classNames = AA.classNames;
//#endregion
//#region ../../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var yj = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, bj = /* @__PURE__ */ new WeakMap(), xj = /* @__PURE__ */ new WeakMap(), Sj = {}, Cj = 0, wj = function(e) {
	return e && (e.host || wj(e.parentNode));
}, Tj = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = wj(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Ej = function(e, t, n, r) {
	var i = Tj(t, Array.isArray(e) ? e : [e]);
	Sj[n] || (Sj[n] = /* @__PURE__ */ new WeakMap());
	var a = Sj[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (bj.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				bj.set(e, c), a.set(e, l), o.push(e), c === 1 && i && xj.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Cj++, function() {
		o.forEach(function(e) {
			var t = bj.get(e) - 1, i = a.get(e) - 1;
			bj.set(e, t), a.set(e, i), t || (xj.has(e) || e.removeAttribute(r), xj.delete(e)), i || e.removeAttribute(n);
		}), Cj--, Cj || (bj = /* @__PURE__ */ new WeakMap(), bj = /* @__PURE__ */ new WeakMap(), xj = /* @__PURE__ */ new WeakMap(), Sj = {});
	};
}, Dj = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || yj(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Ej(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Oj = Object.defineProperty, kj = (e, t) => Oj(e, "name", {
	value: t,
	configurable: !0
}), Aj = "Dialog", [jj, Mj] = /* @__PURE__ */ ga(Aj), [Nj, Pj] = jj(Aj), Fj = /* @__PURE__ */ kj((e) => {
	let { __scopeDialog: t, children: n, open: i, defaultOpen: a, onOpenChange: o, modal: s = !0 } = e, c = r.useRef(null), l = r.useRef(null), [u, d] = zd({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: Aj
	}), [f, p] = r.useState(0), [m, h] = r.useState(0);
	return /* @__PURE__ */ g(Nj, {
		scope: t,
		triggerRef: c,
		contentRef: l,
		contentId: Nc(),
		titleId: Nc(),
		descriptionId: Nc(),
		titlePresent: f > 0,
		descriptionPresent: m > 0,
		setTitleCount: p,
		setDescriptionCount: h,
		open: u,
		onOpenChange: d,
		onOpenToggle: r.useCallback(() => d((e) => !e), [d]),
		modal: s,
		children: n
	});
}, "Dialog"), Ij = "DialogPortal", [Lj, Rj] = jj(Ij, { forceMount: void 0 }), zj = /* @__PURE__ */ kj((e) => {
	let { __scopeDialog: t, forceMount: n, children: i, container: a } = e, o = Pj(Ij, t);
	return /* @__PURE__ */ g(Lj, {
		scope: t,
		forceMount: n,
		children: r.Children.map(i, (e) => /* @__PURE__ */ g(Td, {
			present: n || o.open,
			children: /* @__PURE__ */ g(xd, {
				asChild: !0,
				container: a,
				children: e
			})
		}))
	});
}, "DialogPortal"), Bj = "DialogOverlay", Vj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let n = Rj(Bj, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Pj(Bj, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ g(Td, {
		present: r || a.open,
		children: /* @__PURE__ */ g(Uj, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), Hj = /* @__PURE__ */ ka("DialogOverlay.RemoveScroll"), Uj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Pj(Bj, n), a = Ea(t, Cc());
	return /* @__PURE__ */ g(vj, {
		as: Hj,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ g(Wa.div, {
			"data-state": tM(i.open),
			...r,
			ref: a,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), Wj = "DialogContent", Gj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let n = Rj(Wj, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Pj(Wj, e.__scopeDialog);
	return /* @__PURE__ */ g(Td, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ g(Kj, {
			...i,
			ref: t
		}) : /* @__PURE__ */ g(qj, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), Kj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let n = Pj(Wj, e.__scopeDialog), i = r.useRef(null), a = Ea(t, n.contentRef, i);
	return r.useEffect(() => {
		let e = i.current;
		if (e) return Dj(e);
	}, []), /* @__PURE__ */ g(Jj, {
		...e,
		ref: a,
		trapFocus: n.open,
		disableOutsidePointerEvents: n.open,
		onCloseAutoFocus: uc(e.onCloseAutoFocus, (e) => {
			e.preventDefault(), n.triggerRef.current?.focus();
		}),
		onPointerDownOutside: uc(e.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: uc(e.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), qj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let n = Pj(Wj, e.__scopeDialog), i = r.useRef(!1), a = r.useRef(!1);
	return /* @__PURE__ */ g(Jj, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (i.current || n.triggerRef.current?.focus(), t.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (i.current = !0, t.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let r = t.target;
			n.triggerRef.current?.contains(r) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && a.current && t.preventDefault();
		}
	});
}, "DialogContentNonModal")), Jj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = Pj(Wj, n);
	return lA(), /* @__PURE__ */ g(h, { children: /* @__PURE__ */ g(Kk, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ g(Sc, {
			role: "dialog",
			id: s.contentId,
			"aria-describedby": s.descriptionPresent ? s.descriptionId : void 0,
			"aria-labelledby": s.titlePresent ? s.titleId : void 0,
			"data-state": tM(s.open),
			...o,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => s.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), Yj = "DialogTitle", Xj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Pj(Yj, n), { setTitleCount: a } = i;
	return xa(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ g(Wa.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), Zj = "DialogDescription", Qj = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Pj(Zj, n), { setDescriptionCount: a } = i;
	return xa(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ g(Wa.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), $j = "DialogClose", eM = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ kj(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Pj($j, n);
	return /* @__PURE__ */ g(Wa.button, {
		type: "button",
		...r,
		ref: t,
		onClick: uc(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function tM(e) {
	return e ? "open" : "closed";
}
kj(tM, "getState");
//#endregion
//#region ../ui/dist/components/primitives/dialog.js
var nM = ["className"], rM = [
	"className",
	"children",
	"showCloseButton"
], iM = ["className"], aM = ["className"];
function oM(e) {
	let t = oc({}, (ac(e), e));
	return /* @__PURE__ */ g(Fj, ic({ "data-slot": "dialog" }, t));
}
function sM(e) {
	let t = oc({}, (ac(e), e));
	return /* @__PURE__ */ g(zj, ic({ "data-slot": "dialog-portal" }, t));
}
function cM(e) {
	let { className: t } = e, n = Qs(e, nM);
	return /* @__PURE__ */ g(Vj, ic({
		"data-slot": "dialog-overlay",
		className: $("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", t)
	}, n));
}
function lM(e) {
	let { className: t, children: n, showCloseButton: r = !0 } = e, i = Qs(e, rM);
	return /* @__PURE__ */ _(sM, { children: [/* @__PURE__ */ g(cM, {}), /* @__PURE__ */ _(Gj, ic(ic({
		"data-slot": "dialog-content",
		className: $("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200", t)
	}, i), {}, { children: [n, r && /* @__PURE__ */ _(eM, {
		"data-slot": "dialog-close",
		className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=size-])]:size-4",
		children: [/* @__PURE__ */ g("i", { className: "fa-regular fa-x" }), /* @__PURE__ */ g("span", {
			className: "sr-only",
			children: "Close"
		})]
	})] }))] });
}
function uM(e) {
	let { className: t } = e, n = Qs(e, iM);
	return /* @__PURE__ */ g(Xj, ic({
		"data-slot": "dialog-title",
		className: $("text-lg leading-none font-semibold", t)
	}, n));
}
function dM(e) {
	let { className: t } = e, n = Qs(e, aM);
	return /* @__PURE__ */ g(Qj, ic({
		"data-slot": "dialog-description",
		className: $("text-muted-foreground text-sm", t)
	}, n));
}
//#endregion
//#region lib/components/markup/ordering.ts
var fM = (e) => e !== void 0 && Number.isSafeInteger(e) && e >= 1, pM = ({ annotations: e, highlights: t }) => [...e.map((e, t) => ({
	kind: "annotation",
	item: e,
	index: t
})), ...t.map((t, n) => ({
	kind: "highlight",
	item: t,
	index: e.length + n
}))], mM = (e) => {
	let t = pM(e), n = t.map(({ item: e }) => e.sequence);
	return (t.length > 0 && n.every(fM) && new Set(n).size === n.length ? [...t].sort((e, t) => e.item.sequence - t.item.sequence || e.index - t.index) : t).map((e, t) => e.kind === "annotation" ? {
		kind: "annotation",
		number: t + 1,
		annotation: e.item
	} : {
		kind: "highlight",
		number: t + 1,
		highlight: e.item
	});
}, hM = (e) => new Map(mM(e).map((e) => [e.kind === "annotation" ? e.annotation.id : e.highlight.id, e.number])), gM = (e) => {
	let t = pM(e);
	if (t.some(({ item: e }) => e.sequence !== void 0 && !fM(e.sequence))) return;
	let n = t.map(({ item: e }) => e.sequence).filter((e) => fM(e)), r = Math.max(t.length, ...n, 0);
	return r < 2 ** 53 - 1 ? r + 1 : void 0;
}, _M = (e) => pM(e).length + 1, vM = (e) => {
	let t = Math.max(0, Math.floor(e));
	return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
}, yM = (e) => {
	let t = e ? Date.parse(e) : NaN;
	if (!Number.isFinite(t)) return;
	let n = Math.max(0, Math.floor((Date.now() - t) / 6e4));
	return n < 1 ? "Just now" : n < 60 ? `${n}m ago` : n < 1440 ? `${Math.floor(n / 60)}h ago` : `${Math.floor(n / 1440)}d ago`;
}, bM = (e) => e?.document ? JSON.stringify([e.id, e.document.url]) : void 0, xM = ({ open: e, onOpenChange: t, className: n, title: r, description: i, children: a }) => /* @__PURE__ */ g(oM, {
	open: e,
	onOpenChange: t,
	children: /* @__PURE__ */ _(lM, {
		className: n,
		children: [
			/* @__PURE__ */ g(uM, {
				className: "sr-only",
				children: r
			}),
			/* @__PURE__ */ g(dM, {
				className: "sr-only",
				children: i
			}),
			a
		]
	})
}), SM = (e, t, n) => {
	let r = document.createRange();
	return r.selectNodeContents(e), r.setEnd(t, n), r.toString().length;
}, CM = (e) => e.trim().split(/\s+/).slice(0, 2).map((e) => e[0]?.toUpperCase()).join("") || "R", wM = ({ composerRef: e, comment: t, draft: n, enabled: r, number: i, reviewerName: a, onCancel: o, onChange: s, onSave: c, editing: l, appearance: u }) => {
	let f = p(null);
	return d(() => {
		let e = f.current;
		if (!e) return;
		let t = () => {
			e.style.height = "auto", e.style.height = `${e.scrollHeight + 2}px`;
		};
		if (t(), typeof ResizeObserver > "u") return;
		let n = e.clientWidth, r = new ResizeObserver(() => {
			e.clientWidth !== n && (n = e.clientWidth, t());
		});
		return r.observe(e), () => r.disconnect();
	}, [t]), /* @__PURE__ */ _("div", {
		ref: e,
		role: "dialog",
		"aria-label": n.kind === "pin" ? "New annotation" : "New caption highlight",
		"data-markup-interactive": !0,
		className: $("rounded-lg bg-white p-3 text-neutral-800 shadow-md", u === "internal" ? "ring-1 ring-inset ring-neutral-100" : "border border-neutral-100"),
		onPointerDown: (e) => e.stopPropagation(),
		children: [
			/* @__PURE__ */ _("div", {
				className: "mb-2 flex items-center gap-2",
				children: [/* @__PURE__ */ g("span", {
					className: $("grid size-6 shrink-0 place-items-center rounded-full text-[10px] font-semibold text-white", u === "internal" ? "bg-neutral-300" : "bg-neutral-200"),
					children: CM(a)
				}), /* @__PURE__ */ g("span", {
					className: "truncate text-xs font-semibold",
					children: a
				})]
			}),
			/* @__PURE__ */ g("textarea", {
				ref: f,
				rows: 1,
				autoFocus: !0,
				"aria-label": "Describe the change",
				disabled: !r,
				value: t,
				onChange: (e) => s(e.target.value),
				onKeyDown: (e) => {
					(e.metaKey || e.ctrlKey) && e.key === "Enter" && c(), e.key === "Escape" && o();
				},
				placeholder: "Describe the change…",
				className: $("min-h-8 max-h-40 w-full resize-none overflow-y-auto rounded-md border border-blue-400 p-2 text-xs leading-4 outline-none ring-2 ring-blue-100 placeholder:text-neutral-400", u === "internal" && "block")
			}),
			/* @__PURE__ */ _("div", {
				className: "mt-2 flex items-center gap-2",
				children: [
					/* @__PURE__ */ _("span", {
						className: $("mr-auto flex items-center gap-1 text-xs font-semibold", n.kind === "pin" ? "text-blue-500" : "text-yellow-600"),
						children: [
							u === "external" && /* @__PURE__ */ g("i", {
								className: $("fa-regular", n.kind === "pin" ? "fa-location-dot" : "fa-highlighter-line"),
								"aria-hidden": "true"
							}),
							n.kind === "pin" ? "Pin" : "Highlight",
							" #",
							i,
							n.kind === "pin" && n.timestampSeconds !== void 0 ? ` · ${vM(n.timestampSeconds)}` : ""
						]
					}),
					/* @__PURE__ */ g(Bk, {
						type: "button",
						variant: "link",
						size: "xxs",
						disabled: !r,
						onClick: o,
						className: $("!text-xs !font-medium", u === "internal" && "!text-[#333] hover:!no-underline"),
						children: "Cancel"
					}),
					/* @__PURE__ */ g(Bk, {
						type: "button",
						size: "xxs",
						disabled: !r || !t.trim(),
						onClick: c,
						className: $("!text-xs !font-medium", u === "internal" && "!bg-[#4f31ff] !border-[#4f31ff]"),
						children: l ? "Save" : "Add"
					})
				]
			})
		]
	});
}, TM = ({ captionSnapshot: e, disabled: t, onDraftStateChange: n, caption: r, media: i, account: a, selectedItemId: o, onSelectedItemChange: c, initialMediaId: v, editItemId: y, onEditComplete: b, pendingDraft: x, onPendingDraftChange: S, appearance: C = "internal", suspended: w = !1, expandedMediaDialog: T = xM, readOnly: E = !1, reviewerName: D = "Reviewer", reviewerAvatarUrl: O, reviewerDateLabel: k, reviewerIsSelf: A, reviewerIsExternal: j, value: M, onChange: N, onAnnotationAdd: P, onExpandedMediaOpen: ee }) => {
	let [F, te] = m((x?.draft?.kind === "pin" ? x.draft.mediaId : void 0) ?? v ?? i[0]?.id), ne = i.findIndex((e) => e.id === F), I = p(F);
	I.current = F;
	let [L, R] = m({
		draft: null,
		comment: ""
	}), z = x ?? L, B = p(z);
	B.current = z;
	let { draft: V, comment: H } = z, re = p(null), ie = p(null);
	l(() => () => ie.current?.cancel(), [V]);
	let ae = () => {
		let e = re.current;
		if (e) {
			if (ie.current?.cancel(), window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || !e.animate) {
				e.querySelector("textarea")?.focus({ preventScroll: !0 });
				return;
			}
			ie.current = e.animate([
				{ transform: "translateX(0) rotate(0deg)" },
				{ transform: "translateX(-6px) rotate(-1deg)" },
				{ transform: "translateX(6px) rotate(1deg)" },
				{ transform: "translateX(-4px) rotate(-0.5deg)" },
				{ transform: "translateX(4px) rotate(0.5deg)" },
				{ transform: "translateX(0) rotate(0deg)" }
			], {
				duration: 360,
				easing: "ease-in-out"
			});
		}
	}, oe = s((e) => {
		let t = {
			...B.current,
			...e
		};
		B.current = t, R(t), S?.(t);
	}, [S]), U = s((e) => oe({ draft: e }), [oe]), W = s((e) => oe({ comment: e }), [oe]), [se, ce] = m(null), [le, ue] = m(null), [de, fe] = m(!1), G = o === void 0 ? se : o, K = s((e) => {
		ce(e), c?.(e);
	}, [c]), pe = le ?? G, me = K;
	l(() => {
		if (!pe || V) return;
		let e = (e) => {
			e.target instanceof Element && e.target.closest("[data-markup-detail], [data-markup-trigger]") || (ue(null), K(null));
		};
		return document.addEventListener("pointerdown", e, !0), () => document.removeEventListener("pointerdown", e, !0);
	}, [
		pe,
		V,
		K
	]);
	let he = p(null), ge = u(), _e = p(x?.editingItemId ?? null), [ve, ye] = m(0), [be, xe] = m(!1), [Se, Ce] = m(1), [we, Te] = m({
		x: 0,
		y: 0
	}), Ee = p(null), De = p(null), Oe = p(null), ke = p(!1), Ae = p({}), [je, Me] = m({}), q = E && e !== void 0 ? e : e ?? r, Ne = f(() => sa(q), [q]), J = i[ne], [Pe, Fe] = m({}), Ie = xC(J?.document?.url), Le = Ie?.document?.numPages ?? J?.document?.pageCount ?? 1, Re = bM(J), ze = Math.max(1, Math.min(Re ? Pe[Re] ?? 1 : 1, Le)), Be = J?.document ? JSON.stringify([
		J.id,
		J.document.url,
		ze
	]) : void 0, [Ve, He] = m(), Ue = !J?.document || !!(Ie?.document && Ve === Be), We = JSON.stringify([
		J?.id,
		J?.url,
		Be
	]), Ge = p(We);
	Ge.current = We;
	let Ke = Re ?? We, qe = je[Ke] ?? (J?.width && J?.height && J.width > 0 && J.height > 0 ? J.width / J.height : 1), [Je, Ye] = m(368), Xe = p(null), Ze = (e, t) => {
		if (e > 0 && t > 0) {
			let n = e / t;
			Me((e) => e[Ke] === n ? e : {
				...e,
				[Ke]: n
			});
		}
	}, Qe = () => {
		let e = ke.current ? Oe.current : De.current;
		e && e.readyState > 0 && (Ae.current[We] = {
			time: e.currentTime,
			playing: !e.paused && !e.ended
		});
	}, $e = (e, t) => {
		let n = Ae.current[We];
		n && Math.abs(e.currentTime - n.time) > .01 && (e.currentTime = n.time), n?.playing && !w && t === ke.current && e.play().catch(() => {
			t === ke.current && Ae.current[We] === n && (n.playing = !1);
		});
	}, et = (e) => {
		let t = e && !ke.current;
		Qe(), ke.current = e, (e ? De.current : Oe.current)?.pause(), xe(e), t && ee?.(), e || (De.current && $e(De.current, !1), Ce(1), Te({
			x: 0,
			y: 0
		}));
	}, tt = (e, t) => {
		if (t !== ke.current || e.readyState === 0) return;
		Ae.current[We] = {
			time: e.currentTime,
			playing: !e.paused && !e.ended
		};
		let n = t ? De.current : Oe.current;
		n && Math.abs(n.currentTime - e.currentTime) > .01 && (n.currentTime = e.currentTime);
	}, nt = s((e) => {
		let t = Ae.current[We];
		Ae.current[We] = {
			time: e,
			playing: t?.playing ?? !1
		};
		for (let t of [De.current, Oe.current]) t && (t.currentTime = e);
	}, [We]), rt = s((e) => {
		if (e === I.current) return;
		let t = Ge.current, n = ke.current ? Oe.current : De.current;
		n && n.readyState > 0 ? Ae.current[t] = {
			time: n.currentTime,
			playing: !1
		} : Ae.current[t] && (Ae.current[t].playing = !1), n?.pause(), te(e);
	}, []), it = (e) => {
		rt(i[e]?.id), K(null);
	};
	l(() => {
		if (!w) return;
		let e = Ge.current;
		for (let t of [De.current, Oe.current]) t && (t.readyState > 0 && !t.paused && (Ae.current[e] = {
			time: t.currentTime,
			playing: !1
		}), t.pause());
	}, [w]);
	let at = !t && !E, ot = at && !!q.trim() && M.highlights.length === 0, st = at && Ue && !!(J?.url || J?.thumbnailUrl || J?.document), ct = M.annotations.filter((e) => J?.document && (!Ue || (e.pageNumber ?? 1) !== ze) ? !1 : e.mediaId ? J?.id === e.mediaId || !!J?.aliasIds?.includes(e.mediaId) : e.mediaIndex === ne), lt = Math.max(ve, ...ct.map((e) => e.timestampSeconds || 0), 1), ut = [], dt = ct.filter((e) => e.timestampSeconds !== void 0).sort((e, t) => e.timestampSeconds - t.timestampSeconds).map((e) => {
		let t = Math.min(100, e.timestampSeconds / lt * 100), n = t / 100 * Math.max(1, Je - 8), r = ut.findIndex((e) => n - e >= 16), i = r < 0 ? ut.length : r;
		return ut[i] = n, {
			pin: e,
			percent: t,
			lane: i
		};
	}), ft = ct.find((e) => e.id === pe), pt = hM(M), mt = _e.current ? pt.get(_e.current) ?? _M(M) : _M(M), ht = ft ? pt.get(ft.id) ?? 0 : 0, gt = (e) => e, _t = ft ? gt(ft) : null, vt = p(null), [yt, bt] = m(240), xt = V ? void 0 : ft?.id;
	d(() => {
		let e = vt.current, t = Xe.current;
		if (!xt || !e || !t) return;
		let n = () => {
			bt(e.getBoundingClientRect().width), Ye(t.getBoundingClientRect().width);
		};
		if (n(), typeof ResizeObserver > "u") return;
		let r = new ResizeObserver(n);
		return r.observe(e), r.observe(t), () => r.disconnect();
	}, [xt]);
	let St = C === "external" ? 12 : 0, Ct = _t ? Math.max(St + yt / 2, Math.min(_t.x * Je, Je - St - yt / 2)) : 0, wt = (e) => {
		let t = gt(e);
		return {
			left: Math.min(Math.max(0, t.x * Je - 12), Math.max(0, Je - 248)),
			top: `calc(${t.y * 100}% + 16px)`
		};
	};
	l(() => {
		let e = Xe.current;
		if (!e || typeof ResizeObserver > "u") return;
		let t = new ResizeObserver(([e]) => Ye(e.contentRect.width));
		return t.observe(e), () => t.disconnect();
	}, []), l(() => {
		!G && !V && i.length && !i.some((e) => e.id === F) && rt(i[0].id);
	}, [
		i,
		F,
		G,
		V,
		rt
	]);
	let Tt = V?.kind === "pin" ? V.mediaId : void 0;
	l(() => {
		Tt ? rt(Tt) : v && i.some((e) => e.id === v) && rt(v);
	}, [
		v,
		Tt,
		i,
		rt
	]), l(() => {
		if (V?.kind !== "pin" || !V.mediaId || V.pageNumber === void 0) return;
		let e = bM(i.find((e) => e.id === V.mediaId));
		if (!e) return;
		let t = V.pageNumber;
		Fe((n) => n[e] === t ? n : {
			...n,
			[e]: t
		});
	}, [V, i]);
	let Et = p(null);
	l(() => {
		Et.current !== G && (Et.current = null);
		let e = M.annotations.find((e) => e.id === G);
		if (e) {
			let t = e.mediaId ? i.find((t) => t.id === e.mediaId || t.aliasIds?.includes(e.mediaId)) : i[e.mediaIndex];
			if (rt(t?.id), t?.document) {
				let n = bM(t), r = e.pageNumber ?? 1;
				Fe((e) => e[n] === r ? e : {
					...e,
					[n]: r
				});
			}
			e.timestampSeconds !== void 0 && De.current && t?.id === F && Et.current !== G && (Et.current = G, nt(e.timestampSeconds));
		} else G && M.highlights.some((e) => e.id === G) && he.current?.scrollIntoView?.({ block: "nearest" });
	}, [
		G,
		M.annotations,
		M.highlights,
		i,
		F,
		nt,
		rt
	]), l(() => {
		if (!y || E || t || _e.current === y) return;
		let e = M.annotations.find((e) => e.id === y), n = M.highlights.find((e) => e.id === y);
		(e || n) && (_e.current = y, oe({ editingItemId: y }), e ? (rt(e.mediaId ?? i[e.mediaIndex]?.id), U({
			...e,
			kind: "pin"
		}), W(e.comment)) : n && (U({
			...n,
			kind: "highlight"
		}), W(n.comment)));
	}, [
		y,
		t,
		E,
		M.annotations,
		M.highlights,
		i,
		U,
		W,
		oe,
		rt
	]), l(() => {
		n?.(!!V);
	}, [V, n]), l(() => () => {
		n?.(!1);
	}, [n]), l(() => {
		!at && V && x === void 0 && (U(null), W(""));
	}, [
		at,
		V,
		x,
		U,
		W
	]);
	let Dt = (e, t) => {
		if (st) {
			if (V) {
				ae();
				return;
			}
			me(null), U({
				kind: "pin",
				mediaId: J?.id,
				mediaIndex: ne,
				...J?.document ? { pageNumber: ze } : {},
				x: e,
				y: t,
				...J?.isVideo && De.current ? { timestampSeconds: De.current.currentTime } : {}
			}), W("");
		}
	}, Ot = (e) => {
		if (!st || e.target.closest("[data-markup-interactive]")) return;
		let t = e.currentTarget.getBoundingClientRect();
		if (J?.isVideo && e.clientY >= t.bottom - 44) return;
		let n = (e.clientX - t.left) / t.width, r = (e.clientY - t.top) / t.height;
		n < 0 || n > 1 || r < 0 || r > 1 || (e.preventDefault(), Dt(n, r));
	}, kt = (e) => {
		if (!st || e.target.closest("[data-markup-interactive]")) return;
		if (["Enter", " "].includes(e.key)) {
			e.preventDefault(), Dt(.5, .5);
			return;
		}
		if (V?.kind !== "pin") return;
		let t = {
			ArrowLeft: [-.01, 0],
			ArrowRight: [.01, 0],
			ArrowUp: [0, -.01],
			ArrowDown: [0, .01]
		}[e.key];
		t && (e.preventDefault(), U({
			...V,
			x: Math.min(1, Math.max(0, V.x + t[0])),
			y: Math.min(1, Math.max(0, V.y + t[1]))
		}));
	}, At = () => {
		if (!at) return;
		let e = window.getSelection(), t = he.current;
		if (!e || e.rangeCount === 0 || !t) return;
		let n = e.getRangeAt(0);
		if (n.collapsed || !t.contains(n.startContainer) || !t.contains(n.endContainer)) return;
		let r = SM(t, n.startContainer, n.startOffset), i = SM(t, n.endContainer, n.endOffset), a = ua(Ne, Math.min(r, i), "start"), o = ua(Ne, Math.max(r, i), "end"), s = q.slice(a, o);
		if (s.trim()) {
			if (V) {
				ae();
				return;
			}
			U({
				kind: "highlight",
				start: a,
				end: o,
				quote: s
			}), W(""), e.removeAllRanges();
		}
	}, jt = () => {
		oe({
			draft: null,
			comment: "",
			editingItemId: void 0
		}), _e.current = null, b?.();
	}, Mt = () => {
		let e = H.trim();
		if (!at || !V || !e) return;
		if (_e.current) {
			let t = _e.current;
			N({
				...M,
				annotations: M.annotations.map((n) => n.id === t ? {
					...n,
					comment: e
				} : n),
				highlights: M.highlights.map((n) => n.id === t ? {
					...n,
					comment: e
				} : n)
			}), jt();
			return;
		}
		let t = gM(M), n = M;
		if (t === void 0) {
			let e = new Map(mM(M).map((e) => [e.kind === "annotation" ? e.annotation : e.highlight, e.number]));
			n = {
				...M,
				annotations: M.annotations.map((t) => ({
					...t,
					sequence: e.get(t)
				})),
				highlights: M.highlights.map((t) => ({
					...t,
					sequence: e.get(t)
				}))
			}, t = _M(M);
		}
		if (V.kind === "pin") {
			if (!i.some((e) => e.id === V.mediaId)) return;
			let r = {
				id: crypto.randomUUID(),
				sequence: t,
				mediaId: V.mediaId,
				mediaIndex: V.mediaIndex,
				...V.pageNumber === void 0 ? {} : { pageNumber: V.pageNumber },
				x: V.x,
				y: V.y,
				comment: e,
				...V.timestampSeconds === void 0 ? {} : { timestampSeconds: V.timestampSeconds }
			};
			N({
				...n,
				annotations: [...n.annotations, r]
			}), me(r.id);
		} else {
			let r = {
				id: crypto.randomUUID(),
				sequence: t,
				start: V.start,
				end: V.end,
				quote: V.quote,
				comment: e
			};
			N({
				...n,
				highlights: [...n.highlights, r]
			});
		}
		P?.(V.kind), jt();
	}, Nt = f(() => {
		let e = /* @__PURE__ */ new Set([0, q.length]);
		return M.highlights.forEach((t) => {
			e.add(t.start), e.add(t.end);
		}), V?.kind === "highlight" && (e.add(V.start), e.add(V.end)), [...e].sort((e, t) => e - t);
	}, [
		q,
		V,
		M.highlights
	]), Pt = (e = !1) => J?.document ? Ie?.document ? /* @__PURE__ */ g(bC, {
		document: Ie.document,
		pageNumber: ze,
		onRendered: (e, t) => {
			Ze(e, t), He(Be);
		}
	}, Re) : /* @__PURE__ */ g("div", {
		role: Ie?.error ? "alert" : "status",
		className: "grid size-full place-items-center p-4 text-center text-sm text-white",
		children: Ie?.error || "Loading PDF…"
	}) : J?.isVideo ? /* @__PURE__ */ g("video", {
		ref: e ? Oe : De,
		controls: !0,
		poster: J.thumbnailUrl,
		src: J.url,
		onLoadedMetadata: (t) => {
			let n = t.currentTarget;
			if (ye(n.duration || 0), Ze(n.videoWidth, n.videoHeight), !Ae.current[We]) {
				let e = ct.find((e) => e.id === G);
				e?.timestampSeconds !== void 0 && (Ae.current[We] = {
					time: e.timestampSeconds,
					playing: !1
				});
			}
			$e(n, e);
		},
		onTimeUpdate: (t) => tt(t.currentTarget, e),
		onSeeking: (t) => tt(t.currentTarget, e),
		onPlay: (t) => tt(t.currentTarget, e),
		onPause: (t) => tt(t.currentTarget, e),
		onEnded: (t) => tt(t.currentTarget, e),
		className: "size-full object-contain",
		children: /* @__PURE__ */ g("track", {
			kind: "captions",
			label: "No captions available"
		})
	}, We) : J?.url || J?.thumbnailUrl ? /* @__PURE__ */ g("img", {
		src: J.url || J.thumbnailUrl,
		alt: "Post media",
		onLoad: (e) => Ze(e.currentTarget.naturalWidth, e.currentTarget.naturalHeight),
		draggable: !1,
		className: "size-full object-contain"
	}) : /* @__PURE__ */ g("div", {
		className: "grid size-full place-items-center text-sm text-white",
		children: "Media preview unavailable"
	}), Ft = () => J?.document && /* @__PURE__ */ _("nav", {
		"aria-label": "PDF pages",
		className: "flex shrink-0 items-center overflow-hidden rounded-lg border border-neutral-100 bg-white !text-xs !font-medium !leading-none text-neutral-700",
		children: [
			/* @__PURE__ */ g("button", {
				type: "button",
				"aria-label": "Previous PDF page",
				disabled: !!V || !Ie?.document || ze <= 1,
				onClick: () => It(ze - 1),
				className: $("!m-0 !min-h-0 !min-w-0 !p-0 grid shrink-0 place-items-center !rounded-none !border-0 !bg-transparent !text-neutral-700 !shadow-none hover:!bg-blue-25 !outline-none focus-visible:!bg-blue-50 focus-visible:![box-shadow:inset_0_0_0_1px_#c4b5fd] disabled:!cursor-default disabled:!opacity-30", C === "internal" ? "!h-6 !w-6" : "!h-8 !w-8"),
				children: /* @__PURE__ */ g("svg", {
					width: "14",
					height: "14",
					viewBox: "0 0 24 24",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.75",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					"aria-hidden": "true",
					children: /* @__PURE__ */ g("path", { d: "m14 6-6 6 6 6" })
				})
			}),
			/* @__PURE__ */ _("label", {
				className: "!m-0 flex items-center gap-1 whitespace-nowrap !text-xs !font-medium !leading-none tabular-nums",
				children: [
					/* @__PURE__ */ g("span", {
						className: "sr-only",
						children: "Page"
					}),
					/* @__PURE__ */ _("span", {
						className: "relative flex items-center",
						children: [/* @__PURE__ */ g("select", {
							"aria-label": "PDF page",
							value: ze,
							disabled: !!V || !Ie?.document,
							onChange: (e) => It(Number(e.target.value)),
							style: { width: `${String(Le).length + 3}ch` },
							className: $("!m-0 !min-h-0 !appearance-none !rounded !border-0 !bg-transparent !py-0 !pl-1 !pr-4 !text-xs !font-medium !leading-none !text-neutral-700 !shadow-none !outline-none focus-visible:!bg-blue-50 focus-visible:![box-shadow:inset_0_0_0_1px_#c4b5fd] disabled:!opacity-40", C === "internal" ? "!h-6" : "!h-8"),
							children: Array.from({ length: Le }, (e, t) => /* @__PURE__ */ g("option", {
								value: t + 1,
								children: t + 1
							}, t))
						}), /* @__PURE__ */ g("svg", {
							className: "pointer-events-none absolute right-1",
							width: "10",
							height: "10",
							viewBox: "0 0 24 24",
							fill: "none",
							stroke: "currentColor",
							strokeWidth: "1.75",
							strokeLinecap: "round",
							strokeLinejoin: "round",
							"aria-hidden": "true",
							children: /* @__PURE__ */ g("path", { d: "m6 9 6 6 6-6" })
						})]
					}),
					/* @__PURE__ */ _("span", {
						className: "pr-1 text-neutral-500",
						children: ["/ ", Le]
					})
				]
			}),
			/* @__PURE__ */ g("button", {
				type: "button",
				"aria-label": "Next PDF page",
				disabled: !!V || !Ie?.document || ze >= Le,
				onClick: () => It(ze + 1),
				className: $("!m-0 !min-h-0 !min-w-0 !p-0 grid shrink-0 place-items-center !rounded-none !border-0 !bg-transparent !text-neutral-700 !shadow-none hover:!bg-blue-25 !outline-none focus-visible:!bg-blue-50 focus-visible:![box-shadow:inset_0_0_0_1px_#c4b5fd] disabled:!cursor-default disabled:!opacity-30", C === "internal" ? "!h-6 !w-6" : "!h-8 !w-8"),
				children: /* @__PURE__ */ g("svg", {
					width: "14",
					height: "14",
					viewBox: "0 0 24 24",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.75",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					"aria-hidden": "true",
					children: /* @__PURE__ */ g("path", { d: "m10 6 6 6-6 6" })
				})
			})
		]
	});
	function It(e) {
		!Re || V || e < 1 || e > Le || (Fe((t) => ({
			...t,
			[Re]: e
		})), K(null), Ce(1), Te({
			x: 0,
			y: 0
		}));
	}
	return /* @__PURE__ */ _("div", {
		onClick: (e) => e.stopPropagation(),
		"data-testid": "post-markup-section",
		className: $("w-full", C === "external" && "pb-8"),
		children: [
			/* @__PURE__ */ _("article", {
				className: $("rounded-xl bg-white p-4", C === "external" ? "border border-neutral-100" : "ring-1 ring-inset ring-neutral-100"),
				children: [
					/* @__PURE__ */ _("header", {
						className: "flex items-center justify-between gap-3 pb-3",
						children: [/* @__PURE__ */ _("div", {
							className: "flex min-w-0 items-center gap-2",
							children: [/* @__PURE__ */ _("span", {
								className: "relative size-6 shrink-0",
								children: [/* @__PURE__ */ _(eo, {
									className: "grid size-6 place-items-center overflow-hidden rounded-full",
									children: [/* @__PURE__ */ g(no, {
										src: a?.pictureUrl,
										alt: "",
										className: "size-6 rounded-full object-cover",
										style: a?.color ? { border: `2px solid ${a.color}` } : void 0
									}), /* @__PURE__ */ g(io, {
										className: "grid size-6 place-items-center rounded-full bg-blue-500 text-[10px] font-bold text-white",
										children: (a?.name || "S").slice(0, 1).toUpperCase()
									})]
								}), a?.platformIconUrl && /* @__PURE__ */ g("img", {
									src: a.platformIconUrl,
									alt: "",
									className: "absolute bottom-0 right-0 size-2"
								})]
							}), /* @__PURE__ */ g("span", {
								className: "truncate text-sm font-semibold text-neutral-900",
								children: a?.name || "skedsocial"
							})]
						}), /* @__PURE__ */ _("div", {
							className: "flex shrink-0 items-center gap-2",
							children: [
								Ft(),
								C === "external" && !J?.document && /* @__PURE__ */ _("span", {
									className: "text-xs text-neutral-500",
									children: [
										Math.max(0, ne + 1),
										"/",
										i.length
									]
								}),
								(i.length > 0 || M.annotations.length > 0) && /* @__PURE__ */ g("button", {
									type: "button",
									"aria-label": "Expand media preview",
									"data-markup-interactive": !0,
									onClick: () => et(!0),
									className: $("!min-w-0 !p-0 grid place-items-center rounded-lg border border-neutral-100 bg-white text-neutral-700 shadow-sm hover:bg-neutral-25", C === "internal" ? "!h-6 !w-6 text-xs" : "!h-8 !w-8"),
									children: /* @__PURE__ */ g("i", {
										className: "fa-regular fa-up-right-and-down-left-from-center",
										"aria-hidden": "true"
									})
								})
							]
						})]
					}),
					J?.document && /* @__PURE__ */ g("a", {
						href: J.document.url,
						target: "_blank",
						rel: "noreferrer",
						className: "mb-2 block text-xs text-blue-500 underline",
						children: "Download PDF"
					}),
					(i.length > 0 || M.annotations.length > 0) && /* @__PURE__ */ _("div", {
						ref: Xe,
						onMouseEnter: () => fe(!0),
						onMouseLeave: () => fe(!1),
						className: "relative flex items-center justify-center overflow-visible rounded-lg bg-neutral-800",
						style: { aspectRatio: String(qe) },
						children: [
							st && /* @__PURE__ */ g("span", {
								"aria-hidden": "true",
								"data-testid": "markup-media-border",
								className: "pointer-events-none absolute inset-0 z-10 rounded-lg border-2 border-dashed border-[#725AFF]"
							}),
							/* @__PURE__ */ _("div", {
								"data-testid": "markup-media-content",
								role: st ? "button" : void 0,
								"aria-label": "Post media markup area",
								tabIndex: st ? 0 : void 0,
								className: $("relative w-full overflow-hidden rounded-lg outline-none", st && "cursor-crosshair focus:ring-2 focus:ring-blue-200"),
								style: { aspectRatio: String(qe) },
								onPointerDown: Ot,
								onKeyDown: kt,
								children: [
									Pt(),
									ct.map((e) => {
										let t = pt.get(e.id) ?? 0;
										return /* @__PURE__ */ g("button", {
											type: "button",
											"data-markup-interactive": !0,
											"data-markup-trigger": !0,
											"aria-label": `Pin ${t}: ${e.comment}`,
											onMouseEnter: () => ue(e.id),
											onMouseLeave: () => ue(null),
											"aria-pressed": G === e.id,
											onClick: () => {
												me(G === e.id ? null : e.id), e.timestampSeconds !== void 0 && De.current && nt(e.timestampSeconds);
											},
											className: $("!min-w-0 !p-0 !h-6 !w-6 absolute z-20 grid cursor-pointer -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border-2 border-white bg-blue-500 text-[10px] font-semibold leading-[14px] text-white shadow-sm", C === "internal" && E && pe !== e.id && "opacity-70"),
											style: {
												left: `${e.x * 100}%`,
												top: `${e.y * 100}%`
											},
											children: t
										}, e.id);
									}),
									V?.kind === "pin" && /* @__PURE__ */ g("span", {
										className: "pointer-events-none absolute z-30 grid size-6 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border-2 border-white bg-blue-500 text-[10px] font-semibold leading-[14px] text-white shadow-sm",
										style: {
											left: `${V.x * 100}%`,
											top: `${V.y * 100}%`
										},
										children: mt
									})
								]
							}),
							(C === "external" || de) && st && !V && ct.length === 0 && /* @__PURE__ */ _("span", {
								"data-testid": "place-pin-instruction",
								className: "pointer-events-none absolute left-1/2 top-1/2 z-10 flex min-h-[32px] w-max max-w-[calc(100%-24px)] -translate-x-1/2 -translate-y-1/2 items-center gap-[8px] text-center rounded-[8px] bg-white px-[12px] py-[6px] text-[14px] font-medium leading-[20px] text-[#4F31FF] shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]",
								children: [/* @__PURE__ */ g("i", {
									className: "fa-regular fa-plus grid size-[20px] shrink-0 place-items-center text-[16px]",
									"aria-hidden": "true"
								}), /* @__PURE__ */ g("span", {
									className: "min-w-0",
									children: "Click anywhere to place pin"
								})]
							}),
							V?.kind === "pin" && /* @__PURE__ */ g("div", {
								className: $("absolute z-40", C === "external" ? "w-[min(432px,calc(100%-24px))]" : "w-[280px] max-w-full"),
								style: C === "internal" ? wt(V) : {
									left: "50%",
									top: `${V.y * 100}%`,
									transform: V.y > .42 ? "translate(-50%, calc(-100% - 20px))" : "translate(-50%, 20px)"
								},
								children: /* @__PURE__ */ g(wM, {
									composerRef: re,
									appearance: C,
									comment: H,
									editing: !!_e.current,
									draft: V,
									enabled: at,
									number: mt,
									reviewerName: D,
									onCancel: jt,
									onChange: W,
									onSave: Mt
								})
							}),
							ft && _t && !V && /* @__PURE__ */ _("div", {
								ref: vt,
								role: "dialog",
								"aria-label": `Pin ${ht} annotation detail`,
								"data-markup-interactive": !0,
								"data-markup-detail": !0,
								"data-testid": "selected-pin-popover",
								className: $("absolute z-40 w-[280px] [overflow-wrap:anywhere] rounded-[10px] bg-white p-3 text-neutral-800 shadow-md ring-1 ring-inset ring-neutral-100", C === "external" ? "max-w-[calc(100%-24px)]" : "max-w-full"),
								style: {
									left: Ct,
									top: `${_t.y * 100}%`,
									transform: C === "internal" ? "translate(-50%, 16px)" : _t.y > .42 ? "translate(-50%, calc(-100% - 20px))" : "translate(-50%, 20px)"
								},
								children: [
									/* @__PURE__ */ _("p", {
										className: "mb-2 text-xs font-semibold leading-4 text-blue-500",
										children: ["Pin #", ht]
									}),
									/* @__PURE__ */ _("div", {
										className: "flex flex-wrap items-center gap-1.5 text-xs leading-4",
										children: [
											/* @__PURE__ */ _("span", {
												className: "relative shrink-0",
												children: [O ? /* @__PURE__ */ g("img", {
													src: O,
													alt: "",
													className: "size-6 rounded-full object-cover"
												}) : /* @__PURE__ */ g("span", {
													className: $("grid size-6 place-items-center rounded-full text-[10px] font-semibold text-white", j ? "bg-neutral-300" : "bg-[#9583ff]"),
													children: CM(D)
												}), j && /* @__PURE__ */ g("img", {
													src: "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='arrow-square-left'%3e%3cg%20id='Icon'%3e%3cpath%20d='M1.5%203.9C1.5%203.05992%201.5%202.63988%201.66349%202.31901C1.8073%202.03677%202.03677%201.8073%202.31901%201.66349C2.63988%201.5%203.05992%201.5%203.9%201.5H8.1C8.94008%201.5%209.36012%201.5%209.68099%201.66349C9.96323%201.8073%2010.1927%202.03677%2010.3365%202.31901C10.5%202.63988%2010.5%203.05992%2010.5%203.9V8.1C10.5%208.94008%2010.5%209.36012%2010.3365%209.68099C10.1927%209.96323%209.96323%2010.1927%209.68099%2010.3365C9.36012%2010.5%208.94008%2010.5%208.1%2010.5H3.9C3.05992%2010.5%202.63988%2010.5%202.31901%2010.3365C2.03677%2010.1927%201.8073%209.96323%201.66349%209.68099C1.5%209.36012%201.5%208.94008%201.5%208.1V3.9Z'%20fill='%23F59E0B'/%3e%3cpath%20d='M6%204L4%206L6%208'%20fill='%23F59E0B'/%3e%3cpath%20d='M6%208L4%206L6%204M4%206H8M3.9%2010.5H8.1C8.94008%2010.5%209.36012%2010.5%209.68099%2010.3365C9.96323%2010.1927%2010.1927%209.96323%2010.3365%209.68099C10.5%209.36012%2010.5%208.94008%2010.5%208.1V3.9C10.5%203.05992%2010.5%202.63988%2010.3365%202.31901C10.1927%202.03677%209.96323%201.8073%209.68099%201.66349C9.36012%201.5%208.94008%201.5%208.1%201.5H3.9C3.05992%201.5%202.63988%201.5%202.31901%201.66349C2.03677%201.8073%201.8073%202.03677%201.66349%202.31901C1.5%202.63988%201.5%203.05992%201.5%203.9V8.1C1.5%208.94008%201.5%209.36012%201.66349%209.68099C1.8073%209.96323%202.03677%2010.1927%202.31901%2010.3365C2.63988%2010.5%203.05992%2010.5%203.9%2010.5Z'%20stroke='white'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e",
													alt: "External reviewer",
													className: "absolute -bottom-1 -right-1"
												})]
											}),
											/* @__PURE__ */ g("span", {
												className: "font-semibold",
												children: D
											}),
											A && /* @__PURE__ */ g("span", {
												className: "text-neutral-500",
												children: "(You)"
											}),
											k && /* @__PURE__ */ g("span", {
												className: "text-neutral-500",
												children: k
											})
										]
									}),
									/* @__PURE__ */ g("p", {
										className: "ml-[30px] text-xs leading-4",
										children: ft.comment
									})
								]
							})
						]
					}),
					J?.isVideo && ct.some((e) => e.timestampSeconds !== void 0) && /* @__PURE__ */ _("div", {
						className: "relative mx-1 mt-3",
						style: { height: Math.max(1, ut.length) * 16 },
						"aria-label": "Video annotation markers",
						children: [/* @__PURE__ */ g("span", { className: "absolute left-0 right-0 top-2 h-1 -translate-y-1/2 rounded-full bg-neutral-100" }), dt.map(({ pin: e, percent: t, lane: n }) => {
							let r = pt.get(e.id) ?? 0;
							return /* @__PURE__ */ g("button", {
								type: "button",
								"data-markup-trigger": !0,
								"aria-label": `Seek to pin ${r} at ${vM(e.timestampSeconds)}`,
								onClick: () => {
									nt(e.timestampSeconds || 0), me(e.id);
								},
								className: "!min-w-0 !p-0 !h-3 !w-3 absolute cursor-pointer -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-blue-500 shadow-sm",
								style: {
									left: `${t}%`,
									top: 8 + n * 16
								}
							}, `timeline-${e.id}`);
						})]
					}),
					i.length > 1 && /* @__PURE__ */ g("div", {
						className: "flex gap-2 pt-3",
						children: i.map((e, t) => /* @__PURE__ */ g("button", {
							type: "button",
							"aria-label": `Show media ${t + 1}`,
							disabled: !!V,
							onClick: () => it(t),
							className: $("!min-w-0 !p-0 !h-12 !w-12 overflow-hidden rounded-md border bg-neutral-800", t === ne ? "border-2 border-blue-500" : "border-neutral-100 opacity-60"),
							children: /* @__PURE__ */ g("img", {
								src: e.thumbnailUrl || e.url,
								alt: "",
								className: "size-full object-cover"
							})
						}, e.id || t))
					}),
					q && /* @__PURE__ */ _("div", {
						className: "relative mt-3",
						children: [
							ot && /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ _("div", {
								id: `${ge}-hint`,
								className: "mb-0.5 -ml-1.5 flex w-fit max-w-full select-none items-center gap-2 rounded-t-lg rounded-br-lg border-l-2 border-blue-500 bg-blue-50 px-2 py-1 text-sm font-medium leading-5 text-neutral-800",
								children: [/* @__PURE__ */ g("i", {
									"aria-hidden": "true",
									className: "fa-regular fa-highlighter-line flex size-5 shrink-0 items-center justify-center text-base text-blue-500"
								}), /* @__PURE__ */ g("span", { children: "Select text below to highlight." })]
							}), /* @__PURE__ */ g("span", {
								"aria-hidden": "true",
								className: "pointer-events-none absolute -left-1.5 bottom-0 top-7 w-0.5 rounded-b-lg bg-blue-500"
							})] }),
							/* @__PURE__ */ g("div", {
								ref: he,
								id: ge,
								"aria-label": "Post caption",
								"aria-describedby": ot ? `${ge}-hint` : void 0,
								tabIndex: at ? 0 : -1,
								onPointerUp: At,
								onKeyUp: At,
								className: $("block w-full whitespace-pre-wrap bg-transparent text-left text-sm leading-5 text-neutral-800 outline-none", at && "cursor-text select-text focus-visible:ring-2 focus-visible:ring-blue-100"),
								children: Nt.slice(0, -1).map((e, t) => {
									let n = Nt[t + 1], r = la(Ne, e, n);
									if (!r) return null;
									let i = M.highlights.find((t) => t.start < n && t.end > e), a = !!i, o = V?.kind === "highlight" && V.start < n && V.end > e;
									return /* @__PURE__ */ g(a || o ? "mark" : "span", {
										role: a ? "button" : void 0,
										"data-markup-trigger": a ? "" : void 0,
										tabIndex: a ? 0 : void 0,
										onMouseEnter: () => i && ue(i.id),
										onMouseLeave: () => ue(null),
										onClick: () => i && K(G === i.id ? null : i.id),
										onKeyDown: (e) => {
											i && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), K(i.id));
										},
										className: $(a && "cursor-pointer bg-warning-50 text-inherit", i?.id === G && "outline outline-1 outline-yellow-500", o && "bg-blue-50 text-inherit"),
										children: r
									}, `${e}-${n}`);
								})
							}),
							at && /* @__PURE__ */ g("button", {
								type: "button",
								onClick: At,
								className: "sr-only focus:not-sr-only focus:mt-2 focus:inline-flex focus:rounded focus:bg-blue-50 focus:px-2 focus:py-1 focus:text-xs focus:text-blue-700",
								children: "Highlight selected caption text"
							})
						]
					}),
					!V && M.highlights.filter((e) => e.id === (le ?? G)).map((e) => /* @__PURE__ */ _("div", {
						role: "dialog",
						"aria-label": `Highlight ${pt.get(e.id)} detail`,
						"data-markup-detail": !0,
						className: "mt-3 w-max min-w-[min(240px,100%)] max-w-[min(280px,100%)] [overflow-wrap:anywhere] rounded-lg border border-neutral-100 bg-white p-3 text-xs leading-4 shadow-md",
						children: [
							/* @__PURE__ */ _("div", {
								className: "mb-2 flex items-center gap-2",
								children: [/* @__PURE__ */ g("span", {
									className: "grid size-6 shrink-0 place-items-center rounded-full bg-neutral-300 text-[10px] font-semibold text-white",
									children: CM(D)
								}), /* @__PURE__ */ g("strong", { children: D })]
							}),
							/* @__PURE__ */ g("p", { children: e.comment }),
							/* @__PURE__ */ _("p", {
								className: "mt-2 font-semibold text-yellow-600",
								children: ["Highlight #", pt.get(e.id)]
							})
						]
					}, e.id))
				]
			}),
			V?.kind === "highlight" && /* @__PURE__ */ g("div", {
				className: "mt-3",
				children: /* @__PURE__ */ g(wM, {
					composerRef: re,
					appearance: C,
					comment: H,
					editing: !!_e.current,
					draft: V,
					enabled: at,
					number: mt,
					reviewerName: D,
					onCancel: jt,
					onChange: W,
					onSave: Mt
				})
			}),
			/* @__PURE__ */ _(T, {
				open: be,
				className: "flex h-[calc(100dvh-32px)] w-[calc(100vw-32px)] max-h-none max-w-none flex-col gap-3 overflow-hidden px-3 pb-3 pt-10 md:h-[calc(100dvh-80px)] md:w-[calc(100vw-80px)] md:px-6 md:pb-6",
				title: "Expanded post media",
				description: "Review the post media at a larger size. Annotations cannot be edited in this view.",
				onOpenChange: et,
				children: [J?.document && /* @__PURE__ */ g("div", {
					className: "flex shrink-0 justify-end",
					children: Ft()
				}), /* @__PURE__ */ _("div", {
					className: "flex min-h-0 flex-1 gap-3 md:gap-6",
					children: [i.length > 1 && /* @__PURE__ */ g("div", {
						className: "flex w-16 shrink-0 flex-col gap-2 overflow-y-auto",
						children: i.map((e, t) => /* @__PURE__ */ g("button", {
							type: "button",
							"aria-label": `Show expanded media ${t + 1}`,
							onClick: () => {
								it(t), Ce(1), Te({
									x: 0,
									y: 0
								});
							},
							className: $("!min-w-0 !p-0 !h-16 !w-16 shrink-0 overflow-hidden rounded-md border bg-neutral-800", t === ne ? "border-2 border-blue-500" : "border-neutral-100 opacity-60"),
							children: /* @__PURE__ */ g("img", {
								src: e.thumbnailUrl || e.url,
								alt: "",
								className: "size-full object-cover"
							})
						}, `expanded-${e.id || t}`))
					}), /* @__PURE__ */ _("div", {
						className: "relative flex min-w-0 flex-1 items-center justify-center overflow-hidden rounded-lg bg-neutral-800",
						children: [/* @__PURE__ */ g("div", {
							className: $("size-full", Se > 1 && "cursor-grab active:cursor-grabbing"),
							onPointerDown: (e) => {
								Se <= 1 || (Ee.current = {
									x: e.clientX - we.x,
									y: e.clientY - we.y
								}, e.currentTarget.setPointerCapture(e.pointerId));
							},
							onPointerMove: (e) => {
								Ee.current && Te({
									x: e.clientX - Ee.current.x,
									y: e.clientY - Ee.current.y
								});
							},
							onPointerUp: () => {
								Ee.current = null;
							},
							children: /* @__PURE__ */ g("div", {
								className: "size-full transition-transform",
								style: { transform: `translate(${we.x}px, ${we.y}px) scale(${Se})` },
								children: Pt(!0)
							})
						}), /* @__PURE__ */ _("div", {
							className: "absolute bottom-4 right-4 flex overflow-hidden rounded-lg border border-neutral-100 bg-white shadow-sm",
							children: [/* @__PURE__ */ g("button", {
								type: "button",
								"aria-label": "Zoom out",
								disabled: Se <= 1,
								onClick: () => {
									Ce((e) => Math.max(1, e - .25)), Se <= 1.25 && Te({
										x: 0,
										y: 0
									});
								},
								className: "!min-w-0 !p-0 !h-8 !w-8 grid place-items-center border-r border-neutral-100 disabled:text-neutral-300",
								children: /* @__PURE__ */ g("i", {
									className: "fa-regular fa-minus",
									"aria-hidden": "true"
								})
							}), /* @__PURE__ */ g("button", {
								type: "button",
								"aria-label": "Zoom in",
								disabled: Se >= 3,
								onClick: () => Ce((e) => Math.min(3, e + .25)),
								className: "!min-w-0 !p-0 !h-8 !w-8 grid place-items-center disabled:text-neutral-300",
								children: /* @__PURE__ */ g("i", {
									className: "fa-regular fa-plus",
									"aria-hidden": "true"
								})
							})]
						})]
					})]
				})]
			})
		]
	});
}, EM = () => ({
	generalFeedback: "",
	annotations: [],
	highlights: []
}), DM = (e) => {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return t.version === 1 && Array.isArray(t.annotations) && Array.isArray(t.highlights);
};
//#endregion
//#region lib/components/markup/mediaIdentity.ts
function OM(e) {
	if (!e) return;
	let t = e.split(/[?#]/, 1)[0];
	return t ? `url:${mk(t)}` : void 0;
}
//#endregion
export { Vf as CaptionCopyProvider, em as CopyableSkedCaption, xy as POST_PREVIEW_PLATFORM_NAMES, by as POST_PREVIEW_SUPPORTED_TYPES_BY_PLATFORM, TM as PostMarkupSection, yk as PostModel, Gp as RenderSkedCaption, nm as SkedCaptionPreview, bk as SkedCorePostModel, sk as SkedPreview, ik as canRenderUpliftPreview, yb as canSelectVideoCoverForSelection, gb as canSelectVideoCoverFrame, _b as canUploadVideoCover, bb as canUploadVideoCoverForSelection, EM as emptyMarkupValue, yM as formatMarkupAge, vM as formatMarkupTimestamp, pb as frameSelectVideoCoverPlatforms, Ty as getEffectivePreviewPostType, ca as getLinkedInCaptionText, OM as getMarkupMediaIdentity, hM as getMarkupNumbers, SC as getMarkupPdfDocument, Sy as getPostPreviewSupport, vb as getSelectableVideoCoverPlatforms, wy as getUnsupportedPostPreviewCopy, Ey as hasDocumentMedia, Dy as isDocumentPreviewMedia, DM as isPersistedMarkup, Cy as isPostPreviewSupported, xb as isVideoCoverSelectorEligible, _M as nextMarkupNumber, gM as nextMarkupSequence, hb as normalizeVideoCoverPlatform, mM as orderMarkupItems, Sb as shouldGateVideoCoverPlayback, mb as uploadVideoCoverPlatforms };

//# sourceMappingURL=sked-preview.es.js.map